function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree8ef"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree8ef"] = parcelRequire;
}
parcelRequire.register("1hhYD", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0ee552d66ae1334e$export$ffb0004e005737fa, (v) => $0ee552d66ae1334e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0ee552d66ae1334e$export$34b9dba7ce09269b, (v) => $0ee552d66ae1334e$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0ee552d66ae1334e$export$25062201e9e25d76, (v) => $0ee552d66ae1334e$export$25062201e9e25d76 = v);
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0ee552d66ae1334e$export$ffb0004e005737fa;
var $0ee552d66ae1334e$export$34b9dba7ce09269b;
var $0ee552d66ae1334e$export$25062201e9e25d76;
"use strict";

var $5cNek = parcelRequire("5cNek");
var $0ee552d66ae1334e$var$g = 60103;
$0ee552d66ae1334e$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0ee552d66ae1334e$var$h = Symbol.for;
    $0ee552d66ae1334e$var$g = $0ee552d66ae1334e$var$h("react.element");
    $0ee552d66ae1334e$export$ffb0004e005737fa = $0ee552d66ae1334e$var$h("react.fragment");
}
var $0ee552d66ae1334e$var$m = $5cNek.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0ee552d66ae1334e$var$n = Object.prototype.hasOwnProperty, $0ee552d66ae1334e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0ee552d66ae1334e$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0ee552d66ae1334e$var$n.call(a, b) && !$0ee552d66ae1334e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0ee552d66ae1334e$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0ee552d66ae1334e$var$m.current
    };
}
$0ee552d66ae1334e$export$34b9dba7ce09269b = $0ee552d66ae1334e$var$q;
$0ee552d66ae1334e$export$25062201e9e25d76 = $0ee552d66ae1334e$var$q;

});
parcelRequire.register("5cNek", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3hdL5"));

});
parcelRequire.register("3hdL5", function(module, exports) {

$parcel$export(module.exports, "Children", () => $262da1cc4b49014e$export$dca3b0875bd9a954, (v) => $262da1cc4b49014e$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $262da1cc4b49014e$export$16fa2f45be04daa8, (v) => $262da1cc4b49014e$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $262da1cc4b49014e$export$ffb0004e005737fa, (v) => $262da1cc4b49014e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $262da1cc4b49014e$export$e2c29f18771995cb, (v) => $262da1cc4b49014e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $262da1cc4b49014e$export$221d75b3f55bb0bd, (v) => $262da1cc4b49014e$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $262da1cc4b49014e$export$5f8d39834fd61797, (v) => $262da1cc4b49014e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $262da1cc4b49014e$export$74bf444e3cd11ea5, (v) => $262da1cc4b49014e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $262da1cc4b49014e$export$ae55be85d98224ed, (v) => $262da1cc4b49014e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $262da1cc4b49014e$export$e530037191fcd5d7, (v) => $262da1cc4b49014e$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $262da1cc4b49014e$export$fd42f52fd3ae1109, (v) => $262da1cc4b49014e$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $262da1cc4b49014e$export$c8a8987d4410bf2d, (v) => $262da1cc4b49014e$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $262da1cc4b49014e$export$d38cd72104c1f0e9, (v) => $262da1cc4b49014e$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $262da1cc4b49014e$export$7d1e3a5e95ceca43, (v) => $262da1cc4b49014e$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $262da1cc4b49014e$export$257a8862b851cb5b, (v) => $262da1cc4b49014e$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $262da1cc4b49014e$export$a8257692ac88316c, (v) => $262da1cc4b49014e$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $262da1cc4b49014e$export$488013bae63b21da, (v) => $262da1cc4b49014e$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $262da1cc4b49014e$export$7c73462e0d25e514, (v) => $262da1cc4b49014e$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $262da1cc4b49014e$export$35808ee640e87ca7, (v) => $262da1cc4b49014e$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $262da1cc4b49014e$export$fae74005e78b1a27, (v) => $262da1cc4b49014e$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $262da1cc4b49014e$export$dc8fbce3eb94dc1e, (v) => $262da1cc4b49014e$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $262da1cc4b49014e$export$6d9c69b0de29b591, (v) => $262da1cc4b49014e$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $262da1cc4b49014e$export$d5a552a76deda3c2, (v) => $262da1cc4b49014e$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $262da1cc4b49014e$export$e5c5a5f917a5871c, (v) => $262da1cc4b49014e$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $262da1cc4b49014e$export$1538c33de8887b59, (v) => $262da1cc4b49014e$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $262da1cc4b49014e$export$13e3392192263954, (v) => $262da1cc4b49014e$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $262da1cc4b49014e$export$b8f5890fc79d6aca, (v) => $262da1cc4b49014e$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $262da1cc4b49014e$export$60241385465d0a34, (v) => $262da1cc4b49014e$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $262da1cc4b49014e$export$83d89fbfd8236492, (v) => $262da1cc4b49014e$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $262da1cc4b49014e$export$dca3b0875bd9a954;
var $262da1cc4b49014e$export$16fa2f45be04daa8;
var $262da1cc4b49014e$export$ffb0004e005737fa;
var $262da1cc4b49014e$export$e2c29f18771995cb;
var $262da1cc4b49014e$export$221d75b3f55bb0bd;
var $262da1cc4b49014e$export$5f8d39834fd61797;
var $262da1cc4b49014e$export$74bf444e3cd11ea5;
var $262da1cc4b49014e$export$ae55be85d98224ed;
var $262da1cc4b49014e$export$e530037191fcd5d7;
var $262da1cc4b49014e$export$fd42f52fd3ae1109;
var $262da1cc4b49014e$export$c8a8987d4410bf2d;
var $262da1cc4b49014e$export$d38cd72104c1f0e9;
var $262da1cc4b49014e$export$7d1e3a5e95ceca43;
var $262da1cc4b49014e$export$257a8862b851cb5b;
var $262da1cc4b49014e$export$a8257692ac88316c;
var $262da1cc4b49014e$export$488013bae63b21da;
var $262da1cc4b49014e$export$7c73462e0d25e514;
var $262da1cc4b49014e$export$35808ee640e87ca7;
var $262da1cc4b49014e$export$fae74005e78b1a27;
var $262da1cc4b49014e$export$dc8fbce3eb94dc1e;
var $262da1cc4b49014e$export$6d9c69b0de29b591;
var $262da1cc4b49014e$export$d5a552a76deda3c2;
var $262da1cc4b49014e$export$e5c5a5f917a5871c;
var $262da1cc4b49014e$export$1538c33de8887b59;
var $262da1cc4b49014e$export$13e3392192263954;
var $262da1cc4b49014e$export$b8f5890fc79d6aca;
var $262da1cc4b49014e$export$60241385465d0a34;
var $262da1cc4b49014e$export$83d89fbfd8236492;
"use strict";

var $MsCOU = parcelRequire("MsCOU");
var $262da1cc4b49014e$var$n = "function" === typeof Symbol && Symbol.for, $262da1cc4b49014e$var$p = $262da1cc4b49014e$var$n ? Symbol.for("react.element") : 60103, $262da1cc4b49014e$var$q = $262da1cc4b49014e$var$n ? Symbol.for("react.portal") : 60106, $262da1cc4b49014e$var$r = $262da1cc4b49014e$var$n ? Symbol.for("react.fragment") : 60107, $262da1cc4b49014e$var$t = $262da1cc4b49014e$var$n ? Symbol.for("react.strict_mode") : 60108, $262da1cc4b49014e$var$u = $262da1cc4b49014e$var$n ? Symbol.for("react.profiler") : 60114, $262da1cc4b49014e$var$v = $262da1cc4b49014e$var$n ? Symbol.for("react.provider") : 60109, $262da1cc4b49014e$var$w = $262da1cc4b49014e$var$n ? Symbol.for("react.context") : 60110, $262da1cc4b49014e$var$x = $262da1cc4b49014e$var$n ? Symbol.for("react.forward_ref") : 60112, $262da1cc4b49014e$var$y = $262da1cc4b49014e$var$n ? Symbol.for("react.suspense") : 60113, $262da1cc4b49014e$var$z = $262da1cc4b49014e$var$n ? Symbol.for("react.memo") : 60115, $262da1cc4b49014e$var$A = $262da1cc4b49014e$var$n ? Symbol.for("react.lazy") : 60116, $262da1cc4b49014e$var$B = "function" === typeof Symbol && Symbol.iterator;
function $262da1cc4b49014e$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $262da1cc4b49014e$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $262da1cc4b49014e$var$E = {};
function $262da1cc4b49014e$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $262da1cc4b49014e$var$E;
    this.updater = c || $262da1cc4b49014e$var$D;
}
$262da1cc4b49014e$var$F.prototype.isReactComponent = {};
$262da1cc4b49014e$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($262da1cc4b49014e$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$262da1cc4b49014e$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $262da1cc4b49014e$var$G() {}
$262da1cc4b49014e$var$G.prototype = $262da1cc4b49014e$var$F.prototype;
function $262da1cc4b49014e$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $262da1cc4b49014e$var$E;
    this.updater = c || $262da1cc4b49014e$var$D;
}
var $262da1cc4b49014e$var$I = $262da1cc4b49014e$var$H.prototype = new $262da1cc4b49014e$var$G;
$262da1cc4b49014e$var$I.constructor = $262da1cc4b49014e$var$H;
$MsCOU($262da1cc4b49014e$var$I, $262da1cc4b49014e$var$F.prototype);
$262da1cc4b49014e$var$I.isPureReactComponent = !0;
var $262da1cc4b49014e$var$J = {
    current: null
}, $262da1cc4b49014e$var$K = Object.prototype.hasOwnProperty, $262da1cc4b49014e$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $262da1cc4b49014e$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$262da1cc4b49014e$var$K.call(b, e) && !$262da1cc4b49014e$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $262da1cc4b49014e$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $262da1cc4b49014e$var$J.current
    };
}
function $262da1cc4b49014e$var$N(a, b) {
    return {
        $$typeof: $262da1cc4b49014e$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $262da1cc4b49014e$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $262da1cc4b49014e$var$p;
}
function $262da1cc4b49014e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $262da1cc4b49014e$var$P = /\/+/g, $262da1cc4b49014e$var$Q = [];
function $262da1cc4b49014e$var$R(a, b, c, e) {
    if ($262da1cc4b49014e$var$Q.length) {
        var d = $262da1cc4b49014e$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $262da1cc4b49014e$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $262da1cc4b49014e$var$Q.length && $262da1cc4b49014e$var$Q.push(a);
}
function $262da1cc4b49014e$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $262da1cc4b49014e$var$p:
                case $262da1cc4b49014e$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $262da1cc4b49014e$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $262da1cc4b49014e$var$U(d, k);
        g += $262da1cc4b49014e$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $262da1cc4b49014e$var$B && a[$262da1cc4b49014e$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $262da1cc4b49014e$var$U(d, k++), g += $262da1cc4b49014e$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($262da1cc4b49014e$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $262da1cc4b49014e$var$V(a, b, c) {
    return null == a ? 0 : $262da1cc4b49014e$var$T(a, "", b, c);
}
function $262da1cc4b49014e$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $262da1cc4b49014e$var$escape(a.key) : b.toString(36);
}
function $262da1cc4b49014e$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $262da1cc4b49014e$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $262da1cc4b49014e$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($262da1cc4b49014e$var$O(a) && (a = $262da1cc4b49014e$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($262da1cc4b49014e$var$P, "$&/") + "/") + c)), e.push(a));
}
function $262da1cc4b49014e$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($262da1cc4b49014e$var$P, "$&/") + "/");
    b = $262da1cc4b49014e$var$R(b, g, e, d);
    $262da1cc4b49014e$var$V(a, $262da1cc4b49014e$var$aa, b);
    $262da1cc4b49014e$var$S(b);
}
var $262da1cc4b49014e$var$Y = {
    current: null
};
function $262da1cc4b49014e$var$Z() {
    var a = $262da1cc4b49014e$var$Y.current;
    if (null === a) throw Error($262da1cc4b49014e$var$C(321));
    return a;
}
var $262da1cc4b49014e$var$ba = {
    ReactCurrentDispatcher: $262da1cc4b49014e$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $262da1cc4b49014e$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $MsCOU
};
$262da1cc4b49014e$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $262da1cc4b49014e$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $262da1cc4b49014e$var$R(null, null, b, c);
        $262da1cc4b49014e$var$V(a, $262da1cc4b49014e$var$W, b);
        $262da1cc4b49014e$var$S(b);
    },
    count: function(a) {
        return $262da1cc4b49014e$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $262da1cc4b49014e$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$262da1cc4b49014e$var$O(a)) throw Error($262da1cc4b49014e$var$C(143));
        return a;
    }
};
$262da1cc4b49014e$export$16fa2f45be04daa8 = $262da1cc4b49014e$var$F;
$262da1cc4b49014e$export$ffb0004e005737fa = $262da1cc4b49014e$var$r;
$262da1cc4b49014e$export$e2c29f18771995cb = $262da1cc4b49014e$var$u;
$262da1cc4b49014e$export$221d75b3f55bb0bd = $262da1cc4b49014e$var$H;
$262da1cc4b49014e$export$5f8d39834fd61797 = $262da1cc4b49014e$var$t;
$262da1cc4b49014e$export$74bf444e3cd11ea5 = $262da1cc4b49014e$var$y;
$262da1cc4b49014e$export$ae55be85d98224ed = $262da1cc4b49014e$var$ba;
$262da1cc4b49014e$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($262da1cc4b49014e$var$C(267, a));
    var e = $MsCOU({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $262da1cc4b49014e$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$262da1cc4b49014e$var$K.call(b, h) && !$262da1cc4b49014e$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $262da1cc4b49014e$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$262da1cc4b49014e$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $262da1cc4b49014e$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $262da1cc4b49014e$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$262da1cc4b49014e$export$c8a8987d4410bf2d = $262da1cc4b49014e$var$M;
$262da1cc4b49014e$export$d38cd72104c1f0e9 = function(a) {
    var b = $262da1cc4b49014e$var$M.bind(null, a);
    b.type = a;
    return b;
};
$262da1cc4b49014e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$262da1cc4b49014e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $262da1cc4b49014e$var$x,
        render: a
    };
};
$262da1cc4b49014e$export$a8257692ac88316c = $262da1cc4b49014e$var$O;
$262da1cc4b49014e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $262da1cc4b49014e$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$262da1cc4b49014e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $262da1cc4b49014e$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$262da1cc4b49014e$export$35808ee640e87ca7 = function(a, b) {
    return $262da1cc4b49014e$var$Z().useCallback(a, b);
};
$262da1cc4b49014e$export$fae74005e78b1a27 = function(a, b) {
    return $262da1cc4b49014e$var$Z().useContext(a, b);
};
$262da1cc4b49014e$export$dc8fbce3eb94dc1e = function() {};
$262da1cc4b49014e$export$6d9c69b0de29b591 = function(a, b) {
    return $262da1cc4b49014e$var$Z().useEffect(a, b);
};
$262da1cc4b49014e$export$d5a552a76deda3c2 = function(a, b, c) {
    return $262da1cc4b49014e$var$Z().useImperativeHandle(a, b, c);
};
$262da1cc4b49014e$export$e5c5a5f917a5871c = function(a, b) {
    return $262da1cc4b49014e$var$Z().useLayoutEffect(a, b);
};
$262da1cc4b49014e$export$1538c33de8887b59 = function(a, b) {
    return $262da1cc4b49014e$var$Z().useMemo(a, b);
};
$262da1cc4b49014e$export$13e3392192263954 = function(a, b, c) {
    return $262da1cc4b49014e$var$Z().useReducer(a, b, c);
};
$262da1cc4b49014e$export$b8f5890fc79d6aca = function(a) {
    return $262da1cc4b49014e$var$Z().useRef(a);
};
$262da1cc4b49014e$export$60241385465d0a34 = function(a) {
    return $262da1cc4b49014e$var$Z().useState(a);
};
$262da1cc4b49014e$export$83d89fbfd8236492 = "16.14.0";

});
parcelRequire.register("MsCOU", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $091ab02a1d1614d2$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $091ab02a1d1614d2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $091ab02a1d1614d2$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $091ab02a1d1614d2$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $091ab02a1d1614d2$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $091ab02a1d1614d2$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $091ab02a1d1614d2$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($091ab02a1d1614d2$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($091ab02a1d1614d2$var$getOwnPropertySymbols) {
            symbols = $091ab02a1d1614d2$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($091ab02a1d1614d2$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});




parcelRequire.register("aSly0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $7eafa965a8ae0190$export$2b8d127b894957b9, (v) => $7eafa965a8ae0190$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $7eafa965a8ae0190$export$cea3a54a6425200c, (v) => $7eafa965a8ae0190$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $7eafa965a8ae0190$export$a7c73072b1a182ae, (v) => $7eafa965a8ae0190$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $7eafa965a8ae0190$export$9f27bc3417b4524d, (v) => $7eafa965a8ae0190$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $7eafa965a8ae0190$export$db77ccec0bb4ccac, (v) => $7eafa965a8ae0190$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $7eafa965a8ae0190$export$8392c0c9d3dcbd35, (v) => $7eafa965a8ae0190$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $7eafa965a8ae0190$export$ffb0004e005737fa, (v) => $7eafa965a8ae0190$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $7eafa965a8ae0190$export$b624eff549462981, (v) => $7eafa965a8ae0190$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $7eafa965a8ae0190$export$7897aa7841a5380c, (v) => $7eafa965a8ae0190$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $7eafa965a8ae0190$export$602eac185826482c, (v) => $7eafa965a8ae0190$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $7eafa965a8ae0190$export$e2c29f18771995cb, (v) => $7eafa965a8ae0190$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $7eafa965a8ae0190$export$5f8d39834fd61797, (v) => $7eafa965a8ae0190$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7eafa965a8ae0190$export$74bf444e3cd11ea5, (v) => $7eafa965a8ae0190$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $7eafa965a8ae0190$export$92387174baf9b227, (v) => $7eafa965a8ae0190$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $7eafa965a8ae0190$export$ec112efeb987d9c6, (v) => $7eafa965a8ae0190$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $7eafa965a8ae0190$export$b706b080d889d2c9, (v) => $7eafa965a8ae0190$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $7eafa965a8ae0190$export$5be5a87408f70ddc, (v) => $7eafa965a8ae0190$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $7eafa965a8ae0190$export$45a5e7f76e0caa8d, (v) => $7eafa965a8ae0190$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $7eafa965a8ae0190$export$455c2e768291efa6, (v) => $7eafa965a8ae0190$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $7eafa965a8ae0190$export$9522e17588c12572, (v) => $7eafa965a8ae0190$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $7eafa965a8ae0190$export$2110ac352bb060b9, (v) => $7eafa965a8ae0190$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $7eafa965a8ae0190$export$56885ab8b9c456ab, (v) => $7eafa965a8ae0190$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $7eafa965a8ae0190$export$d927fcb6adf8f9de, (v) => $7eafa965a8ae0190$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $7eafa965a8ae0190$export$b82d16f27459e05a, (v) => $7eafa965a8ae0190$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $7eafa965a8ae0190$export$522c17b4f5e123e8, (v) => $7eafa965a8ae0190$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $7eafa965a8ae0190$export$1aabd8a0274ecfd6, (v) => $7eafa965a8ae0190$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $7eafa965a8ae0190$export$9b621391a187a31a, (v) => $7eafa965a8ae0190$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $7eafa965a8ae0190$export$f5bbd400c2f4426f, (v) => $7eafa965a8ae0190$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7eafa965a8ae0190$export$2b8d127b894957b9;
var $7eafa965a8ae0190$export$cea3a54a6425200c;
var $7eafa965a8ae0190$export$a7c73072b1a182ae;
var $7eafa965a8ae0190$export$9f27bc3417b4524d;
var $7eafa965a8ae0190$export$db77ccec0bb4ccac;
var $7eafa965a8ae0190$export$8392c0c9d3dcbd35;
var $7eafa965a8ae0190$export$ffb0004e005737fa;
var $7eafa965a8ae0190$export$b624eff549462981;
var $7eafa965a8ae0190$export$7897aa7841a5380c;
var $7eafa965a8ae0190$export$602eac185826482c;
var $7eafa965a8ae0190$export$e2c29f18771995cb;
var $7eafa965a8ae0190$export$5f8d39834fd61797;
var $7eafa965a8ae0190$export$74bf444e3cd11ea5;
var $7eafa965a8ae0190$export$92387174baf9b227;
var $7eafa965a8ae0190$export$ec112efeb987d9c6;
var $7eafa965a8ae0190$export$b706b080d889d2c9;
var $7eafa965a8ae0190$export$5be5a87408f70ddc;
var $7eafa965a8ae0190$export$45a5e7f76e0caa8d;
var $7eafa965a8ae0190$export$455c2e768291efa6;
var $7eafa965a8ae0190$export$9522e17588c12572;
var $7eafa965a8ae0190$export$2110ac352bb060b9;
var $7eafa965a8ae0190$export$56885ab8b9c456ab;
var $7eafa965a8ae0190$export$d927fcb6adf8f9de;
var $7eafa965a8ae0190$export$b82d16f27459e05a;
var $7eafa965a8ae0190$export$522c17b4f5e123e8;
var $7eafa965a8ae0190$export$1aabd8a0274ecfd6;
var $7eafa965a8ae0190$export$9b621391a187a31a;
var $7eafa965a8ae0190$export$f5bbd400c2f4426f;
"use strict";
var $7eafa965a8ae0190$var$b = "function" === typeof Symbol && Symbol.for, $7eafa965a8ae0190$var$c = $7eafa965a8ae0190$var$b ? Symbol.for("react.element") : 60103, $7eafa965a8ae0190$var$d = $7eafa965a8ae0190$var$b ? Symbol.for("react.portal") : 60106, $7eafa965a8ae0190$var$e = $7eafa965a8ae0190$var$b ? Symbol.for("react.fragment") : 60107, $7eafa965a8ae0190$var$f = $7eafa965a8ae0190$var$b ? Symbol.for("react.strict_mode") : 60108, $7eafa965a8ae0190$var$g = $7eafa965a8ae0190$var$b ? Symbol.for("react.profiler") : 60114, $7eafa965a8ae0190$var$h = $7eafa965a8ae0190$var$b ? Symbol.for("react.provider") : 60109, $7eafa965a8ae0190$var$k = $7eafa965a8ae0190$var$b ? Symbol.for("react.context") : 60110, $7eafa965a8ae0190$var$l = $7eafa965a8ae0190$var$b ? Symbol.for("react.async_mode") : 60111, $7eafa965a8ae0190$var$m = $7eafa965a8ae0190$var$b ? Symbol.for("react.concurrent_mode") : 60111, $7eafa965a8ae0190$var$n = $7eafa965a8ae0190$var$b ? Symbol.for("react.forward_ref") : 60112, $7eafa965a8ae0190$var$p = $7eafa965a8ae0190$var$b ? Symbol.for("react.suspense") : 60113, $7eafa965a8ae0190$var$q = $7eafa965a8ae0190$var$b ? Symbol.for("react.suspense_list") : 60120, $7eafa965a8ae0190$var$r = $7eafa965a8ae0190$var$b ? Symbol.for("react.memo") : 60115, $7eafa965a8ae0190$var$t = $7eafa965a8ae0190$var$b ? Symbol.for("react.lazy") : 60116, $7eafa965a8ae0190$var$v = $7eafa965a8ae0190$var$b ? Symbol.for("react.block") : 60121, $7eafa965a8ae0190$var$w = $7eafa965a8ae0190$var$b ? Symbol.for("react.fundamental") : 60117, $7eafa965a8ae0190$var$x = $7eafa965a8ae0190$var$b ? Symbol.for("react.responder") : 60118, $7eafa965a8ae0190$var$y = $7eafa965a8ae0190$var$b ? Symbol.for("react.scope") : 60119;
function $7eafa965a8ae0190$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $7eafa965a8ae0190$var$c:
                switch(a = a.type, a){
                    case $7eafa965a8ae0190$var$l:
                    case $7eafa965a8ae0190$var$m:
                    case $7eafa965a8ae0190$var$e:
                    case $7eafa965a8ae0190$var$g:
                    case $7eafa965a8ae0190$var$f:
                    case $7eafa965a8ae0190$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7eafa965a8ae0190$var$k:
                            case $7eafa965a8ae0190$var$n:
                            case $7eafa965a8ae0190$var$t:
                            case $7eafa965a8ae0190$var$r:
                            case $7eafa965a8ae0190$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $7eafa965a8ae0190$var$d:
                return u;
        }
    }
}
function $7eafa965a8ae0190$var$A(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$m;
}
$7eafa965a8ae0190$export$2b8d127b894957b9 = $7eafa965a8ae0190$var$l;
$7eafa965a8ae0190$export$cea3a54a6425200c = $7eafa965a8ae0190$var$m;
$7eafa965a8ae0190$export$a7c73072b1a182ae = $7eafa965a8ae0190$var$k;
$7eafa965a8ae0190$export$9f27bc3417b4524d = $7eafa965a8ae0190$var$h;
$7eafa965a8ae0190$export$db77ccec0bb4ccac = $7eafa965a8ae0190$var$c;
$7eafa965a8ae0190$export$8392c0c9d3dcbd35 = $7eafa965a8ae0190$var$n;
$7eafa965a8ae0190$export$ffb0004e005737fa = $7eafa965a8ae0190$var$e;
$7eafa965a8ae0190$export$b624eff549462981 = $7eafa965a8ae0190$var$t;
$7eafa965a8ae0190$export$7897aa7841a5380c = $7eafa965a8ae0190$var$r;
$7eafa965a8ae0190$export$602eac185826482c = $7eafa965a8ae0190$var$d;
$7eafa965a8ae0190$export$e2c29f18771995cb = $7eafa965a8ae0190$var$g;
$7eafa965a8ae0190$export$5f8d39834fd61797 = $7eafa965a8ae0190$var$f;
$7eafa965a8ae0190$export$74bf444e3cd11ea5 = $7eafa965a8ae0190$var$p;
$7eafa965a8ae0190$export$92387174baf9b227 = function(a) {
    return $7eafa965a8ae0190$var$A(a) || $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$l;
};
$7eafa965a8ae0190$export$ec112efeb987d9c6 = $7eafa965a8ae0190$var$A;
$7eafa965a8ae0190$export$b706b080d889d2c9 = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$k;
};
$7eafa965a8ae0190$export$5be5a87408f70ddc = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$h;
};
$7eafa965a8ae0190$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7eafa965a8ae0190$var$c;
};
$7eafa965a8ae0190$export$455c2e768291efa6 = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$n;
};
$7eafa965a8ae0190$export$9522e17588c12572 = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$e;
};
$7eafa965a8ae0190$export$2110ac352bb060b9 = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$t;
};
$7eafa965a8ae0190$export$56885ab8b9c456ab = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$r;
};
$7eafa965a8ae0190$export$d927fcb6adf8f9de = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$d;
};
$7eafa965a8ae0190$export$b82d16f27459e05a = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$g;
};
$7eafa965a8ae0190$export$522c17b4f5e123e8 = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$f;
};
$7eafa965a8ae0190$export$1aabd8a0274ecfd6 = function(a) {
    return $7eafa965a8ae0190$var$z(a) === $7eafa965a8ae0190$var$p;
};
$7eafa965a8ae0190$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7eafa965a8ae0190$var$e || a === $7eafa965a8ae0190$var$m || a === $7eafa965a8ae0190$var$g || a === $7eafa965a8ae0190$var$f || a === $7eafa965a8ae0190$var$p || a === $7eafa965a8ae0190$var$q || "object" === typeof a && null !== a && (a.$$typeof === $7eafa965a8ae0190$var$t || a.$$typeof === $7eafa965a8ae0190$var$r || a.$$typeof === $7eafa965a8ae0190$var$h || a.$$typeof === $7eafa965a8ae0190$var$k || a.$$typeof === $7eafa965a8ae0190$var$n || a.$$typeof === $7eafa965a8ae0190$var$w || a.$$typeof === $7eafa965a8ae0190$var$x || a.$$typeof === $7eafa965a8ae0190$var$y || a.$$typeof === $7eafa965a8ae0190$var$v);
};
$7eafa965a8ae0190$export$f5bbd400c2f4426f = $7eafa965a8ae0190$var$z;

});

parcelRequire.register("eGxVA", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $ab0f4e46668e4381$export$ae55be85d98224ed, (v) => $ab0f4e46668e4381$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $ab0f4e46668e4381$export$d39a5bbd09211389, (v) => $ab0f4e46668e4381$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "findDOMNode", () => $ab0f4e46668e4381$export$466bfc07425424d5, (v) => $ab0f4e46668e4381$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $ab0f4e46668e4381$export$cd75ccfd720a3cd4, (v) => $ab0f4e46668e4381$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $ab0f4e46668e4381$export$fa8d919ba61d84db, (v) => $ab0f4e46668e4381$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "render", () => $ab0f4e46668e4381$export$b3890eb0ae9dca99, (v) => $ab0f4e46668e4381$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $ab0f4e46668e4381$export$502457920280e6be, (v) => $ab0f4e46668e4381$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $ab0f4e46668e4381$export$c78a37762a8d58e1, (v) => $ab0f4e46668e4381$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_createPortal", () => $ab0f4e46668e4381$export$2577ef5d2565d52f, (v) => $ab0f4e46668e4381$export$2577ef5d2565d52f = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $ab0f4e46668e4381$export$dc54d992c10e8a18, (v) => $ab0f4e46668e4381$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $ab0f4e46668e4381$export$83d89fbfd8236492, (v) => $ab0f4e46668e4381$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $ab0f4e46668e4381$export$ae55be85d98224ed;
var $ab0f4e46668e4381$export$d39a5bbd09211389;
var $ab0f4e46668e4381$export$466bfc07425424d5;
var $ab0f4e46668e4381$export$cd75ccfd720a3cd4;
var $ab0f4e46668e4381$export$fa8d919ba61d84db;
var $ab0f4e46668e4381$export$b3890eb0ae9dca99;
var $ab0f4e46668e4381$export$502457920280e6be;
var $ab0f4e46668e4381$export$c78a37762a8d58e1;
var $ab0f4e46668e4381$export$2577ef5d2565d52f;
var $ab0f4e46668e4381$export$dc54d992c10e8a18;
var $ab0f4e46668e4381$export$83d89fbfd8236492;
"use strict";

var $5cNek = parcelRequire("5cNek");

var $MsCOU = parcelRequire("MsCOU");

var $5GQyf = parcelRequire("5GQyf");
function $ab0f4e46668e4381$var$u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$5cNek) throw Error($ab0f4e46668e4381$var$u(227));
function $ab0f4e46668e4381$var$ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $ab0f4e46668e4381$var$da = !1, $ab0f4e46668e4381$var$ea = null, $ab0f4e46668e4381$var$fa = !1, $ab0f4e46668e4381$var$ha = null, $ab0f4e46668e4381$var$ia = {
    onError: function(a) {
        $ab0f4e46668e4381$var$da = !0;
        $ab0f4e46668e4381$var$ea = a;
    }
};
function $ab0f4e46668e4381$var$ja(a, b, c, d, e, f, g, h, k) {
    $ab0f4e46668e4381$var$da = !1;
    $ab0f4e46668e4381$var$ea = null;
    $ab0f4e46668e4381$var$ba.apply($ab0f4e46668e4381$var$ia, arguments);
}
function $ab0f4e46668e4381$var$ka(a, b, c, d, e, f, g, h, k) {
    $ab0f4e46668e4381$var$ja.apply(this, arguments);
    if ($ab0f4e46668e4381$var$da) {
        if ($ab0f4e46668e4381$var$da) {
            var l = $ab0f4e46668e4381$var$ea;
            $ab0f4e46668e4381$var$da = !1;
            $ab0f4e46668e4381$var$ea = null;
        } else throw Error($ab0f4e46668e4381$var$u(198));
        $ab0f4e46668e4381$var$fa || ($ab0f4e46668e4381$var$fa = !0, $ab0f4e46668e4381$var$ha = l);
    }
}
var $ab0f4e46668e4381$var$la = null, $ab0f4e46668e4381$var$ma = null, $ab0f4e46668e4381$var$na = null;
function $ab0f4e46668e4381$var$oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $ab0f4e46668e4381$var$na(c);
    $ab0f4e46668e4381$var$ka(d, b, void 0, a);
    a.currentTarget = null;
}
var $ab0f4e46668e4381$var$pa = null, $ab0f4e46668e4381$var$qa = {};
function $ab0f4e46668e4381$var$ra() {
    if ($ab0f4e46668e4381$var$pa) for(var a in $ab0f4e46668e4381$var$qa){
        var b = $ab0f4e46668e4381$var$qa[a], c = $ab0f4e46668e4381$var$pa.indexOf(a);
        if (!(-1 < c)) throw Error($ab0f4e46668e4381$var$u(96, a));
        if (!$ab0f4e46668e4381$var$sa[c]) {
            if (!b.extractEvents) throw Error($ab0f4e46668e4381$var$u(97, a));
            $ab0f4e46668e4381$var$sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if ($ab0f4e46668e4381$var$ta.hasOwnProperty(h)) throw Error($ab0f4e46668e4381$var$u(99, h));
                $ab0f4e46668e4381$var$ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && $ab0f4e46668e4381$var$ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? ($ab0f4e46668e4381$var$ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error($ab0f4e46668e4381$var$u(98, d, a));
            }
        }
    }
}
function $ab0f4e46668e4381$var$ua(a, b, c) {
    if ($ab0f4e46668e4381$var$va[a]) throw Error($ab0f4e46668e4381$var$u(100, a));
    $ab0f4e46668e4381$var$va[a] = b;
    $ab0f4e46668e4381$var$wa[a] = b.eventTypes[c].dependencies;
}
var $ab0f4e46668e4381$var$sa = [], $ab0f4e46668e4381$var$ta = {}, $ab0f4e46668e4381$var$va = {}, $ab0f4e46668e4381$var$wa = {};
function $ab0f4e46668e4381$var$xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!$ab0f4e46668e4381$var$qa.hasOwnProperty(c) || $ab0f4e46668e4381$var$qa[c] !== d) {
            if ($ab0f4e46668e4381$var$qa[c]) throw Error($ab0f4e46668e4381$var$u(102, c));
            $ab0f4e46668e4381$var$qa[c] = d;
            b = !0;
        }
    }
    b && $ab0f4e46668e4381$var$ra();
}
var $ab0f4e46668e4381$var$ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $ab0f4e46668e4381$var$za = null, $ab0f4e46668e4381$var$Aa = null, $ab0f4e46668e4381$var$Ba = null;
function $ab0f4e46668e4381$var$Ca(a) {
    if (a = $ab0f4e46668e4381$var$ma(a)) {
        if ("function" !== typeof $ab0f4e46668e4381$var$za) throw Error($ab0f4e46668e4381$var$u(280));
        var b = a.stateNode;
        b && (b = $ab0f4e46668e4381$var$la(b), $ab0f4e46668e4381$var$za(a.stateNode, a.type, b));
    }
}
function $ab0f4e46668e4381$var$Da(a) {
    $ab0f4e46668e4381$var$Aa ? $ab0f4e46668e4381$var$Ba ? $ab0f4e46668e4381$var$Ba.push(a) : $ab0f4e46668e4381$var$Ba = [
        a
    ] : $ab0f4e46668e4381$var$Aa = a;
}
function $ab0f4e46668e4381$var$Ea() {
    if ($ab0f4e46668e4381$var$Aa) {
        var a = $ab0f4e46668e4381$var$Aa, b = $ab0f4e46668e4381$var$Ba;
        $ab0f4e46668e4381$var$Ba = $ab0f4e46668e4381$var$Aa = null;
        $ab0f4e46668e4381$var$Ca(a);
        if (b) for(a = 0; a < b.length; a++)$ab0f4e46668e4381$var$Ca(b[a]);
    }
}
function $ab0f4e46668e4381$var$Fa(a, b) {
    return a(b);
}
function $ab0f4e46668e4381$var$Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $ab0f4e46668e4381$var$Ha() {}
var $ab0f4e46668e4381$var$Ia = $ab0f4e46668e4381$var$Fa, $ab0f4e46668e4381$var$Ja = !1, $ab0f4e46668e4381$var$Ka = !1;
function $ab0f4e46668e4381$var$La() {
    if (null !== $ab0f4e46668e4381$var$Aa || null !== $ab0f4e46668e4381$var$Ba) $ab0f4e46668e4381$var$Ha(), $ab0f4e46668e4381$var$Ea();
}
function $ab0f4e46668e4381$var$Ma(a, b, c) {
    if ($ab0f4e46668e4381$var$Ka) return a(b, c);
    $ab0f4e46668e4381$var$Ka = !0;
    try {
        return $ab0f4e46668e4381$var$Ia(a, b, c);
    } finally{
        $ab0f4e46668e4381$var$Ka = !1, $ab0f4e46668e4381$var$La();
    }
}
var $ab0f4e46668e4381$var$Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $ab0f4e46668e4381$var$Oa = Object.prototype.hasOwnProperty, $ab0f4e46668e4381$var$Pa = {}, $ab0f4e46668e4381$var$Qa = {};
function $ab0f4e46668e4381$var$Ra(a) {
    if ($ab0f4e46668e4381$var$Oa.call($ab0f4e46668e4381$var$Qa, a)) return !0;
    if ($ab0f4e46668e4381$var$Oa.call($ab0f4e46668e4381$var$Pa, a)) return !1;
    if ($ab0f4e46668e4381$var$Na.test(a)) return $ab0f4e46668e4381$var$Qa[a] = !0;
    $ab0f4e46668e4381$var$Pa[a] = !0;
    return !1;
}
function $ab0f4e46668e4381$var$Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $ab0f4e46668e4381$var$Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $ab0f4e46668e4381$var$Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $ab0f4e46668e4381$var$v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var $ab0f4e46668e4381$var$C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $ab0f4e46668e4381$var$C[b] = new $ab0f4e46668e4381$var$v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 5, !1, a.toLowerCase(), null, !1);
});
var $ab0f4e46668e4381$var$Ua = /[\-:]([a-z])/g;
function $ab0f4e46668e4381$var$Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($ab0f4e46668e4381$var$Ua, $ab0f4e46668e4381$var$Va);
    $ab0f4e46668e4381$var$C[b] = new $ab0f4e46668e4381$var$v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($ab0f4e46668e4381$var$Ua, $ab0f4e46668e4381$var$Va);
    $ab0f4e46668e4381$var$C[b] = new $ab0f4e46668e4381$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($ab0f4e46668e4381$var$Ua, $ab0f4e46668e4381$var$Va);
    $ab0f4e46668e4381$var$C[b] = new $ab0f4e46668e4381$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 1, !1, a.toLowerCase(), null, !1);
});
$ab0f4e46668e4381$var$C.xlinkHref = new $ab0f4e46668e4381$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $ab0f4e46668e4381$var$C[a] = new $ab0f4e46668e4381$var$v(a, 1, !1, a.toLowerCase(), null, !0);
});
var $ab0f4e46668e4381$var$Wa = $5cNek.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$ab0f4e46668e4381$var$Wa.hasOwnProperty("ReactCurrentDispatcher") || ($ab0f4e46668e4381$var$Wa.ReactCurrentDispatcher = {
    current: null
});
$ab0f4e46668e4381$var$Wa.hasOwnProperty("ReactCurrentBatchConfig") || ($ab0f4e46668e4381$var$Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function $ab0f4e46668e4381$var$Xa(a, b, c, d) {
    var e = $ab0f4e46668e4381$var$C.hasOwnProperty(b) ? $ab0f4e46668e4381$var$C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($ab0f4e46668e4381$var$Ta(b, c, e, d) && (c = null), d || null === e ? $ab0f4e46668e4381$var$Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $ab0f4e46668e4381$var$Ya = /^(.*)[\\\/]/, $ab0f4e46668e4381$var$E = "function" === typeof Symbol && Symbol.for, $ab0f4e46668e4381$var$Za = $ab0f4e46668e4381$var$E ? Symbol.for("react.element") : 60103, $ab0f4e46668e4381$var$$a = $ab0f4e46668e4381$var$E ? Symbol.for("react.portal") : 60106, $ab0f4e46668e4381$var$ab = $ab0f4e46668e4381$var$E ? Symbol.for("react.fragment") : 60107, $ab0f4e46668e4381$var$bb = $ab0f4e46668e4381$var$E ? Symbol.for("react.strict_mode") : 60108, $ab0f4e46668e4381$var$cb = $ab0f4e46668e4381$var$E ? Symbol.for("react.profiler") : 60114, $ab0f4e46668e4381$var$db = $ab0f4e46668e4381$var$E ? Symbol.for("react.provider") : 60109, $ab0f4e46668e4381$var$eb = $ab0f4e46668e4381$var$E ? Symbol.for("react.context") : 60110, $ab0f4e46668e4381$var$fb = $ab0f4e46668e4381$var$E ? Symbol.for("react.concurrent_mode") : 60111, $ab0f4e46668e4381$var$gb = $ab0f4e46668e4381$var$E ? Symbol.for("react.forward_ref") : 60112, $ab0f4e46668e4381$var$hb = $ab0f4e46668e4381$var$E ? Symbol.for("react.suspense") : 60113, $ab0f4e46668e4381$var$ib = $ab0f4e46668e4381$var$E ? Symbol.for("react.suspense_list") : 60120, $ab0f4e46668e4381$var$jb = $ab0f4e46668e4381$var$E ? Symbol.for("react.memo") : 60115, $ab0f4e46668e4381$var$kb = $ab0f4e46668e4381$var$E ? Symbol.for("react.lazy") : 60116, $ab0f4e46668e4381$var$lb = $ab0f4e46668e4381$var$E ? Symbol.for("react.block") : 60121, $ab0f4e46668e4381$var$mb = "function" === typeof Symbol && Symbol.iterator;
function $ab0f4e46668e4381$var$nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ab0f4e46668e4381$var$mb && a[$ab0f4e46668e4381$var$mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $ab0f4e46668e4381$var$ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function $ab0f4e46668e4381$var$pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $ab0f4e46668e4381$var$ab:
            return "Fragment";
        case $ab0f4e46668e4381$var$$a:
            return "Portal";
        case $ab0f4e46668e4381$var$cb:
            return "Profiler";
        case $ab0f4e46668e4381$var$bb:
            return "StrictMode";
        case $ab0f4e46668e4381$var$hb:
            return "Suspense";
        case $ab0f4e46668e4381$var$ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $ab0f4e46668e4381$var$eb:
            return "Context.Consumer";
        case $ab0f4e46668e4381$var$db:
            return "Context.Provider";
        case $ab0f4e46668e4381$var$gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $ab0f4e46668e4381$var$jb:
            return $ab0f4e46668e4381$var$pb(a.type);
        case $ab0f4e46668e4381$var$lb:
            return $ab0f4e46668e4381$var$pb(a.render);
        case $ab0f4e46668e4381$var$kb:
            if (a = 1 === a._status ? a._result : null) return $ab0f4e46668e4381$var$pb(a);
    }
    return null;
}
function $ab0f4e46668e4381$var$qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = $ab0f4e46668e4381$var$pb(a.type);
                c = null;
                d && (c = $ab0f4e46668e4381$var$pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace($ab0f4e46668e4381$var$Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function $ab0f4e46668e4381$var$rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $ab0f4e46668e4381$var$sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $ab0f4e46668e4381$var$tb(a) {
    var b = $ab0f4e46668e4381$var$sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $ab0f4e46668e4381$var$xb(a) {
    a._valueTracker || (a._valueTracker = $ab0f4e46668e4381$var$tb(a));
}
function $ab0f4e46668e4381$var$yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $ab0f4e46668e4381$var$sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $ab0f4e46668e4381$var$zb(a, b) {
    var c = b.checked;
    return $MsCOU({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $ab0f4e46668e4381$var$Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $ab0f4e46668e4381$var$rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $ab0f4e46668e4381$var$Bb(a, b) {
    b = b.checked;
    null != b && $ab0f4e46668e4381$var$Xa(a, "checked", b, !1);
}
function $ab0f4e46668e4381$var$Cb(a, b) {
    $ab0f4e46668e4381$var$Bb(a, b);
    var c = $ab0f4e46668e4381$var$rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $ab0f4e46668e4381$var$Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && $ab0f4e46668e4381$var$Db(a, b.type, $ab0f4e46668e4381$var$rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $ab0f4e46668e4381$var$Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $ab0f4e46668e4381$var$Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $ab0f4e46668e4381$var$Fb(a) {
    var b = "";
    $5cNek.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $ab0f4e46668e4381$var$Gb(a, b) {
    a = $MsCOU({
        children: void 0
    }, b);
    if (b = $ab0f4e46668e4381$var$Fb(b.children)) a.children = b;
    return a;
}
function $ab0f4e46668e4381$var$Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $ab0f4e46668e4381$var$rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $ab0f4e46668e4381$var$Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($ab0f4e46668e4381$var$u(91));
    return $MsCOU({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $ab0f4e46668e4381$var$Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($ab0f4e46668e4381$var$u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($ab0f4e46668e4381$var$u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $ab0f4e46668e4381$var$rb(c)
    };
}
function $ab0f4e46668e4381$var$Kb(a, b) {
    var c = $ab0f4e46668e4381$var$rb(b.value), d = $ab0f4e46668e4381$var$rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $ab0f4e46668e4381$var$Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $ab0f4e46668e4381$var$Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $ab0f4e46668e4381$var$Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $ab0f4e46668e4381$var$Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $ab0f4e46668e4381$var$Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $ab0f4e46668e4381$var$Pb, $ab0f4e46668e4381$var$Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $ab0f4e46668e4381$var$Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $ab0f4e46668e4381$var$Pb = $ab0f4e46668e4381$var$Pb || document.createElement("div");
        $ab0f4e46668e4381$var$Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $ab0f4e46668e4381$var$Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $ab0f4e46668e4381$var$Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function $ab0f4e46668e4381$var$Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $ab0f4e46668e4381$var$Tb = {
    animationend: $ab0f4e46668e4381$var$Sb("Animation", "AnimationEnd"),
    animationiteration: $ab0f4e46668e4381$var$Sb("Animation", "AnimationIteration"),
    animationstart: $ab0f4e46668e4381$var$Sb("Animation", "AnimationStart"),
    transitionend: $ab0f4e46668e4381$var$Sb("Transition", "TransitionEnd")
}, $ab0f4e46668e4381$var$Ub = {}, $ab0f4e46668e4381$var$Vb = {};
$ab0f4e46668e4381$var$ya && ($ab0f4e46668e4381$var$Vb = document.createElement("div").style, "AnimationEvent" in window || (delete $ab0f4e46668e4381$var$Tb.animationend.animation, delete $ab0f4e46668e4381$var$Tb.animationiteration.animation, delete $ab0f4e46668e4381$var$Tb.animationstart.animation), "TransitionEvent" in window || delete $ab0f4e46668e4381$var$Tb.transitionend.transition);
function $ab0f4e46668e4381$var$Wb(a) {
    if ($ab0f4e46668e4381$var$Ub[a]) return $ab0f4e46668e4381$var$Ub[a];
    if (!$ab0f4e46668e4381$var$Tb[a]) return a;
    var b = $ab0f4e46668e4381$var$Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $ab0f4e46668e4381$var$Vb) return $ab0f4e46668e4381$var$Ub[a] = b[c];
    return a;
}
var $ab0f4e46668e4381$var$Xb = $ab0f4e46668e4381$var$Wb("animationend"), $ab0f4e46668e4381$var$Yb = $ab0f4e46668e4381$var$Wb("animationiteration"), $ab0f4e46668e4381$var$Zb = $ab0f4e46668e4381$var$Wb("animationstart"), $ab0f4e46668e4381$var$$b = $ab0f4e46668e4381$var$Wb("transitionend"), $ab0f4e46668e4381$var$ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $ab0f4e46668e4381$var$bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function $ab0f4e46668e4381$var$cc(a) {
    var b = $ab0f4e46668e4381$var$bc.get(a);
    void 0 === b && (b = new Map, $ab0f4e46668e4381$var$bc.set(a, b));
    return b;
}
function $ab0f4e46668e4381$var$dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $ab0f4e46668e4381$var$ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $ab0f4e46668e4381$var$fc(a) {
    if ($ab0f4e46668e4381$var$dc(a) !== a) throw Error($ab0f4e46668e4381$var$u(188));
}
function $ab0f4e46668e4381$var$gc(a) {
    var b = a.alternate;
    if (!b) {
        b = $ab0f4e46668e4381$var$dc(a);
        if (null === b) throw Error($ab0f4e46668e4381$var$u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $ab0f4e46668e4381$var$fc(e), a;
                if (f === d) return $ab0f4e46668e4381$var$fc(e), b;
                f = f.sibling;
            }
            throw Error($ab0f4e46668e4381$var$u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($ab0f4e46668e4381$var$u(189));
            }
        }
        if (c.alternate !== d) throw Error($ab0f4e46668e4381$var$u(190));
    }
    if (3 !== c.tag) throw Error($ab0f4e46668e4381$var$u(188));
    return c.stateNode.current === c ? a : b;
}
function $ab0f4e46668e4381$var$hc(a) {
    a = $ab0f4e46668e4381$var$gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $ab0f4e46668e4381$var$ic(a, b) {
    if (null == b) throw Error($ab0f4e46668e4381$var$u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function $ab0f4e46668e4381$var$jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var $ab0f4e46668e4381$var$kc = null;
function $ab0f4e46668e4381$var$lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)$ab0f4e46668e4381$var$oa(a, b[d], c[d]);
        else b && $ab0f4e46668e4381$var$oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function $ab0f4e46668e4381$var$mc(a) {
    null !== a && ($ab0f4e46668e4381$var$kc = $ab0f4e46668e4381$var$ic($ab0f4e46668e4381$var$kc, a));
    a = $ab0f4e46668e4381$var$kc;
    $ab0f4e46668e4381$var$kc = null;
    if (a) {
        $ab0f4e46668e4381$var$jc(a, $ab0f4e46668e4381$var$lc);
        if ($ab0f4e46668e4381$var$kc) throw Error($ab0f4e46668e4381$var$u(95));
        if ($ab0f4e46668e4381$var$fa) throw a = $ab0f4e46668e4381$var$ha, $ab0f4e46668e4381$var$fa = !1, $ab0f4e46668e4381$var$ha = null, a;
    }
}
function $ab0f4e46668e4381$var$nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function $ab0f4e46668e4381$var$oc(a) {
    if (!$ab0f4e46668e4381$var$ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var $ab0f4e46668e4381$var$pc = [];
function $ab0f4e46668e4381$var$qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > $ab0f4e46668e4381$var$pc.length && $ab0f4e46668e4381$var$pc.push(a);
}
function $ab0f4e46668e4381$var$rc(a, b, c, d) {
    if ($ab0f4e46668e4381$var$pc.length) {
        var e = $ab0f4e46668e4381$var$pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function $ab0f4e46668e4381$var$sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = $ab0f4e46668e4381$var$tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = $ab0f4e46668e4381$var$nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < $ab0f4e46668e4381$var$sa.length; k++){
            var l = $ab0f4e46668e4381$var$sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = $ab0f4e46668e4381$var$ic(h, l));
        }
        $ab0f4e46668e4381$var$mc(h);
    }
}
function $ab0f4e46668e4381$var$uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                $ab0f4e46668e4381$var$vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                $ab0f4e46668e4381$var$vc(b, "focus", !0);
                $ab0f4e46668e4381$var$vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                $ab0f4e46668e4381$var$oc(a) && $ab0f4e46668e4381$var$vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === $ab0f4e46668e4381$var$ac.indexOf(a) && $ab0f4e46668e4381$var$F(a, b);
        }
        c.set(a, null);
    }
}
var $ab0f4e46668e4381$var$wc, $ab0f4e46668e4381$var$xc, $ab0f4e46668e4381$var$yc, $ab0f4e46668e4381$var$zc = !1, $ab0f4e46668e4381$var$Ac = [], $ab0f4e46668e4381$var$Bc = null, $ab0f4e46668e4381$var$Cc = null, $ab0f4e46668e4381$var$Dc = null, $ab0f4e46668e4381$var$Ec = new Map, $ab0f4e46668e4381$var$Fc = new Map, $ab0f4e46668e4381$var$Gc = [], $ab0f4e46668e4381$var$Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), $ab0f4e46668e4381$var$Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function $ab0f4e46668e4381$var$Jc(a, b) {
    var c = $ab0f4e46668e4381$var$cc(b);
    $ab0f4e46668e4381$var$Hc.forEach(function(a) {
        $ab0f4e46668e4381$var$uc(a, b, c);
    });
    $ab0f4e46668e4381$var$Ic.forEach(function(a) {
        $ab0f4e46668e4381$var$uc(a, b, c);
    });
}
function $ab0f4e46668e4381$var$Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function $ab0f4e46668e4381$var$Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            $ab0f4e46668e4381$var$Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            $ab0f4e46668e4381$var$Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            $ab0f4e46668e4381$var$Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            $ab0f4e46668e4381$var$Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $ab0f4e46668e4381$var$Fc.delete(b.pointerId);
    }
}
function $ab0f4e46668e4381$var$Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $ab0f4e46668e4381$var$Kc(b, c, d, e, f), null !== b && (b = $ab0f4e46668e4381$var$Nc(b), null !== b && $ab0f4e46668e4381$var$xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function $ab0f4e46668e4381$var$Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return $ab0f4e46668e4381$var$Bc = $ab0f4e46668e4381$var$Mc($ab0f4e46668e4381$var$Bc, a, b, c, d, e), !0;
        case "dragenter":
            return $ab0f4e46668e4381$var$Cc = $ab0f4e46668e4381$var$Mc($ab0f4e46668e4381$var$Cc, a, b, c, d, e), !0;
        case "mouseover":
            return $ab0f4e46668e4381$var$Dc = $ab0f4e46668e4381$var$Mc($ab0f4e46668e4381$var$Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $ab0f4e46668e4381$var$Ec.set(f, $ab0f4e46668e4381$var$Mc($ab0f4e46668e4381$var$Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $ab0f4e46668e4381$var$Fc.set(f, $ab0f4e46668e4381$var$Mc($ab0f4e46668e4381$var$Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $ab0f4e46668e4381$var$Pc(a) {
    var b = $ab0f4e46668e4381$var$tc(a.target);
    if (null !== b) {
        var c = $ab0f4e46668e4381$var$dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $ab0f4e46668e4381$var$ec(c), null !== b) {
                    a.blockedOn = b;
                    $5GQyf.unstable_runWithPriority(a.priority, function() {
                        $ab0f4e46668e4381$var$yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $ab0f4e46668e4381$var$Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = $ab0f4e46668e4381$var$Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = $ab0f4e46668e4381$var$Nc(b);
        null !== c && $ab0f4e46668e4381$var$xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function $ab0f4e46668e4381$var$Sc(a, b, c) {
    $ab0f4e46668e4381$var$Qc(a) && c.delete(b);
}
function $ab0f4e46668e4381$var$Tc() {
    for($ab0f4e46668e4381$var$zc = !1; 0 < $ab0f4e46668e4381$var$Ac.length;){
        var a = $ab0f4e46668e4381$var$Ac[0];
        if (null !== a.blockedOn) {
            a = $ab0f4e46668e4381$var$Nc(a.blockedOn);
            null !== a && $ab0f4e46668e4381$var$wc(a);
            break;
        }
        var b = $ab0f4e46668e4381$var$Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : $ab0f4e46668e4381$var$Ac.shift();
    }
    null !== $ab0f4e46668e4381$var$Bc && $ab0f4e46668e4381$var$Qc($ab0f4e46668e4381$var$Bc) && ($ab0f4e46668e4381$var$Bc = null);
    null !== $ab0f4e46668e4381$var$Cc && $ab0f4e46668e4381$var$Qc($ab0f4e46668e4381$var$Cc) && ($ab0f4e46668e4381$var$Cc = null);
    null !== $ab0f4e46668e4381$var$Dc && $ab0f4e46668e4381$var$Qc($ab0f4e46668e4381$var$Dc) && ($ab0f4e46668e4381$var$Dc = null);
    $ab0f4e46668e4381$var$Ec.forEach($ab0f4e46668e4381$var$Sc);
    $ab0f4e46668e4381$var$Fc.forEach($ab0f4e46668e4381$var$Sc);
}
function $ab0f4e46668e4381$var$Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $ab0f4e46668e4381$var$zc || ($ab0f4e46668e4381$var$zc = !0, $5GQyf.unstable_scheduleCallback($5GQyf.unstable_NormalPriority, $ab0f4e46668e4381$var$Tc)));
}
function $ab0f4e46668e4381$var$Vc(a) {
    function b(b) {
        return $ab0f4e46668e4381$var$Uc(b, a);
    }
    if (0 < $ab0f4e46668e4381$var$Ac.length) {
        $ab0f4e46668e4381$var$Uc($ab0f4e46668e4381$var$Ac[0], a);
        for(var c = 1; c < $ab0f4e46668e4381$var$Ac.length; c++){
            var d = $ab0f4e46668e4381$var$Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $ab0f4e46668e4381$var$Bc && $ab0f4e46668e4381$var$Uc($ab0f4e46668e4381$var$Bc, a);
    null !== $ab0f4e46668e4381$var$Cc && $ab0f4e46668e4381$var$Uc($ab0f4e46668e4381$var$Cc, a);
    null !== $ab0f4e46668e4381$var$Dc && $ab0f4e46668e4381$var$Uc($ab0f4e46668e4381$var$Dc, a);
    $ab0f4e46668e4381$var$Ec.forEach(b);
    $ab0f4e46668e4381$var$Fc.forEach(b);
    for(c = 0; c < $ab0f4e46668e4381$var$Gc.length; c++)d = $ab0f4e46668e4381$var$Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $ab0f4e46668e4381$var$Gc.length && (c = $ab0f4e46668e4381$var$Gc[0], null === c.blockedOn);)$ab0f4e46668e4381$var$Pc(c), null === c.blockedOn && $ab0f4e46668e4381$var$Gc.shift();
}
var $ab0f4e46668e4381$var$Wc = {}, $ab0f4e46668e4381$var$Yc = new Map, $ab0f4e46668e4381$var$Zc = new Map, $ab0f4e46668e4381$var$$c = [
    "abort",
    "abort",
    $ab0f4e46668e4381$var$Xb,
    "animationEnd",
    $ab0f4e46668e4381$var$Yb,
    "animationIteration",
    $ab0f4e46668e4381$var$Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $ab0f4e46668e4381$var$$b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $ab0f4e46668e4381$var$ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        $ab0f4e46668e4381$var$Zc.set(d, b);
        $ab0f4e46668e4381$var$Yc.set(d, f);
        $ab0f4e46668e4381$var$Wc[e] = f;
    }
}
$ab0f4e46668e4381$var$ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$ab0f4e46668e4381$var$ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$ab0f4e46668e4381$var$ad($ab0f4e46668e4381$var$$c, 2);
for(var $ab0f4e46668e4381$var$bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $ab0f4e46668e4381$var$cd = 0; $ab0f4e46668e4381$var$cd < $ab0f4e46668e4381$var$bd.length; $ab0f4e46668e4381$var$cd++)$ab0f4e46668e4381$var$Zc.set($ab0f4e46668e4381$var$bd[$ab0f4e46668e4381$var$cd], 0);
var $ab0f4e46668e4381$var$dd = $5GQyf.unstable_UserBlockingPriority, $ab0f4e46668e4381$var$ed = $5GQyf.unstable_runWithPriority, $ab0f4e46668e4381$var$fd = !0;
function $ab0f4e46668e4381$var$F(a, b) {
    $ab0f4e46668e4381$var$vc(b, a, !1);
}
function $ab0f4e46668e4381$var$vc(a, b, c) {
    var d = $ab0f4e46668e4381$var$Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = $ab0f4e46668e4381$var$gd.bind(null, b, 1, a);
            break;
        case 1:
            d = $ab0f4e46668e4381$var$hd.bind(null, b, 1, a);
            break;
        default:
            d = $ab0f4e46668e4381$var$id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function $ab0f4e46668e4381$var$gd(a, b, c, d) {
    $ab0f4e46668e4381$var$Ja || $ab0f4e46668e4381$var$Ha();
    var e = $ab0f4e46668e4381$var$id, f = $ab0f4e46668e4381$var$Ja;
    $ab0f4e46668e4381$var$Ja = !0;
    try {
        $ab0f4e46668e4381$var$Ga(e, a, b, c, d);
    } finally{
        ($ab0f4e46668e4381$var$Ja = f) || $ab0f4e46668e4381$var$La();
    }
}
function $ab0f4e46668e4381$var$hd(a, b, c, d) {
    $ab0f4e46668e4381$var$ed($ab0f4e46668e4381$var$dd, $ab0f4e46668e4381$var$id.bind(null, a, b, c, d));
}
function $ab0f4e46668e4381$var$id(a, b, c, d) {
    if ($ab0f4e46668e4381$var$fd) {
        if (0 < $ab0f4e46668e4381$var$Ac.length && -1 < $ab0f4e46668e4381$var$Hc.indexOf(a)) a = $ab0f4e46668e4381$var$Kc(null, a, b, c, d), $ab0f4e46668e4381$var$Ac.push(a);
        else {
            var e = $ab0f4e46668e4381$var$Rc(a, b, c, d);
            if (null === e) $ab0f4e46668e4381$var$Lc(a, d);
            else if (-1 < $ab0f4e46668e4381$var$Hc.indexOf(a)) a = $ab0f4e46668e4381$var$Kc(e, a, b, c, d), $ab0f4e46668e4381$var$Ac.push(a);
            else if (!$ab0f4e46668e4381$var$Oc(e, a, b, c, d)) {
                $ab0f4e46668e4381$var$Lc(a, d);
                a = $ab0f4e46668e4381$var$rc(a, d, null, b);
                try {
                    $ab0f4e46668e4381$var$Ma($ab0f4e46668e4381$var$sc, a);
                } finally{
                    $ab0f4e46668e4381$var$qc(a);
                }
            }
        }
    }
}
function $ab0f4e46668e4381$var$Rc(a, b, c, d) {
    c = $ab0f4e46668e4381$var$nc(d);
    c = $ab0f4e46668e4381$var$tc(c);
    if (null !== c) {
        var e = $ab0f4e46668e4381$var$dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = $ab0f4e46668e4381$var$ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = $ab0f4e46668e4381$var$rc(a, d, c, b);
    try {
        $ab0f4e46668e4381$var$Ma($ab0f4e46668e4381$var$sc, a);
    } finally{
        $ab0f4e46668e4381$var$qc(a);
    }
    return null;
}
var $ab0f4e46668e4381$var$jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $ab0f4e46668e4381$var$kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($ab0f4e46668e4381$var$jd).forEach(function(a) {
    $ab0f4e46668e4381$var$kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $ab0f4e46668e4381$var$jd[b] = $ab0f4e46668e4381$var$jd[a];
    });
});
function $ab0f4e46668e4381$var$ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $ab0f4e46668e4381$var$jd.hasOwnProperty(a) && $ab0f4e46668e4381$var$jd[a] ? ("" + b).trim() : b + "px";
}
function $ab0f4e46668e4381$var$md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $ab0f4e46668e4381$var$ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $ab0f4e46668e4381$var$nd = $MsCOU({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $ab0f4e46668e4381$var$od(a, b) {
    if (b) {
        if ($ab0f4e46668e4381$var$nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($ab0f4e46668e4381$var$u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($ab0f4e46668e4381$var$u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($ab0f4e46668e4381$var$u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($ab0f4e46668e4381$var$u(62, ""));
    }
}
function $ab0f4e46668e4381$var$pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $ab0f4e46668e4381$var$qd = $ab0f4e46668e4381$var$Mb.html;
function $ab0f4e46668e4381$var$rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = $ab0f4e46668e4381$var$cc(a);
    b = $ab0f4e46668e4381$var$wa[b];
    for(var d = 0; d < b.length; d++)$ab0f4e46668e4381$var$uc(b[d], a, c);
}
function $ab0f4e46668e4381$var$sd() {}
function $ab0f4e46668e4381$var$td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $ab0f4e46668e4381$var$ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $ab0f4e46668e4381$var$vd(a, b) {
    var c = $ab0f4e46668e4381$var$ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $ab0f4e46668e4381$var$ud(c);
    }
}
function $ab0f4e46668e4381$var$wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $ab0f4e46668e4381$var$wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $ab0f4e46668e4381$var$xd() {
    for(var a = window, b = $ab0f4e46668e4381$var$td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $ab0f4e46668e4381$var$td(a.document);
    }
    return b;
}
function $ab0f4e46668e4381$var$yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $ab0f4e46668e4381$var$zd = "$", $ab0f4e46668e4381$var$Ad = "/$", $ab0f4e46668e4381$var$Bd = "$?", $ab0f4e46668e4381$var$Cd = "$!", $ab0f4e46668e4381$var$Dd = null, $ab0f4e46668e4381$var$Ed = null;
function $ab0f4e46668e4381$var$Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $ab0f4e46668e4381$var$Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $ab0f4e46668e4381$var$Hd = "function" === typeof setTimeout ? setTimeout : void 0, $ab0f4e46668e4381$var$Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $ab0f4e46668e4381$var$Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $ab0f4e46668e4381$var$Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === $ab0f4e46668e4381$var$zd || c === $ab0f4e46668e4381$var$Cd || c === $ab0f4e46668e4381$var$Bd) {
                if (0 === b) return a;
                b--;
            } else c === $ab0f4e46668e4381$var$Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $ab0f4e46668e4381$var$Ld = Math.random().toString(36).slice(2), $ab0f4e46668e4381$var$Md = "__reactInternalInstance$" + $ab0f4e46668e4381$var$Ld, $ab0f4e46668e4381$var$Nd = "__reactEventHandlers$" + $ab0f4e46668e4381$var$Ld, $ab0f4e46668e4381$var$Od = "__reactContainere$" + $ab0f4e46668e4381$var$Ld;
function $ab0f4e46668e4381$var$tc(a) {
    var b = a[$ab0f4e46668e4381$var$Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$ab0f4e46668e4381$var$Od] || c[$ab0f4e46668e4381$var$Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $ab0f4e46668e4381$var$Kd(a); null !== a;){
                if (c = a[$ab0f4e46668e4381$var$Md]) return c;
                a = $ab0f4e46668e4381$var$Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $ab0f4e46668e4381$var$Nc(a) {
    a = a[$ab0f4e46668e4381$var$Md] || a[$ab0f4e46668e4381$var$Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $ab0f4e46668e4381$var$Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($ab0f4e46668e4381$var$u(33));
}
function $ab0f4e46668e4381$var$Qd(a) {
    return a[$ab0f4e46668e4381$var$Nd] || null;
}
function $ab0f4e46668e4381$var$Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $ab0f4e46668e4381$var$Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $ab0f4e46668e4381$var$la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($ab0f4e46668e4381$var$u(231, b, typeof c));
    return c;
}
function $ab0f4e46668e4381$var$Td(a, b, c) {
    if (b = $ab0f4e46668e4381$var$Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = $ab0f4e46668e4381$var$ic(c._dispatchListeners, b), c._dispatchInstances = $ab0f4e46668e4381$var$ic(c._dispatchInstances, a);
}
function $ab0f4e46668e4381$var$Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = $ab0f4e46668e4381$var$Rd(b);
        for(b = c.length; 0 < b--;)$ab0f4e46668e4381$var$Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)$ab0f4e46668e4381$var$Td(c[b], "bubbled", a);
    }
}
function $ab0f4e46668e4381$var$Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = $ab0f4e46668e4381$var$Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = $ab0f4e46668e4381$var$ic(c._dispatchListeners, b), c._dispatchInstances = $ab0f4e46668e4381$var$ic(c._dispatchInstances, a));
}
function $ab0f4e46668e4381$var$Wd(a) {
    a && a.dispatchConfig.registrationName && $ab0f4e46668e4381$var$Vd(a._targetInst, null, a);
}
function $ab0f4e46668e4381$var$Xd(a) {
    $ab0f4e46668e4381$var$jc(a, $ab0f4e46668e4381$var$Ud);
}
var $ab0f4e46668e4381$var$Yd = null, $ab0f4e46668e4381$var$Zd = null, $ab0f4e46668e4381$var$$d = null;
function $ab0f4e46668e4381$var$ae() {
    if ($ab0f4e46668e4381$var$$d) return $ab0f4e46668e4381$var$$d;
    var a, b = $ab0f4e46668e4381$var$Zd, c = b.length, d, e = "value" in $ab0f4e46668e4381$var$Yd ? $ab0f4e46668e4381$var$Yd.value : $ab0f4e46668e4381$var$Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $ab0f4e46668e4381$var$$d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $ab0f4e46668e4381$var$be() {
    return !0;
}
function $ab0f4e46668e4381$var$ce() {
    return !1;
}
function $ab0f4e46668e4381$var$G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $ab0f4e46668e4381$var$be : $ab0f4e46668e4381$var$ce;
    this.isPropagationStopped = $ab0f4e46668e4381$var$ce;
    return this;
}
$MsCOU($ab0f4e46668e4381$var$G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $ab0f4e46668e4381$var$be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $ab0f4e46668e4381$var$be);
    },
    persist: function() {
        this.isPersistent = $ab0f4e46668e4381$var$be;
    },
    isPersistent: $ab0f4e46668e4381$var$ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = $ab0f4e46668e4381$var$ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
$ab0f4e46668e4381$var$G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
$ab0f4e46668e4381$var$G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $MsCOU(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $MsCOU({}, d.Interface, a);
    c.extend = d.extend;
    $ab0f4e46668e4381$var$de(c);
    return c;
};
$ab0f4e46668e4381$var$de($ab0f4e46668e4381$var$G);
function $ab0f4e46668e4381$var$ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function $ab0f4e46668e4381$var$fe(a) {
    if (!(a instanceof this)) throw Error($ab0f4e46668e4381$var$u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function $ab0f4e46668e4381$var$de(a) {
    a.eventPool = [];
    a.getPooled = $ab0f4e46668e4381$var$ee;
    a.release = $ab0f4e46668e4381$var$fe;
}
var $ab0f4e46668e4381$var$ge = $ab0f4e46668e4381$var$G.extend({
    data: null
}), $ab0f4e46668e4381$var$he = $ab0f4e46668e4381$var$G.extend({
    data: null
}), $ab0f4e46668e4381$var$ie = [
    9,
    13,
    27,
    32
], $ab0f4e46668e4381$var$je = $ab0f4e46668e4381$var$ya && "CompositionEvent" in window, $ab0f4e46668e4381$var$ke = null;
$ab0f4e46668e4381$var$ya && "documentMode" in document && ($ab0f4e46668e4381$var$ke = document.documentMode);
var $ab0f4e46668e4381$var$le = $ab0f4e46668e4381$var$ya && "TextEvent" in window && !$ab0f4e46668e4381$var$ke, $ab0f4e46668e4381$var$me = $ab0f4e46668e4381$var$ya && (!$ab0f4e46668e4381$var$je || $ab0f4e46668e4381$var$ke && 8 < $ab0f4e46668e4381$var$ke && 11 >= $ab0f4e46668e4381$var$ke), $ab0f4e46668e4381$var$ne = String.fromCharCode(32), $ab0f4e46668e4381$var$oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, $ab0f4e46668e4381$var$pe = !1;
function $ab0f4e46668e4381$var$qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $ab0f4e46668e4381$var$ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function $ab0f4e46668e4381$var$re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $ab0f4e46668e4381$var$se = !1;
function $ab0f4e46668e4381$var$te(a, b) {
    switch(a){
        case "compositionend":
            return $ab0f4e46668e4381$var$re(b);
        case "keypress":
            if (32 !== b.which) return null;
            $ab0f4e46668e4381$var$pe = !0;
            return $ab0f4e46668e4381$var$ne;
        case "textInput":
            return a = b.data, a === $ab0f4e46668e4381$var$ne && $ab0f4e46668e4381$var$pe ? null : a;
        default:
            return null;
    }
}
function $ab0f4e46668e4381$var$ue(a, b) {
    if ($ab0f4e46668e4381$var$se) return "compositionend" === a || !$ab0f4e46668e4381$var$je && $ab0f4e46668e4381$var$qe(a, b) ? (a = $ab0f4e46668e4381$var$ae(), $ab0f4e46668e4381$var$$d = $ab0f4e46668e4381$var$Zd = $ab0f4e46668e4381$var$Yd = null, $ab0f4e46668e4381$var$se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $ab0f4e46668e4381$var$me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $ab0f4e46668e4381$var$ve = {
    eventTypes: $ab0f4e46668e4381$var$oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if ($ab0f4e46668e4381$var$je) b: {
            switch(a){
                case "compositionstart":
                    var f = $ab0f4e46668e4381$var$oe.compositionStart;
                    break b;
                case "compositionend":
                    f = $ab0f4e46668e4381$var$oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = $ab0f4e46668e4381$var$oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else $ab0f4e46668e4381$var$se ? $ab0f4e46668e4381$var$qe(a, c) && (f = $ab0f4e46668e4381$var$oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = $ab0f4e46668e4381$var$oe.compositionStart);
        f ? ($ab0f4e46668e4381$var$me && "ko" !== c.locale && ($ab0f4e46668e4381$var$se || f !== $ab0f4e46668e4381$var$oe.compositionStart ? f === $ab0f4e46668e4381$var$oe.compositionEnd && $ab0f4e46668e4381$var$se && (e = $ab0f4e46668e4381$var$ae()) : ($ab0f4e46668e4381$var$Yd = d, $ab0f4e46668e4381$var$Zd = "value" in $ab0f4e46668e4381$var$Yd ? $ab0f4e46668e4381$var$Yd.value : $ab0f4e46668e4381$var$Yd.textContent, $ab0f4e46668e4381$var$se = !0)), f = $ab0f4e46668e4381$var$ge.getPooled(f, b, c, d), e ? f.data = e : (e = $ab0f4e46668e4381$var$re(c), null !== e && (f.data = e)), $ab0f4e46668e4381$var$Xd(f), e = f) : e = null;
        (a = $ab0f4e46668e4381$var$le ? $ab0f4e46668e4381$var$te(a, c) : $ab0f4e46668e4381$var$ue(a, c)) ? (b = $ab0f4e46668e4381$var$he.getPooled($ab0f4e46668e4381$var$oe.beforeInput, b, c, d), b.data = a, $ab0f4e46668e4381$var$Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, $ab0f4e46668e4381$var$we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $ab0f4e46668e4381$var$xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$ab0f4e46668e4381$var$we[a.type] : "textarea" === b ? !0 : !1;
}
var $ab0f4e46668e4381$var$ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function $ab0f4e46668e4381$var$ze(a, b, c) {
    a = $ab0f4e46668e4381$var$G.getPooled($ab0f4e46668e4381$var$ye.change, a, b, c);
    a.type = "change";
    $ab0f4e46668e4381$var$Da(c);
    $ab0f4e46668e4381$var$Xd(a);
    return a;
}
var $ab0f4e46668e4381$var$Ae = null, $ab0f4e46668e4381$var$Be = null;
function $ab0f4e46668e4381$var$Ce(a) {
    $ab0f4e46668e4381$var$mc(a);
}
function $ab0f4e46668e4381$var$De(a) {
    var b = $ab0f4e46668e4381$var$Pd(a);
    if ($ab0f4e46668e4381$var$yb(b)) return a;
}
function $ab0f4e46668e4381$var$Ee(a, b) {
    if ("change" === a) return b;
}
var $ab0f4e46668e4381$var$Fe = !1;
$ab0f4e46668e4381$var$ya && ($ab0f4e46668e4381$var$Fe = $ab0f4e46668e4381$var$oc("input") && (!document.documentMode || 9 < document.documentMode));
function $ab0f4e46668e4381$var$Ge() {
    $ab0f4e46668e4381$var$Ae && ($ab0f4e46668e4381$var$Ae.detachEvent("onpropertychange", $ab0f4e46668e4381$var$He), $ab0f4e46668e4381$var$Be = $ab0f4e46668e4381$var$Ae = null);
}
function $ab0f4e46668e4381$var$He(a) {
    if ("value" === a.propertyName && $ab0f4e46668e4381$var$De($ab0f4e46668e4381$var$Be)) {
        if (a = $ab0f4e46668e4381$var$ze($ab0f4e46668e4381$var$Be, a, $ab0f4e46668e4381$var$nc(a)), $ab0f4e46668e4381$var$Ja) $ab0f4e46668e4381$var$mc(a);
        else {
            $ab0f4e46668e4381$var$Ja = !0;
            try {
                $ab0f4e46668e4381$var$Fa($ab0f4e46668e4381$var$Ce, a);
            } finally{
                $ab0f4e46668e4381$var$Ja = !1, $ab0f4e46668e4381$var$La();
            }
        }
    }
}
function $ab0f4e46668e4381$var$Ie(a, b, c) {
    "focus" === a ? ($ab0f4e46668e4381$var$Ge(), $ab0f4e46668e4381$var$Ae = b, $ab0f4e46668e4381$var$Be = c, $ab0f4e46668e4381$var$Ae.attachEvent("onpropertychange", $ab0f4e46668e4381$var$He)) : "blur" === a && $ab0f4e46668e4381$var$Ge();
}
function $ab0f4e46668e4381$var$Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $ab0f4e46668e4381$var$De($ab0f4e46668e4381$var$Be);
}
function $ab0f4e46668e4381$var$Ke(a, b) {
    if ("click" === a) return $ab0f4e46668e4381$var$De(b);
}
function $ab0f4e46668e4381$var$Le(a, b) {
    if ("input" === a || "change" === a) return $ab0f4e46668e4381$var$De(b);
}
var $ab0f4e46668e4381$var$Me = {
    eventTypes: $ab0f4e46668e4381$var$ye,
    _isInputEventSupported: $ab0f4e46668e4381$var$Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? $ab0f4e46668e4381$var$Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = $ab0f4e46668e4381$var$Ee;
        else if ($ab0f4e46668e4381$var$xe(e)) {
            if ($ab0f4e46668e4381$var$Fe) g = $ab0f4e46668e4381$var$Le;
            else {
                g = $ab0f4e46668e4381$var$Je;
                var h = $ab0f4e46668e4381$var$Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = $ab0f4e46668e4381$var$Ke);
        if (g && (g = g(a, b))) return $ab0f4e46668e4381$var$ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && $ab0f4e46668e4381$var$Db(e, "number", e.value);
    }
}, $ab0f4e46668e4381$var$Ne = $ab0f4e46668e4381$var$G.extend({
    view: null,
    detail: null
}), $ab0f4e46668e4381$var$Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $ab0f4e46668e4381$var$Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $ab0f4e46668e4381$var$Oe[a]) ? !!b[a] : !1;
}
function $ab0f4e46668e4381$var$Qe() {
    return $ab0f4e46668e4381$var$Pe;
}
var $ab0f4e46668e4381$var$Re = 0, $ab0f4e46668e4381$var$Se = 0, $ab0f4e46668e4381$var$Te = !1, $ab0f4e46668e4381$var$Ue = !1, $ab0f4e46668e4381$var$Ve = $ab0f4e46668e4381$var$Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $ab0f4e46668e4381$var$Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = $ab0f4e46668e4381$var$Re;
        $ab0f4e46668e4381$var$Re = a.screenX;
        return $ab0f4e46668e4381$var$Te ? "mousemove" === a.type ? a.screenX - b : 0 : ($ab0f4e46668e4381$var$Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = $ab0f4e46668e4381$var$Se;
        $ab0f4e46668e4381$var$Se = a.screenY;
        return $ab0f4e46668e4381$var$Ue ? "mousemove" === a.type ? a.screenY - b : 0 : ($ab0f4e46668e4381$var$Ue = !0, 0);
    }
}), $ab0f4e46668e4381$var$We = $ab0f4e46668e4381$var$Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), $ab0f4e46668e4381$var$Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, $ab0f4e46668e4381$var$Ye = {
    eventTypes: $ab0f4e46668e4381$var$Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? $ab0f4e46668e4381$var$tc(b) : null, null !== b) {
                var h = $ab0f4e46668e4381$var$dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = $ab0f4e46668e4381$var$Ve;
            var l = $ab0f4e46668e4381$var$Xe.mouseLeave;
            var m = $ab0f4e46668e4381$var$Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = $ab0f4e46668e4381$var$We, l = $ab0f4e46668e4381$var$Xe.pointerLeave, m = $ab0f4e46668e4381$var$Xe.pointerEnter, p = "pointer";
        a = null == g ? f : $ab0f4e46668e4381$var$Pd(g);
        f = null == b ? f : $ab0f4e46668e4381$var$Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = $ab0f4e46668e4381$var$Rd(a))g++;
            a = 0;
            for(b = m; b; b = $ab0f4e46668e4381$var$Rd(b))a++;
            for(; 0 < g - a;)k = $ab0f4e46668e4381$var$Rd(k), g--;
            for(; 0 < a - g;)m = $ab0f4e46668e4381$var$Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = $ab0f4e46668e4381$var$Rd(k);
                m = $ab0f4e46668e4381$var$Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = $ab0f4e46668e4381$var$Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = $ab0f4e46668e4381$var$Rd(p);
        }
        for(p = 0; p < k.length; p++)$ab0f4e46668e4381$var$Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)$ab0f4e46668e4381$var$Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function $ab0f4e46668e4381$var$Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ab0f4e46668e4381$var$$e = "function" === typeof Object.is ? Object.is : $ab0f4e46668e4381$var$Ze, $ab0f4e46668e4381$var$af = Object.prototype.hasOwnProperty;
function $ab0f4e46668e4381$var$bf(a, b) {
    if ($ab0f4e46668e4381$var$$e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$ab0f4e46668e4381$var$af.call(b, c[d]) || !$ab0f4e46668e4381$var$$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var $ab0f4e46668e4381$var$cf = $ab0f4e46668e4381$var$ya && "documentMode" in document && 11 >= document.documentMode, $ab0f4e46668e4381$var$df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, $ab0f4e46668e4381$var$ef = null, $ab0f4e46668e4381$var$ff = null, $ab0f4e46668e4381$var$gf = null, $ab0f4e46668e4381$var$hf = !1;
function $ab0f4e46668e4381$var$jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if ($ab0f4e46668e4381$var$hf || null == $ab0f4e46668e4381$var$ef || $ab0f4e46668e4381$var$ef !== $ab0f4e46668e4381$var$td(c)) return null;
    c = $ab0f4e46668e4381$var$ef;
    "selectionStart" in c && $ab0f4e46668e4381$var$yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return $ab0f4e46668e4381$var$gf && $ab0f4e46668e4381$var$bf($ab0f4e46668e4381$var$gf, c) ? null : ($ab0f4e46668e4381$var$gf = c, a = $ab0f4e46668e4381$var$G.getPooled($ab0f4e46668e4381$var$df.select, $ab0f4e46668e4381$var$ff, a, b), a.type = "select", a.target = $ab0f4e46668e4381$var$ef, $ab0f4e46668e4381$var$Xd(a), a);
}
var $ab0f4e46668e4381$var$kf = {
    eventTypes: $ab0f4e46668e4381$var$df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = $ab0f4e46668e4381$var$cc(e);
                f = $ab0f4e46668e4381$var$wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? $ab0f4e46668e4381$var$Pd(b) : window;
        switch(a){
            case "focus":
                if ($ab0f4e46668e4381$var$xe(e) || "true" === e.contentEditable) $ab0f4e46668e4381$var$ef = e, $ab0f4e46668e4381$var$ff = b, $ab0f4e46668e4381$var$gf = null;
                break;
            case "blur":
                $ab0f4e46668e4381$var$gf = $ab0f4e46668e4381$var$ff = $ab0f4e46668e4381$var$ef = null;
                break;
            case "mousedown":
                $ab0f4e46668e4381$var$hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return $ab0f4e46668e4381$var$hf = !1, $ab0f4e46668e4381$var$jf(c, d);
            case "selectionchange":
                if ($ab0f4e46668e4381$var$cf) break;
            case "keydown":
            case "keyup":
                return $ab0f4e46668e4381$var$jf(c, d);
        }
        return null;
    }
}, $ab0f4e46668e4381$var$lf = $ab0f4e46668e4381$var$G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), $ab0f4e46668e4381$var$mf = $ab0f4e46668e4381$var$G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $ab0f4e46668e4381$var$nf = $ab0f4e46668e4381$var$Ne.extend({
    relatedTarget: null
});
function $ab0f4e46668e4381$var$of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var $ab0f4e46668e4381$var$pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $ab0f4e46668e4381$var$qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $ab0f4e46668e4381$var$rf = $ab0f4e46668e4381$var$Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = $ab0f4e46668e4381$var$pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $ab0f4e46668e4381$var$of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $ab0f4e46668e4381$var$qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $ab0f4e46668e4381$var$Qe,
    charCode: function(a) {
        return "keypress" === a.type ? $ab0f4e46668e4381$var$of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $ab0f4e46668e4381$var$of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $ab0f4e46668e4381$var$sf = $ab0f4e46668e4381$var$Ve.extend({
    dataTransfer: null
}), $ab0f4e46668e4381$var$tf = $ab0f4e46668e4381$var$Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $ab0f4e46668e4381$var$Qe
}), $ab0f4e46668e4381$var$uf = $ab0f4e46668e4381$var$G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), $ab0f4e46668e4381$var$vf = $ab0f4e46668e4381$var$Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), $ab0f4e46668e4381$var$wf = {
    eventTypes: $ab0f4e46668e4381$var$Wc,
    extractEvents: function(a, b, c, d) {
        var e = $ab0f4e46668e4381$var$Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === $ab0f4e46668e4381$var$of(c)) return null;
            case "keydown":
            case "keyup":
                a = $ab0f4e46668e4381$var$rf;
                break;
            case "blur":
            case "focus":
                a = $ab0f4e46668e4381$var$nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = $ab0f4e46668e4381$var$Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = $ab0f4e46668e4381$var$sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = $ab0f4e46668e4381$var$tf;
                break;
            case $ab0f4e46668e4381$var$Xb:
            case $ab0f4e46668e4381$var$Yb:
            case $ab0f4e46668e4381$var$Zb:
                a = $ab0f4e46668e4381$var$lf;
                break;
            case $ab0f4e46668e4381$var$$b:
                a = $ab0f4e46668e4381$var$uf;
                break;
            case "scroll":
                a = $ab0f4e46668e4381$var$Ne;
                break;
            case "wheel":
                a = $ab0f4e46668e4381$var$vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = $ab0f4e46668e4381$var$mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = $ab0f4e46668e4381$var$We;
                break;
            default:
                a = $ab0f4e46668e4381$var$G;
        }
        b = a.getPooled(e, b, c, d);
        $ab0f4e46668e4381$var$Xd(b);
        return b;
    }
};
if ($ab0f4e46668e4381$var$pa) throw Error($ab0f4e46668e4381$var$u(101));
$ab0f4e46668e4381$var$pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
$ab0f4e46668e4381$var$ra();
var $ab0f4e46668e4381$var$xf = $ab0f4e46668e4381$var$Nc;
$ab0f4e46668e4381$var$la = $ab0f4e46668e4381$var$Qd;
$ab0f4e46668e4381$var$ma = $ab0f4e46668e4381$var$xf;
$ab0f4e46668e4381$var$na = $ab0f4e46668e4381$var$Pd;
$ab0f4e46668e4381$var$xa({
    SimpleEventPlugin: $ab0f4e46668e4381$var$wf,
    EnterLeaveEventPlugin: $ab0f4e46668e4381$var$Ye,
    ChangeEventPlugin: $ab0f4e46668e4381$var$Me,
    SelectEventPlugin: $ab0f4e46668e4381$var$kf,
    BeforeInputEventPlugin: $ab0f4e46668e4381$var$ve
});
var $ab0f4e46668e4381$var$yf = [], $ab0f4e46668e4381$var$zf = -1;
function $ab0f4e46668e4381$var$H(a) {
    0 > $ab0f4e46668e4381$var$zf || (a.current = $ab0f4e46668e4381$var$yf[$ab0f4e46668e4381$var$zf], $ab0f4e46668e4381$var$yf[$ab0f4e46668e4381$var$zf] = null, $ab0f4e46668e4381$var$zf--);
}
function $ab0f4e46668e4381$var$I(a, b) {
    $ab0f4e46668e4381$var$zf++;
    $ab0f4e46668e4381$var$yf[$ab0f4e46668e4381$var$zf] = a.current;
    a.current = b;
}
var $ab0f4e46668e4381$var$Af = {}, $ab0f4e46668e4381$var$J = {
    current: $ab0f4e46668e4381$var$Af
}, $ab0f4e46668e4381$var$K = {
    current: !1
}, $ab0f4e46668e4381$var$Bf = $ab0f4e46668e4381$var$Af;
function $ab0f4e46668e4381$var$Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $ab0f4e46668e4381$var$Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $ab0f4e46668e4381$var$L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $ab0f4e46668e4381$var$Df() {
    $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$K);
    $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$J);
}
function $ab0f4e46668e4381$var$Ef(a, b, c) {
    if ($ab0f4e46668e4381$var$J.current !== $ab0f4e46668e4381$var$Af) throw Error($ab0f4e46668e4381$var$u(168));
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$J, b);
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$K, c);
}
function $ab0f4e46668e4381$var$Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($ab0f4e46668e4381$var$u(108, $ab0f4e46668e4381$var$pb(b) || "Unknown", e));
    return $MsCOU({}, c, {}, d);
}
function $ab0f4e46668e4381$var$Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $ab0f4e46668e4381$var$Af;
    $ab0f4e46668e4381$var$Bf = $ab0f4e46668e4381$var$J.current;
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$J, a);
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$K, $ab0f4e46668e4381$var$K.current);
    return !0;
}
function $ab0f4e46668e4381$var$Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($ab0f4e46668e4381$var$u(169));
    c ? (a = $ab0f4e46668e4381$var$Ff(a, b, $ab0f4e46668e4381$var$Bf), d.__reactInternalMemoizedMergedChildContext = a, $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$K), $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$J), $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$J, a)) : $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$K);
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$K, c);
}
var $ab0f4e46668e4381$var$If = $5GQyf.unstable_runWithPriority, $ab0f4e46668e4381$var$Jf = $5GQyf.unstable_scheduleCallback, $ab0f4e46668e4381$var$Kf = $5GQyf.unstable_cancelCallback, $ab0f4e46668e4381$var$Lf = $5GQyf.unstable_requestPaint, $ab0f4e46668e4381$var$Mf = $5GQyf.unstable_now, $ab0f4e46668e4381$var$Nf = $5GQyf.unstable_getCurrentPriorityLevel, $ab0f4e46668e4381$var$Of = $5GQyf.unstable_ImmediatePriority, $ab0f4e46668e4381$var$Pf = $5GQyf.unstable_UserBlockingPriority, $ab0f4e46668e4381$var$Qf = $5GQyf.unstable_NormalPriority, $ab0f4e46668e4381$var$Rf = $5GQyf.unstable_LowPriority, $ab0f4e46668e4381$var$Sf = $5GQyf.unstable_IdlePriority, $ab0f4e46668e4381$var$Tf = {}, $ab0f4e46668e4381$var$Uf = $5GQyf.unstable_shouldYield, $ab0f4e46668e4381$var$Vf = void 0 !== $ab0f4e46668e4381$var$Lf ? $ab0f4e46668e4381$var$Lf : function() {}, $ab0f4e46668e4381$var$Wf = null, $ab0f4e46668e4381$var$Xf = null, $ab0f4e46668e4381$var$Yf = !1, $ab0f4e46668e4381$var$Zf = $ab0f4e46668e4381$var$Mf(), $ab0f4e46668e4381$var$$f = 1E4 > $ab0f4e46668e4381$var$Zf ? $ab0f4e46668e4381$var$Mf : function() {
    return $ab0f4e46668e4381$var$Mf() - $ab0f4e46668e4381$var$Zf;
};
function $ab0f4e46668e4381$var$ag() {
    switch($ab0f4e46668e4381$var$Nf()){
        case $ab0f4e46668e4381$var$Of:
            return 99;
        case $ab0f4e46668e4381$var$Pf:
            return 98;
        case $ab0f4e46668e4381$var$Qf:
            return 97;
        case $ab0f4e46668e4381$var$Rf:
            return 96;
        case $ab0f4e46668e4381$var$Sf:
            return 95;
        default:
            throw Error($ab0f4e46668e4381$var$u(332));
    }
}
function $ab0f4e46668e4381$var$bg(a) {
    switch(a){
        case 99:
            return $ab0f4e46668e4381$var$Of;
        case 98:
            return $ab0f4e46668e4381$var$Pf;
        case 97:
            return $ab0f4e46668e4381$var$Qf;
        case 96:
            return $ab0f4e46668e4381$var$Rf;
        case 95:
            return $ab0f4e46668e4381$var$Sf;
        default:
            throw Error($ab0f4e46668e4381$var$u(332));
    }
}
function $ab0f4e46668e4381$var$cg(a, b) {
    a = $ab0f4e46668e4381$var$bg(a);
    return $ab0f4e46668e4381$var$If(a, b);
}
function $ab0f4e46668e4381$var$dg(a, b, c) {
    a = $ab0f4e46668e4381$var$bg(a);
    return $ab0f4e46668e4381$var$Jf(a, b, c);
}
function $ab0f4e46668e4381$var$eg(a) {
    null === $ab0f4e46668e4381$var$Wf ? ($ab0f4e46668e4381$var$Wf = [
        a
    ], $ab0f4e46668e4381$var$Xf = $ab0f4e46668e4381$var$Jf($ab0f4e46668e4381$var$Of, $ab0f4e46668e4381$var$fg)) : $ab0f4e46668e4381$var$Wf.push(a);
    return $ab0f4e46668e4381$var$Tf;
}
function $ab0f4e46668e4381$var$gg() {
    if (null !== $ab0f4e46668e4381$var$Xf) {
        var a = $ab0f4e46668e4381$var$Xf;
        $ab0f4e46668e4381$var$Xf = null;
        $ab0f4e46668e4381$var$Kf(a);
    }
    $ab0f4e46668e4381$var$fg();
}
function $ab0f4e46668e4381$var$fg() {
    if (!$ab0f4e46668e4381$var$Yf && null !== $ab0f4e46668e4381$var$Wf) {
        $ab0f4e46668e4381$var$Yf = !0;
        var a = 0;
        try {
            var b = $ab0f4e46668e4381$var$Wf;
            $ab0f4e46668e4381$var$cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $ab0f4e46668e4381$var$Wf = null;
        } catch (c) {
            throw null !== $ab0f4e46668e4381$var$Wf && ($ab0f4e46668e4381$var$Wf = $ab0f4e46668e4381$var$Wf.slice(a + 1)), $ab0f4e46668e4381$var$Jf($ab0f4e46668e4381$var$Of, $ab0f4e46668e4381$var$gg), c;
        } finally{
            $ab0f4e46668e4381$var$Yf = !1;
        }
    }
}
function $ab0f4e46668e4381$var$hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function $ab0f4e46668e4381$var$ig(a, b) {
    if (a && a.defaultProps) {
        b = $MsCOU({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var $ab0f4e46668e4381$var$jg = {
    current: null
}, $ab0f4e46668e4381$var$kg = null, $ab0f4e46668e4381$var$lg = null, $ab0f4e46668e4381$var$mg = null;
function $ab0f4e46668e4381$var$ng() {
    $ab0f4e46668e4381$var$mg = $ab0f4e46668e4381$var$lg = $ab0f4e46668e4381$var$kg = null;
}
function $ab0f4e46668e4381$var$og(a) {
    var b = $ab0f4e46668e4381$var$jg.current;
    $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$jg);
    a.type._context._currentValue = b;
}
function $ab0f4e46668e4381$var$pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function $ab0f4e46668e4381$var$qg(a, b) {
    $ab0f4e46668e4381$var$kg = a;
    $ab0f4e46668e4381$var$mg = $ab0f4e46668e4381$var$lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && ($ab0f4e46668e4381$var$rg = !0), a.firstContext = null);
}
function $ab0f4e46668e4381$var$sg(a, b) {
    if ($ab0f4e46668e4381$var$mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $ab0f4e46668e4381$var$mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $ab0f4e46668e4381$var$lg) {
            if (null === $ab0f4e46668e4381$var$kg) throw Error($ab0f4e46668e4381$var$u(308));
            $ab0f4e46668e4381$var$lg = b;
            $ab0f4e46668e4381$var$kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else $ab0f4e46668e4381$var$lg = $ab0f4e46668e4381$var$lg.next = b;
    }
    return a._currentValue;
}
var $ab0f4e46668e4381$var$tg = !1;
function $ab0f4e46668e4381$var$ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $ab0f4e46668e4381$var$vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function $ab0f4e46668e4381$var$wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function $ab0f4e46668e4381$var$xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $ab0f4e46668e4381$var$yg(a, b) {
    var c = a.alternate;
    null !== c && $ab0f4e46668e4381$var$vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function $ab0f4e46668e4381$var$zg(a, b, c, d) {
    var e = a.updateQueue;
    $ab0f4e46668e4381$var$tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    $ab0f4e46668e4381$var$Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $MsCOU({}, k, g);
                                break a;
                            case 2:
                                $ab0f4e46668e4381$var$tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        $ab0f4e46668e4381$var$Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function $ab0f4e46668e4381$var$Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error($ab0f4e46668e4381$var$u(191, d));
            d.call(e);
        }
    }
}
var $ab0f4e46668e4381$var$Dg = $ab0f4e46668e4381$var$Wa.ReactCurrentBatchConfig, $ab0f4e46668e4381$var$Eg = (new $5cNek.Component).refs;
function $ab0f4e46668e4381$var$Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $MsCOU({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var $ab0f4e46668e4381$var$Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? $ab0f4e46668e4381$var$dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $ab0f4e46668e4381$var$Gg(), e = $ab0f4e46668e4381$var$Dg.suspense;
        d = $ab0f4e46668e4381$var$Hg(d, a, e);
        e = $ab0f4e46668e4381$var$wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $ab0f4e46668e4381$var$xg(a, e);
        $ab0f4e46668e4381$var$Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $ab0f4e46668e4381$var$Gg(), e = $ab0f4e46668e4381$var$Dg.suspense;
        d = $ab0f4e46668e4381$var$Hg(d, a, e);
        e = $ab0f4e46668e4381$var$wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $ab0f4e46668e4381$var$xg(a, e);
        $ab0f4e46668e4381$var$Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = $ab0f4e46668e4381$var$Gg(), d = $ab0f4e46668e4381$var$Dg.suspense;
        c = $ab0f4e46668e4381$var$Hg(c, a, d);
        d = $ab0f4e46668e4381$var$wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        $ab0f4e46668e4381$var$xg(a, d);
        $ab0f4e46668e4381$var$Ig(a, c);
    }
};
function $ab0f4e46668e4381$var$Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$ab0f4e46668e4381$var$bf(c, d) || !$ab0f4e46668e4381$var$bf(e, f) : !0;
}
function $ab0f4e46668e4381$var$Lg(a, b, c) {
    var d = !1, e = $ab0f4e46668e4381$var$Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $ab0f4e46668e4381$var$sg(f) : (e = $ab0f4e46668e4381$var$L(b) ? $ab0f4e46668e4381$var$Bf : $ab0f4e46668e4381$var$J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $ab0f4e46668e4381$var$Cf(a, e) : $ab0f4e46668e4381$var$Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $ab0f4e46668e4381$var$Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $ab0f4e46668e4381$var$Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $ab0f4e46668e4381$var$Jg.enqueueReplaceState(b, b.state, null);
}
function $ab0f4e46668e4381$var$Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $ab0f4e46668e4381$var$Eg;
    $ab0f4e46668e4381$var$ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $ab0f4e46668e4381$var$sg(f) : (f = $ab0f4e46668e4381$var$L(b) ? $ab0f4e46668e4381$var$Bf : $ab0f4e46668e4381$var$J.current, e.context = $ab0f4e46668e4381$var$Cf(a, f));
    $ab0f4e46668e4381$var$zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($ab0f4e46668e4381$var$Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $ab0f4e46668e4381$var$Jg.enqueueReplaceState(e, e.state, null), $ab0f4e46668e4381$var$zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var $ab0f4e46668e4381$var$Og = Array.isArray;
function $ab0f4e46668e4381$var$Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($ab0f4e46668e4381$var$u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($ab0f4e46668e4381$var$u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $ab0f4e46668e4381$var$Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($ab0f4e46668e4381$var$u(284));
        if (!c._owner) throw Error($ab0f4e46668e4381$var$u(290, a));
    }
    return a;
}
function $ab0f4e46668e4381$var$Qg(a, b) {
    if ("textarea" !== a.type) throw Error($ab0f4e46668e4381$var$u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function $ab0f4e46668e4381$var$Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $ab0f4e46668e4381$var$Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $ab0f4e46668e4381$var$Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $ab0f4e46668e4381$var$Pg(a, b, c), d.return = a, d;
        d = $ab0f4e46668e4381$var$Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $ab0f4e46668e4381$var$Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $ab0f4e46668e4381$var$Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $ab0f4e46668e4381$var$Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $ab0f4e46668e4381$var$Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $ab0f4e46668e4381$var$Za:
                    return c = $ab0f4e46668e4381$var$Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = $ab0f4e46668e4381$var$Pg(a, null, b), c.return = a, c;
                case $ab0f4e46668e4381$var$$a:
                    return b = $ab0f4e46668e4381$var$Vg(b, a.mode, c), b.return = a, b;
            }
            if ($ab0f4e46668e4381$var$Og(b) || $ab0f4e46668e4381$var$nb(b)) return b = $ab0f4e46668e4381$var$Wg(b, a.mode, c, null), b.return = a, b;
            $ab0f4e46668e4381$var$Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $ab0f4e46668e4381$var$Za:
                    return c.key === e ? c.type === $ab0f4e46668e4381$var$ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $ab0f4e46668e4381$var$$a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($ab0f4e46668e4381$var$Og(c) || $ab0f4e46668e4381$var$nb(c)) return null !== e ? null : m(a, b, c, d, null);
            $ab0f4e46668e4381$var$Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $ab0f4e46668e4381$var$Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $ab0f4e46668e4381$var$ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $ab0f4e46668e4381$var$$a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($ab0f4e46668e4381$var$Og(d) || $ab0f4e46668e4381$var$nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $ab0f4e46668e4381$var$Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = $ab0f4e46668e4381$var$nb(h);
        if ("function" !== typeof k) throw Error($ab0f4e46668e4381$var$u(150));
        h = k.call(h);
        if (null == h) throw Error($ab0f4e46668e4381$var$u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $ab0f4e46668e4381$var$ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $ab0f4e46668e4381$var$Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $ab0f4e46668e4381$var$ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $ab0f4e46668e4381$var$Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $ab0f4e46668e4381$var$ab ? (d = $ab0f4e46668e4381$var$Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $ab0f4e46668e4381$var$Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = $ab0f4e46668e4381$var$Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $ab0f4e46668e4381$var$$a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $ab0f4e46668e4381$var$Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $ab0f4e46668e4381$var$Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if ($ab0f4e46668e4381$var$Og(f)) return ca(a, d, f, h);
        if ($ab0f4e46668e4381$var$nb(f)) return D(a, d, f, h);
        l && $ab0f4e46668e4381$var$Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error($ab0f4e46668e4381$var$u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var $ab0f4e46668e4381$var$Xg = $ab0f4e46668e4381$var$Rg(!0), $ab0f4e46668e4381$var$Yg = $ab0f4e46668e4381$var$Rg(!1), $ab0f4e46668e4381$var$Zg = {}, $ab0f4e46668e4381$var$$g = {
    current: $ab0f4e46668e4381$var$Zg
}, $ab0f4e46668e4381$var$ah = {
    current: $ab0f4e46668e4381$var$Zg
}, $ab0f4e46668e4381$var$bh = {
    current: $ab0f4e46668e4381$var$Zg
};
function $ab0f4e46668e4381$var$ch(a) {
    if (a === $ab0f4e46668e4381$var$Zg) throw Error($ab0f4e46668e4381$var$u(174));
    return a;
}
function $ab0f4e46668e4381$var$dh(a, b) {
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$bh, b);
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$ah, a);
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$$g, $ab0f4e46668e4381$var$Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $ab0f4e46668e4381$var$Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $ab0f4e46668e4381$var$Ob(b, a);
    }
    $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$$g);
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$$g, b);
}
function $ab0f4e46668e4381$var$eh() {
    $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$$g);
    $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$ah);
    $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$bh);
}
function $ab0f4e46668e4381$var$fh(a) {
    $ab0f4e46668e4381$var$ch($ab0f4e46668e4381$var$bh.current);
    var b = $ab0f4e46668e4381$var$ch($ab0f4e46668e4381$var$$g.current);
    var c = $ab0f4e46668e4381$var$Ob(b, a.type);
    b !== c && ($ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$ah, a), $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$$g, c));
}
function $ab0f4e46668e4381$var$gh(a) {
    $ab0f4e46668e4381$var$ah.current === a && ($ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$$g), $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$ah));
}
var $ab0f4e46668e4381$var$M = {
    current: 0
};
function $ab0f4e46668e4381$var$hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === $ab0f4e46668e4381$var$Bd || c.data === $ab0f4e46668e4381$var$Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function $ab0f4e46668e4381$var$ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var $ab0f4e46668e4381$var$jh = $ab0f4e46668e4381$var$Wa.ReactCurrentDispatcher, $ab0f4e46668e4381$var$kh = $ab0f4e46668e4381$var$Wa.ReactCurrentBatchConfig, $ab0f4e46668e4381$var$lh = 0, $ab0f4e46668e4381$var$N = null, $ab0f4e46668e4381$var$O = null, $ab0f4e46668e4381$var$P = null, $ab0f4e46668e4381$var$mh = !1;
function $ab0f4e46668e4381$var$Q() {
    throw Error($ab0f4e46668e4381$var$u(321));
}
function $ab0f4e46668e4381$var$nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$ab0f4e46668e4381$var$$e(a[c], b[c])) return !1;
    return !0;
}
function $ab0f4e46668e4381$var$oh(a, b, c, d, e, f) {
    $ab0f4e46668e4381$var$lh = f;
    $ab0f4e46668e4381$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    $ab0f4e46668e4381$var$jh.current = null === a || null === a.memoizedState ? $ab0f4e46668e4381$var$ph : $ab0f4e46668e4381$var$qh;
    a = c(d, e);
    if (b.expirationTime === $ab0f4e46668e4381$var$lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error($ab0f4e46668e4381$var$u(301));
            f += 1;
            $ab0f4e46668e4381$var$P = $ab0f4e46668e4381$var$O = null;
            b.updateQueue = null;
            $ab0f4e46668e4381$var$jh.current = $ab0f4e46668e4381$var$rh;
            a = c(d, e);
        }while (b.expirationTime === $ab0f4e46668e4381$var$lh);
    }
    $ab0f4e46668e4381$var$jh.current = $ab0f4e46668e4381$var$sh;
    b = null !== $ab0f4e46668e4381$var$O && null !== $ab0f4e46668e4381$var$O.next;
    $ab0f4e46668e4381$var$lh = 0;
    $ab0f4e46668e4381$var$P = $ab0f4e46668e4381$var$O = $ab0f4e46668e4381$var$N = null;
    $ab0f4e46668e4381$var$mh = !1;
    if (b) throw Error($ab0f4e46668e4381$var$u(300));
    return a;
}
function $ab0f4e46668e4381$var$th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $ab0f4e46668e4381$var$P ? $ab0f4e46668e4381$var$N.memoizedState = $ab0f4e46668e4381$var$P = a : $ab0f4e46668e4381$var$P = $ab0f4e46668e4381$var$P.next = a;
    return $ab0f4e46668e4381$var$P;
}
function $ab0f4e46668e4381$var$uh() {
    if (null === $ab0f4e46668e4381$var$O) {
        var a = $ab0f4e46668e4381$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $ab0f4e46668e4381$var$O.next;
    var b = null === $ab0f4e46668e4381$var$P ? $ab0f4e46668e4381$var$N.memoizedState : $ab0f4e46668e4381$var$P.next;
    if (null !== b) $ab0f4e46668e4381$var$P = b, $ab0f4e46668e4381$var$O = a;
    else {
        if (null === a) throw Error($ab0f4e46668e4381$var$u(310));
        $ab0f4e46668e4381$var$O = a;
        a = {
            memoizedState: $ab0f4e46668e4381$var$O.memoizedState,
            baseState: $ab0f4e46668e4381$var$O.baseState,
            baseQueue: $ab0f4e46668e4381$var$O.baseQueue,
            queue: $ab0f4e46668e4381$var$O.queue,
            next: null
        };
        null === $ab0f4e46668e4381$var$P ? $ab0f4e46668e4381$var$N.memoizedState = $ab0f4e46668e4381$var$P = a : $ab0f4e46668e4381$var$P = $ab0f4e46668e4381$var$P.next = a;
    }
    return $ab0f4e46668e4381$var$P;
}
function $ab0f4e46668e4381$var$vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $ab0f4e46668e4381$var$wh(a) {
    var b = $ab0f4e46668e4381$var$uh(), c = b.queue;
    if (null === c) throw Error($ab0f4e46668e4381$var$u(311));
    c.lastRenderedReducer = a;
    var d = $ab0f4e46668e4381$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < $ab0f4e46668e4381$var$lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > $ab0f4e46668e4381$var$N.expirationTime && ($ab0f4e46668e4381$var$N.expirationTime = l, $ab0f4e46668e4381$var$Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), $ab0f4e46668e4381$var$Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $ab0f4e46668e4381$var$$e(d, b.memoizedState) || ($ab0f4e46668e4381$var$rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $ab0f4e46668e4381$var$xh(a) {
    var b = $ab0f4e46668e4381$var$uh(), c = b.queue;
    if (null === c) throw Error($ab0f4e46668e4381$var$u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $ab0f4e46668e4381$var$$e(f, b.memoizedState) || ($ab0f4e46668e4381$var$rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $ab0f4e46668e4381$var$yh(a) {
    var b = $ab0f4e46668e4381$var$th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $ab0f4e46668e4381$var$vh,
        lastRenderedState: a
    };
    a = a.dispatch = $ab0f4e46668e4381$var$zh.bind(null, $ab0f4e46668e4381$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $ab0f4e46668e4381$var$Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $ab0f4e46668e4381$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $ab0f4e46668e4381$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $ab0f4e46668e4381$var$Bh() {
    return $ab0f4e46668e4381$var$uh().memoizedState;
}
function $ab0f4e46668e4381$var$Ch(a, b, c, d) {
    var e = $ab0f4e46668e4381$var$th();
    $ab0f4e46668e4381$var$N.effectTag |= a;
    e.memoizedState = $ab0f4e46668e4381$var$Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function $ab0f4e46668e4381$var$Dh(a, b, c, d) {
    var e = $ab0f4e46668e4381$var$uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $ab0f4e46668e4381$var$O) {
        var g = $ab0f4e46668e4381$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $ab0f4e46668e4381$var$nh(d, g.deps)) {
            $ab0f4e46668e4381$var$Ah(b, c, f, d);
            return;
        }
    }
    $ab0f4e46668e4381$var$N.effectTag |= a;
    e.memoizedState = $ab0f4e46668e4381$var$Ah(1 | b, c, f, d);
}
function $ab0f4e46668e4381$var$Eh(a, b) {
    return $ab0f4e46668e4381$var$Ch(516, 4, a, b);
}
function $ab0f4e46668e4381$var$Fh(a, b) {
    return $ab0f4e46668e4381$var$Dh(516, 4, a, b);
}
function $ab0f4e46668e4381$var$Gh(a, b) {
    return $ab0f4e46668e4381$var$Dh(4, 2, a, b);
}
function $ab0f4e46668e4381$var$Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $ab0f4e46668e4381$var$Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $ab0f4e46668e4381$var$Dh(4, 2, $ab0f4e46668e4381$var$Hh.bind(null, b, a), c);
}
function $ab0f4e46668e4381$var$Jh() {}
function $ab0f4e46668e4381$var$Kh(a, b) {
    $ab0f4e46668e4381$var$th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function $ab0f4e46668e4381$var$Lh(a, b) {
    var c = $ab0f4e46668e4381$var$uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $ab0f4e46668e4381$var$nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $ab0f4e46668e4381$var$Mh(a, b) {
    var c = $ab0f4e46668e4381$var$uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $ab0f4e46668e4381$var$nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $ab0f4e46668e4381$var$Nh(a, b, c) {
    var d = $ab0f4e46668e4381$var$ag();
    $ab0f4e46668e4381$var$cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    $ab0f4e46668e4381$var$cg(97 < d ? 97 : d, function() {
        var d = $ab0f4e46668e4381$var$kh.suspense;
        $ab0f4e46668e4381$var$kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            $ab0f4e46668e4381$var$kh.suspense = d;
        }
    });
}
function $ab0f4e46668e4381$var$zh(a, b, c) {
    var d = $ab0f4e46668e4381$var$Gg(), e = $ab0f4e46668e4381$var$Dg.suspense;
    d = $ab0f4e46668e4381$var$Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === $ab0f4e46668e4381$var$N || null !== f && f === $ab0f4e46668e4381$var$N) $ab0f4e46668e4381$var$mh = !0, e.expirationTime = $ab0f4e46668e4381$var$lh, $ab0f4e46668e4381$var$N.expirationTime = $ab0f4e46668e4381$var$lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($ab0f4e46668e4381$var$$e(h, g)) return;
        } catch (k) {} finally{}
        $ab0f4e46668e4381$var$Ig(a, d);
    }
}
var $ab0f4e46668e4381$var$sh = {
    readContext: $ab0f4e46668e4381$var$sg,
    useCallback: $ab0f4e46668e4381$var$Q,
    useContext: $ab0f4e46668e4381$var$Q,
    useEffect: $ab0f4e46668e4381$var$Q,
    useImperativeHandle: $ab0f4e46668e4381$var$Q,
    useLayoutEffect: $ab0f4e46668e4381$var$Q,
    useMemo: $ab0f4e46668e4381$var$Q,
    useReducer: $ab0f4e46668e4381$var$Q,
    useRef: $ab0f4e46668e4381$var$Q,
    useState: $ab0f4e46668e4381$var$Q,
    useDebugValue: $ab0f4e46668e4381$var$Q,
    useResponder: $ab0f4e46668e4381$var$Q,
    useDeferredValue: $ab0f4e46668e4381$var$Q,
    useTransition: $ab0f4e46668e4381$var$Q
}, $ab0f4e46668e4381$var$ph = {
    readContext: $ab0f4e46668e4381$var$sg,
    useCallback: $ab0f4e46668e4381$var$Kh,
    useContext: $ab0f4e46668e4381$var$sg,
    useEffect: $ab0f4e46668e4381$var$Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $ab0f4e46668e4381$var$Ch(4, 2, $ab0f4e46668e4381$var$Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $ab0f4e46668e4381$var$Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $ab0f4e46668e4381$var$th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $ab0f4e46668e4381$var$th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $ab0f4e46668e4381$var$zh.bind(null, $ab0f4e46668e4381$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $ab0f4e46668e4381$var$th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $ab0f4e46668e4381$var$yh,
    useDebugValue: $ab0f4e46668e4381$var$Jh,
    useResponder: $ab0f4e46668e4381$var$ih,
    useDeferredValue: function(a, b) {
        var c = $ab0f4e46668e4381$var$yh(a), d = c[0], e = c[1];
        $ab0f4e46668e4381$var$Eh(function() {
            var c = $ab0f4e46668e4381$var$kh.suspense;
            $ab0f4e46668e4381$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $ab0f4e46668e4381$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $ab0f4e46668e4381$var$yh(!1), c = b[0];
        b = b[1];
        return [
            $ab0f4e46668e4381$var$Kh($ab0f4e46668e4381$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $ab0f4e46668e4381$var$qh = {
    readContext: $ab0f4e46668e4381$var$sg,
    useCallback: $ab0f4e46668e4381$var$Lh,
    useContext: $ab0f4e46668e4381$var$sg,
    useEffect: $ab0f4e46668e4381$var$Fh,
    useImperativeHandle: $ab0f4e46668e4381$var$Ih,
    useLayoutEffect: $ab0f4e46668e4381$var$Gh,
    useMemo: $ab0f4e46668e4381$var$Mh,
    useReducer: $ab0f4e46668e4381$var$wh,
    useRef: $ab0f4e46668e4381$var$Bh,
    useState: function() {
        return $ab0f4e46668e4381$var$wh($ab0f4e46668e4381$var$vh);
    },
    useDebugValue: $ab0f4e46668e4381$var$Jh,
    useResponder: $ab0f4e46668e4381$var$ih,
    useDeferredValue: function(a, b) {
        var c = $ab0f4e46668e4381$var$wh($ab0f4e46668e4381$var$vh), d = c[0], e = c[1];
        $ab0f4e46668e4381$var$Fh(function() {
            var c = $ab0f4e46668e4381$var$kh.suspense;
            $ab0f4e46668e4381$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $ab0f4e46668e4381$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $ab0f4e46668e4381$var$wh($ab0f4e46668e4381$var$vh), c = b[0];
        b = b[1];
        return [
            $ab0f4e46668e4381$var$Lh($ab0f4e46668e4381$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $ab0f4e46668e4381$var$rh = {
    readContext: $ab0f4e46668e4381$var$sg,
    useCallback: $ab0f4e46668e4381$var$Lh,
    useContext: $ab0f4e46668e4381$var$sg,
    useEffect: $ab0f4e46668e4381$var$Fh,
    useImperativeHandle: $ab0f4e46668e4381$var$Ih,
    useLayoutEffect: $ab0f4e46668e4381$var$Gh,
    useMemo: $ab0f4e46668e4381$var$Mh,
    useReducer: $ab0f4e46668e4381$var$xh,
    useRef: $ab0f4e46668e4381$var$Bh,
    useState: function() {
        return $ab0f4e46668e4381$var$xh($ab0f4e46668e4381$var$vh);
    },
    useDebugValue: $ab0f4e46668e4381$var$Jh,
    useResponder: $ab0f4e46668e4381$var$ih,
    useDeferredValue: function(a, b) {
        var c = $ab0f4e46668e4381$var$xh($ab0f4e46668e4381$var$vh), d = c[0], e = c[1];
        $ab0f4e46668e4381$var$Fh(function() {
            var c = $ab0f4e46668e4381$var$kh.suspense;
            $ab0f4e46668e4381$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $ab0f4e46668e4381$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $ab0f4e46668e4381$var$xh($ab0f4e46668e4381$var$vh), c = b[0];
        b = b[1];
        return [
            $ab0f4e46668e4381$var$Lh($ab0f4e46668e4381$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $ab0f4e46668e4381$var$Oh = null, $ab0f4e46668e4381$var$Ph = null, $ab0f4e46668e4381$var$Qh = !1;
function $ab0f4e46668e4381$var$Rh(a, b) {
    var c = $ab0f4e46668e4381$var$Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $ab0f4e46668e4381$var$Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $ab0f4e46668e4381$var$Uh(a) {
    if ($ab0f4e46668e4381$var$Qh) {
        var b = $ab0f4e46668e4381$var$Ph;
        if (b) {
            var c = b;
            if (!$ab0f4e46668e4381$var$Th(a, b)) {
                b = $ab0f4e46668e4381$var$Jd(c.nextSibling);
                if (!b || !$ab0f4e46668e4381$var$Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    $ab0f4e46668e4381$var$Qh = !1;
                    $ab0f4e46668e4381$var$Oh = a;
                    return;
                }
                $ab0f4e46668e4381$var$Rh($ab0f4e46668e4381$var$Oh, c);
            }
            $ab0f4e46668e4381$var$Oh = a;
            $ab0f4e46668e4381$var$Ph = $ab0f4e46668e4381$var$Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, $ab0f4e46668e4381$var$Qh = !1, $ab0f4e46668e4381$var$Oh = a;
    }
}
function $ab0f4e46668e4381$var$Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $ab0f4e46668e4381$var$Oh = a;
}
function $ab0f4e46668e4381$var$Wh(a) {
    if (a !== $ab0f4e46668e4381$var$Oh) return !1;
    if (!$ab0f4e46668e4381$var$Qh) return $ab0f4e46668e4381$var$Vh(a), $ab0f4e46668e4381$var$Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$ab0f4e46668e4381$var$Gd(b, a.memoizedProps)) for(b = $ab0f4e46668e4381$var$Ph; b;)$ab0f4e46668e4381$var$Rh(a, b), b = $ab0f4e46668e4381$var$Jd(b.nextSibling);
    $ab0f4e46668e4381$var$Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($ab0f4e46668e4381$var$u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === $ab0f4e46668e4381$var$Ad) {
                        if (0 === b) {
                            $ab0f4e46668e4381$var$Ph = $ab0f4e46668e4381$var$Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== $ab0f4e46668e4381$var$zd && c !== $ab0f4e46668e4381$var$Cd && c !== $ab0f4e46668e4381$var$Bd || b++;
                }
                a = a.nextSibling;
            }
            $ab0f4e46668e4381$var$Ph = null;
        }
    } else $ab0f4e46668e4381$var$Ph = $ab0f4e46668e4381$var$Oh ? $ab0f4e46668e4381$var$Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function $ab0f4e46668e4381$var$Xh() {
    $ab0f4e46668e4381$var$Ph = $ab0f4e46668e4381$var$Oh = null;
    $ab0f4e46668e4381$var$Qh = !1;
}
var $ab0f4e46668e4381$var$Yh = $ab0f4e46668e4381$var$Wa.ReactCurrentOwner, $ab0f4e46668e4381$var$rg = !1;
function $ab0f4e46668e4381$var$R(a, b, c, d) {
    b.child = null === a ? $ab0f4e46668e4381$var$Yg(b, null, c, d) : $ab0f4e46668e4381$var$Xg(b, a.child, c, d);
}
function $ab0f4e46668e4381$var$Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $ab0f4e46668e4381$var$qg(b, e);
    d = $ab0f4e46668e4381$var$oh(a, b, c, d, f, e);
    if (null !== a && !$ab0f4e46668e4381$var$rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $ab0f4e46668e4381$var$$h(a, b, e);
    b.effectTag |= 1;
    $ab0f4e46668e4381$var$R(a, b, d, e);
    return b.child;
}
function $ab0f4e46668e4381$var$ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$ab0f4e46668e4381$var$bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $ab0f4e46668e4381$var$ci(a, b, g, d, e, f);
        a = $ab0f4e46668e4381$var$Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $ab0f4e46668e4381$var$bf, c(e, d) && a.ref === b.ref)) return $ab0f4e46668e4381$var$$h(a, b, f);
    b.effectTag |= 1;
    a = $ab0f4e46668e4381$var$Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $ab0f4e46668e4381$var$ci(a, b, c, d, e, f) {
    return null !== a && $ab0f4e46668e4381$var$bf(a.memoizedProps, d) && a.ref === b.ref && ($ab0f4e46668e4381$var$rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $ab0f4e46668e4381$var$$h(a, b, f)) : $ab0f4e46668e4381$var$di(a, b, c, d, f);
}
function $ab0f4e46668e4381$var$ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function $ab0f4e46668e4381$var$di(a, b, c, d, e) {
    var f = $ab0f4e46668e4381$var$L(c) ? $ab0f4e46668e4381$var$Bf : $ab0f4e46668e4381$var$J.current;
    f = $ab0f4e46668e4381$var$Cf(b, f);
    $ab0f4e46668e4381$var$qg(b, e);
    c = $ab0f4e46668e4381$var$oh(a, b, c, d, f, e);
    if (null !== a && !$ab0f4e46668e4381$var$rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $ab0f4e46668e4381$var$$h(a, b, e);
    b.effectTag |= 1;
    $ab0f4e46668e4381$var$R(a, b, c, e);
    return b.child;
}
function $ab0f4e46668e4381$var$fi(a, b, c, d, e) {
    if ($ab0f4e46668e4381$var$L(c)) {
        var f = !0;
        $ab0f4e46668e4381$var$Gf(b);
    } else f = !1;
    $ab0f4e46668e4381$var$qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), $ab0f4e46668e4381$var$Lg(b, c, d), $ab0f4e46668e4381$var$Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $ab0f4e46668e4381$var$sg(l) : (l = $ab0f4e46668e4381$var$L(c) ? $ab0f4e46668e4381$var$Bf : $ab0f4e46668e4381$var$J.current, l = $ab0f4e46668e4381$var$Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $ab0f4e46668e4381$var$Mg(b, g, d, l);
        $ab0f4e46668e4381$var$tg = !1;
        var x = b.memoizedState;
        g.state = x;
        $ab0f4e46668e4381$var$zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || $ab0f4e46668e4381$var$K.current || $ab0f4e46668e4381$var$tg ? ("function" === typeof m && ($ab0f4e46668e4381$var$Fg(b, c, m, d), k = b.memoizedState), (h = $ab0f4e46668e4381$var$tg || $ab0f4e46668e4381$var$Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, $ab0f4e46668e4381$var$vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : $ab0f4e46668e4381$var$ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = $ab0f4e46668e4381$var$sg(l) : (l = $ab0f4e46668e4381$var$L(c) ? $ab0f4e46668e4381$var$Bf : $ab0f4e46668e4381$var$J.current, l = $ab0f4e46668e4381$var$Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $ab0f4e46668e4381$var$Mg(b, g, d, l), $ab0f4e46668e4381$var$tg = !1, k = b.memoizedState, g.state = k, $ab0f4e46668e4381$var$zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || $ab0f4e46668e4381$var$K.current || $ab0f4e46668e4381$var$tg ? ("function" === typeof m && ($ab0f4e46668e4381$var$Fg(b, c, m, d), x = b.memoizedState), (m = $ab0f4e46668e4381$var$tg || $ab0f4e46668e4381$var$Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return $ab0f4e46668e4381$var$gi(a, b, c, d, f, e);
}
function $ab0f4e46668e4381$var$gi(a, b, c, d, e, f) {
    $ab0f4e46668e4381$var$ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && $ab0f4e46668e4381$var$Hf(b, c, !1), $ab0f4e46668e4381$var$$h(a, b, f);
    d = b.stateNode;
    $ab0f4e46668e4381$var$Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = $ab0f4e46668e4381$var$Xg(b, a.child, null, f), b.child = $ab0f4e46668e4381$var$Xg(b, null, h, f)) : $ab0f4e46668e4381$var$R(a, b, h, f);
    b.memoizedState = d.state;
    e && $ab0f4e46668e4381$var$Hf(b, c, !0);
    return b.child;
}
function $ab0f4e46668e4381$var$hi(a) {
    var b = a.stateNode;
    b.pendingContext ? $ab0f4e46668e4381$var$Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $ab0f4e46668e4381$var$Ef(a, b.context, !1);
    $ab0f4e46668e4381$var$dh(a, b.containerInfo);
}
var $ab0f4e46668e4381$var$ii = {
    dehydrated: null,
    retryTime: 0
};
function $ab0f4e46668e4381$var$ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = $ab0f4e46668e4381$var$M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && $ab0f4e46668e4381$var$Uh(b);
        if (g) {
            g = e.fallback;
            e = $ab0f4e46668e4381$var$Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = $ab0f4e46668e4381$var$Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = $ab0f4e46668e4381$var$ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = $ab0f4e46668e4381$var$Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = $ab0f4e46668e4381$var$Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = $ab0f4e46668e4381$var$Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = $ab0f4e46668e4381$var$ii;
            b.child = c;
            return d;
        }
        c = $ab0f4e46668e4381$var$Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = $ab0f4e46668e4381$var$Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = $ab0f4e46668e4381$var$Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = $ab0f4e46668e4381$var$ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = $ab0f4e46668e4381$var$Xg(b, a, e.children, c);
}
function $ab0f4e46668e4381$var$ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    $ab0f4e46668e4381$var$pg(a.return, b);
}
function $ab0f4e46668e4381$var$li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function $ab0f4e46668e4381$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $ab0f4e46668e4381$var$R(a, b, d.children, c);
    d = $ab0f4e46668e4381$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $ab0f4e46668e4381$var$ki(a, c);
            else if (19 === a.tag) $ab0f4e46668e4381$var$ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $ab0f4e46668e4381$var$hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $ab0f4e46668e4381$var$li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $ab0f4e46668e4381$var$hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $ab0f4e46668e4381$var$li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $ab0f4e46668e4381$var$li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $ab0f4e46668e4381$var$$h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && $ab0f4e46668e4381$var$Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error($ab0f4e46668e4381$var$u(153));
    if (null !== b.child) {
        a = b.child;
        c = $ab0f4e46668e4381$var$Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $ab0f4e46668e4381$var$Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var $ab0f4e46668e4381$var$ni, $ab0f4e46668e4381$var$oi, $ab0f4e46668e4381$var$pi, $ab0f4e46668e4381$var$qi;
$ab0f4e46668e4381$var$ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$ab0f4e46668e4381$var$oi = function() {};
$ab0f4e46668e4381$var$pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        $ab0f4e46668e4381$var$ch($ab0f4e46668e4381$var$$g.current);
        a = null;
        switch(c){
            case "input":
                f = $ab0f4e46668e4381$var$zb(g, f);
                d = $ab0f4e46668e4381$var$zb(g, d);
                a = [];
                break;
            case "option":
                f = $ab0f4e46668e4381$var$Gb(g, f);
                d = $ab0f4e46668e4381$var$Gb(g, d);
                a = [];
                break;
            case "select":
                f = $MsCOU({}, f, {
                    value: void 0
                });
                d = $MsCOU({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = $ab0f4e46668e4381$var$Ib(g, f);
                d = $ab0f4e46668e4381$var$Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = $ab0f4e46668e4381$var$sd);
        }
        $ab0f4e46668e4381$var$od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && ($ab0f4e46668e4381$var$va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && ($ab0f4e46668e4381$var$va.hasOwnProperty(h) ? (null != l && $ab0f4e46668e4381$var$rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
$ab0f4e46668e4381$var$qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function $ab0f4e46668e4381$var$ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $ab0f4e46668e4381$var$si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $ab0f4e46668e4381$var$L(b.type) && $ab0f4e46668e4381$var$Df(), null;
        case 3:
            return $ab0f4e46668e4381$var$eh(), $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$K), $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !$ab0f4e46668e4381$var$Wh(b) || (b.effectTag |= 4), $ab0f4e46668e4381$var$oi(b), null;
        case 5:
            $ab0f4e46668e4381$var$gh(b);
            c = $ab0f4e46668e4381$var$ch($ab0f4e46668e4381$var$bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) $ab0f4e46668e4381$var$pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($ab0f4e46668e4381$var$u(166));
                    return null;
                }
                a = $ab0f4e46668e4381$var$ch($ab0f4e46668e4381$var$$g.current);
                if ($ab0f4e46668e4381$var$Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[$ab0f4e46668e4381$var$Md] = b;
                    d[$ab0f4e46668e4381$var$Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            $ab0f4e46668e4381$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $ab0f4e46668e4381$var$ac.length; a++)$ab0f4e46668e4381$var$F($ab0f4e46668e4381$var$ac[a], d);
                            break;
                        case "source":
                            $ab0f4e46668e4381$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $ab0f4e46668e4381$var$F("error", d);
                            $ab0f4e46668e4381$var$F("load", d);
                            break;
                        case "form":
                            $ab0f4e46668e4381$var$F("reset", d);
                            $ab0f4e46668e4381$var$F("submit", d);
                            break;
                        case "details":
                            $ab0f4e46668e4381$var$F("toggle", d);
                            break;
                        case "input":
                            $ab0f4e46668e4381$var$Ab(d, f);
                            $ab0f4e46668e4381$var$F("invalid", d);
                            $ab0f4e46668e4381$var$rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $ab0f4e46668e4381$var$F("invalid", d);
                            $ab0f4e46668e4381$var$rd(c, "onChange");
                            break;
                        case "textarea":
                            $ab0f4e46668e4381$var$Jb(d, f), $ab0f4e46668e4381$var$F("invalid", d), $ab0f4e46668e4381$var$rd(c, "onChange");
                    }
                    $ab0f4e46668e4381$var$od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : $ab0f4e46668e4381$var$va.hasOwnProperty(g) && null != h && $ab0f4e46668e4381$var$rd(c, g);
                    }
                    switch(e){
                        case "input":
                            $ab0f4e46668e4381$var$xb(d);
                            $ab0f4e46668e4381$var$Eb(d, f, !0);
                            break;
                        case "textarea":
                            $ab0f4e46668e4381$var$xb(d);
                            $ab0f4e46668e4381$var$Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $ab0f4e46668e4381$var$sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === $ab0f4e46668e4381$var$qd && (a = $ab0f4e46668e4381$var$Nb(e));
                    a === $ab0f4e46668e4381$var$qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[$ab0f4e46668e4381$var$Md] = b;
                    a[$ab0f4e46668e4381$var$Nd] = d;
                    $ab0f4e46668e4381$var$ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = $ab0f4e46668e4381$var$pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            $ab0f4e46668e4381$var$F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < $ab0f4e46668e4381$var$ac.length; h++)$ab0f4e46668e4381$var$F($ab0f4e46668e4381$var$ac[h], a);
                            h = d;
                            break;
                        case "source":
                            $ab0f4e46668e4381$var$F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $ab0f4e46668e4381$var$F("error", a);
                            $ab0f4e46668e4381$var$F("load", a);
                            h = d;
                            break;
                        case "form":
                            $ab0f4e46668e4381$var$F("reset", a);
                            $ab0f4e46668e4381$var$F("submit", a);
                            h = d;
                            break;
                        case "details":
                            $ab0f4e46668e4381$var$F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            $ab0f4e46668e4381$var$Ab(a, d);
                            h = $ab0f4e46668e4381$var$zb(a, d);
                            $ab0f4e46668e4381$var$F("invalid", a);
                            $ab0f4e46668e4381$var$rd(c, "onChange");
                            break;
                        case "option":
                            h = $ab0f4e46668e4381$var$Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $MsCOU({}, d, {
                                value: void 0
                            });
                            $ab0f4e46668e4381$var$F("invalid", a);
                            $ab0f4e46668e4381$var$rd(c, "onChange");
                            break;
                        case "textarea":
                            $ab0f4e46668e4381$var$Jb(a, d);
                            h = $ab0f4e46668e4381$var$Ib(a, d);
                            $ab0f4e46668e4381$var$F("invalid", a);
                            $ab0f4e46668e4381$var$rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    $ab0f4e46668e4381$var$od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? $ab0f4e46668e4381$var$md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && $ab0f4e46668e4381$var$Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && $ab0f4e46668e4381$var$Rb(a, l) : "number" === typeof l && $ab0f4e46668e4381$var$Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($ab0f4e46668e4381$var$va.hasOwnProperty(f) ? null != l && $ab0f4e46668e4381$var$rd(c, f) : null != l && $ab0f4e46668e4381$var$Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            $ab0f4e46668e4381$var$xb(a);
                            $ab0f4e46668e4381$var$Eb(a, d, !1);
                            break;
                        case "textarea":
                            $ab0f4e46668e4381$var$xb(a);
                            $ab0f4e46668e4381$var$Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $ab0f4e46668e4381$var$rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? $ab0f4e46668e4381$var$Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && $ab0f4e46668e4381$var$Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = $ab0f4e46668e4381$var$sd);
                    }
                    $ab0f4e46668e4381$var$Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $ab0f4e46668e4381$var$qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($ab0f4e46668e4381$var$u(166));
                c = $ab0f4e46668e4381$var$ch($ab0f4e46668e4381$var$bh.current);
                $ab0f4e46668e4381$var$ch($ab0f4e46668e4381$var$$g.current);
                $ab0f4e46668e4381$var$Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[$ab0f4e46668e4381$var$Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[$ab0f4e46668e4381$var$Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $ab0f4e46668e4381$var$Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($ab0f4e46668e4381$var$M.current & 1)) $ab0f4e46668e4381$var$S === $ab0f4e46668e4381$var$ti && ($ab0f4e46668e4381$var$S = $ab0f4e46668e4381$var$ui);
                else {
                    if ($ab0f4e46668e4381$var$S === $ab0f4e46668e4381$var$ti || $ab0f4e46668e4381$var$S === $ab0f4e46668e4381$var$ui) $ab0f4e46668e4381$var$S = $ab0f4e46668e4381$var$vi;
                    0 !== $ab0f4e46668e4381$var$wi && null !== $ab0f4e46668e4381$var$T && ($ab0f4e46668e4381$var$xi($ab0f4e46668e4381$var$T, $ab0f4e46668e4381$var$U), $ab0f4e46668e4381$var$yi($ab0f4e46668e4381$var$T, $ab0f4e46668e4381$var$wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return $ab0f4e46668e4381$var$eh(), $ab0f4e46668e4381$var$oi(b), null;
        case 10:
            return $ab0f4e46668e4381$var$og(b), null;
        case 17:
            return $ab0f4e46668e4381$var$L(b.type) && $ab0f4e46668e4381$var$Df(), null;
        case 19:
            $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) $ab0f4e46668e4381$var$ri(d, !1);
                else {
                    if ($ab0f4e46668e4381$var$S !== $ab0f4e46668e4381$var$ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = $ab0f4e46668e4381$var$hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            $ab0f4e46668e4381$var$ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$M, $ab0f4e46668e4381$var$M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = $ab0f4e46668e4381$var$hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), $ab0f4e46668e4381$var$ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $ab0f4e46668e4381$var$$f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, $ab0f4e46668e4381$var$ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $ab0f4e46668e4381$var$$f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $ab0f4e46668e4381$var$$f(), c.sibling = null, b = $ab0f4e46668e4381$var$M.current, $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error($ab0f4e46668e4381$var$u(156, b.tag));
}
function $ab0f4e46668e4381$var$zi(a) {
    switch(a.tag){
        case 1:
            $ab0f4e46668e4381$var$L(a.type) && $ab0f4e46668e4381$var$Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            $ab0f4e46668e4381$var$eh();
            $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$K);
            $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error($ab0f4e46668e4381$var$u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return $ab0f4e46668e4381$var$gh(a), null;
        case 13:
            return $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$M), null;
        case 4:
            return $ab0f4e46668e4381$var$eh(), null;
        case 10:
            return $ab0f4e46668e4381$var$og(a), null;
        default:
            return null;
    }
}
function $ab0f4e46668e4381$var$Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: $ab0f4e46668e4381$var$qb(b)
    };
}
var $ab0f4e46668e4381$var$Bi = "function" === typeof WeakSet ? WeakSet : Set;
function $ab0f4e46668e4381$var$Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = $ab0f4e46668e4381$var$qb(c));
    null !== c && $ab0f4e46668e4381$var$pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && $ab0f4e46668e4381$var$pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function $ab0f4e46668e4381$var$Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        $ab0f4e46668e4381$var$Ei(a, c);
    }
}
function $ab0f4e46668e4381$var$Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $ab0f4e46668e4381$var$Ei(a, c);
        }
        else b.current = null;
    }
}
function $ab0f4e46668e4381$var$Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $ab0f4e46668e4381$var$ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($ab0f4e46668e4381$var$u(163));
}
function $ab0f4e46668e4381$var$Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $ab0f4e46668e4381$var$Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $ab0f4e46668e4381$var$Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            $ab0f4e46668e4381$var$Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : $ab0f4e46668e4381$var$ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && $ab0f4e46668e4381$var$Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $ab0f4e46668e4381$var$Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && $ab0f4e46668e4381$var$Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $ab0f4e46668e4381$var$Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error($ab0f4e46668e4381$var$u(163));
}
function $ab0f4e46668e4381$var$Ki(a, b, c) {
    "function" === typeof $ab0f4e46668e4381$var$Li && $ab0f4e46668e4381$var$Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                $ab0f4e46668e4381$var$cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                $ab0f4e46668e4381$var$Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            $ab0f4e46668e4381$var$Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && $ab0f4e46668e4381$var$Di(b, c);
            break;
        case 5:
            $ab0f4e46668e4381$var$Fi(b);
            break;
        case 4:
            $ab0f4e46668e4381$var$Mi(a, b, c);
    }
}
function $ab0f4e46668e4381$var$Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && $ab0f4e46668e4381$var$Ni(b);
}
function $ab0f4e46668e4381$var$Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $ab0f4e46668e4381$var$Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($ab0f4e46668e4381$var$Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error($ab0f4e46668e4381$var$u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($ab0f4e46668e4381$var$u(161));
    }
    c.effectTag & 16 && ($ab0f4e46668e4381$var$Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $ab0f4e46668e4381$var$Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $ab0f4e46668e4381$var$Qi(a, c, b) : $ab0f4e46668e4381$var$Ri(a, c, b);
}
function $ab0f4e46668e4381$var$Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $ab0f4e46668e4381$var$sd));
    else if (4 !== d && (a = a.child, null !== a)) for($ab0f4e46668e4381$var$Qi(a, b, c), a = a.sibling; null !== a;)$ab0f4e46668e4381$var$Qi(a, b, c), a = a.sibling;
}
function $ab0f4e46668e4381$var$Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($ab0f4e46668e4381$var$Ri(a, b, c), a = a.sibling; null !== a;)$ab0f4e46668e4381$var$Ri(a, b, c), a = a.sibling;
}
function $ab0f4e46668e4381$var$Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error($ab0f4e46668e4381$var$u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if ($ab0f4e46668e4381$var$Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if ($ab0f4e46668e4381$var$Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function $ab0f4e46668e4381$var$Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            $ab0f4e46668e4381$var$Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$ab0f4e46668e4381$var$Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && $ab0f4e46668e4381$var$Bb(c, d);
                    $ab0f4e46668e4381$var$pd(a, e);
                    b = $ab0f4e46668e4381$var$pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $ab0f4e46668e4381$var$md(c, h) : "dangerouslySetInnerHTML" === g ? $ab0f4e46668e4381$var$Qb(c, h) : "children" === g ? $ab0f4e46668e4381$var$Rb(c, h) : $ab0f4e46668e4381$var$Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $ab0f4e46668e4381$var$Cb(c, d);
                            break;
                        case "textarea":
                            $ab0f4e46668e4381$var$Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? $ab0f4e46668e4381$var$Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? $ab0f4e46668e4381$var$Hb(c, !!d.multiple, d.defaultValue, !0) : $ab0f4e46668e4381$var$Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($ab0f4e46668e4381$var$u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, $ab0f4e46668e4381$var$Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, $ab0f4e46668e4381$var$Ti = $ab0f4e46668e4381$var$$f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = $ab0f4e46668e4381$var$ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            $ab0f4e46668e4381$var$Ui(b);
            return;
        case 19:
            $ab0f4e46668e4381$var$Ui(b);
            return;
        case 17:
            return;
    }
    throw Error($ab0f4e46668e4381$var$u(163));
}
function $ab0f4e46668e4381$var$Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $ab0f4e46668e4381$var$Bi);
        b.forEach(function(b) {
            var d = $ab0f4e46668e4381$var$Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var $ab0f4e46668e4381$var$Wi = "function" === typeof WeakMap ? WeakMap : Map;
function $ab0f4e46668e4381$var$Xi(a, b, c) {
    c = $ab0f4e46668e4381$var$wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $ab0f4e46668e4381$var$Yi || ($ab0f4e46668e4381$var$Yi = !0, $ab0f4e46668e4381$var$Zi = d);
        $ab0f4e46668e4381$var$Ci(a, b);
    };
    return c;
}
function $ab0f4e46668e4381$var$$i(a, b, c) {
    c = $ab0f4e46668e4381$var$wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $ab0f4e46668e4381$var$Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $ab0f4e46668e4381$var$aj ? $ab0f4e46668e4381$var$aj = new Set([
            this
        ]) : $ab0f4e46668e4381$var$aj.add(this), $ab0f4e46668e4381$var$Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $ab0f4e46668e4381$var$bj = Math.ceil, $ab0f4e46668e4381$var$cj = $ab0f4e46668e4381$var$Wa.ReactCurrentDispatcher, $ab0f4e46668e4381$var$dj = $ab0f4e46668e4381$var$Wa.ReactCurrentOwner, $ab0f4e46668e4381$var$V = 0, $ab0f4e46668e4381$var$ej = 8, $ab0f4e46668e4381$var$fj = 16, $ab0f4e46668e4381$var$gj = 32, $ab0f4e46668e4381$var$ti = 0, $ab0f4e46668e4381$var$hj = 1, $ab0f4e46668e4381$var$ij = 2, $ab0f4e46668e4381$var$ui = 3, $ab0f4e46668e4381$var$vi = 4, $ab0f4e46668e4381$var$jj = 5, $ab0f4e46668e4381$var$W = $ab0f4e46668e4381$var$V, $ab0f4e46668e4381$var$T = null, $ab0f4e46668e4381$var$X = null, $ab0f4e46668e4381$var$U = 0, $ab0f4e46668e4381$var$S = $ab0f4e46668e4381$var$ti, $ab0f4e46668e4381$var$kj = null, $ab0f4e46668e4381$var$lj = 1073741823, $ab0f4e46668e4381$var$mj = 1073741823, $ab0f4e46668e4381$var$nj = null, $ab0f4e46668e4381$var$wi = 0, $ab0f4e46668e4381$var$oj = !1, $ab0f4e46668e4381$var$Ti = 0, $ab0f4e46668e4381$var$pj = 500, $ab0f4e46668e4381$var$Y = null, $ab0f4e46668e4381$var$Yi = !1, $ab0f4e46668e4381$var$Zi = null, $ab0f4e46668e4381$var$aj = null, $ab0f4e46668e4381$var$qj = !1, $ab0f4e46668e4381$var$rj = null, $ab0f4e46668e4381$var$sj = 90, $ab0f4e46668e4381$var$tj = null, $ab0f4e46668e4381$var$uj = 0, $ab0f4e46668e4381$var$vj = null, $ab0f4e46668e4381$var$wj = 0;
function $ab0f4e46668e4381$var$Gg() {
    return ($ab0f4e46668e4381$var$W & ($ab0f4e46668e4381$var$fj | $ab0f4e46668e4381$var$gj)) !== $ab0f4e46668e4381$var$V ? 1073741821 - ($ab0f4e46668e4381$var$$f() / 10 | 0) : 0 !== $ab0f4e46668e4381$var$wj ? $ab0f4e46668e4381$var$wj : $ab0f4e46668e4381$var$wj = 1073741821 - ($ab0f4e46668e4381$var$$f() / 10 | 0);
}
function $ab0f4e46668e4381$var$Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = $ab0f4e46668e4381$var$ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if (($ab0f4e46668e4381$var$W & $ab0f4e46668e4381$var$fj) !== $ab0f4e46668e4381$var$V) return $ab0f4e46668e4381$var$U;
    if (null !== c) a = $ab0f4e46668e4381$var$hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = $ab0f4e46668e4381$var$hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = $ab0f4e46668e4381$var$hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error($ab0f4e46668e4381$var$u(326));
    }
    null !== $ab0f4e46668e4381$var$T && a === $ab0f4e46668e4381$var$U && --a;
    return a;
}
function $ab0f4e46668e4381$var$Ig(a, b) {
    if (50 < $ab0f4e46668e4381$var$uj) throw $ab0f4e46668e4381$var$uj = 0, $ab0f4e46668e4381$var$vj = null, Error($ab0f4e46668e4381$var$u(185));
    a = $ab0f4e46668e4381$var$xj(a, b);
    if (null !== a) {
        var c = $ab0f4e46668e4381$var$ag();
        1073741823 === b ? ($ab0f4e46668e4381$var$W & $ab0f4e46668e4381$var$ej) !== $ab0f4e46668e4381$var$V && ($ab0f4e46668e4381$var$W & ($ab0f4e46668e4381$var$fj | $ab0f4e46668e4381$var$gj)) === $ab0f4e46668e4381$var$V ? $ab0f4e46668e4381$var$yj(a) : ($ab0f4e46668e4381$var$Z(a), $ab0f4e46668e4381$var$W === $ab0f4e46668e4381$var$V && $ab0f4e46668e4381$var$gg()) : $ab0f4e46668e4381$var$Z(a);
        ($ab0f4e46668e4381$var$W & 4) === $ab0f4e46668e4381$var$V || 98 !== c && 99 !== c || (null === $ab0f4e46668e4381$var$tj ? $ab0f4e46668e4381$var$tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = $ab0f4e46668e4381$var$tj.get(a), (void 0 === c || c > b) && $ab0f4e46668e4381$var$tj.set(a, b)));
    }
}
function $ab0f4e46668e4381$var$xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && ($ab0f4e46668e4381$var$T === e && ($ab0f4e46668e4381$var$Bg(b), $ab0f4e46668e4381$var$S === $ab0f4e46668e4381$var$vi && $ab0f4e46668e4381$var$xi(e, $ab0f4e46668e4381$var$U)), $ab0f4e46668e4381$var$yi(e, b));
    return e;
}
function $ab0f4e46668e4381$var$zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!$ab0f4e46668e4381$var$Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function $ab0f4e46668e4381$var$Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = $ab0f4e46668e4381$var$eg($ab0f4e46668e4381$var$yj.bind(null, a));
    else {
        var b = $ab0f4e46668e4381$var$zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = $ab0f4e46668e4381$var$Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== $ab0f4e46668e4381$var$Tf && $ab0f4e46668e4381$var$Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? $ab0f4e46668e4381$var$eg($ab0f4e46668e4381$var$yj.bind(null, a)) : $ab0f4e46668e4381$var$dg(d, $ab0f4e46668e4381$var$Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $ab0f4e46668e4381$var$$f()
            });
            a.callbackNode = b;
        }
    }
}
function $ab0f4e46668e4381$var$Bj(a, b) {
    $ab0f4e46668e4381$var$wj = 0;
    if (b) return b = $ab0f4e46668e4381$var$Gg(), $ab0f4e46668e4381$var$Cj(a, b), $ab0f4e46668e4381$var$Z(a), null;
    var c = $ab0f4e46668e4381$var$zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if (($ab0f4e46668e4381$var$W & ($ab0f4e46668e4381$var$fj | $ab0f4e46668e4381$var$gj)) !== $ab0f4e46668e4381$var$V) throw Error($ab0f4e46668e4381$var$u(327));
        $ab0f4e46668e4381$var$Dj();
        a === $ab0f4e46668e4381$var$T && c === $ab0f4e46668e4381$var$U || $ab0f4e46668e4381$var$Ej(a, c);
        if (null !== $ab0f4e46668e4381$var$X) {
            var d = $ab0f4e46668e4381$var$W;
            $ab0f4e46668e4381$var$W |= $ab0f4e46668e4381$var$fj;
            var e = $ab0f4e46668e4381$var$Fj();
            for(;;)try {
                $ab0f4e46668e4381$var$Gj();
                break;
            } catch (h) {
                $ab0f4e46668e4381$var$Hj(a, h);
            }
            $ab0f4e46668e4381$var$ng();
            $ab0f4e46668e4381$var$W = d;
            $ab0f4e46668e4381$var$cj.current = e;
            if ($ab0f4e46668e4381$var$S === $ab0f4e46668e4381$var$hj) throw b = $ab0f4e46668e4381$var$kj, $ab0f4e46668e4381$var$Ej(a, c), $ab0f4e46668e4381$var$xi(a, c), $ab0f4e46668e4381$var$Z(a), b;
            if (null === $ab0f4e46668e4381$var$X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = $ab0f4e46668e4381$var$S, $ab0f4e46668e4381$var$T = null, d){
                case $ab0f4e46668e4381$var$ti:
                case $ab0f4e46668e4381$var$hj:
                    throw Error($ab0f4e46668e4381$var$u(345));
                case $ab0f4e46668e4381$var$ij:
                    $ab0f4e46668e4381$var$Cj(a, 2 < c ? 2 : c);
                    break;
                case $ab0f4e46668e4381$var$ui:
                    $ab0f4e46668e4381$var$xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $ab0f4e46668e4381$var$Ij(e));
                    if (1073741823 === $ab0f4e46668e4381$var$lj && (e = $ab0f4e46668e4381$var$Ti + $ab0f4e46668e4381$var$pj - $ab0f4e46668e4381$var$$f(), 10 < e)) {
                        if ($ab0f4e46668e4381$var$oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                $ab0f4e46668e4381$var$Ej(a, c);
                                break;
                            }
                        }
                        f = $ab0f4e46668e4381$var$zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = $ab0f4e46668e4381$var$Hd($ab0f4e46668e4381$var$Jj.bind(null, a), e);
                        break;
                    }
                    $ab0f4e46668e4381$var$Jj(a);
                    break;
                case $ab0f4e46668e4381$var$vi:
                    $ab0f4e46668e4381$var$xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $ab0f4e46668e4381$var$Ij(e));
                    if ($ab0f4e46668e4381$var$oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        $ab0f4e46668e4381$var$Ej(a, c);
                        break;
                    }
                    e = $ab0f4e46668e4381$var$zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== $ab0f4e46668e4381$var$mj ? d = 10 * (1073741821 - $ab0f4e46668e4381$var$mj) - $ab0f4e46668e4381$var$$f() : 1073741823 === $ab0f4e46668e4381$var$lj ? d = 0 : (d = 10 * (1073741821 - $ab0f4e46668e4381$var$lj) - 5E3, e = $ab0f4e46668e4381$var$$f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $ab0f4e46668e4381$var$bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = $ab0f4e46668e4381$var$Hd($ab0f4e46668e4381$var$Jj.bind(null, a), d);
                        break;
                    }
                    $ab0f4e46668e4381$var$Jj(a);
                    break;
                case $ab0f4e46668e4381$var$jj:
                    if (1073741823 !== $ab0f4e46668e4381$var$lj && null !== $ab0f4e46668e4381$var$nj) {
                        f = $ab0f4e46668e4381$var$lj;
                        var g = $ab0f4e46668e4381$var$nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $ab0f4e46668e4381$var$$f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            $ab0f4e46668e4381$var$xi(a, c);
                            a.timeoutHandle = $ab0f4e46668e4381$var$Hd($ab0f4e46668e4381$var$Jj.bind(null, a), d);
                            break;
                        }
                    }
                    $ab0f4e46668e4381$var$Jj(a);
                    break;
                default:
                    throw Error($ab0f4e46668e4381$var$u(329));
            }
            $ab0f4e46668e4381$var$Z(a);
            if (a.callbackNode === b) return $ab0f4e46668e4381$var$Bj.bind(null, a);
        }
    }
    return null;
}
function $ab0f4e46668e4381$var$yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if (($ab0f4e46668e4381$var$W & ($ab0f4e46668e4381$var$fj | $ab0f4e46668e4381$var$gj)) !== $ab0f4e46668e4381$var$V) throw Error($ab0f4e46668e4381$var$u(327));
    $ab0f4e46668e4381$var$Dj();
    a === $ab0f4e46668e4381$var$T && b === $ab0f4e46668e4381$var$U || $ab0f4e46668e4381$var$Ej(a, b);
    if (null !== $ab0f4e46668e4381$var$X) {
        var c = $ab0f4e46668e4381$var$W;
        $ab0f4e46668e4381$var$W |= $ab0f4e46668e4381$var$fj;
        var d = $ab0f4e46668e4381$var$Fj();
        for(;;)try {
            $ab0f4e46668e4381$var$Kj();
            break;
        } catch (e) {
            $ab0f4e46668e4381$var$Hj(a, e);
        }
        $ab0f4e46668e4381$var$ng();
        $ab0f4e46668e4381$var$W = c;
        $ab0f4e46668e4381$var$cj.current = d;
        if ($ab0f4e46668e4381$var$S === $ab0f4e46668e4381$var$hj) throw c = $ab0f4e46668e4381$var$kj, $ab0f4e46668e4381$var$Ej(a, b), $ab0f4e46668e4381$var$xi(a, b), $ab0f4e46668e4381$var$Z(a), c;
        if (null !== $ab0f4e46668e4381$var$X) throw Error($ab0f4e46668e4381$var$u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        $ab0f4e46668e4381$var$T = null;
        $ab0f4e46668e4381$var$Jj(a);
        $ab0f4e46668e4381$var$Z(a);
    }
    return null;
}
function $ab0f4e46668e4381$var$Lj() {
    if (null !== $ab0f4e46668e4381$var$tj) {
        var a = $ab0f4e46668e4381$var$tj;
        $ab0f4e46668e4381$var$tj = null;
        a.forEach(function(a, c) {
            $ab0f4e46668e4381$var$Cj(c, a);
            $ab0f4e46668e4381$var$Z(c);
        });
        $ab0f4e46668e4381$var$gg();
    }
}
function $ab0f4e46668e4381$var$Mj(a, b) {
    var c = $ab0f4e46668e4381$var$W;
    $ab0f4e46668e4381$var$W |= 1;
    try {
        return a(b);
    } finally{
        $ab0f4e46668e4381$var$W = c, $ab0f4e46668e4381$var$W === $ab0f4e46668e4381$var$V && $ab0f4e46668e4381$var$gg();
    }
}
function $ab0f4e46668e4381$var$Nj(a, b) {
    var c = $ab0f4e46668e4381$var$W;
    $ab0f4e46668e4381$var$W &= -2;
    $ab0f4e46668e4381$var$W |= $ab0f4e46668e4381$var$ej;
    try {
        return a(b);
    } finally{
        $ab0f4e46668e4381$var$W = c, $ab0f4e46668e4381$var$W === $ab0f4e46668e4381$var$V && $ab0f4e46668e4381$var$gg();
    }
}
function $ab0f4e46668e4381$var$Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $ab0f4e46668e4381$var$Id(c));
    if (null !== $ab0f4e46668e4381$var$X) for(c = $ab0f4e46668e4381$var$X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $ab0f4e46668e4381$var$Df();
                break;
            case 3:
                $ab0f4e46668e4381$var$eh();
                $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$K);
                $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$J);
                break;
            case 5:
                $ab0f4e46668e4381$var$gh(d);
                break;
            case 4:
                $ab0f4e46668e4381$var$eh();
                break;
            case 13:
                $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$M);
                break;
            case 19:
                $ab0f4e46668e4381$var$H($ab0f4e46668e4381$var$M);
                break;
            case 10:
                $ab0f4e46668e4381$var$og(d);
        }
        c = c.return;
    }
    $ab0f4e46668e4381$var$T = a;
    $ab0f4e46668e4381$var$X = $ab0f4e46668e4381$var$Sg(a.current, null);
    $ab0f4e46668e4381$var$U = b;
    $ab0f4e46668e4381$var$S = $ab0f4e46668e4381$var$ti;
    $ab0f4e46668e4381$var$kj = null;
    $ab0f4e46668e4381$var$mj = $ab0f4e46668e4381$var$lj = 1073741823;
    $ab0f4e46668e4381$var$nj = null;
    $ab0f4e46668e4381$var$wi = 0;
    $ab0f4e46668e4381$var$oj = !1;
}
function $ab0f4e46668e4381$var$Hj(a, b) {
    do {
        try {
            $ab0f4e46668e4381$var$ng();
            $ab0f4e46668e4381$var$jh.current = $ab0f4e46668e4381$var$sh;
            if ($ab0f4e46668e4381$var$mh) for(var c = $ab0f4e46668e4381$var$N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            $ab0f4e46668e4381$var$lh = 0;
            $ab0f4e46668e4381$var$P = $ab0f4e46668e4381$var$O = $ab0f4e46668e4381$var$N = null;
            $ab0f4e46668e4381$var$mh = !1;
            if (null === $ab0f4e46668e4381$var$X || null === $ab0f4e46668e4381$var$X.return) return $ab0f4e46668e4381$var$S = $ab0f4e46668e4381$var$hj, $ab0f4e46668e4381$var$kj = b, $ab0f4e46668e4381$var$X = null;
            a: {
                var e = a, f = $ab0f4e46668e4381$var$X.return, g = $ab0f4e46668e4381$var$X, h = b;
                b = $ab0f4e46668e4381$var$U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== ($ab0f4e46668e4381$var$M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = $ab0f4e46668e4381$var$wg(1073741823, null);
                                        y.tag = 2;
                                        $ab0f4e46668e4381$var$xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new $ab0f4e46668e4381$var$Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = $ab0f4e46668e4381$var$Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error(($ab0f4e46668e4381$var$pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + $ab0f4e46668e4381$var$qb(g));
                }
                $ab0f4e46668e4381$var$S !== $ab0f4e46668e4381$var$jj && ($ab0f4e46668e4381$var$S = $ab0f4e46668e4381$var$ij);
                h = $ab0f4e46668e4381$var$Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = $ab0f4e46668e4381$var$Xi(p, k, b);
                            $ab0f4e46668e4381$var$yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === $ab0f4e46668e4381$var$aj || !$ab0f4e46668e4381$var$aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $ab0f4e46668e4381$var$$i(p, k, b);
                                $ab0f4e46668e4381$var$yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $ab0f4e46668e4381$var$X = $ab0f4e46668e4381$var$Pj($ab0f4e46668e4381$var$X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function $ab0f4e46668e4381$var$Fj() {
    var a = $ab0f4e46668e4381$var$cj.current;
    $ab0f4e46668e4381$var$cj.current = $ab0f4e46668e4381$var$sh;
    return null === a ? $ab0f4e46668e4381$var$sh : a;
}
function $ab0f4e46668e4381$var$Ag(a, b) {
    a < $ab0f4e46668e4381$var$lj && 2 < a && ($ab0f4e46668e4381$var$lj = a);
    null !== b && a < $ab0f4e46668e4381$var$mj && 2 < a && ($ab0f4e46668e4381$var$mj = a, $ab0f4e46668e4381$var$nj = b);
}
function $ab0f4e46668e4381$var$Bg(a) {
    a > $ab0f4e46668e4381$var$wi && ($ab0f4e46668e4381$var$wi = a);
}
function $ab0f4e46668e4381$var$Kj() {
    for(; null !== $ab0f4e46668e4381$var$X;)$ab0f4e46668e4381$var$X = $ab0f4e46668e4381$var$Qj($ab0f4e46668e4381$var$X);
}
function $ab0f4e46668e4381$var$Gj() {
    for(; null !== $ab0f4e46668e4381$var$X && !$ab0f4e46668e4381$var$Uf();)$ab0f4e46668e4381$var$X = $ab0f4e46668e4381$var$Qj($ab0f4e46668e4381$var$X);
}
function $ab0f4e46668e4381$var$Qj(a) {
    var b = $ab0f4e46668e4381$var$Rj(a.alternate, a, $ab0f4e46668e4381$var$U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = $ab0f4e46668e4381$var$Pj(a));
    $ab0f4e46668e4381$var$dj.current = null;
    return b;
}
function $ab0f4e46668e4381$var$Pj(a) {
    $ab0f4e46668e4381$var$X = a;
    do {
        var b = $ab0f4e46668e4381$var$X.alternate;
        a = $ab0f4e46668e4381$var$X.return;
        if (0 === ($ab0f4e46668e4381$var$X.effectTag & 2048)) {
            b = $ab0f4e46668e4381$var$si(b, $ab0f4e46668e4381$var$X, $ab0f4e46668e4381$var$U);
            if (1 === $ab0f4e46668e4381$var$U || 1 !== $ab0f4e46668e4381$var$X.childExpirationTime) {
                for(var c = 0, d = $ab0f4e46668e4381$var$X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                $ab0f4e46668e4381$var$X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = $ab0f4e46668e4381$var$X.firstEffect), null !== $ab0f4e46668e4381$var$X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = $ab0f4e46668e4381$var$X.firstEffect), a.lastEffect = $ab0f4e46668e4381$var$X.lastEffect), 1 < $ab0f4e46668e4381$var$X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = $ab0f4e46668e4381$var$X : a.firstEffect = $ab0f4e46668e4381$var$X, a.lastEffect = $ab0f4e46668e4381$var$X));
        } else {
            b = $ab0f4e46668e4381$var$zi($ab0f4e46668e4381$var$X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = $ab0f4e46668e4381$var$X.sibling;
        if (null !== b) return b;
        $ab0f4e46668e4381$var$X = a;
    }while (null !== $ab0f4e46668e4381$var$X);
    $ab0f4e46668e4381$var$S === $ab0f4e46668e4381$var$ti && ($ab0f4e46668e4381$var$S = $ab0f4e46668e4381$var$jj);
    return null;
}
function $ab0f4e46668e4381$var$Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function $ab0f4e46668e4381$var$Jj(a) {
    var b = $ab0f4e46668e4381$var$ag();
    $ab0f4e46668e4381$var$cg(99, $ab0f4e46668e4381$var$Sj.bind(null, a, b));
    return null;
}
function $ab0f4e46668e4381$var$Sj(a, b) {
    do $ab0f4e46668e4381$var$Dj();
    while (null !== $ab0f4e46668e4381$var$rj);
    if (($ab0f4e46668e4381$var$W & ($ab0f4e46668e4381$var$fj | $ab0f4e46668e4381$var$gj)) !== $ab0f4e46668e4381$var$V) throw Error($ab0f4e46668e4381$var$u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error($ab0f4e46668e4381$var$u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = $ab0f4e46668e4381$var$Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === $ab0f4e46668e4381$var$T && ($ab0f4e46668e4381$var$X = $ab0f4e46668e4381$var$T = null, $ab0f4e46668e4381$var$U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = $ab0f4e46668e4381$var$W;
        $ab0f4e46668e4381$var$W |= $ab0f4e46668e4381$var$gj;
        $ab0f4e46668e4381$var$dj.current = null;
        $ab0f4e46668e4381$var$Dd = $ab0f4e46668e4381$var$fd;
        var g = $ab0f4e46668e4381$var$xd();
        if ($ab0f4e46668e4381$var$yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $ab0f4e46668e4381$var$Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        $ab0f4e46668e4381$var$fd = !1;
        $ab0f4e46668e4381$var$Y = e;
        do try {
            $ab0f4e46668e4381$var$Tj();
        } catch (wb) {
            if (null === $ab0f4e46668e4381$var$Y) throw Error($ab0f4e46668e4381$var$u(330));
            $ab0f4e46668e4381$var$Ei($ab0f4e46668e4381$var$Y, wb);
            $ab0f4e46668e4381$var$Y = $ab0f4e46668e4381$var$Y.nextEffect;
        }
        while (null !== $ab0f4e46668e4381$var$Y);
        $ab0f4e46668e4381$var$Y = e;
        do try {
            for(g = a, h = b; null !== $ab0f4e46668e4381$var$Y;){
                var q = $ab0f4e46668e4381$var$Y.effectTag;
                q & 16 && $ab0f4e46668e4381$var$Rb($ab0f4e46668e4381$var$Y.stateNode, "");
                if (q & 128) {
                    var B = $ab0f4e46668e4381$var$Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        $ab0f4e46668e4381$var$Pi($ab0f4e46668e4381$var$Y);
                        $ab0f4e46668e4381$var$Y.effectTag &= -3;
                        break;
                    case 6:
                        $ab0f4e46668e4381$var$Pi($ab0f4e46668e4381$var$Y);
                        $ab0f4e46668e4381$var$Y.effectTag &= -3;
                        $ab0f4e46668e4381$var$Si($ab0f4e46668e4381$var$Y.alternate, $ab0f4e46668e4381$var$Y);
                        break;
                    case 1024:
                        $ab0f4e46668e4381$var$Y.effectTag &= -1025;
                        break;
                    case 1028:
                        $ab0f4e46668e4381$var$Y.effectTag &= -1025;
                        $ab0f4e46668e4381$var$Si($ab0f4e46668e4381$var$Y.alternate, $ab0f4e46668e4381$var$Y);
                        break;
                    case 4:
                        $ab0f4e46668e4381$var$Si($ab0f4e46668e4381$var$Y.alternate, $ab0f4e46668e4381$var$Y);
                        break;
                    case 8:
                        l = $ab0f4e46668e4381$var$Y, $ab0f4e46668e4381$var$Mi(g, l, h), $ab0f4e46668e4381$var$Ni(l);
                }
                $ab0f4e46668e4381$var$Y = $ab0f4e46668e4381$var$Y.nextEffect;
            }
        } catch (wb) {
            if (null === $ab0f4e46668e4381$var$Y) throw Error($ab0f4e46668e4381$var$u(330));
            $ab0f4e46668e4381$var$Ei($ab0f4e46668e4381$var$Y, wb);
            $ab0f4e46668e4381$var$Y = $ab0f4e46668e4381$var$Y.nextEffect;
        }
        while (null !== $ab0f4e46668e4381$var$Y);
        w = $ab0f4e46668e4381$var$Ed;
        B = $ab0f4e46668e4381$var$xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && $ab0f4e46668e4381$var$wd(q.ownerDocument.documentElement, q)) {
            null !== h && $ab0f4e46668e4381$var$yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = $ab0f4e46668e4381$var$vd(q, g), m = $ab0f4e46668e4381$var$vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        $ab0f4e46668e4381$var$fd = !!$ab0f4e46668e4381$var$Dd;
        $ab0f4e46668e4381$var$Ed = $ab0f4e46668e4381$var$Dd = null;
        a.current = c;
        $ab0f4e46668e4381$var$Y = e;
        do try {
            for(q = a; null !== $ab0f4e46668e4381$var$Y;){
                var ub = $ab0f4e46668e4381$var$Y.effectTag;
                ub & 36 && $ab0f4e46668e4381$var$Ji(q, $ab0f4e46668e4381$var$Y.alternate, $ab0f4e46668e4381$var$Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = $ab0f4e46668e4381$var$Y.ref;
                    if (null !== vb) {
                        var Xc = $ab0f4e46668e4381$var$Y.stateNode;
                        switch($ab0f4e46668e4381$var$Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                $ab0f4e46668e4381$var$Y = $ab0f4e46668e4381$var$Y.nextEffect;
            }
        } catch (wb) {
            if (null === $ab0f4e46668e4381$var$Y) throw Error($ab0f4e46668e4381$var$u(330));
            $ab0f4e46668e4381$var$Ei($ab0f4e46668e4381$var$Y, wb);
            $ab0f4e46668e4381$var$Y = $ab0f4e46668e4381$var$Y.nextEffect;
        }
        while (null !== $ab0f4e46668e4381$var$Y);
        $ab0f4e46668e4381$var$Y = null;
        $ab0f4e46668e4381$var$Vf();
        $ab0f4e46668e4381$var$W = f;
    } else a.current = c;
    if ($ab0f4e46668e4381$var$qj) $ab0f4e46668e4381$var$qj = !1, $ab0f4e46668e4381$var$rj = a, $ab0f4e46668e4381$var$sj = b;
    else for($ab0f4e46668e4381$var$Y = e; null !== $ab0f4e46668e4381$var$Y;)b = $ab0f4e46668e4381$var$Y.nextEffect, $ab0f4e46668e4381$var$Y.nextEffect = null, $ab0f4e46668e4381$var$Y = b;
    b = a.firstPendingTime;
    0 === b && ($ab0f4e46668e4381$var$aj = null);
    1073741823 === b ? a === $ab0f4e46668e4381$var$vj ? $ab0f4e46668e4381$var$uj++ : ($ab0f4e46668e4381$var$uj = 0, $ab0f4e46668e4381$var$vj = a) : $ab0f4e46668e4381$var$uj = 0;
    "function" === typeof $ab0f4e46668e4381$var$Uj && $ab0f4e46668e4381$var$Uj(c.stateNode, d);
    $ab0f4e46668e4381$var$Z(a);
    if ($ab0f4e46668e4381$var$Yi) throw $ab0f4e46668e4381$var$Yi = !1, a = $ab0f4e46668e4381$var$Zi, $ab0f4e46668e4381$var$Zi = null, a;
    if (($ab0f4e46668e4381$var$W & $ab0f4e46668e4381$var$ej) !== $ab0f4e46668e4381$var$V) return null;
    $ab0f4e46668e4381$var$gg();
    return null;
}
function $ab0f4e46668e4381$var$Tj() {
    for(; null !== $ab0f4e46668e4381$var$Y;){
        var a = $ab0f4e46668e4381$var$Y.effectTag;
        0 !== (a & 256) && $ab0f4e46668e4381$var$Gi($ab0f4e46668e4381$var$Y.alternate, $ab0f4e46668e4381$var$Y);
        0 === (a & 512) || $ab0f4e46668e4381$var$qj || ($ab0f4e46668e4381$var$qj = !0, $ab0f4e46668e4381$var$dg(97, function() {
            $ab0f4e46668e4381$var$Dj();
            return null;
        }));
        $ab0f4e46668e4381$var$Y = $ab0f4e46668e4381$var$Y.nextEffect;
    }
}
function $ab0f4e46668e4381$var$Dj() {
    if (90 !== $ab0f4e46668e4381$var$sj) {
        var a = 97 < $ab0f4e46668e4381$var$sj ? 97 : $ab0f4e46668e4381$var$sj;
        $ab0f4e46668e4381$var$sj = 90;
        return $ab0f4e46668e4381$var$cg(a, $ab0f4e46668e4381$var$Vj);
    }
}
function $ab0f4e46668e4381$var$Vj() {
    if (null === $ab0f4e46668e4381$var$rj) return !1;
    var a = $ab0f4e46668e4381$var$rj;
    $ab0f4e46668e4381$var$rj = null;
    if (($ab0f4e46668e4381$var$W & ($ab0f4e46668e4381$var$fj | $ab0f4e46668e4381$var$gj)) !== $ab0f4e46668e4381$var$V) throw Error($ab0f4e46668e4381$var$u(331));
    var b = $ab0f4e46668e4381$var$W;
    $ab0f4e46668e4381$var$W |= $ab0f4e46668e4381$var$gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    $ab0f4e46668e4381$var$Hi(5, c), $ab0f4e46668e4381$var$Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error($ab0f4e46668e4381$var$u(330));
            $ab0f4e46668e4381$var$Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    $ab0f4e46668e4381$var$W = b;
    $ab0f4e46668e4381$var$gg();
    return !0;
}
function $ab0f4e46668e4381$var$Wj(a, b, c) {
    b = $ab0f4e46668e4381$var$Ai(c, b);
    b = $ab0f4e46668e4381$var$Xi(a, b, 1073741823);
    $ab0f4e46668e4381$var$xg(a, b);
    a = $ab0f4e46668e4381$var$xj(a, 1073741823);
    null !== a && $ab0f4e46668e4381$var$Z(a);
}
function $ab0f4e46668e4381$var$Ei(a, b) {
    if (3 === a.tag) $ab0f4e46668e4381$var$Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $ab0f4e46668e4381$var$Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $ab0f4e46668e4381$var$aj || !$ab0f4e46668e4381$var$aj.has(d))) {
                a = $ab0f4e46668e4381$var$Ai(b, a);
                a = $ab0f4e46668e4381$var$$i(c, a, 1073741823);
                $ab0f4e46668e4381$var$xg(c, a);
                c = $ab0f4e46668e4381$var$xj(c, 1073741823);
                null !== c && $ab0f4e46668e4381$var$Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function $ab0f4e46668e4381$var$Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    $ab0f4e46668e4381$var$T === a && $ab0f4e46668e4381$var$U === c ? $ab0f4e46668e4381$var$S === $ab0f4e46668e4381$var$vi || $ab0f4e46668e4381$var$S === $ab0f4e46668e4381$var$ui && 1073741823 === $ab0f4e46668e4381$var$lj && $ab0f4e46668e4381$var$$f() - $ab0f4e46668e4381$var$Ti < $ab0f4e46668e4381$var$pj ? $ab0f4e46668e4381$var$Ej(a, $ab0f4e46668e4381$var$U) : $ab0f4e46668e4381$var$oj = !0 : $ab0f4e46668e4381$var$Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, $ab0f4e46668e4381$var$Z(a)));
}
function $ab0f4e46668e4381$var$Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = $ab0f4e46668e4381$var$Gg(), b = $ab0f4e46668e4381$var$Hg(b, a, null));
    a = $ab0f4e46668e4381$var$xj(a, b);
    null !== a && $ab0f4e46668e4381$var$Z(a);
}
var $ab0f4e46668e4381$var$Rj;
$ab0f4e46668e4381$var$Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || $ab0f4e46668e4381$var$K.current) $ab0f4e46668e4381$var$rg = !0;
        else {
            if (d < c) {
                $ab0f4e46668e4381$var$rg = !1;
                switch(b.tag){
                    case 3:
                        $ab0f4e46668e4381$var$hi(b);
                        $ab0f4e46668e4381$var$Xh();
                        break;
                    case 5:
                        $ab0f4e46668e4381$var$fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        $ab0f4e46668e4381$var$L(b.type) && $ab0f4e46668e4381$var$Gf(b);
                        break;
                    case 4:
                        $ab0f4e46668e4381$var$dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return $ab0f4e46668e4381$var$ji(a, b, c);
                            $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$M, $ab0f4e46668e4381$var$M.current & 1);
                            b = $ab0f4e46668e4381$var$$h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$M, $ab0f4e46668e4381$var$M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return $ab0f4e46668e4381$var$mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$M, $ab0f4e46668e4381$var$M.current);
                        if (!d) return null;
                }
                return $ab0f4e46668e4381$var$$h(a, b, c);
            }
            $ab0f4e46668e4381$var$rg = !1;
        }
    } else $ab0f4e46668e4381$var$rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = $ab0f4e46668e4381$var$Cf(b, $ab0f4e46668e4381$var$J.current);
            $ab0f4e46668e4381$var$qg(b, c);
            e = $ab0f4e46668e4381$var$oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($ab0f4e46668e4381$var$L(d)) {
                    var f = !0;
                    $ab0f4e46668e4381$var$Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $ab0f4e46668e4381$var$ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $ab0f4e46668e4381$var$Fg(b, d, g, a);
                e.updater = $ab0f4e46668e4381$var$Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                $ab0f4e46668e4381$var$Ng(b, d, a, c);
                b = $ab0f4e46668e4381$var$gi(null, b, d, !0, f, c);
            } else b.tag = 0, $ab0f4e46668e4381$var$R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                $ab0f4e46668e4381$var$ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = $ab0f4e46668e4381$var$Xj(e);
                a = $ab0f4e46668e4381$var$ig(e, a);
                switch(f){
                    case 0:
                        b = $ab0f4e46668e4381$var$di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $ab0f4e46668e4381$var$fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $ab0f4e46668e4381$var$Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $ab0f4e46668e4381$var$ai(null, b, e, $ab0f4e46668e4381$var$ig(e.type, a), d, c);
                        break a;
                }
                throw Error($ab0f4e46668e4381$var$u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ab0f4e46668e4381$var$ig(d, e), $ab0f4e46668e4381$var$di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ab0f4e46668e4381$var$ig(d, e), $ab0f4e46668e4381$var$fi(a, b, d, e, c);
        case 3:
            $ab0f4e46668e4381$var$hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($ab0f4e46668e4381$var$u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $ab0f4e46668e4381$var$vg(a, b);
            $ab0f4e46668e4381$var$zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $ab0f4e46668e4381$var$Xh(), b = $ab0f4e46668e4381$var$$h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) $ab0f4e46668e4381$var$Ph = $ab0f4e46668e4381$var$Jd(b.stateNode.containerInfo.firstChild), $ab0f4e46668e4381$var$Oh = b, e = $ab0f4e46668e4381$var$Qh = !0;
                if (e) for(c = $ab0f4e46668e4381$var$Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else $ab0f4e46668e4381$var$R(a, b, d, c), $ab0f4e46668e4381$var$Xh();
                b = b.child;
            }
            return b;
        case 5:
            return $ab0f4e46668e4381$var$fh(b), null === a && $ab0f4e46668e4381$var$Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $ab0f4e46668e4381$var$Gd(d, e) ? g = null : null !== f && $ab0f4e46668e4381$var$Gd(d, f) && (b.effectTag |= 16), $ab0f4e46668e4381$var$ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : ($ab0f4e46668e4381$var$R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && $ab0f4e46668e4381$var$Uh(b), null;
        case 13:
            return $ab0f4e46668e4381$var$ji(a, b, c);
        case 4:
            return $ab0f4e46668e4381$var$dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $ab0f4e46668e4381$var$Xg(b, null, d, c) : $ab0f4e46668e4381$var$R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ab0f4e46668e4381$var$ig(d, e), $ab0f4e46668e4381$var$Zh(a, b, d, e, c);
        case 7:
            return $ab0f4e46668e4381$var$R(a, b, b.pendingProps, c), b.child;
        case 8:
            return $ab0f4e46668e4381$var$R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $ab0f4e46668e4381$var$R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $ab0f4e46668e4381$var$I($ab0f4e46668e4381$var$jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $ab0f4e46668e4381$var$$e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$ab0f4e46668e4381$var$K.current) {
                            b = $ab0f4e46668e4381$var$$h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $ab0f4e46668e4381$var$wg(c, null), l.tag = 2, $ab0f4e46668e4381$var$xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    $ab0f4e46668e4381$var$pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $ab0f4e46668e4381$var$R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $ab0f4e46668e4381$var$qg(b, c), e = $ab0f4e46668e4381$var$sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, $ab0f4e46668e4381$var$R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $ab0f4e46668e4381$var$ig(e, b.pendingProps), f = $ab0f4e46668e4381$var$ig(e.type, f), $ab0f4e46668e4381$var$ai(a, b, e, f, d, c);
        case 15:
            return $ab0f4e46668e4381$var$ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ab0f4e46668e4381$var$ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, $ab0f4e46668e4381$var$L(d) ? (a = !0, $ab0f4e46668e4381$var$Gf(b)) : a = !1, $ab0f4e46668e4381$var$qg(b, c), $ab0f4e46668e4381$var$Lg(b, d, e), $ab0f4e46668e4381$var$Ng(b, d, e, c), $ab0f4e46668e4381$var$gi(null, b, d, !0, a, c);
        case 19:
            return $ab0f4e46668e4381$var$mi(a, b, c);
    }
    throw Error($ab0f4e46668e4381$var$u(156, b.tag));
};
var $ab0f4e46668e4381$var$Uj = null, $ab0f4e46668e4381$var$Li = null;
function $ab0f4e46668e4381$var$Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        $ab0f4e46668e4381$var$Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        $ab0f4e46668e4381$var$Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function $ab0f4e46668e4381$var$Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function $ab0f4e46668e4381$var$Sh(a, b, c, d) {
    return new $ab0f4e46668e4381$var$Zj(a, b, c, d);
}
function $ab0f4e46668e4381$var$bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $ab0f4e46668e4381$var$Xj(a) {
    if ("function" === typeof a) return $ab0f4e46668e4381$var$bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $ab0f4e46668e4381$var$gb) return 11;
        if (a === $ab0f4e46668e4381$var$jb) return 14;
    }
    return 2;
}
function $ab0f4e46668e4381$var$Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = $ab0f4e46668e4381$var$Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $ab0f4e46668e4381$var$Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $ab0f4e46668e4381$var$bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $ab0f4e46668e4381$var$ab:
            return $ab0f4e46668e4381$var$Wg(c.children, e, f, b);
        case $ab0f4e46668e4381$var$fb:
            g = 8;
            e |= 7;
            break;
        case $ab0f4e46668e4381$var$bb:
            g = 8;
            e |= 1;
            break;
        case $ab0f4e46668e4381$var$cb:
            return a = $ab0f4e46668e4381$var$Sh(12, c, b, e | 8), a.elementType = $ab0f4e46668e4381$var$cb, a.type = $ab0f4e46668e4381$var$cb, a.expirationTime = f, a;
        case $ab0f4e46668e4381$var$hb:
            return a = $ab0f4e46668e4381$var$Sh(13, c, b, e), a.type = $ab0f4e46668e4381$var$hb, a.elementType = $ab0f4e46668e4381$var$hb, a.expirationTime = f, a;
        case $ab0f4e46668e4381$var$ib:
            return a = $ab0f4e46668e4381$var$Sh(19, c, b, e), a.elementType = $ab0f4e46668e4381$var$ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $ab0f4e46668e4381$var$db:
                    g = 10;
                    break a;
                case $ab0f4e46668e4381$var$eb:
                    g = 9;
                    break a;
                case $ab0f4e46668e4381$var$gb:
                    g = 11;
                    break a;
                case $ab0f4e46668e4381$var$jb:
                    g = 14;
                    break a;
                case $ab0f4e46668e4381$var$kb:
                    g = 16;
                    d = null;
                    break a;
                case $ab0f4e46668e4381$var$lb:
                    g = 22;
                    break a;
            }
            throw Error($ab0f4e46668e4381$var$u(130, null == a ? a : typeof a, ""));
    }
    b = $ab0f4e46668e4381$var$Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function $ab0f4e46668e4381$var$Wg(a, b, c, d) {
    a = $ab0f4e46668e4381$var$Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function $ab0f4e46668e4381$var$Tg(a, b, c) {
    a = $ab0f4e46668e4381$var$Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function $ab0f4e46668e4381$var$Vg(a, b, c) {
    b = $ab0f4e46668e4381$var$Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $ab0f4e46668e4381$var$ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function $ab0f4e46668e4381$var$Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function $ab0f4e46668e4381$var$xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function $ab0f4e46668e4381$var$yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function $ab0f4e46668e4381$var$Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function $ab0f4e46668e4381$var$bk(a, b, c, d) {
    var e = b.current, f = $ab0f4e46668e4381$var$Gg(), g = $ab0f4e46668e4381$var$Dg.suspense;
    f = $ab0f4e46668e4381$var$Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if ($ab0f4e46668e4381$var$dc(c) !== c || 1 !== c.tag) throw Error($ab0f4e46668e4381$var$u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($ab0f4e46668e4381$var$L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($ab0f4e46668e4381$var$u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($ab0f4e46668e4381$var$L(k)) {
                c = $ab0f4e46668e4381$var$Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $ab0f4e46668e4381$var$Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $ab0f4e46668e4381$var$wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $ab0f4e46668e4381$var$xg(e, b);
    $ab0f4e46668e4381$var$Ig(e, f);
    return f;
}
function $ab0f4e46668e4381$var$ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $ab0f4e46668e4381$var$dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function $ab0f4e46668e4381$var$ek(a, b) {
    $ab0f4e46668e4381$var$dk(a, b);
    (a = a.alternate) && $ab0f4e46668e4381$var$dk(a, b);
}
function $ab0f4e46668e4381$var$fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new $ab0f4e46668e4381$var$ak(a, b, c), e = $ab0f4e46668e4381$var$Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    $ab0f4e46668e4381$var$ug(e);
    a[$ab0f4e46668e4381$var$Od] = d.current;
    c && 0 !== b && $ab0f4e46668e4381$var$Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
$ab0f4e46668e4381$var$fk.prototype.render = function(a) {
    $ab0f4e46668e4381$var$bk(a, this._internalRoot, null, null);
};
$ab0f4e46668e4381$var$fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $ab0f4e46668e4381$var$bk(null, a, null, function() {
        b[$ab0f4e46668e4381$var$Od] = null;
    });
};
function $ab0f4e46668e4381$var$gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $ab0f4e46668e4381$var$hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $ab0f4e46668e4381$var$fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $ab0f4e46668e4381$var$ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $ab0f4e46668e4381$var$ck(g);
                h.call(a);
            };
        }
        $ab0f4e46668e4381$var$bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $ab0f4e46668e4381$var$hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $ab0f4e46668e4381$var$ck(g);
                k.call(a);
            };
        }
        $ab0f4e46668e4381$var$Nj(function() {
            $ab0f4e46668e4381$var$bk(b, g, a, e);
        });
    }
    return $ab0f4e46668e4381$var$ck(g);
}
function $ab0f4e46668e4381$var$jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $ab0f4e46668e4381$var$$a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
$ab0f4e46668e4381$var$wc = function(a) {
    if (13 === a.tag) {
        var b = $ab0f4e46668e4381$var$hg($ab0f4e46668e4381$var$Gg(), 150, 100);
        $ab0f4e46668e4381$var$Ig(a, b);
        $ab0f4e46668e4381$var$ek(a, b);
    }
};
$ab0f4e46668e4381$var$xc = function(a) {
    13 === a.tag && ($ab0f4e46668e4381$var$Ig(a, 3), $ab0f4e46668e4381$var$ek(a, 3));
};
$ab0f4e46668e4381$var$yc = function(a) {
    if (13 === a.tag) {
        var b = $ab0f4e46668e4381$var$Gg();
        b = $ab0f4e46668e4381$var$Hg(b, a, null);
        $ab0f4e46668e4381$var$Ig(a, b);
        $ab0f4e46668e4381$var$ek(a, b);
    }
};
$ab0f4e46668e4381$var$za = function(a, b, c) {
    switch(b){
        case "input":
            $ab0f4e46668e4381$var$Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $ab0f4e46668e4381$var$Qd(d);
                        if (!e) throw Error($ab0f4e46668e4381$var$u(90));
                        $ab0f4e46668e4381$var$yb(d);
                        $ab0f4e46668e4381$var$Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $ab0f4e46668e4381$var$Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && $ab0f4e46668e4381$var$Hb(a, !!c.multiple, b, !1);
    }
};
$ab0f4e46668e4381$var$Fa = $ab0f4e46668e4381$var$Mj;
$ab0f4e46668e4381$var$Ga = function(a, b, c, d, e) {
    var f = $ab0f4e46668e4381$var$W;
    $ab0f4e46668e4381$var$W |= 4;
    try {
        return $ab0f4e46668e4381$var$cg(98, a.bind(null, b, c, d, e));
    } finally{
        $ab0f4e46668e4381$var$W = f, $ab0f4e46668e4381$var$W === $ab0f4e46668e4381$var$V && $ab0f4e46668e4381$var$gg();
    }
};
$ab0f4e46668e4381$var$Ha = function() {
    ($ab0f4e46668e4381$var$W & (1 | $ab0f4e46668e4381$var$fj | $ab0f4e46668e4381$var$gj)) === $ab0f4e46668e4381$var$V && ($ab0f4e46668e4381$var$Lj(), $ab0f4e46668e4381$var$Dj());
};
$ab0f4e46668e4381$var$Ia = function(a, b) {
    var c = $ab0f4e46668e4381$var$W;
    $ab0f4e46668e4381$var$W |= 2;
    try {
        return a(b);
    } finally{
        $ab0f4e46668e4381$var$W = c, $ab0f4e46668e4381$var$W === $ab0f4e46668e4381$var$V && $ab0f4e46668e4381$var$gg();
    }
};
function $ab0f4e46668e4381$var$kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$ab0f4e46668e4381$var$gk(b)) throw Error($ab0f4e46668e4381$var$u(200));
    return $ab0f4e46668e4381$var$jk(a, b, null, c);
}
var $ab0f4e46668e4381$var$lk = {
    Events: [
        $ab0f4e46668e4381$var$Nc,
        $ab0f4e46668e4381$var$Pd,
        $ab0f4e46668e4381$var$Qd,
        $ab0f4e46668e4381$var$xa,
        $ab0f4e46668e4381$var$ta,
        $ab0f4e46668e4381$var$Xd,
        function(a) {
            $ab0f4e46668e4381$var$jc(a, $ab0f4e46668e4381$var$Wd);
        },
        $ab0f4e46668e4381$var$Da,
        $ab0f4e46668e4381$var$Ea,
        $ab0f4e46668e4381$var$id,
        $ab0f4e46668e4381$var$mc,
        $ab0f4e46668e4381$var$Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return $ab0f4e46668e4381$var$Yj($MsCOU({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: $ab0f4e46668e4381$var$Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = $ab0f4e46668e4381$var$hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: $ab0f4e46668e4381$var$tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
$ab0f4e46668e4381$export$ae55be85d98224ed = $ab0f4e46668e4381$var$lk;
$ab0f4e46668e4381$export$d39a5bbd09211389 = $ab0f4e46668e4381$var$kk;
$ab0f4e46668e4381$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($ab0f4e46668e4381$var$u(188));
        throw Error($ab0f4e46668e4381$var$u(268, Object.keys(a)));
    }
    a = $ab0f4e46668e4381$var$hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$ab0f4e46668e4381$export$cd75ccfd720a3cd4 = function(a, b) {
    if (($ab0f4e46668e4381$var$W & ($ab0f4e46668e4381$var$fj | $ab0f4e46668e4381$var$gj)) !== $ab0f4e46668e4381$var$V) throw Error($ab0f4e46668e4381$var$u(187));
    var c = $ab0f4e46668e4381$var$W;
    $ab0f4e46668e4381$var$W |= 1;
    try {
        return $ab0f4e46668e4381$var$cg(99, a.bind(null, b));
    } finally{
        $ab0f4e46668e4381$var$W = c, $ab0f4e46668e4381$var$gg();
    }
};
$ab0f4e46668e4381$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$ab0f4e46668e4381$var$gk(b)) throw Error($ab0f4e46668e4381$var$u(200));
    return $ab0f4e46668e4381$var$ik(null, a, b, !0, c);
};
$ab0f4e46668e4381$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$ab0f4e46668e4381$var$gk(b)) throw Error($ab0f4e46668e4381$var$u(200));
    return $ab0f4e46668e4381$var$ik(null, a, b, !1, c);
};
$ab0f4e46668e4381$export$502457920280e6be = function(a) {
    if (!$ab0f4e46668e4381$var$gk(a)) throw Error($ab0f4e46668e4381$var$u(40));
    return a._reactRootContainer ? ($ab0f4e46668e4381$var$Nj(function() {
        $ab0f4e46668e4381$var$ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$ab0f4e46668e4381$var$Od] = null;
        });
    }), !0) : !1;
};
$ab0f4e46668e4381$export$c78a37762a8d58e1 = $ab0f4e46668e4381$var$Mj;
$ab0f4e46668e4381$export$2577ef5d2565d52f = function(a, b) {
    return $ab0f4e46668e4381$var$kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$ab0f4e46668e4381$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$ab0f4e46668e4381$var$gk(c)) throw Error($ab0f4e46668e4381$var$u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error($ab0f4e46668e4381$var$u(38));
    return $ab0f4e46668e4381$var$ik(a, b, c, !1, d);
};
$ab0f4e46668e4381$export$83d89fbfd8236492 = "16.14.0";

});
parcelRequire.register("5GQyf", function(module, exports) {
"use strict";

module.exports = (parcelRequire("69TIK"));

});
parcelRequire.register("69TIK", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $47bece5708b11508$export$c4744153514ff05d, (v) => $47bece5708b11508$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $47bece5708b11508$export$d66a1c1c77bd778b, (v) => $47bece5708b11508$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $47bece5708b11508$export$3e506c1ccc9cc1a7, (v) => $47bece5708b11508$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $47bece5708b11508$export$e26fe2ed2fa76875, (v) => $47bece5708b11508$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $47bece5708b11508$export$502329bbf4b505b1, (v) => $47bece5708b11508$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $47bece5708b11508$export$6e3807111c4874c4, (v) => $47bece5708b11508$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $47bece5708b11508$export$c27134553091fb3a, (v) => $47bece5708b11508$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $47bece5708b11508$export$33ee1acdc04fd2a2, (v) => $47bece5708b11508$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $47bece5708b11508$export$b00a404bbd5edef2, (v) => $47bece5708b11508$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $47bece5708b11508$export$8352ce38b91d0c62, (v) => $47bece5708b11508$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $47bece5708b11508$export$d3dfb8e4810cb555, (v) => $47bece5708b11508$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $47bece5708b11508$export$839f9183b0465a69, (v) => $47bece5708b11508$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $47bece5708b11508$export$72fdf0e06517287b, (v) => $47bece5708b11508$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $47bece5708b11508$export$4b844e58a3e414b4, (v) => $47bece5708b11508$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $47bece5708b11508$export$816d2913ae6b83b1, (v) => $47bece5708b11508$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $47bece5708b11508$export$61bcfe829111a1d0, (v) => $47bece5708b11508$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $47bece5708b11508$export$7ee8c9beb337bc3f, (v) => $47bece5708b11508$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $47bece5708b11508$export$b5836b71941fa3ed, (v) => $47bece5708b11508$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $47bece5708b11508$export$cf845f2c119da08a, (v) => $47bece5708b11508$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $47bece5708b11508$export$c4744153514ff05d;
var $47bece5708b11508$export$d66a1c1c77bd778b;
var $47bece5708b11508$export$3e506c1ccc9cc1a7;
var $47bece5708b11508$export$e26fe2ed2fa76875;
var $47bece5708b11508$export$502329bbf4b505b1;
var $47bece5708b11508$export$6e3807111c4874c4;
var $47bece5708b11508$export$c27134553091fb3a;
var $47bece5708b11508$export$33ee1acdc04fd2a2;
var $47bece5708b11508$export$b00a404bbd5edef2;
var $47bece5708b11508$export$8352ce38b91d0c62;
var $47bece5708b11508$export$d3dfb8e4810cb555;
var $47bece5708b11508$export$839f9183b0465a69;
var $47bece5708b11508$export$72fdf0e06517287b;
var $47bece5708b11508$export$4b844e58a3e414b4;
var $47bece5708b11508$export$816d2913ae6b83b1;
var $47bece5708b11508$export$61bcfe829111a1d0;
var $47bece5708b11508$export$7ee8c9beb337bc3f;
var $47bece5708b11508$export$b5836b71941fa3ed;
var $47bece5708b11508$export$cf845f2c119da08a;
"use strict";
var $47bece5708b11508$var$f, $47bece5708b11508$var$g, $47bece5708b11508$var$h, $47bece5708b11508$var$k, $47bece5708b11508$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $47bece5708b11508$var$p = null, $47bece5708b11508$var$q = null, $47bece5708b11508$var$t = function() {
        if (null !== $47bece5708b11508$var$p) try {
            var a = $47bece5708b11508$export$c4744153514ff05d();
            $47bece5708b11508$var$p(!0, a);
            $47bece5708b11508$var$p = null;
        } catch (b) {
            throw setTimeout($47bece5708b11508$var$t, 0), b;
        }
    }, $47bece5708b11508$var$u = Date.now();
    $47bece5708b11508$export$c4744153514ff05d = function() {
        return Date.now() - $47bece5708b11508$var$u;
    };
    $47bece5708b11508$var$f = function(a) {
        null !== $47bece5708b11508$var$p ? setTimeout($47bece5708b11508$var$f, 0, a) : ($47bece5708b11508$var$p = a, setTimeout($47bece5708b11508$var$t, 0));
    };
    $47bece5708b11508$var$g = function(a, b) {
        $47bece5708b11508$var$q = setTimeout(a, b);
    };
    $47bece5708b11508$var$h = function() {
        clearTimeout($47bece5708b11508$var$q);
    };
    $47bece5708b11508$var$k = function() {
        return !1;
    };
    $47bece5708b11508$var$l = $47bece5708b11508$export$d66a1c1c77bd778b = function() {};
} else {
    var $47bece5708b11508$var$w = window.performance, $47bece5708b11508$var$x = window.Date, $47bece5708b11508$var$y = window.setTimeout, $47bece5708b11508$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $47bece5708b11508$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $47bece5708b11508$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $47bece5708b11508$var$w && "function" === typeof $47bece5708b11508$var$w.now) $47bece5708b11508$export$c4744153514ff05d = function() {
        return $47bece5708b11508$var$w.now();
    };
    else {
        var $47bece5708b11508$var$B = $47bece5708b11508$var$x.now();
        $47bece5708b11508$export$c4744153514ff05d = function() {
            return $47bece5708b11508$var$x.now() - $47bece5708b11508$var$B;
        };
    }
    var $47bece5708b11508$var$C = !1, $47bece5708b11508$var$D = null, $47bece5708b11508$var$E = -1, $47bece5708b11508$var$F = 5, $47bece5708b11508$var$G = 0;
    $47bece5708b11508$var$k = function() {
        return $47bece5708b11508$export$c4744153514ff05d() >= $47bece5708b11508$var$G;
    };
    $47bece5708b11508$var$l = function() {};
    $47bece5708b11508$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $47bece5708b11508$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $47bece5708b11508$var$H = new MessageChannel, $47bece5708b11508$var$I = $47bece5708b11508$var$H.port2;
    $47bece5708b11508$var$H.port1.onmessage = function() {
        if (null !== $47bece5708b11508$var$D) {
            var a = $47bece5708b11508$export$c4744153514ff05d();
            $47bece5708b11508$var$G = a + $47bece5708b11508$var$F;
            try {
                $47bece5708b11508$var$D(!0, a) ? $47bece5708b11508$var$I.postMessage(null) : ($47bece5708b11508$var$C = !1, $47bece5708b11508$var$D = null);
            } catch (b) {
                throw $47bece5708b11508$var$I.postMessage(null), b;
            }
        } else $47bece5708b11508$var$C = !1;
    };
    $47bece5708b11508$var$f = function(a) {
        $47bece5708b11508$var$D = a;
        $47bece5708b11508$var$C || ($47bece5708b11508$var$C = !0, $47bece5708b11508$var$I.postMessage(null));
    };
    $47bece5708b11508$var$g = function(a, b) {
        $47bece5708b11508$var$E = $47bece5708b11508$var$y(function() {
            a($47bece5708b11508$export$c4744153514ff05d());
        }, b);
    };
    $47bece5708b11508$var$h = function() {
        $47bece5708b11508$var$z($47bece5708b11508$var$E);
        $47bece5708b11508$var$E = -1;
    };
}
function $47bece5708b11508$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $47bece5708b11508$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $47bece5708b11508$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $47bece5708b11508$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $47bece5708b11508$var$K(n, c)) void 0 !== r && 0 > $47bece5708b11508$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $47bece5708b11508$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $47bece5708b11508$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $47bece5708b11508$var$N = [], $47bece5708b11508$var$O = [], $47bece5708b11508$var$P = 1, $47bece5708b11508$var$Q = null, $47bece5708b11508$var$R = 3, $47bece5708b11508$var$S = !1, $47bece5708b11508$var$T = !1, $47bece5708b11508$var$U = !1;
function $47bece5708b11508$var$V(a) {
    for(var b = $47bece5708b11508$var$L($47bece5708b11508$var$O); null !== b;){
        if (null === b.callback) $47bece5708b11508$var$M($47bece5708b11508$var$O);
        else if (b.startTime <= a) $47bece5708b11508$var$M($47bece5708b11508$var$O), b.sortIndex = b.expirationTime, $47bece5708b11508$var$J($47bece5708b11508$var$N, b);
        else break;
        b = $47bece5708b11508$var$L($47bece5708b11508$var$O);
    }
}
function $47bece5708b11508$var$W(a) {
    $47bece5708b11508$var$U = !1;
    $47bece5708b11508$var$V(a);
    if (!$47bece5708b11508$var$T) {
        if (null !== $47bece5708b11508$var$L($47bece5708b11508$var$N)) $47bece5708b11508$var$T = !0, $47bece5708b11508$var$f($47bece5708b11508$var$X);
        else {
            var b = $47bece5708b11508$var$L($47bece5708b11508$var$O);
            null !== b && $47bece5708b11508$var$g($47bece5708b11508$var$W, b.startTime - a);
        }
    }
}
function $47bece5708b11508$var$X(a, b) {
    $47bece5708b11508$var$T = !1;
    $47bece5708b11508$var$U && ($47bece5708b11508$var$U = !1, $47bece5708b11508$var$h());
    $47bece5708b11508$var$S = !0;
    var c = $47bece5708b11508$var$R;
    try {
        $47bece5708b11508$var$V(b);
        for($47bece5708b11508$var$Q = $47bece5708b11508$var$L($47bece5708b11508$var$N); null !== $47bece5708b11508$var$Q && (!($47bece5708b11508$var$Q.expirationTime > b) || a && !$47bece5708b11508$var$k());){
            var d = $47bece5708b11508$var$Q.callback;
            if (null !== d) {
                $47bece5708b11508$var$Q.callback = null;
                $47bece5708b11508$var$R = $47bece5708b11508$var$Q.priorityLevel;
                var e = d($47bece5708b11508$var$Q.expirationTime <= b);
                b = $47bece5708b11508$export$c4744153514ff05d();
                "function" === typeof e ? $47bece5708b11508$var$Q.callback = e : $47bece5708b11508$var$Q === $47bece5708b11508$var$L($47bece5708b11508$var$N) && $47bece5708b11508$var$M($47bece5708b11508$var$N);
                $47bece5708b11508$var$V(b);
            } else $47bece5708b11508$var$M($47bece5708b11508$var$N);
            $47bece5708b11508$var$Q = $47bece5708b11508$var$L($47bece5708b11508$var$N);
        }
        if (null !== $47bece5708b11508$var$Q) var m = !0;
        else {
            var n = $47bece5708b11508$var$L($47bece5708b11508$var$O);
            null !== n && $47bece5708b11508$var$g($47bece5708b11508$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $47bece5708b11508$var$Q = null, $47bece5708b11508$var$R = c, $47bece5708b11508$var$S = !1;
    }
}
function $47bece5708b11508$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $47bece5708b11508$var$Z = $47bece5708b11508$var$l;
$47bece5708b11508$export$3e506c1ccc9cc1a7 = 5;
$47bece5708b11508$export$e26fe2ed2fa76875 = 1;
$47bece5708b11508$export$502329bbf4b505b1 = 4;
$47bece5708b11508$export$6e3807111c4874c4 = 3;
$47bece5708b11508$export$c27134553091fb3a = null;
$47bece5708b11508$export$33ee1acdc04fd2a2 = 2;
$47bece5708b11508$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$47bece5708b11508$export$8352ce38b91d0c62 = function() {
    $47bece5708b11508$var$T || $47bece5708b11508$var$S || ($47bece5708b11508$var$T = !0, $47bece5708b11508$var$f($47bece5708b11508$var$X));
};
$47bece5708b11508$export$d3dfb8e4810cb555 = function() {
    return $47bece5708b11508$var$R;
};
$47bece5708b11508$export$839f9183b0465a69 = function() {
    return $47bece5708b11508$var$L($47bece5708b11508$var$N);
};
$47bece5708b11508$export$72fdf0e06517287b = function(a) {
    switch($47bece5708b11508$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $47bece5708b11508$var$R;
    }
    var c = $47bece5708b11508$var$R;
    $47bece5708b11508$var$R = b;
    try {
        return a();
    } finally{
        $47bece5708b11508$var$R = c;
    }
};
$47bece5708b11508$export$4b844e58a3e414b4 = function() {};
$47bece5708b11508$export$816d2913ae6b83b1 = $47bece5708b11508$var$Z;
$47bece5708b11508$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $47bece5708b11508$var$R;
    $47bece5708b11508$var$R = a;
    try {
        return b();
    } finally{
        $47bece5708b11508$var$R = c;
    }
};
$47bece5708b11508$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $47bece5708b11508$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $47bece5708b11508$var$Y(a);
    } else c = $47bece5708b11508$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $47bece5708b11508$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $47bece5708b11508$var$J($47bece5708b11508$var$O, a), null === $47bece5708b11508$var$L($47bece5708b11508$var$N) && a === $47bece5708b11508$var$L($47bece5708b11508$var$O) && ($47bece5708b11508$var$U ? $47bece5708b11508$var$h() : $47bece5708b11508$var$U = !0, $47bece5708b11508$var$g($47bece5708b11508$var$W, e - d))) : (a.sortIndex = c, $47bece5708b11508$var$J($47bece5708b11508$var$N, a), $47bece5708b11508$var$T || $47bece5708b11508$var$S || ($47bece5708b11508$var$T = !0, $47bece5708b11508$var$f($47bece5708b11508$var$X)));
    return a;
};
$47bece5708b11508$export$b5836b71941fa3ed = function() {
    var a = $47bece5708b11508$export$c4744153514ff05d();
    $47bece5708b11508$var$V(a);
    var b = $47bece5708b11508$var$L($47bece5708b11508$var$N);
    return b !== $47bece5708b11508$var$Q && null !== $47bece5708b11508$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $47bece5708b11508$var$Q.expirationTime || $47bece5708b11508$var$k();
};
$47bece5708b11508$export$cf845f2c119da08a = function(a) {
    var b = $47bece5708b11508$var$R;
    return function() {
        var c = $47bece5708b11508$var$R;
        $47bece5708b11508$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $47bece5708b11508$var$R = c;
        }
    };
};

});



parcelRequire.register("2FWxW", function(module, exports) {

var $8CXp8 = parcelRequire("8CXp8");
function $1f2cd3302cd3808a$var$_defineProperty(e, r, t) {
    return (r = $8CXp8(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $1f2cd3302cd3808a$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("8CXp8", function(module, exports) {

var $eE0N6 = parcelRequire("eE0N6");
var $647ff3d230894fb3$var$_typeof = $eE0N6.default;

var $6OwRV = parcelRequire("6OwRV");
function $647ff3d230894fb3$var$toPropertyKey(t) {
    var i = $6OwRV(t, "string");
    return "symbol" == $647ff3d230894fb3$var$_typeof(i) ? i : i + "";
}
module.exports = $647ff3d230894fb3$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("eE0N6", function(module, exports) {
function $aa956a2edc52d902$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $aa956a2edc52d902$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $aa956a2edc52d902$var$_typeof(o);
}
module.exports = $aa956a2edc52d902$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("6OwRV", function(module, exports) {

var $eE0N6 = parcelRequire("eE0N6");
var $4f60e89e88d87e37$var$_typeof = $eE0N6.default;
function $4f60e89e88d87e37$var$toPrimitive(t, r) {
    if ("object" != $4f60e89e88d87e37$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4f60e89e88d87e37$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $4f60e89e88d87e37$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("1CFxY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $iAhIx = parcelRequire("iAhIx");
function $12e9916bea99cf27$var$emptyFunction() {}
function $12e9916bea99cf27$var$emptyFunctionWithReset() {}
$12e9916bea99cf27$var$emptyFunctionWithReset.resetWarningCache = $12e9916bea99cf27$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iAhIx) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $12e9916bea99cf27$var$emptyFunctionWithReset,
        resetWarningCache: $12e9916bea99cf27$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("iAhIx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $d879551569e38f83$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $d879551569e38f83$var$ReactPropTypesSecret;

});


parcelRequire.register("XLpyq", function(module, exports) {

var $5eSSh = parcelRequire("5eSSh");

var $1IVR2 = parcelRequire("1IVR2");

var $1Nqwe = parcelRequire("1Nqwe");

var $bhlcF = parcelRequire("bhlcF");
function $0b3a49ac2e39bcfa$var$_slicedToArray(r, e) {
    return $5eSSh(r) || $1IVR2(r, e) || $1Nqwe(r, e) || $bhlcF();
}
module.exports = $0b3a49ac2e39bcfa$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("5eSSh", function(module, exports) {
function $3d08d37e710b026a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $3d08d37e710b026a$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("1IVR2", function(module, exports) {
function $1416c735775e46d2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $1416c735775e46d2$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("1Nqwe", function(module, exports) {

var $3YmT2 = parcelRequire("3YmT2");
function $14eef0236af10343$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3YmT2(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3YmT2(r, a) : void 0;
    }
}
module.exports = $14eef0236af10343$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("3YmT2", function(module, exports) {
function $2e48ba80b3bcaa03$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $2e48ba80b3bcaa03$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("bhlcF", function(module, exports) {
function $8361bac05682a0c2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $8361bac05682a0c2$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("xSEPi", function(module, exports) {

var $eE0N6 = parcelRequire("eE0N6");
var $065d7b055d72f339$var$_typeof = $eE0N6.default;
function $065d7b055d72f339$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $065d7b055d72f339$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $065d7b055d72f339$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($065d7b055d72f339$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $065d7b055d72f339$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("fx4dg", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $b4ed34b0a5f98492$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $b4ed34b0a5f98492$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $b4ed34b0a5f98492$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $b4ed34b0a5f98492$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $b4ed34b0a5f98492$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $b4ed34b0a5f98492$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $b4ed34b0a5f98492$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "dark",
    "dark-increased-contrast",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "typography",
    "shape",
    "typography-adg3",
    "typography-minor3"
];
var $b4ed34b0a5f98492$export$ba8a43b83ecc69f8 = [
    "light-new-input-border",
    "dark-new-input-border"
];
var $b4ed34b0a5f98492$export$92ba366331403db2 = [].concat($b4ed34b0a5f98492$export$7d43e72a58e3283f, $b4ed34b0a5f98492$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $b4ed34b0a5f98492$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-light-new-input-border": {
        id: "light-new-input-border",
        displayName: "Light Theme New Input Border",
        palette: "defaultPalette",
        override: "light",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-new-input-border": {
        id: "dark-new-input-border",
        displayName: "Dark Theme New Input Border",
        palette: "defaultPalette",
        override: "dark",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-typography": {
        id: "typography",
        displayName: "Atlassian Typography (Minor Second)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-minor3": {
        id: "typography-minor3",
        displayName: "Atlassian Typography (Minor Third)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    }
};
var $b4ed34b0a5f98492$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $b4ed34b0a5f98492$export$2e2bcd8739ae039 = $b4ed34b0a5f98492$var$themeConfig;

});

parcelRequire.register("bc6zD", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $8265ea1eb25b3146$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $8265ea1eb25b3146$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $8265ea1eb25b3146$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $8265ea1eb25b3146$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $8265ea1eb25b3146$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $8265ea1eb25b3146$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $8265ea1eb25b3146$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $8265ea1eb25b3146$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $8265ea1eb25b3146$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
var $8265ea1eb25b3146$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $8265ea1eb25b3146$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $8265ea1eb25b3146$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $8265ea1eb25b3146$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $8265ea1eb25b3146$export$b36dbdb4f463f05c(hex) {
    if (!$8265ea1eb25b3146$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $8265ea1eb25b3146$export$1212645cf40ebf71(hex)
    ];
}
function $8265ea1eb25b3146$export$5a544e13ad4e1fa5(hex) {
    if (!$8265ea1eb25b3146$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $8265ea1eb25b3146$export$47ea145a83f50dc0(hex) {
    if (!$8265ea1eb25b3146$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $8265ea1eb25b3146$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $8265ea1eb25b3146$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $8265ea1eb25b3146$export$d061e26956a60b0a(foreground, background) {
    if (!$8265ea1eb25b3146$var$isValidHex(foreground) || !$8265ea1eb25b3146$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $8265ea1eb25b3146$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $8265ea1eb25b3146$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $8265ea1eb25b3146$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $8265ea1eb25b3146$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $8265ea1eb25b3146$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $8265ea1eb25b3146$var$rgbToLab(rgbA);
    var labB = $8265ea1eb25b3146$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $8265ea1eb25b3146$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRequire.register("lCES2", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $fbdcd99f9fa8f602$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $fbdcd99f9fa8f602$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $fbdcd99f9fa8f602$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $fbdcd99f9fa8f602$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $fbdcd99f9fa8f602$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $fbdcd99f9fa8f602$export$9d7b58831ae93caa);
var $fbdcd99f9fa8f602$export$4ef52930e33717cd = "data-theme";
var $fbdcd99f9fa8f602$export$a00eac3f8684bcd0 = "data-color-mode";
var $fbdcd99f9fa8f602$export$2112803007239c61 = "data-contrast-mode";
var $fbdcd99f9fa8f602$export$352e418ed5b6193a = "data-custom-theme";
var $fbdcd99f9fa8f602$export$2faeed762aac6741 = "light";
var $fbdcd99f9fa8f602$export$6f0c6fb8c80fcc92 = "ds";
var $fbdcd99f9fa8f602$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $fbdcd99f9fa8f602$export$dddac1532e822863 = "--".concat($fbdcd99f9fa8f602$export$6f0c6fb8c80fcc92, "-token-not-found");
var $fbdcd99f9fa8f602$export$9d7b58831ae93caa = "--".concat($fbdcd99f9fa8f602$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRequire.register("4iBhm", function(module, exports) {

$parcel$export(module.exports, "hash", () => $3215c2b452dda224$export$d6af199866bfb566);
var $3215c2b452dda224$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRequire.register("i2CXH", function(module, exports) {
function $d226a2e4f7b5ac30$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $d226a2e4f7b5ac30$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("4URe7", function(module, exports) {

var $8CXp8 = parcelRequire("8CXp8");
function $3945ae171eb84fed$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $8CXp8(o.key), o);
    }
}
function $3945ae171eb84fed$var$_createClass(e, r, t) {
    return r && $3945ae171eb84fed$var$_defineProperties(e.prototype, r), t && $3945ae171eb84fed$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $3945ae171eb84fed$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("12eaz", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("jBlPy")).then(()=>parcelRequire("2jEbx"));

});

parcelRequire.register("3pfdX", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("cB8d9")).then(()=>parcelRequire("ifikT"));

});

parcelRequire.register("bXhzj", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("aElnn")).then(()=>parcelRequire("ez1lN"));

});

parcelRequire.register("xkBC4", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("at5WK")).then(()=>parcelRequire("9zSWn"));

});

parcelRequire.register("g7rvX", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("7Xa6B")).then(()=>parcelRequire("9CnpV"));

});

parcelRequire.register("94QHZ", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("1Damt")).then(()=>parcelRequire("5cKkr"));

});

parcelRequire.register("4Eh5p", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("1ZNn2")).then(()=>parcelRequire("bH8Q6"));

});

parcelRequire.register("goH5m", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("lmBfz")).then(()=>parcelRequire("iB8LQ"));

});

parcelRequire.register("ak7Vt", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("hva3N")).then(()=>parcelRequire("lTo7y"));

});

parcelRequire.register("7DxlS", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("6wsdE")).then(()=>parcelRequire("fDnWY"));

});

parcelRequire.register("hb47Z", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("kk4um")).then(()=>parcelRequire("4zjtJ"));

});

parcelRequire.register("4QQ0y", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("ihzX0")).then(()=>parcelRequire("34dKl"));

});

parcelRequire.register("hexyk", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("jxW33")).then(()=>parcelRequire("bNghf"));

});

parcelRequire.register("gGmKi", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $c252366c3b9fdabf$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $c252366c3b9fdabf$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $c252366c3b9fdabf$export$e673f367da2ff23e);

var $XLpyq = parcelRequire("XLpyq");

var $gdzT2 = parcelRequire("gdzT2");

var $ga0rZ = parcelRequire("ga0rZ");

var $lCES2 = parcelRequire("lCES2");

var $4iBhm = parcelRequire("4iBhm");
function $c252366c3b9fdabf$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $4iBhm.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $lCES2.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $lCES2.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $c252366c3b9fdabf$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($gdzT2)))(Array.from(document.head.querySelectorAll("style[".concat((0, $lCES2.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $lCES2.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $c252366c3b9fdabf$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $ga0rZ.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});
parcelRequire.register("gdzT2", function(module, exports) {

var $lrpRa = parcelRequire("lrpRa");

var $f1M4h = parcelRequire("f1M4h");

var $1Nqwe = parcelRequire("1Nqwe");

var $6MtxX = parcelRequire("6MtxX");
function $bce9b29a253f6201$var$_toConsumableArray(r) {
    return $lrpRa(r) || $f1M4h(r) || $1Nqwe(r) || $6MtxX();
}
module.exports = $bce9b29a253f6201$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("lrpRa", function(module, exports) {

var $3YmT2 = parcelRequire("3YmT2");
function $f9c02d25e90fbe93$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $3YmT2(r);
}
module.exports = $f9c02d25e90fbe93$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("f1M4h", function(module, exports) {
function $af0c3c532936bee2$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $af0c3c532936bee2$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("6MtxX", function(module, exports) {
function $4efe252149f5e5ef$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $4efe252149f5e5ef$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("ga0rZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc3dedf88770e63d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8507162c70d82c2e8040cc31a142fdb>>
 * @codegenCommand yarn build tokens
 */ var $bc3dedf88770e63d$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.body": "--ds-font-body",
    "font.body.large": "--ds-font-body-large",
    "font.body.small": "--ds-font-body-small",
    "font.code": "--ds-font-code",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.letterSpacing.0": "--ds-font-letterSpacing-0",
    "font.letterSpacing.100": "--ds-font-letterSpacing-100",
    "font.letterSpacing.200": "--ds-font-letterSpacing-200",
    "font.letterSpacing.300": "--ds-font-letterSpacing-300",
    "font.letterSpacing.400": "--ds-font-letterSpacing-400",
    "font.ui": "--ds-font-ui",
    "font.ui.small": "--ds-font-ui-small",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.monospace": "--ds-font-family-monospace",
    "font.family.sans": "--ds-font-family-sans",
    "font.family.brand": "--ds-font-family-brand",
    "font.size.050": "--ds-font-size-050",
    "font.size.075": "--ds-font-size-075",
    "font.size.100": "--ds-font-size-100",
    "font.size.200": "--ds-font-size-200",
    "font.size.300": "--ds-font-size-300",
    "font.size.400": "--ds-font-size-400",
    "font.size.500": "--ds-font-size-500",
    "font.size.600": "--ds-font-size-600",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.lineHeight.1": "--ds-font-lineHeight-1",
    "font.lineHeight.100": "--ds-font-lineHeight-100",
    "font.lineHeight.200": "--ds-font-lineHeight-200",
    "font.lineHeight.300": "--ds-font-lineHeight-300",
    "font.lineHeight.400": "--ds-font-lineHeight-400",
    "font.lineHeight.500": "--ds-font-lineHeight-500",
    "font.lineHeight.600": "--ds-font-lineHeight-600"
};
var $bc3dedf88770e63d$export$2e2bcd8739ae039 = $bc3dedf88770e63d$var$tokens;

});


parcelRequire.register("a0I0G", function(module, exports) {

module.exports = import("./" + (parcelRequire("fXxkw")).resolve("cLtaQ")).then(()=>parcelRequire("1057U"));

});

parcelRequire.register("2UUn7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.websocketWrapper = void 0;
module.exports.websocketWrapper = function(webSocket, start) {
    return new Proxy(webSocket, {
        get: function(obj, key) {
            var val = obj[key];
            if (key === "reconnect") return start;
            if (typeof val === "function") {
                console.error("Calling methods directly on the websocket is not supported at this moment. You must use the methods returned by useWebSocket.");
                //Prevent error thrown by invoking a non-function
                return function() {};
            } else return val;
        },
        set: function(obj, key, val) {
            if (/^on/.test(key)) {
                console.warn("The websocket's event handlers should be defined through the options object passed into useWebSocket.");
                return false;
            } else {
                obj[key] = val;
                return true;
            }
        }
    });
};
module.exports.default = module.exports.websocketWrapper;

});

var $edb0ecc8242c88ed$exports = {};
"use strict";

$edb0ecc8242c88ed$exports = (parcelRequire("1hhYD"));



var $5cNek = parcelRequire("5cNek");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $51ef8d60a459932d$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $51ef8d60a459932d$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $51ef8d60a459932d$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($51ef8d60a459932d$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $51ef8d60a459932d$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $e39b462e017b390b$export$71ad59f2e432cfe8 = "-ms-";
var $e39b462e017b390b$export$2c0f367103c8d01c = "-moz-";
var $e39b462e017b390b$export$39dfd62a25e0fe93 = "-webkit-";
var $e39b462e017b390b$export$a29989082612d0d9 = "comm";
var $e39b462e017b390b$export$aa3a2e812ca8570d = "rule";
var $e39b462e017b390b$export$527d108ccf083c2b = "decl";
var $e39b462e017b390b$export$d3d35020fa5b54f0 = "@page";
var $e39b462e017b390b$export$500415a86c544f73 = "@media";
var $e39b462e017b390b$export$a763edbf796b780a = "@import";
var $e39b462e017b390b$export$2790aeb8b4e5c826 = "@charset";
var $e39b462e017b390b$export$1cc683e23b84b133 = "@viewport";
var $e39b462e017b390b$export$9447a5efea57e862 = "@supports";
var $e39b462e017b390b$export$ef011b4e114b1fba = "@document";
var $e39b462e017b390b$export$6aad947bda0f3f46 = "@namespace";
var $e39b462e017b390b$export$b44a8529a35fcb60 = "@keyframes";
var $e39b462e017b390b$export$2c16de31893252e6 = "@font-face";
var $e39b462e017b390b$export$3d846dd52e150c6f = "@counter-style";
var $e39b462e017b390b$export$22314bfbb57653fe = "@font-feature-values";
var $e39b462e017b390b$export$d773506282b3cfe6 = "@layer";
var $e39b462e017b390b$export$2335f513bbd82c6d = Math.abs;
var $e39b462e017b390b$export$6788812c4e6611e6 = String.fromCharCode;
var $e39b462e017b390b$export$e6e34fd1f2686227 = Object.assign;
function $e39b462e017b390b$export$d6af199866bfb566(e, r) {
    return $e39b462e017b390b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $e39b462e017b390b$export$a9db5e087081082d(e, 0)) << 2 ^ $e39b462e017b390b$export$a9db5e087081082d(e, 1)) << 2 ^ $e39b462e017b390b$export$a9db5e087081082d(e, 2)) << 2 ^ $e39b462e017b390b$export$a9db5e087081082d(e, 3) : 0;
}
function $e39b462e017b390b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $e39b462e017b390b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $e39b462e017b390b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $e39b462e017b390b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $e39b462e017b390b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $e39b462e017b390b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $e39b462e017b390b$export$36776f635604f274(e) {
    return e.length;
}
function $e39b462e017b390b$export$f9084667e487ed46(e) {
    return e.length;
}
function $e39b462e017b390b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $e39b462e017b390b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $e39b462e017b390b$export$53f1d5ea8de3d7c = 1;
var $e39b462e017b390b$export$4e0c71f277ca26b3 = 1;
var $e39b462e017b390b$export$f24224f1c91d8156 = 0;
var $e39b462e017b390b$export$5880b8b5730aff45 = 0;
var $e39b462e017b390b$export$c0306caf338ac095 = 0;
var $e39b462e017b390b$export$30a86d91af8ff6e6 = "";
function $e39b462e017b390b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $e39b462e017b390b$export$53f1d5ea8de3d7c,
        column: $e39b462e017b390b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $e39b462e017b390b$export$784d13d8ee351f07(e, r) {
    return $e39b462e017b390b$export$e6e34fd1f2686227($e39b462e017b390b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $e39b462e017b390b$export$eba6f6f03b0a92e7() {
    return $e39b462e017b390b$export$c0306caf338ac095;
}
function $e39b462e017b390b$export$232faf9add678146() {
    $e39b462e017b390b$export$c0306caf338ac095 = $e39b462e017b390b$export$5880b8b5730aff45 > 0 ? $e39b462e017b390b$export$a9db5e087081082d($e39b462e017b390b$export$30a86d91af8ff6e6, --$e39b462e017b390b$export$5880b8b5730aff45) : 0;
    if ($e39b462e017b390b$export$4e0c71f277ca26b3--, $e39b462e017b390b$export$c0306caf338ac095 === 10) $e39b462e017b390b$export$4e0c71f277ca26b3 = 1, $e39b462e017b390b$export$53f1d5ea8de3d7c--;
    return $e39b462e017b390b$export$c0306caf338ac095;
}
function $e39b462e017b390b$export$48cfd1e771a65c4f() {
    $e39b462e017b390b$export$c0306caf338ac095 = $e39b462e017b390b$export$5880b8b5730aff45 < $e39b462e017b390b$export$f24224f1c91d8156 ? $e39b462e017b390b$export$a9db5e087081082d($e39b462e017b390b$export$30a86d91af8ff6e6, $e39b462e017b390b$export$5880b8b5730aff45++) : 0;
    if ($e39b462e017b390b$export$4e0c71f277ca26b3++, $e39b462e017b390b$export$c0306caf338ac095 === 10) $e39b462e017b390b$export$4e0c71f277ca26b3 = 1, $e39b462e017b390b$export$53f1d5ea8de3d7c++;
    return $e39b462e017b390b$export$c0306caf338ac095;
}
function $e39b462e017b390b$export$4d3fb11e950abb9e() {
    return $e39b462e017b390b$export$a9db5e087081082d($e39b462e017b390b$export$30a86d91af8ff6e6, $e39b462e017b390b$export$5880b8b5730aff45);
}
function $e39b462e017b390b$export$e88cb2efb12ae807() {
    return $e39b462e017b390b$export$5880b8b5730aff45;
}
function $e39b462e017b390b$export$58adb3bec8346d0f(e, r) {
    return $e39b462e017b390b$export$2f35ab04d2335697($e39b462e017b390b$export$30a86d91af8ff6e6, e, r);
}
function $e39b462e017b390b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e39b462e017b390b$export$2de70f21292aac9e(e) {
    return $e39b462e017b390b$export$53f1d5ea8de3d7c = $e39b462e017b390b$export$4e0c71f277ca26b3 = 1, $e39b462e017b390b$export$f24224f1c91d8156 = $e39b462e017b390b$export$36776f635604f274($e39b462e017b390b$export$30a86d91af8ff6e6 = e), $e39b462e017b390b$export$5880b8b5730aff45 = 0, [];
}
function $e39b462e017b390b$export$45918ac1574455b1(e) {
    return $e39b462e017b390b$export$30a86d91af8ff6e6 = "", e;
}
function $e39b462e017b390b$export$410ac95b9ec204b8(e) {
    return $e39b462e017b390b$export$87c2784dc9fc4ab($e39b462e017b390b$export$58adb3bec8346d0f($e39b462e017b390b$export$5880b8b5730aff45 - 1, $e39b462e017b390b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $e39b462e017b390b$export$660b2ee2d4fb4eff(e) {
    return $e39b462e017b390b$export$45918ac1574455b1($e39b462e017b390b$export$5f8c09e3ae6f64e1($e39b462e017b390b$export$2de70f21292aac9e(e)));
}
function $e39b462e017b390b$export$7af1228ff777d175(e) {
    while($e39b462e017b390b$export$c0306caf338ac095 = $e39b462e017b390b$export$4d3fb11e950abb9e())if ($e39b462e017b390b$export$c0306caf338ac095 < 33) $e39b462e017b390b$export$48cfd1e771a65c4f();
    else break;
    return $e39b462e017b390b$export$9e1725a4cfeada27(e) > 2 || $e39b462e017b390b$export$9e1725a4cfeada27($e39b462e017b390b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $e39b462e017b390b$export$5f8c09e3ae6f64e1(e) {
    while($e39b462e017b390b$export$48cfd1e771a65c4f())switch($e39b462e017b390b$export$9e1725a4cfeada27($e39b462e017b390b$export$c0306caf338ac095)){
        case 0:
            $e39b462e017b390b$export$10d8903dec122b9d($e39b462e017b390b$export$c2ab62c7bf24634($e39b462e017b390b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $e39b462e017b390b$export$10d8903dec122b9d($e39b462e017b390b$export$410ac95b9ec204b8($e39b462e017b390b$export$c0306caf338ac095), e);
            break;
        default:
            $e39b462e017b390b$export$10d8903dec122b9d($e39b462e017b390b$export$6788812c4e6611e6($e39b462e017b390b$export$c0306caf338ac095), e);
    }
    return e;
}
function $e39b462e017b390b$export$955ba06d119e085e(e, r) {
    while(--r && $e39b462e017b390b$export$48cfd1e771a65c4f())if ($e39b462e017b390b$export$c0306caf338ac095 < 48 || $e39b462e017b390b$export$c0306caf338ac095 > 102 || $e39b462e017b390b$export$c0306caf338ac095 > 57 && $e39b462e017b390b$export$c0306caf338ac095 < 65 || $e39b462e017b390b$export$c0306caf338ac095 > 70 && $e39b462e017b390b$export$c0306caf338ac095 < 97) break;
    return $e39b462e017b390b$export$58adb3bec8346d0f(e, $e39b462e017b390b$export$e88cb2efb12ae807() + (r < 6 && $e39b462e017b390b$export$4d3fb11e950abb9e() == 32 && $e39b462e017b390b$export$48cfd1e771a65c4f() == 32));
}
function $e39b462e017b390b$export$c889f2fcc19dbf12(e) {
    while($e39b462e017b390b$export$48cfd1e771a65c4f())switch($e39b462e017b390b$export$c0306caf338ac095){
        case e:
            return $e39b462e017b390b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $e39b462e017b390b$export$c889f2fcc19dbf12($e39b462e017b390b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $e39b462e017b390b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $e39b462e017b390b$export$48cfd1e771a65c4f();
            break;
    }
    return $e39b462e017b390b$export$5880b8b5730aff45;
}
function $e39b462e017b390b$export$4254d4e2b3745c4c(e, r) {
    while($e39b462e017b390b$export$48cfd1e771a65c4f())if (e + $e39b462e017b390b$export$c0306caf338ac095 === 57) break;
    else if (e + $e39b462e017b390b$export$c0306caf338ac095 === 84 && $e39b462e017b390b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $e39b462e017b390b$export$58adb3bec8346d0f(r, $e39b462e017b390b$export$5880b8b5730aff45 - 1) + "*" + $e39b462e017b390b$export$6788812c4e6611e6(e === 47 ? e : $e39b462e017b390b$export$48cfd1e771a65c4f());
}
function $e39b462e017b390b$export$c2ab62c7bf24634(e) {
    while(!$e39b462e017b390b$export$9e1725a4cfeada27($e39b462e017b390b$export$4d3fb11e950abb9e()))$e39b462e017b390b$export$48cfd1e771a65c4f();
    return $e39b462e017b390b$export$58adb3bec8346d0f(e, $e39b462e017b390b$export$5880b8b5730aff45);
}
function $e39b462e017b390b$export$ef7acd7185315e22(e) {
    return $e39b462e017b390b$export$45918ac1574455b1($e39b462e017b390b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $e39b462e017b390b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $e39b462e017b390b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $e39b462e017b390b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $e39b462e017b390b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($e39b462e017b390b$export$f8e21b1e77979a08(j += $e39b462e017b390b$export$77ad94ebf1c2b9ed($e39b462e017b390b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $e39b462e017b390b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $e39b462e017b390b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $e39b462e017b390b$export$955ba06d119e085e($e39b462e017b390b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($e39b462e017b390b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $e39b462e017b390b$export$10d8903dec122b9d($e39b462e017b390b$export$4a34f930e789283c($e39b462e017b390b$export$4254d4e2b3745c4c($e39b462e017b390b$export$48cfd1e771a65c4f(), $e39b462e017b390b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $e39b462e017b390b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $e39b462e017b390b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $e39b462e017b390b$export$36776f635604f274(j) - l) $e39b462e017b390b$export$10d8903dec122b9d(p > 32 ? $e39b462e017b390b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $e39b462e017b390b$export$f8483753829ec8f3($e39b462e017b390b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $e39b462e017b390b$export$10d8903dec122b9d(y = $e39b462e017b390b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $e39b462e017b390b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $e39b462e017b390b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $e39b462e017b390b$export$98e6a39c04603d36(e, y, y, n && $e39b462e017b390b$export$10d8903dec122b9d($e39b462e017b390b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $e39b462e017b390b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $e39b462e017b390b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $e39b462e017b390b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $e39b462e017b390b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($e39b462e017b390b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($e39b462e017b390b$export$4d3fb11e950abb9e() === 45) j += $e39b462e017b390b$export$410ac95b9ec204b8($e39b462e017b390b$export$48cfd1e771a65c4f());
                    v = $e39b462e017b390b$export$4d3fb11e950abb9e(), o = l = $e39b462e017b390b$export$36776f635604f274(g = j += $e39b462e017b390b$export$c2ab62c7bf24634($e39b462e017b390b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $e39b462e017b390b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $e39b462e017b390b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $e39b462e017b390b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $e39b462e017b390b$export$2f35ab04d2335697(e, v + 1, v = $e39b462e017b390b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $e39b462e017b390b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $e39b462e017b390b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $e39b462e017b390b$export$35059013cd4a06db(e, r, a, s === 0 ? $e39b462e017b390b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $e39b462e017b390b$export$4a34f930e789283c(e, r, a) {
    return $e39b462e017b390b$export$35059013cd4a06db(e, r, a, $e39b462e017b390b$export$a29989082612d0d9, $e39b462e017b390b$export$6788812c4e6611e6($e39b462e017b390b$export$eba6f6f03b0a92e7()), $e39b462e017b390b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $e39b462e017b390b$export$f8483753829ec8f3(e, r, a, n) {
    return $e39b462e017b390b$export$35059013cd4a06db(e, r, a, $e39b462e017b390b$export$527d108ccf083c2b, $e39b462e017b390b$export$2f35ab04d2335697(e, 0, n), $e39b462e017b390b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $e39b462e017b390b$export$82e9f45cca5ba907(n, c, s) {
    switch($e39b462e017b390b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $e39b462e017b390b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$2c0f367103c8d01c + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($e39b462e017b390b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $e39b462e017b390b$export$39dfd62a25e0fe93 + "box-$1$2" + $e39b462e017b390b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + "flex-item-" + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$e39b462e017b390b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $e39b462e017b390b$export$71ad59f2e432cfe8 + "grid-row-" + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + "flex-line-pack" + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + "box-" + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $e39b462e017b390b$export$39dfd62a25e0fe93 + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $e39b462e017b390b$export$39dfd62a25e0fe93 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $e39b462e017b390b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $e39b462e017b390b$export$77ad94ebf1c2b9ed($e39b462e017b390b$export$77ad94ebf1c2b9ed($e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $e39b462e017b390b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $e39b462e017b390b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $e39b462e017b390b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $e39b462e017b390b$export$77ad94ebf1c2b9ed($e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $e39b462e017b390b$export$39dfd62a25e0fe93 + "box-pack:$3" + $e39b462e017b390b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $e39b462e017b390b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$e39b462e017b390b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $e39b462e017b390b$export$71ad59f2e432cfe8 + "grid-column-align" + $e39b462e017b390b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $e39b462e017b390b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$e39b462e017b390b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $e39b462e017b390b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$e39b462e017b390b$export$f8e21b1e77979a08(s, "span") ? $e39b462e017b390b$export$4659b591c19bdf3d(s, /\d+/) : +$e39b462e017b390b$export$4659b591c19bdf3d(s, /\d+/) - +$e39b462e017b390b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $e39b462e017b390b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $e39b462e017b390b$export$71ad59f2e432cfe8 + $e39b462e017b390b$export$77ad94ebf1c2b9ed($e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $e39b462e017b390b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($e39b462e017b390b$export$36776f635604f274(n) - 1 - c > 6) switch($e39b462e017b390b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($e39b462e017b390b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $e39b462e017b390b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $e39b462e017b390b$export$2c0f367103c8d01c + ($e39b462e017b390b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$e39b462e017b390b$export$f8e21b1e77979a08(n, "stretch") ? $e39b462e017b390b$export$82e9f45cca5ba907($e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $e39b462e017b390b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $e39b462e017b390b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($e39b462e017b390b$export$a9db5e087081082d(n, c + 6) === 121) return $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, ":", ":" + $e39b462e017b390b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($e39b462e017b390b$export$a9db5e087081082d(n, $e39b462e017b390b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $e39b462e017b390b$export$39dfd62a25e0fe93 + ($e39b462e017b390b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $e39b462e017b390b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $e39b462e017b390b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, ":", ":" + $e39b462e017b390b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $e39b462e017b390b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $e39b462e017b390b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $e39b462e017b390b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $e39b462e017b390b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $e39b462e017b390b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $e39b462e017b390b$export$a763edbf796b780a:
        case $e39b462e017b390b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $e39b462e017b390b$export$a29989082612d0d9:
            return "";
        case $e39b462e017b390b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $e39b462e017b390b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $e39b462e017b390b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $e39b462e017b390b$export$36776f635604f274(a = $e39b462e017b390b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $e39b462e017b390b$export$5a7767152ae0305f(e) {
    var r = $e39b462e017b390b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $e39b462e017b390b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $e39b462e017b390b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $e39b462e017b390b$export$527d108ccf083c2b:
                n.return = $e39b462e017b390b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $e39b462e017b390b$export$b44a8529a35fcb60:
                return $e39b462e017b390b$export$dfdc1655ccc5b9cb([
                    $e39b462e017b390b$export$784d13d8ee351f07(n, {
                        value: $e39b462e017b390b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $e39b462e017b390b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $e39b462e017b390b$export$aa3a2e812ca8570d:
                if (n.length) return $e39b462e017b390b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($e39b462e017b390b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $e39b462e017b390b$export$dfdc1655ccc5b9cb([
                                $e39b462e017b390b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e39b462e017b390b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $e39b462e017b390b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $e39b462e017b390b$export$dfdc1655ccc5b9cb([
                                $e39b462e017b390b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e39b462e017b390b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e39b462e017b390b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $e39b462e017b390b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e39b462e017b390b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e39b462e017b390b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $e39b462e017b390b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e39b462e017b390b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $e39b462e017b390b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $e39b462e017b390b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $e39b462e017b390b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $e39b462e017b390b$export$1be1fc439b849fdf($e39b462e017b390b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($e39b462e017b390b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $e39b462e017b390b$export$2f35ab04d2335697(r, 1, $e39b462e017b390b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $e39b462e017b390b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $e39b462e017b390b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $e39b462e017b390b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $17dfc07823ce1e52$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6901f54d11aa3867$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $d4fabc4aca68e7fd$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $e39b462e017b390b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $e39b462e017b390b$export$9e1725a4cfeada27)(character)) break;
        (0, $e39b462e017b390b$export$48cfd1e771a65c4f)();
    }
    return (0, $e39b462e017b390b$export$58adb3bec8346d0f)(begin, (0, $e39b462e017b390b$export$5880b8b5730aff45));
};
var $d4fabc4aca68e7fd$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $e39b462e017b390b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $e39b462e017b390b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $d4fabc4aca68e7fd$var$identifierWithPointTracking((0, $e39b462e017b390b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $e39b462e017b390b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $e39b462e017b390b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $e39b462e017b390b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $e39b462e017b390b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $d4fabc4aca68e7fd$var$getRules = function getRules(value, points) {
    return (0, $e39b462e017b390b$export$45918ac1574455b1)($d4fabc4aca68e7fd$var$toRules((0, $e39b462e017b390b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $d4fabc4aca68e7fd$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $d4fabc4aca68e7fd$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$d4fabc4aca68e7fd$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $d4fabc4aca68e7fd$var$fixedElements.set(element, true);
    var points = [];
    var rules = $d4fabc4aca68e7fd$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $d4fabc4aca68e7fd$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $d4fabc4aca68e7fd$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $d4fabc4aca68e7fd$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($d4fabc4aca68e7fd$var$ignoreFlag) > -1;
};
var $d4fabc4aca68e7fd$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($d4fabc4aca68e7fd$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $d4fabc4aca68e7fd$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $d4fabc4aca68e7fd$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$d4fabc4aca68e7fd$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $d4fabc4aca68e7fd$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $d4fabc4aca68e7fd$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$d4fabc4aca68e7fd$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $d4fabc4aca68e7fd$var$nullifyElement(element);
    } else if ($d4fabc4aca68e7fd$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $d4fabc4aca68e7fd$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $d4fabc4aca68e7fd$var$prefix(value, length) {
    switch((0, $e39b462e017b390b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$2c0f367103c8d01c) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "box-" + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)((0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)((0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)((0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $e39b462e017b390b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $e39b462e017b390b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $e39b462e017b390b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $e39b462e017b390b$export$2c0f367103c8d01c) + ((0, $e39b462e017b390b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $e39b462e017b390b$export$f8e21b1e77979a08)(value, "stretch") ? $d4fabc4aca68e7fd$var$prefix((0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $e39b462e017b390b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $e39b462e017b390b$export$a9db5e087081082d)(value, (0, $e39b462e017b390b$export$36776f635604f274)(value) - 3 - (~(0, $e39b462e017b390b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $e39b462e017b390b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + ((0, $e39b462e017b390b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $e39b462e017b390b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + value + (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $d4fabc4aca68e7fd$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $e39b462e017b390b$export$527d108ccf083c2b:
                element["return"] = $d4fabc4aca68e7fd$var$prefix(element.value, element.length);
                break;
            case 0, $e39b462e017b390b$export$b44a8529a35fcb60:
                return (0, $e39b462e017b390b$export$dfdc1655ccc5b9cb)([
                    (0, $e39b462e017b390b$export$784d13d8ee351f07)(element, {
                        value: (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $e39b462e017b390b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e39b462e017b390b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $e39b462e017b390b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $e39b462e017b390b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $e39b462e017b390b$export$dfdc1655ccc5b9cb)([
                                (0, $e39b462e017b390b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $e39b462e017b390b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $e39b462e017b390b$export$dfdc1655ccc5b9cb)([
                                (0, $e39b462e017b390b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e39b462e017b390b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $e39b462e017b390b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e39b462e017b390b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $e39b462e017b390b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e39b462e017b390b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e39b462e017b390b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $d4fabc4aca68e7fd$var$defaultStylisPlugins = [
    $d4fabc4aca68e7fd$var$prefixer
];
var $d4fabc4aca68e7fd$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $d4fabc4aca68e7fd$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $d4fabc4aca68e7fd$var$compat,
        $d4fabc4aca68e7fd$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $e39b462e017b390b$export$fac44ee5b035f737),
        (0, $e39b462e017b390b$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $e39b462e017b390b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $e39b462e017b390b$export$dfdc1655ccc5b9cb)((0, $e39b462e017b390b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $51ef8d60a459932d$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $452258aad9357ad1$export$2e2bcd8739ae039() {
    return $452258aad9357ad1$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $452258aad9357ad1$export$2e2bcd8739ae039.apply(null, arguments);
}



var $9aefa66d61c8c929$exports = {};
"use strict";
var $de37ac0f3b185044$exports = {};
"use strict";

$de37ac0f3b185044$exports = (parcelRequire("aSly0"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $9aefa66d61c8c929$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $9aefa66d61c8c929$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $9aefa66d61c8c929$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $9aefa66d61c8c929$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $9aefa66d61c8c929$var$TYPE_STATICS = {};
$9aefa66d61c8c929$var$TYPE_STATICS[$de37ac0f3b185044$exports.ForwardRef] = $9aefa66d61c8c929$var$FORWARD_REF_STATICS;
$9aefa66d61c8c929$var$TYPE_STATICS[$de37ac0f3b185044$exports.Memo] = $9aefa66d61c8c929$var$MEMO_STATICS;
function $9aefa66d61c8c929$var$getStatics(component) {
    // React v16.11 and below
    if ($de37ac0f3b185044$exports.isMemo(component)) return $9aefa66d61c8c929$var$MEMO_STATICS;
     // React v16.12 and above
    return $9aefa66d61c8c929$var$TYPE_STATICS[component["$$typeof"]] || $9aefa66d61c8c929$var$REACT_STATICS;
}
var $9aefa66d61c8c929$var$defineProperty = Object.defineProperty;
var $9aefa66d61c8c929$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $9aefa66d61c8c929$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9aefa66d61c8c929$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9aefa66d61c8c929$var$getPrototypeOf = Object.getPrototypeOf;
var $9aefa66d61c8c929$var$objectPrototype = Object.prototype;
function $9aefa66d61c8c929$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($9aefa66d61c8c929$var$objectPrototype) {
            var inheritedComponent = $9aefa66d61c8c929$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $9aefa66d61c8c929$var$objectPrototype) $9aefa66d61c8c929$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $9aefa66d61c8c929$var$getOwnPropertyNames(sourceComponent);
        if ($9aefa66d61c8c929$var$getOwnPropertySymbols) keys = keys.concat($9aefa66d61c8c929$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $9aefa66d61c8c929$var$getStatics(targetComponent);
        var sourceStatics = $9aefa66d61c8c929$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$9aefa66d61c8c929$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $9aefa66d61c8c929$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $9aefa66d61c8c929$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$9aefa66d61c8c929$exports = $9aefa66d61c8c929$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $2556e46d1325dc11$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9aefa66d61c8c929$exports)))(targetComponent, sourceComponent);
};


var $35fc4a68c01797f3$var$isBrowser = true;
function $35fc4a68c01797f3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $35fc4a68c01797f3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $35fc4a68c01797f3$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $35fc4a68c01797f3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $35fc4a68c01797f3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $86508aa326f4e620$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $3b18dd77108a03c2$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $7af428967f6af30d$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $7af428967f6af30d$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $7af428967f6af30d$var$hyphenateRegex = /[A-Z]|^ms/g;
var $7af428967f6af30d$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $7af428967f6af30d$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $7af428967f6af30d$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $7af428967f6af30d$var$processStyleName = /* #__PURE__ */ (0, $6901f54d11aa3867$export$2e2bcd8739ae039)(function(styleName) {
    return $7af428967f6af30d$var$isCustomProperty(styleName) ? styleName : styleName.replace($7af428967f6af30d$var$hyphenateRegex, "-$&").toLowerCase();
});
var $7af428967f6af30d$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($7af428967f6af30d$var$animationRegex, function(match, p1, p2) {
                $7af428967f6af30d$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $7af428967f6af30d$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3b18dd77108a03c2$export$2e2bcd8739ae039)[key] !== 1 && !$7af428967f6af30d$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $7af428967f6af30d$var$contentValuePattern, $7af428967f6af30d$var$contentValues, $7af428967f6af30d$var$oldProcessStyleValue, $7af428967f6af30d$var$msPattern, $7af428967f6af30d$var$hyphenPattern, $7af428967f6af30d$var$hyphenatedCache;
var $7af428967f6af30d$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $7af428967f6af30d$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $7af428967f6af30d$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $7af428967f6af30d$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $7af428967f6af30d$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $7af428967f6af30d$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $7af428967f6af30d$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $7af428967f6af30d$var$cursor;
                var result = interpolation(mergedProps);
                $7af428967f6af30d$var$cursor = previousCursor;
                return $7af428967f6af30d$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $7af428967f6af30d$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $7af428967f6af30d$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($7af428967f6af30d$var$isProcessableValue(value)) string += $7af428967f6af30d$var$processStyleName(_key) + ":" + $7af428967f6af30d$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($7af428967f6af30d$var$isProcessableValue(value[_i])) string += $7af428967f6af30d$var$processStyleName(_key) + ":" + $7af428967f6af30d$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $7af428967f6af30d$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $7af428967f6af30d$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $7af428967f6af30d$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $7af428967f6af30d$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $7af428967f6af30d$var$cursor;
var $7af428967f6af30d$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $7af428967f6af30d$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $7af428967f6af30d$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $7af428967f6af30d$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $7af428967f6af30d$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $7af428967f6af30d$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $86508aa326f4e620$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $7af428967f6af30d$var$cursor
    };
};



var $5cNek = parcelRequire("5cNek");
var $69252b5ce27af9a9$var$syncFallback = function syncFallback(create) {
    return create();
};
var $69252b5ce27af9a9$var$useInsertionEffect = $5cNek.useInsertionEffect ? $5cNek.useInsertionEffect : false;
var $69252b5ce27af9a9$export$db21c7ffa21794e7 = $69252b5ce27af9a9$var$useInsertionEffect || $69252b5ce27af9a9$var$syncFallback;
var $69252b5ce27af9a9$export$811a713a7276cb9d = $69252b5ce27af9a9$var$useInsertionEffect || $5cNek.useLayoutEffect;


var $4d5564f5ca36dd68$export$23f2a1d2818174ef = true;
var $4d5564f5ca36dd68$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4d5564f5ca36dd68$var$EmotionCacheContext = /* #__PURE__ */ $5cNek.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $d4fabc4aca68e7fd$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $4d5564f5ca36dd68$export$e7094788287c5e9b = $4d5564f5ca36dd68$var$EmotionCacheContext.Provider;
var $4d5564f5ca36dd68$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $5cNek.useContext)($4d5564f5ca36dd68$var$EmotionCacheContext);
};
var $4d5564f5ca36dd68$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $5cNek.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $5cNek.useContext)($4d5564f5ca36dd68$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4d5564f5ca36dd68$export$23f2a1d2818174ef) $4d5564f5ca36dd68$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $5cNek.useContext)($4d5564f5ca36dd68$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $d4fabc4aca68e7fd$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $5cNek.createElement($4d5564f5ca36dd68$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4d5564f5ca36dd68$export$971d5caa766a69d7 = /* #__PURE__ */ $5cNek.createContext({});
var $4d5564f5ca36dd68$export$3b14a55fb2447963 = function useTheme() {
    return $5cNek.useContext($4d5564f5ca36dd68$export$971d5caa766a69d7);
};
var $4d5564f5ca36dd68$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $452258aad9357ad1$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $4d5564f5ca36dd68$var$createCacheWithTheme = /* #__PURE__ */ (0, $17dfc07823ce1e52$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $17dfc07823ce1e52$export$2e2bcd8739ae039)(function(theme) {
        return $4d5564f5ca36dd68$var$getTheme(outerTheme, theme);
    });
});
var $4d5564f5ca36dd68$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $5cNek.useContext($4d5564f5ca36dd68$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4d5564f5ca36dd68$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $5cNek.createElement($4d5564f5ca36dd68$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4d5564f5ca36dd68$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $5cNek.useContext($4d5564f5ca36dd68$export$971d5caa766a69d7);
        return /*#__PURE__*/ $5cNek.createElement(Component, (0, $452258aad9357ad1$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $5cNek.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $2556e46d1325dc11$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $4d5564f5ca36dd68$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $4d5564f5ca36dd68$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $4d5564f5ca36dd68$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $4d5564f5ca36dd68$var$getLastPart(match[1]);
    return undefined;
};
var $4d5564f5ca36dd68$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $4d5564f5ca36dd68$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $4d5564f5ca36dd68$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $4d5564f5ca36dd68$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($4d5564f5ca36dd68$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $4d5564f5ca36dd68$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $4d5564f5ca36dd68$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $4d5564f5ca36dd68$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $4d5564f5ca36dd68$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4d5564f5ca36dd68$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4d5564f5ca36dd68$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $4d5564f5ca36dd68$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $35fc4a68c01797f3$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $69252b5ce27af9a9$export$db21c7ffa21794e7)(function() {
        return (0, $35fc4a68c01797f3$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $4d5564f5ca36dd68$var$Emotion = /* #__PURE__ */ $4d5564f5ca36dd68$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4d5564f5ca36dd68$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $35fc4a68c01797f3$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $7af428967f6af30d$export$6321afa313b251b5)(registeredStyles, undefined, $5cNek.useContext($4d5564f5ca36dd68$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4d5564f5ca36dd68$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $4d5564f5ca36dd68$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $5cNek.createElement($5cNek.Fragment, null, /*#__PURE__*/ $5cNek.createElement($4d5564f5ca36dd68$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $5cNek.createElement(WrappedComponent, newProps));
});
var $4d5564f5ca36dd68$export$a9c23c6ac3fc3eca = $4d5564f5ca36dd68$var$Emotion;


parcelRequire("5cNek");

var $39533520dac89738$exports = {};
function $39533520dac89738$var$_extends() {
    return $39533520dac89738$exports = $39533520dac89738$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39533520dac89738$exports.__esModule = true, $39533520dac89738$exports["default"] = $39533520dac89738$exports, $39533520dac89738$var$_extends.apply(null, arguments);
}
$39533520dac89738$exports = $39533520dac89738$var$_extends, $39533520dac89738$exports.__esModule = true, $39533520dac89738$exports["default"] = $39533520dac89738$exports;








var $cff4b33188421449$export$ffb0004e005737fa = $edb0ecc8242c88ed$exports.Fragment;
function $cff4b33188421449$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $4d5564f5ca36dd68$export$dda1d9f60106f0e9).call(props, "css")) return $edb0ecc8242c88ed$exports.jsx(type, props, key);
    return $edb0ecc8242c88ed$exports.jsx((0, $4d5564f5ca36dd68$export$a9c23c6ac3fc3eca), (0, $4d5564f5ca36dd68$export$db3b6bfb95261072)(type, props), key);
}
function $cff4b33188421449$export$25062201e9e25d76(type, props, key) {
    if (!(0, $4d5564f5ca36dd68$export$dda1d9f60106f0e9).call(props, "css")) return $edb0ecc8242c88ed$exports.jsxs(type, props, key);
    return $edb0ecc8242c88ed$exports.jsxs((0, $4d5564f5ca36dd68$export$a9c23c6ac3fc3eca), (0, $4d5564f5ca36dd68$export$db3b6bfb95261072)(type, props), key);
}



/** @jsx jsx */ 
var $5cNek = parcelRequire("5cNek");


var $5cNek = parcelRequire("5cNek");








var $e5448515388bb91a$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $e5448515388bb91a$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $4d5564f5ca36dd68$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $5cNek.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4d5564f5ca36dd68$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4d5564f5ca36dd68$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $5cNek.createElement.apply(null, createElementArgArray);
};
var $e5448515388bb91a$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e5448515388bb91a$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4d5564f5ca36dd68$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $7af428967f6af30d$export$6321afa313b251b5)([
        styles
    ], undefined, $5cNek.useContext((0, $4d5564f5ca36dd68$export$971d5caa766a69d7)));
    if (!(0, $4d5564f5ca36dd68$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $5cNek.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $5cNek.useRef();
    (0, $69252b5ce27af9a9$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $69252b5ce27af9a9$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $35fc4a68c01797f3$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e5448515388bb91a$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $7af428967f6af30d$export$6321afa313b251b5)(args);
}
var $e5448515388bb91a$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $e5448515388bb91a$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $e5448515388bb91a$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $e5448515388bb91a$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $35fc4a68c01797f3$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e5448515388bb91a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $69252b5ce27af9a9$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $35fc4a68c01797f3$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $e5448515388bb91a$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $4d5564f5ca36dd68$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $7af428967f6af30d$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $35fc4a68c01797f3$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e5448515388bb91a$var$merge(cache.registered, css, $e5448515388bb91a$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $5cNek.useContext((0, $4d5564f5ca36dd68$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $5cNek.createElement($5cNek.Fragment, null, /*#__PURE__*/ $5cNek.createElement($e5448515388bb91a$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $e5448515388bb91a$var$isBrowser, $e5448515388bb91a$var$isTestEnv, $e5448515388bb91a$var$globalContext, $e5448515388bb91a$var$globalKey;



var $5cNek = parcelRequire("5cNek");
var $0884f9b62b1e3b6a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5cNek.createContext)(null);


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-console */ var $77e153d250056799$var$printed = {};
function $77e153d250056799$export$2e2bcd8739ae039(message) {
    if ($77e153d250056799$var$printed[message]) return;
    $77e153d250056799$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}


var $458e44519ac5ea1c$exports = {};
// shim for using process in browser
var $458e44519ac5ea1c$var$process = $458e44519ac5ea1c$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $458e44519ac5ea1c$var$cachedSetTimeout;
var $458e44519ac5ea1c$var$cachedClearTimeout;
function $458e44519ac5ea1c$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $458e44519ac5ea1c$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $458e44519ac5ea1c$var$cachedSetTimeout = setTimeout;
        else $458e44519ac5ea1c$var$cachedSetTimeout = $458e44519ac5ea1c$var$defaultSetTimout;
    } catch (e) {
        $458e44519ac5ea1c$var$cachedSetTimeout = $458e44519ac5ea1c$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $458e44519ac5ea1c$var$cachedClearTimeout = clearTimeout;
        else $458e44519ac5ea1c$var$cachedClearTimeout = $458e44519ac5ea1c$var$defaultClearTimeout;
    } catch (e) {
        $458e44519ac5ea1c$var$cachedClearTimeout = $458e44519ac5ea1c$var$defaultClearTimeout;
    }
})();
function $458e44519ac5ea1c$var$runTimeout(fun) {
    if ($458e44519ac5ea1c$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($458e44519ac5ea1c$var$cachedSetTimeout === $458e44519ac5ea1c$var$defaultSetTimout || !$458e44519ac5ea1c$var$cachedSetTimeout) && setTimeout) {
        $458e44519ac5ea1c$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $458e44519ac5ea1c$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $458e44519ac5ea1c$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $458e44519ac5ea1c$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $458e44519ac5ea1c$var$runClearTimeout(marker) {
    if ($458e44519ac5ea1c$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($458e44519ac5ea1c$var$cachedClearTimeout === $458e44519ac5ea1c$var$defaultClearTimeout || !$458e44519ac5ea1c$var$cachedClearTimeout) && clearTimeout) {
        $458e44519ac5ea1c$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $458e44519ac5ea1c$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $458e44519ac5ea1c$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $458e44519ac5ea1c$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $458e44519ac5ea1c$var$queue = [];
var $458e44519ac5ea1c$var$draining = false;
var $458e44519ac5ea1c$var$currentQueue;
var $458e44519ac5ea1c$var$queueIndex = -1;
function $458e44519ac5ea1c$var$cleanUpNextTick() {
    if (!$458e44519ac5ea1c$var$draining || !$458e44519ac5ea1c$var$currentQueue) return;
    $458e44519ac5ea1c$var$draining = false;
    if ($458e44519ac5ea1c$var$currentQueue.length) $458e44519ac5ea1c$var$queue = $458e44519ac5ea1c$var$currentQueue.concat($458e44519ac5ea1c$var$queue);
    else $458e44519ac5ea1c$var$queueIndex = -1;
    if ($458e44519ac5ea1c$var$queue.length) $458e44519ac5ea1c$var$drainQueue();
}
function $458e44519ac5ea1c$var$drainQueue() {
    if ($458e44519ac5ea1c$var$draining) return;
    var timeout = $458e44519ac5ea1c$var$runTimeout($458e44519ac5ea1c$var$cleanUpNextTick);
    $458e44519ac5ea1c$var$draining = true;
    var len = $458e44519ac5ea1c$var$queue.length;
    while(len){
        $458e44519ac5ea1c$var$currentQueue = $458e44519ac5ea1c$var$queue;
        $458e44519ac5ea1c$var$queue = [];
        while(++$458e44519ac5ea1c$var$queueIndex < len)if ($458e44519ac5ea1c$var$currentQueue) $458e44519ac5ea1c$var$currentQueue[$458e44519ac5ea1c$var$queueIndex].run();
        $458e44519ac5ea1c$var$queueIndex = -1;
        len = $458e44519ac5ea1c$var$queue.length;
    }
    $458e44519ac5ea1c$var$currentQueue = null;
    $458e44519ac5ea1c$var$draining = false;
    $458e44519ac5ea1c$var$runClearTimeout(timeout);
}
$458e44519ac5ea1c$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $458e44519ac5ea1c$var$queue.push(new $458e44519ac5ea1c$var$Item(fun, args));
    if ($458e44519ac5ea1c$var$queue.length === 1 && !$458e44519ac5ea1c$var$draining) $458e44519ac5ea1c$var$runTimeout($458e44519ac5ea1c$var$drainQueue);
};
// v8 likes predictible objects
function $458e44519ac5ea1c$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$458e44519ac5ea1c$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$458e44519ac5ea1c$var$process.title = "browser";
$458e44519ac5ea1c$var$process.browser = true;
$458e44519ac5ea1c$var$process.env = {};
$458e44519ac5ea1c$var$process.argv = [];
$458e44519ac5ea1c$var$process.version = ""; // empty string to avoid regexp issues
$458e44519ac5ea1c$var$process.versions = {};
function $458e44519ac5ea1c$var$noop() {}
$458e44519ac5ea1c$var$process.on = $458e44519ac5ea1c$var$noop;
$458e44519ac5ea1c$var$process.addListener = $458e44519ac5ea1c$var$noop;
$458e44519ac5ea1c$var$process.once = $458e44519ac5ea1c$var$noop;
$458e44519ac5ea1c$var$process.off = $458e44519ac5ea1c$var$noop;
$458e44519ac5ea1c$var$process.removeListener = $458e44519ac5ea1c$var$noop;
$458e44519ac5ea1c$var$process.removeAllListeners = $458e44519ac5ea1c$var$noop;
$458e44519ac5ea1c$var$process.emit = $458e44519ac5ea1c$var$noop;
$458e44519ac5ea1c$var$process.prependListener = $458e44519ac5ea1c$var$noop;
$458e44519ac5ea1c$var$process.prependOnceListener = $458e44519ac5ea1c$var$noop;
$458e44519ac5ea1c$var$process.listeners = function(name) {
    return [];
};
$458e44519ac5ea1c$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$458e44519ac5ea1c$var$process.cwd = function() {
    return "/";
};
$458e44519ac5ea1c$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$458e44519ac5ea1c$var$process.umask = function() {
    return 0;
};


function $0ee865757bb4b051$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $77e153d250056799$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $0ee865757bb4b051$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $458e44519ac5ea1c$exports;
}



var $ea1180a9039473b6$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $ea1180a9039473b6$export$c93026a968943f95 = "light";
var $ea1180a9039473b6$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $ea1180a9039473b6$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $ea1180a9039473b6$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $ea1180a9039473b6$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $ea1180a9039473b6$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $ea1180a9039473b6$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $ea1180a9039473b6$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $ea1180a9039473b6$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $db8844ebfff7fa2d$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ea1180a9039473b6$export$6d8204c2cb2e06b8() / 4;
    (0, $0ee865757bb4b051$export$2e2bcd8739ae039)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $ea1180a9039473b6$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $ea1180a9039473b6$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $ea1180a9039473b6$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $0ee865757bb4b051$export$2e2bcd8739ae039)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $ea1180a9039473b6$export$ba1d834b86d72a09 = $ea1180a9039473b6$export$a1b3edb637fb4f35;
var $ea1180a9039473b6$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $db8844ebfff7fa2d$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $db8844ebfff7fa2d$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $db8844ebfff7fa2d$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $43b4654d5e79e2a5$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $ea1180a9039473b6$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $ea1180a9039473b6$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $ea1180a9039473b6$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $ea1180a9039473b6$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $2a259850ce7023da$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $43b4654d5e79e2a5$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $2a259850ce7023da$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $2a259850ce7023da$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $43b4654d5e79e2a5$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $db8844ebfff7fa2d$export$4b84fd0e2c617bd = "#FFEBE6";
var $db8844ebfff7fa2d$export$b34b069eff244586 = "#FFBDAD";
var $db8844ebfff7fa2d$export$be802dd0d8b57f35 = "#FF8F73";
var $db8844ebfff7fa2d$export$60847d42f9da92a6 = "#FF7452";
var $db8844ebfff7fa2d$export$4a7404f376229999 = "#FF5630";
var $db8844ebfff7fa2d$export$2010d0fb4295b346 = "#DE350B";
var $db8844ebfff7fa2d$export$2837b5a1a71d5c02 = "#BF2600";
var $db8844ebfff7fa2d$export$8d9596b529bbb9cf = "#FFFAE6";
var $db8844ebfff7fa2d$export$41060a744ab0b7ae = "#FFF0B3";
var $db8844ebfff7fa2d$export$1cc05bbbf340e559 = "#FFE380";
var $db8844ebfff7fa2d$export$5aae31392d72caaa = "#FFC400";
var $db8844ebfff7fa2d$export$c6930421db9fa514 = "#FFAB00";
var $db8844ebfff7fa2d$export$59619663aa6500fb = "#FF991F";
var $db8844ebfff7fa2d$export$874739ea9e379ab6 = "#FF8B00";
var $db8844ebfff7fa2d$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $db8844ebfff7fa2d$export$69a3bf21b9686c2b = "#ABF5D1";
var $db8844ebfff7fa2d$export$afbce1382ec95f73 = "#79F2C0";
var $db8844ebfff7fa2d$export$747d86715d4175de = "#57D9A3";
var $db8844ebfff7fa2d$export$940e1f69e873f202 = "#36B37E";
var $db8844ebfff7fa2d$export$a49394138f7b8e85 = "#00875A";
var $db8844ebfff7fa2d$export$6fa04827ac68a4fb = "#006644";
var $db8844ebfff7fa2d$export$226de0355ed012f8 = "#DEEBFF";
var $db8844ebfff7fa2d$export$8c13c2ee36917869 = "#B3D4FF";
var $db8844ebfff7fa2d$export$ecfc1dff386a3e7a = "#4C9AFF";
var $db8844ebfff7fa2d$export$215b7063051591f1 = "#2684FF";
var $db8844ebfff7fa2d$export$e62e8919cca44969 = "#0065FF";
var $db8844ebfff7fa2d$export$b3de0ae08da2ce64 = "#0052CC";
var $db8844ebfff7fa2d$export$a6ee3d71bc067634 = "#0747A6";
var $db8844ebfff7fa2d$export$363e4475840015bb = "#EAE6FF";
var $db8844ebfff7fa2d$export$4b0a4417ed59760f = "#C0B6F2";
var $db8844ebfff7fa2d$export$6011520a64d9a187 = "#998DD9";
var $db8844ebfff7fa2d$export$a7175d4e9206bc80 = "#8777D9";
var $db8844ebfff7fa2d$export$b48405b95304b5a1 = "#6554C0";
var $db8844ebfff7fa2d$export$c71e4279dd54a18d = "#5243AA";
var $db8844ebfff7fa2d$export$147899de772240ec = "#403294";
var $db8844ebfff7fa2d$export$2cf711fe14c66f06 = "#E6FCFF";
var $db8844ebfff7fa2d$export$7a8f4d33f6f9772c = "#B3F5FF";
var $db8844ebfff7fa2d$export$776c9c497ef08533 = "#79E2F2";
var $db8844ebfff7fa2d$export$69cb3ca10c1e330e = "#00C7E6";
var $db8844ebfff7fa2d$export$9dc1ef0f3f48059b = "#00B8D9";
var $db8844ebfff7fa2d$export$7c835c78b6fcdef8 = "#00A3BF";
var $db8844ebfff7fa2d$export$6036577f95c3877e = "#008DA6";
var $db8844ebfff7fa2d$export$29a4f05edc054374 = "#FFFFFF";
var $db8844ebfff7fa2d$export$e655ef011c4aa1a2 = "#FAFBFC";
var $db8844ebfff7fa2d$export$9fdfb749e33cdf97 = "#F4F5F7";
var $db8844ebfff7fa2d$export$3e51e8f1440314ba = "#EBECF0";
var $db8844ebfff7fa2d$export$1ce2d1575d444ceb = "#DFE1E6";
var $db8844ebfff7fa2d$export$8754fc7e6d8b3000 = "#C1C7D0";
var $db8844ebfff7fa2d$export$c2e91cbeada39b8b = "#B3BAC5";
var $db8844ebfff7fa2d$export$5f71e19f3a7ad9de = "#A5ADBA";
var $db8844ebfff7fa2d$export$eaa8c8a70ac22806 = "#97A0AF";
var $db8844ebfff7fa2d$export$7c87d337fb91a97d = "#8993A4";
var $db8844ebfff7fa2d$export$d6447c357493214f = "#7A869A";
var $db8844ebfff7fa2d$export$f563ee71e9ee74cd = "#6B778C";
var $db8844ebfff7fa2d$export$e2ef2124cf4024b1 = "#5E6C84";
var $db8844ebfff7fa2d$export$eece5f492e429f08 = "#505F79";
var $db8844ebfff7fa2d$export$c39c0fe0f26207ae = "#42526E";
var $db8844ebfff7fa2d$export$7090862dc3038a9f = "#344563";
var $db8844ebfff7fa2d$export$ad0bacf983b7ddaa = "#253858";
var $db8844ebfff7fa2d$export$7d61b15e0da132af = "#172B4D";
var $db8844ebfff7fa2d$export$fbda843f0a27fe96 = "#091E42";
var $db8844ebfff7fa2d$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $db8844ebfff7fa2d$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $db8844ebfff7fa2d$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $db8844ebfff7fa2d$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $db8844ebfff7fa2d$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $db8844ebfff7fa2d$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $db8844ebfff7fa2d$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $db8844ebfff7fa2d$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $db8844ebfff7fa2d$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $db8844ebfff7fa2d$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $db8844ebfff7fa2d$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $db8844ebfff7fa2d$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $db8844ebfff7fa2d$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $db8844ebfff7fa2d$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $db8844ebfff7fa2d$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $db8844ebfff7fa2d$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $db8844ebfff7fa2d$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $db8844ebfff7fa2d$export$2f6319cf7d736c2a = "#E6EDFA";
var $db8844ebfff7fa2d$export$95126bc8884d6634 = "#DCE5F5";
var $db8844ebfff7fa2d$export$8338d8c35d44ff1 = "#CED9EB";
var $db8844ebfff7fa2d$export$5368d76ae4fbbda7 = "#B8C7E0";
var $db8844ebfff7fa2d$export$9f0a771d16ec8d36 = "#ABBBD6";
var $db8844ebfff7fa2d$export$abcf8c38338b4aa5 = "#9FB0CC";
var $db8844ebfff7fa2d$export$97e81faa16a182c7 = "#8C9CB8";
var $db8844ebfff7fa2d$export$bfe21c59123ecf33 = "#7988A3";
var $db8844ebfff7fa2d$export$ee82aa2ea6a1558 = "#67758F";
var $db8844ebfff7fa2d$export$682927c6ed76be02 = "#56637A";
var $db8844ebfff7fa2d$export$91fd9994c5be9757 = "#455166";
var $db8844ebfff7fa2d$export$d281fbfe3cff2df6 = "#3B475C";
var $db8844ebfff7fa2d$export$3902c91d8b98a753 = "#313D52";
var $db8844ebfff7fa2d$export$8e8133c1ba5845b5 = "#283447";
var $db8844ebfff7fa2d$export$33ff357f6620b39 = "#202B3D";
var $db8844ebfff7fa2d$export$633847cf062b69e0 = "#1B2638";
var $db8844ebfff7fa2d$export$9776a6e503bdbf76 = "#121A29";
var $db8844ebfff7fa2d$export$6c813d5160dff5db = "#0E1624";
var $db8844ebfff7fa2d$export$3d4f271a500072a = "#0D1424";
var $db8844ebfff7fa2d$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $db8844ebfff7fa2d$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $db8844ebfff7fa2d$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $db8844ebfff7fa2d$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $db8844ebfff7fa2d$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $db8844ebfff7fa2d$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $db8844ebfff7fa2d$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $db8844ebfff7fa2d$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $db8844ebfff7fa2d$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $db8844ebfff7fa2d$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $db8844ebfff7fa2d$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $db8844ebfff7fa2d$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $db8844ebfff7fa2d$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $db8844ebfff7fa2d$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $db8844ebfff7fa2d$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $db8844ebfff7fa2d$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $db8844ebfff7fa2d$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $db8844ebfff7fa2d$export$8ce1fd94bee2f412 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($db8844ebfff7fa2d$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($db8844ebfff7fa2d$export$633847cf062b69e0, ")")
});
var $db8844ebfff7fa2d$export$b861914ea877b580 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$8c13c2ee36917869, ")")
});
var $db8844ebfff7fa2d$export$3f1b020df94387af = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($db8844ebfff7fa2d$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($db8844ebfff7fa2d$export$d281fbfe3cff2df6, ")")
});
var $db8844ebfff7fa2d$export$c0183dbab98ca63e = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($db8844ebfff7fa2d$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($db8844ebfff7fa2d$export$8e8133c1ba5845b5, ")")
});
var $db8844ebfff7fa2d$export$6f093cfa640b7166 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$5368d76ae4fbbda7, ")")
});
var $db8844ebfff7fa2d$export$42f8e9c698766e7a = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$5368d76ae4fbbda7, ")")
});
var $db8844ebfff7fa2d$export$c2d157ca1c34b6e3 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")")
});
var $db8844ebfff7fa2d$export$1905ba28d7cf066f = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($db8844ebfff7fa2d$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($db8844ebfff7fa2d$export$97e81faa16a182c7, ")")
});
var $db8844ebfff7fa2d$export$bd9002130d306d39 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($db8844ebfff7fa2d$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($db8844ebfff7fa2d$export$bfe21c59123ecf33, ")")
});
var $db8844ebfff7fa2d$export$46e4a324ac90507f = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$5368d76ae4fbbda7, ")")
});
var $db8844ebfff7fa2d$export$79f3f2b82beb0d36 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($db8844ebfff7fa2d$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($db8844ebfff7fa2d$export$97e81faa16a182c7, ")")
});
var $db8844ebfff7fa2d$export$7bb0d5c671655cc4 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: $db8844ebfff7fa2d$export$9fdfb749e33cdf97,
    dark: $db8844ebfff7fa2d$export$8e8133c1ba5845b5
});
var $db8844ebfff7fa2d$export$9c30223ca0a664fb = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($db8844ebfff7fa2d$export$ecfc1dff386a3e7a, ")")
});
var $db8844ebfff7fa2d$export$7ed258b0728b004b = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($db8844ebfff7fa2d$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($db8844ebfff7fa2d$export$215b7063051591f1, ")")
});
var $db8844ebfff7fa2d$export$dfa920d8decc8a59 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($db8844ebfff7fa2d$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($db8844ebfff7fa2d$export$ecfc1dff386a3e7a, ")")
});
var $db8844ebfff7fa2d$export$6069e6ad5c78f632 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($db8844ebfff7fa2d$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($db8844ebfff7fa2d$export$215b7063051591f1, ")")
});
var $db8844ebfff7fa2d$export$9ad721cf3b3debe0 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($db8844ebfff7fa2d$export$ecfc1dff386a3e7a, ")")
});
var $db8844ebfff7fa2d$export$2aa0182783e7e9de = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: $db8844ebfff7fa2d$export$b3de0ae08da2ce64,
    dark: $db8844ebfff7fa2d$export$ecfc1dff386a3e7a
});
var $db8844ebfff7fa2d$export$8bf7dff220b82b4a = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: $db8844ebfff7fa2d$export$9dc1ef0f3f48059b,
    dark: $db8844ebfff7fa2d$export$69cb3ca10c1e330e
});
var $db8844ebfff7fa2d$export$e13cce2a2d16a9d4 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: $db8844ebfff7fa2d$export$b48405b95304b5a1,
    dark: $db8844ebfff7fa2d$export$6011520a64d9a187
});
var $db8844ebfff7fa2d$export$a90204d1394caf30 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: $db8844ebfff7fa2d$export$4a7404f376229999,
    dark: $db8844ebfff7fa2d$export$4a7404f376229999
});
var $db8844ebfff7fa2d$export$594c5a8758200c32 = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: $db8844ebfff7fa2d$export$c6930421db9fa514,
    dark: $db8844ebfff7fa2d$export$c6930421db9fa514
});
var $db8844ebfff7fa2d$export$955a2ebd2fb142ae = (0, $2a259850ce7023da$export$2e2bcd8739ae039)({
    light: $db8844ebfff7fa2d$export$940e1f69e873f202,
    dark: $db8844ebfff7fa2d$export$940e1f69e873f202
});
var $db8844ebfff7fa2d$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($db8844ebfff7fa2d$export$8d43898f60b96a82, ")");
};


var $8733b61bde91fa4a$exports = {};
var $37eda165156877f9$exports = {};
function $37eda165156877f9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$37eda165156877f9$exports = $37eda165156877f9$var$_objectWithoutPropertiesLoose, $37eda165156877f9$exports.__esModule = true, $37eda165156877f9$exports["default"] = $37eda165156877f9$exports;


function $8733b61bde91fa4a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $37eda165156877f9$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$8733b61bde91fa4a$exports = $8733b61bde91fa4a$var$_objectWithoutProperties, $8733b61bde91fa4a$exports.__esModule = true, $8733b61bde91fa4a$exports["default"] = $8733b61bde91fa4a$exports;



var $5cNek = parcelRequire("5cNek");
var $ac0d3d85c294037c$var$_excluded = [
    "children"
];
function $ac0d3d85c294037c$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $5cNek.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $5cNek.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($8733b61bde91fa4a$exports)))(props, $ac0d3d85c294037c$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $5cNek.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $5cNek.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $ab2a8332a3eacc83$var$_createTheme = (0, $ac0d3d85c294037c$export$25d302a5b900a763)(function() {
    return {
        mode: "light"
    };
}), $ab2a8332a3eacc83$var$Provider = $ab2a8332a3eacc83$var$_createTheme.Provider, $ab2a8332a3eacc83$var$Consumer = $ab2a8332a3eacc83$var$_createTheme.Consumer, $ab2a8332a3eacc83$export$7692396083754928 = $ab2a8332a3eacc83$var$_createTheme.useTheme;
var $ab2a8332a3eacc83$export$2e2bcd8739ae039 = {
    Provider: $ab2a8332a3eacc83$var$Provider,
    Consumer: $ab2a8332a3eacc83$var$Consumer
};


var $f225361506226e85$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $9240654f48141bfe$var$getStrokeColor(_ref) {
    var mode = _ref.mode, appearance = _ref.appearance;
    if (mode === "light") return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $db8844ebfff7fa2d$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $db8844ebfff7fa2d$export$29a4f05edc054374), ")");
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $db8844ebfff7fa2d$export$2f6319cf7d736c2a), ")") : "var(--ds-icon-inverse, ".concat((0, $db8844ebfff7fa2d$export$9f0a771d16ec8d36), ")");
}
var $9240654f48141bfe$var$rotate = (0, $e5448515388bb91a$export$d25ddfdf17c3ad3e)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $9240654f48141bfe$var$rotateStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    animation: "".concat($9240654f48141bfe$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $9240654f48141bfe$var$loadIn = (0, $e5448515388bb91a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $9240654f48141bfe$var$loadInStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    animation: "".concat($9240654f48141bfe$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $9240654f48141bfe$var$wrapperStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $9240654f48141bfe$var$circleStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $9240654f48141bfe$var$useLayoutEffect = typeof window === "undefined" ? (0, $5cNek.useEffect) : (0, $5cNek.useLayoutEffect);
var $9240654f48141bfe$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).forwardRef(function Spinner(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "inherit" : _ref2$appearance, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 0 : _ref2$delay, interactionName = _ref2.interactionName, label = _ref2.label, _ref2$size = _ref2.size, providedSize = _ref2$size === void 0 ? "medium" : _ref2$size, testId = _ref2.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $f225361506226e85$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var _useGlobalTheme = (0, $ab2a8332a3eacc83$export$7692396083754928)(), mode = _useGlobalTheme.mode;
    var stroke = $9240654f48141bfe$var$getStrokeColor({
        mode: mode,
        appearance: appearance
    });
    var context = (0, $5cNek.useContext)((0, $0884f9b62b1e3b6a$export$2e2bcd8739ae039));
    $9240654f48141bfe$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $9240654f48141bfe$var$wrapperStyles,
            $9240654f48141bfe$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $9240654f48141bfe$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $9240654f48141bfe$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));



function $7d9ece1931efbf1d$var$e(e) {
    this.message = e;
}
$7d9ece1931efbf1d$var$e.prototype = new Error, $7d9ece1931efbf1d$var$e.prototype.name = "InvalidCharacterError";
var $7d9ece1931efbf1d$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $7d9ece1931efbf1d$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $7d9ece1931efbf1d$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($7d9ece1931efbf1d$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $7d9ece1931efbf1d$var$r(t);
    }
}
function $7d9ece1931efbf1d$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $7d9ece1931efbf1d$var$o(e, r) {
    if ("string" != typeof e) throw new $7d9ece1931efbf1d$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($7d9ece1931efbf1d$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $7d9ece1931efbf1d$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$7d9ece1931efbf1d$export$b9721ef022f71a68.prototype = new Error, $7d9ece1931efbf1d$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $7d9ece1931efbf1d$export$2e2bcd8739ae039 = $7d9ece1931efbf1d$var$o;



var $5cNek = parcelRequire("5cNek");
var $3a6b787322b342cd$exports = {};
"use strict";
function $3a6b787322b342cd$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3a6b787322b342cd$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3a6b787322b342cd$var$checkDCE();

$3a6b787322b342cd$exports = (parcelRequire("eGxVA"));


/**
 * React Router DOM v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5cNek = parcelRequire("5cNek");
/**
 * @remix-run/router v1.9.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $4cbe0a50b1516daf$var$_extends() {
    $4cbe0a50b1516daf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4cbe0a50b1516daf$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $4cbe0a50b1516daf$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($4cbe0a50b1516daf$export$e19cd5f9376f8cee || ($4cbe0a50b1516daf$export$e19cd5f9376f8cee = {}));
const $4cbe0a50b1516daf$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $4cbe0a50b1516daf$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $4cbe0a50b1516daf$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $4cbe0a50b1516daf$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $4cbe0a50b1516daf$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $4cbe0a50b1516daf$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $4cbe0a50b1516daf$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $4cbe0a50b1516daf$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $4cbe0a50b1516daf$export$fe53371bee54353d(to);
    }
    return $4cbe0a50b1516daf$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $4cbe0a50b1516daf$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $4cbe0a50b1516daf$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $4cbe0a50b1516daf$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $4cbe0a50b1516daf$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $4cbe0a50b1516daf$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $4cbe0a50b1516daf$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $4cbe0a50b1516daf$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $4cbe0a50b1516daf$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $4cbe0a50b1516daf$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $4cbe0a50b1516daf$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $4cbe0a50b1516daf$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $4cbe0a50b1516daf$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $4cbe0a50b1516daf$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $4cbe0a50b1516daf$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $4cbe0a50b1516daf$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $4cbe0a50b1516daf$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $4cbe0a50b1516daf$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($4cbe0a50b1516daf$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Push;
        let location = $4cbe0a50b1516daf$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $4cbe0a50b1516daf$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Replace;
        let location = $4cbe0a50b1516daf$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $4cbe0a50b1516daf$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $4cbe0a50b1516daf$export$fe53371bee54353d(to);
        $4cbe0a50b1516daf$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($4cbe0a50b1516daf$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($4cbe0a50b1516daf$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $4cbe0a50b1516daf$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($4cbe0a50b1516daf$var$ResultType || ($4cbe0a50b1516daf$var$ResultType = {}));
const $4cbe0a50b1516daf$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $4cbe0a50b1516daf$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $4cbe0a50b1516daf$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $4cbe0a50b1516daf$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $4cbe0a50b1516daf$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($4cbe0a50b1516daf$var$isIndexRoute(route)) {
            let indexRoute = $4cbe0a50b1516daf$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $4cbe0a50b1516daf$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $4cbe0a50b1516daf$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $4cbe0a50b1516daf$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $4cbe0a50b1516daf$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $4cbe0a50b1516daf$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $4cbe0a50b1516daf$var$flattenRoutes(routes);
    $4cbe0a50b1516daf$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $4cbe0a50b1516daf$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $4cbe0a50b1516daf$var$safelyDecodeURI(pathname));
    return matches;
}
function $4cbe0a50b1516daf$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $4cbe0a50b1516daf$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $4cbe0a50b1516daf$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $4cbe0a50b1516daf$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $4cbe0a50b1516daf$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $4cbe0a50b1516daf$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $4cbe0a50b1516daf$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $4cbe0a50b1516daf$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $4cbe0a50b1516daf$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $4cbe0a50b1516daf$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $4cbe0a50b1516daf$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $4cbe0a50b1516daf$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $4cbe0a50b1516daf$var$paramRe = /^:\w+$/;
const $4cbe0a50b1516daf$var$dynamicSegmentValue = 3;
const $4cbe0a50b1516daf$var$indexRouteValue = 2;
const $4cbe0a50b1516daf$var$emptySegmentValue = 1;
const $4cbe0a50b1516daf$var$staticSegmentValue = 10;
const $4cbe0a50b1516daf$var$splatPenalty = -2;
const $4cbe0a50b1516daf$var$isSplat = (s)=>s === "*";
function $4cbe0a50b1516daf$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($4cbe0a50b1516daf$var$isSplat)) initialScore += $4cbe0a50b1516daf$var$splatPenalty;
    if (index) initialScore += $4cbe0a50b1516daf$var$indexRouteValue;
    return segments.filter((s)=>!$4cbe0a50b1516daf$var$isSplat(s)).reduce((score, segment)=>score + ($4cbe0a50b1516daf$var$paramRe.test(segment) ? $4cbe0a50b1516daf$var$dynamicSegmentValue : segment === "" ? $4cbe0a50b1516daf$var$emptySegmentValue : $4cbe0a50b1516daf$var$staticSegmentValue), initialScore);
}
function $4cbe0a50b1516daf$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $4cbe0a50b1516daf$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $4cbe0a50b1516daf$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $4cbe0a50b1516daf$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $4cbe0a50b1516daf$export$a5c6d149b50c1d86($4cbe0a50b1516daf$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $4cbe0a50b1516daf$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $4cbe0a50b1516daf$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $4cbe0a50b1516daf$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $4cbe0a50b1516daf$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $4cbe0a50b1516daf$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $4cbe0a50b1516daf$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $4cbe0a50b1516daf$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $4cbe0a50b1516daf$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $4cbe0a50b1516daf$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $4cbe0a50b1516daf$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $4cbe0a50b1516daf$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $4cbe0a50b1516daf$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $4cbe0a50b1516daf$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $4cbe0a50b1516daf$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $4cbe0a50b1516daf$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $4cbe0a50b1516daf$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $4cbe0a50b1516daf$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $4cbe0a50b1516daf$var$normalizeSearch(search),
        hash: $4cbe0a50b1516daf$var$normalizeHash(hash)
    };
}
function $4cbe0a50b1516daf$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $4cbe0a50b1516daf$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $4cbe0a50b1516daf$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $4cbe0a50b1516daf$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $4cbe0a50b1516daf$export$8ccf933b0513f8d0(toArg);
    else {
        to = $4cbe0a50b1516daf$var$_extends({}, toArg);
        $4cbe0a50b1516daf$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $4cbe0a50b1516daf$var$getInvalidPathError("?", "pathname", "search", to));
        $4cbe0a50b1516daf$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $4cbe0a50b1516daf$var$getInvalidPathError("#", "pathname", "hash", to));
        $4cbe0a50b1516daf$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $4cbe0a50b1516daf$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $4cbe0a50b1516daf$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $4cbe0a50b1516daf$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $4cbe0a50b1516daf$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $4cbe0a50b1516daf$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $4cbe0a50b1516daf$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $4cbe0a50b1516daf$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $4cbe0a50b1516daf$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $4cbe0a50b1516daf$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $4cbe0a50b1516daf$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $4cbe0a50b1516daf$export$42a99a7a4bc0e76a extends Error {
}
class $4cbe0a50b1516daf$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $4cbe0a50b1516daf$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $4cbe0a50b1516daf$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $4cbe0a50b1516daf$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $4cbe0a50b1516daf$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $4cbe0a50b1516daf$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $4cbe0a50b1516daf$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $4cbe0a50b1516daf$var$unwrapTrackedPromise(value) {
    if (!$4cbe0a50b1516daf$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $4cbe0a50b1516daf$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $4cbe0a50b1516daf$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $4cbe0a50b1516daf$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $4cbe0a50b1516daf$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $4cbe0a50b1516daf$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $4cbe0a50b1516daf$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $4cbe0a50b1516daf$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $4cbe0a50b1516daf$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $4cbe0a50b1516daf$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $4cbe0a50b1516daf$var$validMutationMethods = new Set($4cbe0a50b1516daf$var$validMutationMethodsArr);
const $4cbe0a50b1516daf$var$validRequestMethodsArr = [
    "get",
    ...$4cbe0a50b1516daf$var$validMutationMethodsArr
];
const $4cbe0a50b1516daf$var$validRequestMethods = new Set($4cbe0a50b1516daf$var$validRequestMethodsArr);
const $4cbe0a50b1516daf$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $4cbe0a50b1516daf$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $4cbe0a50b1516daf$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $4cbe0a50b1516daf$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $4cbe0a50b1516daf$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $4cbe0a50b1516daf$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $4cbe0a50b1516daf$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $4cbe0a50b1516daf$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $4cbe0a50b1516daf$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $4cbe0a50b1516daf$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $4cbe0a50b1516daf$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $4cbe0a50b1516daf$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $4cbe0a50b1516daf$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $4cbe0a50b1516daf$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $4cbe0a50b1516daf$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $4cbe0a50b1516daf$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $4cbe0a50b1516daf$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $4cbe0a50b1516daf$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($4cbe0a50b1516daf$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $4cbe0a50b1516daf$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $4cbe0a50b1516daf$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $4cbe0a50b1516daf$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $4cbe0a50b1516daf$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $4cbe0a50b1516daf$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($4cbe0a50b1516daf$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $4cbe0a50b1516daf$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $4cbe0a50b1516daf$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $4cbe0a50b1516daf$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $4cbe0a50b1516daf$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $4cbe0a50b1516daf$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $4cbe0a50b1516daf$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $4cbe0a50b1516daf$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $4cbe0a50b1516daf$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $4cbe0a50b1516daf$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $4cbe0a50b1516daf$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $4cbe0a50b1516daf$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $4cbe0a50b1516daf$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $4cbe0a50b1516daf$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$4cbe0a50b1516daf$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $4cbe0a50b1516daf$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $4cbe0a50b1516daf$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $4cbe0a50b1516daf$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $4cbe0a50b1516daf$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $4cbe0a50b1516daf$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $4cbe0a50b1516daf$var$ResultType.error,
            error: $4cbe0a50b1516daf$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $4cbe0a50b1516daf$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($4cbe0a50b1516daf$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($4cbe0a50b1516daf$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $4cbe0a50b1516daf$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($4cbe0a50b1516daf$var$isDeferredResult(result)) throw $4cbe0a50b1516daf$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $4cbe0a50b1516daf$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $4cbe0a50b1516daf$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $4cbe0a50b1516daf$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $4cbe0a50b1516daf$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $4cbe0a50b1516daf$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($4cbe0a50b1516daf$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $4cbe0a50b1516daf$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $4cbe0a50b1516daf$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $4cbe0a50b1516daf$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $4cbe0a50b1516daf$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $4cbe0a50b1516daf$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $4cbe0a50b1516daf$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $4cbe0a50b1516daf$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $4cbe0a50b1516daf$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $4cbe0a50b1516daf$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $4cbe0a50b1516daf$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $4cbe0a50b1516daf$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $4cbe0a50b1516daf$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $4cbe0a50b1516daf$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $4cbe0a50b1516daf$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($4cbe0a50b1516daf$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $4cbe0a50b1516daf$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $4cbe0a50b1516daf$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($4cbe0a50b1516daf$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($4cbe0a50b1516daf$var$isDeferredResult(actionResult)) throw $4cbe0a50b1516daf$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $4cbe0a50b1516daf$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $4cbe0a50b1516daf$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $4cbe0a50b1516daf$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $4cbe0a50b1516daf$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $4cbe0a50b1516daf$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $4cbe0a50b1516daf$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $4cbe0a50b1516daf$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $4cbe0a50b1516daf$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $4cbe0a50b1516daf$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $4cbe0a50b1516daf$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($4cbe0a50b1516daf$var$_extends({
                errors: errors,
                loaderData: $4cbe0a50b1516daf$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $4cbe0a50b1516daf$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $4cbe0a50b1516daf$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $4cbe0a50b1516daf$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($4cbe0a50b1516daf$var$isDeferredResult(result)) result = await $4cbe0a50b1516daf$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($4cbe0a50b1516daf$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $4cbe0a50b1516daf$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($4cbe0a50b1516daf$var$isErrorResult(result)) {
            let boundaryMatch = $4cbe0a50b1516daf$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $4cbe0a50b1516daf$export$3e9cee6b33872309(!$4cbe0a50b1516daf$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $4cbe0a50b1516daf$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $4cbe0a50b1516daf$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $4cbe0a50b1516daf$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($4cbe0a50b1516daf$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $4cbe0a50b1516daf$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Replace : $4cbe0a50b1516daf$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $4cbe0a50b1516daf$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($4cbe0a50b1516daf$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $4cbe0a50b1516daf$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $4cbe0a50b1516daf$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $4cbe0a50b1516daf$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$4cbe0a50b1516daf$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $4cbe0a50b1516daf$var$callLoaderOrAction("loader", $4cbe0a50b1516daf$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $4cbe0a50b1516daf$var$ResultType.error,
                        error: $4cbe0a50b1516daf$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $4cbe0a50b1516daf$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $4cbe0a50b1516daf$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $4cbe0a50b1516daf$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $4cbe0a50b1516daf$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $4cbe0a50b1516daf$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $4cbe0a50b1516daf$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $4cbe0a50b1516daf$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $4cbe0a50b1516daf$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $4cbe0a50b1516daf$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $4cbe0a50b1516daf$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $4cbe0a50b1516daf$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $4cbe0a50b1516daf$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$4cbe0a50b1516daf$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $4cbe0a50b1516daf$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $4cbe0a50b1516daf$export$4d0306f8f6a4585b = Symbol("deferred");
function $4cbe0a50b1516daf$export$3336b097a6fbc59a(routes, opts) {
    $4cbe0a50b1516daf$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $4cbe0a50b1516daf$var$defaultMapRouteProperties;
    let dataRoutes = $4cbe0a50b1516daf$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $4cbe0a50b1516daf$var$createLocation("", $4cbe0a50b1516daf$export$fe53371bee54353d(url), null, "default");
        let matches = $4cbe0a50b1516daf$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$4cbe0a50b1516daf$var$isValidMethod(method) && method !== "HEAD") {
            let error = $4cbe0a50b1516daf$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $4cbe0a50b1516daf$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $4cbe0a50b1516daf$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $4cbe0a50b1516daf$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($4cbe0a50b1516daf$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $4cbe0a50b1516daf$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $4cbe0a50b1516daf$var$createLocation("", $4cbe0a50b1516daf$export$fe53371bee54353d(url), null, "default");
        let matches = $4cbe0a50b1516daf$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$4cbe0a50b1516daf$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $4cbe0a50b1516daf$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $4cbe0a50b1516daf$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $4cbe0a50b1516daf$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $4cbe0a50b1516daf$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $4cbe0a50b1516daf$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($4cbe0a50b1516daf$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$4cbe0a50b1516daf$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $4cbe0a50b1516daf$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($4cbe0a50b1516daf$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $4cbe0a50b1516daf$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $4cbe0a50b1516daf$var$isResponse(result) ? result : $4cbe0a50b1516daf$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($4cbe0a50b1516daf$var$isQueryRouteResponse(e)) {
                if (e.type === $4cbe0a50b1516daf$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($4cbe0a50b1516daf$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $4cbe0a50b1516daf$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $4cbe0a50b1516daf$var$ResultType.error,
                error: error
            };
        } else {
            result = await $4cbe0a50b1516daf$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($4cbe0a50b1516daf$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($4cbe0a50b1516daf$var$isDeferredResult(result)) {
            let error = $4cbe0a50b1516daf$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $4cbe0a50b1516daf$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($4cbe0a50b1516daf$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($4cbe0a50b1516daf$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $4cbe0a50b1516daf$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $4cbe0a50b1516daf$var$_extends({}, context, {
                statusCode: $4cbe0a50b1516daf$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $4cbe0a50b1516daf$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $4cbe0a50b1516daf$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $4cbe0a50b1516daf$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $4cbe0a50b1516daf$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $4cbe0a50b1516daf$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$4cbe0a50b1516daf$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $4cbe0a50b1516daf$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $4cbe0a50b1516daf$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $4cbe0a50b1516daf$export$fec11da027c70692(routes, context, error) {
    let newContext = $4cbe0a50b1516daf$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $4cbe0a50b1516daf$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $4cbe0a50b1516daf$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $4cbe0a50b1516daf$export$cae722b0cc860f13(to ? to : ".", $4cbe0a50b1516daf$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $4cbe0a50b1516daf$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$4cbe0a50b1516daf$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $4cbe0a50b1516daf$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $4cbe0a50b1516daf$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $4cbe0a50b1516daf$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$4cbe0a50b1516daf$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$4cbe0a50b1516daf$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $4cbe0a50b1516daf$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $4cbe0a50b1516daf$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $4cbe0a50b1516daf$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$4cbe0a50b1516daf$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$4cbe0a50b1516daf$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $4cbe0a50b1516daf$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $4cbe0a50b1516daf$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $4cbe0a50b1516daf$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $4cbe0a50b1516daf$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $4cbe0a50b1516daf$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($4cbe0a50b1516daf$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $4cbe0a50b1516daf$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $4cbe0a50b1516daf$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $4cbe0a50b1516daf$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $4cbe0a50b1516daf$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $4cbe0a50b1516daf$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $4cbe0a50b1516daf$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($4cbe0a50b1516daf$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $4cbe0a50b1516daf$var$shouldRevalidateLoader(match, $4cbe0a50b1516daf$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $4cbe0a50b1516daf$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $4cbe0a50b1516daf$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $4cbe0a50b1516daf$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $4cbe0a50b1516daf$var$shouldRevalidateLoader(fetcherMatch, $4cbe0a50b1516daf$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $4cbe0a50b1516daf$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $4cbe0a50b1516daf$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $4cbe0a50b1516daf$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $4cbe0a50b1516daf$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $4cbe0a50b1516daf$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $4cbe0a50b1516daf$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$4cbe0a50b1516daf$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $4cbe0a50b1516daf$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $4cbe0a50b1516daf$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $4cbe0a50b1516daf$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $4cbe0a50b1516daf$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $4cbe0a50b1516daf$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $4cbe0a50b1516daf$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $4cbe0a50b1516daf$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $4cbe0a50b1516daf$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $4cbe0a50b1516daf$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($4cbe0a50b1516daf$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($4cbe0a50b1516daf$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $4cbe0a50b1516daf$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$4cbe0a50b1516daf$var$ABSOLUTE_URL_REGEX.test(location)) location = $4cbe0a50b1516daf$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $4cbe0a50b1516daf$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $4cbe0a50b1516daf$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $4cbe0a50b1516daf$var$ResultType.error ? $4cbe0a50b1516daf$var$ResultType.error : $4cbe0a50b1516daf$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $4cbe0a50b1516daf$var$ResultType.error) return {
            type: resultType,
            error: new $4cbe0a50b1516daf$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $4cbe0a50b1516daf$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $4cbe0a50b1516daf$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($4cbe0a50b1516daf$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $4cbe0a50b1516daf$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $4cbe0a50b1516daf$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $4cbe0a50b1516daf$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($4cbe0a50b1516daf$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $4cbe0a50b1516daf$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $4cbe0a50b1516daf$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $4cbe0a50b1516daf$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $4cbe0a50b1516daf$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $4cbe0a50b1516daf$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $4cbe0a50b1516daf$export$3e9cee6b33872309(!$4cbe0a50b1516daf$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($4cbe0a50b1516daf$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $4cbe0a50b1516daf$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $4cbe0a50b1516daf$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($4cbe0a50b1516daf$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $4cbe0a50b1516daf$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $4cbe0a50b1516daf$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $4cbe0a50b1516daf$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($4cbe0a50b1516daf$var$isErrorResult(result)) {
            let boundaryMatch = $4cbe0a50b1516daf$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $4cbe0a50b1516daf$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($4cbe0a50b1516daf$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $4cbe0a50b1516daf$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($4cbe0a50b1516daf$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $4cbe0a50b1516daf$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $4cbe0a50b1516daf$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $4cbe0a50b1516daf$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $4cbe0a50b1516daf$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $4cbe0a50b1516daf$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $4cbe0a50b1516daf$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $4cbe0a50b1516daf$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $4cbe0a50b1516daf$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $4cbe0a50b1516daf$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($4cbe0a50b1516daf$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $4cbe0a50b1516daf$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $4cbe0a50b1516daf$export$8ccf933b0513f8d0(path) : path;
    return $4cbe0a50b1516daf$export$fe53371bee54353d($4cbe0a50b1516daf$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $4cbe0a50b1516daf$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $4cbe0a50b1516daf$var$isDeferredResult(result) {
    return result.type === $4cbe0a50b1516daf$var$ResultType.deferred;
}
function $4cbe0a50b1516daf$var$isErrorResult(result) {
    return result.type === $4cbe0a50b1516daf$var$ResultType.error;
}
function $4cbe0a50b1516daf$var$isRedirectResult(result) {
    return (result && result.type) === $4cbe0a50b1516daf$var$ResultType.redirect;
}
function $4cbe0a50b1516daf$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $4cbe0a50b1516daf$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $4cbe0a50b1516daf$var$isRedirectResponse(result) {
    if (!$4cbe0a50b1516daf$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $4cbe0a50b1516daf$var$isQueryRouteResponse(obj) {
    return obj && $4cbe0a50b1516daf$var$isResponse(obj.response) && (obj.type === $4cbe0a50b1516daf$var$ResultType.data || obj.type === $4cbe0a50b1516daf$var$ResultType.error);
}
function $4cbe0a50b1516daf$var$isValidMethod(method) {
    return $4cbe0a50b1516daf$var$validRequestMethods.has(method.toLowerCase());
}
function $4cbe0a50b1516daf$var$isMutationMethod(method) {
    return $4cbe0a50b1516daf$var$validMutationMethods.has(method.toLowerCase());
}
async function $4cbe0a50b1516daf$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$4cbe0a50b1516daf$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($4cbe0a50b1516daf$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $4cbe0a50b1516daf$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $4cbe0a50b1516daf$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $4cbe0a50b1516daf$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $4cbe0a50b1516daf$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $4cbe0a50b1516daf$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $4cbe0a50b1516daf$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $4cbe0a50b1516daf$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $4cbe0a50b1516daf$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $4cbe0a50b1516daf$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $4cbe0a50b1516daf$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $4cbe0a50b1516daf$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $4cbe0a50b1516daf$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $4cbe0a50b1516daf$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $4cbe0a50b1516daf$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $4cbe0a50b1516daf$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $4cbe0a50b1516daf$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $4cbe0a50b1516daf$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}

/**
 * React Router v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5cNek = parcelRequire("5cNek");

function $7bdcd4addcd96486$var$_extends() {
    $7bdcd4addcd96486$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7bdcd4addcd96486$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7bdcd4addcd96486$export$3add0d5dce533e2e = /*#__PURE__*/ $5cNek.createContext(null);
const $7bdcd4addcd96486$export$145dfa71566a64dc = /*#__PURE__*/ $5cNek.createContext(null);
const $7bdcd4addcd96486$var$AwaitContext = /*#__PURE__*/ $5cNek.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7bdcd4addcd96486$export$26749e8557646306 = /*#__PURE__*/ $5cNek.createContext(null);
const $7bdcd4addcd96486$export$c7914228fb69b0f5 = /*#__PURE__*/ $5cNek.createContext(null);
const $7bdcd4addcd96486$export$9072aa6dd1f93057 = /*#__PURE__*/ $5cNek.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7bdcd4addcd96486$var$RouteErrorContext = /*#__PURE__*/ $5cNek.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7bdcd4addcd96486$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7bdcd4addcd96486$export$9c954a9d03d32f4a() && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $5cNek.useContext($7bdcd4addcd96486$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7bdcd4addcd96486$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $4cbe0a50b1516daf$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7bdcd4addcd96486$export$9c954a9d03d32f4a() {
    return $5cNek.useContext($7bdcd4addcd96486$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7bdcd4addcd96486$export$45d76561a5302f2b() {
    !$7bdcd4addcd96486$export$9c954a9d03d32f4a() && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    return $5cNek.useContext($7bdcd4addcd96486$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7bdcd4addcd96486$export$1b3f31771c5d07c() {
    return $5cNek.useContext($7bdcd4addcd96486$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7bdcd4addcd96486$export$6c330e8992e8a295(pattern) {
    !$7bdcd4addcd96486$export$9c954a9d03d32f4a() && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7bdcd4addcd96486$export$45d76561a5302f2b();
    return $5cNek.useMemo(()=>(0, $4cbe0a50b1516daf$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7bdcd4addcd96486$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7bdcd4addcd96486$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $5cNek.useContext($7bdcd4addcd96486$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5cNek.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7bdcd4addcd96486$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $5cNek.useContext($7bdcd4addcd96486$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7bdcd4addcd96486$var$useNavigateStable() : $7bdcd4addcd96486$var$useNavigateUnstable();
}
function $7bdcd4addcd96486$var$useNavigateUnstable() {
    !$7bdcd4addcd96486$export$9c954a9d03d32f4a() && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    let dataRouterContext = $5cNek.useContext($7bdcd4addcd96486$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $5cNek.useContext($7bdcd4addcd96486$export$26749e8557646306);
    let { matches: matches } = $5cNek.useContext($7bdcd4addcd96486$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7bdcd4addcd96486$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $4cbe0a50b1516daf$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $5cNek.useRef(false);
    $7bdcd4addcd96486$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5cNek.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $4cbe0a50b1516daf$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $4cbe0a50b1516daf$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7bdcd4addcd96486$var$OutletContext = /*#__PURE__*/ $5cNek.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7bdcd4addcd96486$export$4138103a3ae699cc() {
    return $5cNek.useContext($7bdcd4addcd96486$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7bdcd4addcd96486$export$a3be3530d8e40d0b(context) {
    let outlet = $5cNek.useContext($7bdcd4addcd96486$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7bdcd4addcd96486$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $5cNek.useContext($7bdcd4addcd96486$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7bdcd4addcd96486$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $5cNek.useContext($7bdcd4addcd96486$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7bdcd4addcd96486$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $4cbe0a50b1516daf$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $5cNek.useMemo(()=>(0, $4cbe0a50b1516daf$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7bdcd4addcd96486$export$5d3fca4a98652595(routes, locationArg) {
    return $7bdcd4addcd96486$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7bdcd4addcd96486$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7bdcd4addcd96486$export$9c954a9d03d32f4a() && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $5cNek.useContext($7bdcd4addcd96486$export$26749e8557646306);
    let { matches: parentMatches } = $5cNek.useContext($7bdcd4addcd96486$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7bdcd4addcd96486$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $4cbe0a50b1516daf$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $4cbe0a50b1516daf$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7bdcd4addcd96486$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $4cbe0a50b1516daf$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $4cbe0a50b1516daf$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7bdcd4addcd96486$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $4cbe0a50b1516daf$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7bdcd4addcd96486$var$DefaultErrorComponent() {
    let error = $7bdcd4addcd96486$export$ed527bf60f6e05f2();
    let message = (0, $4cbe0a50b1516daf$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $5cNek.createElement($5cNek.Fragment, null, /*#__PURE__*/ $5cNek.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $5cNek.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $5cNek.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7bdcd4addcd96486$var$defaultErrorElement = /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$DefaultErrorComponent, null);
class $7bdcd4addcd96486$var$RenderErrorBoundary extends $5cNek.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7bdcd4addcd96486$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $5cNek.useContext($7bdcd4addcd96486$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7bdcd4addcd96486$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7bdcd4addcd96486$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $5cNek.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7bdcd4addcd96486$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7bdcd4addcd96486$var$DataRouterHook || {});
var $7bdcd4addcd96486$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7bdcd4addcd96486$var$DataRouterStateHook || {});
function $7bdcd4addcd96486$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7bdcd4addcd96486$var$useDataRouterContext(hookName) {
    let ctx = $5cNek.useContext($7bdcd4addcd96486$export$3add0d5dce533e2e);
    !ctx && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7bdcd4addcd96486$var$useDataRouterState(hookName) {
    let state = $5cNek.useContext($7bdcd4addcd96486$export$145dfa71566a64dc);
    !state && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    return state;
}
function $7bdcd4addcd96486$var$useRouteContext(hookName) {
    let route = $5cNek.useContext($7bdcd4addcd96486$export$9072aa6dd1f93057);
    !route && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7bdcd4addcd96486$var$useCurrentRouteId(hookName) {
    let route = $7bdcd4addcd96486$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7bdcd4addcd96486$export$5fc8298006ad9e58() {
    return $7bdcd4addcd96486$var$useCurrentRouteId($7bdcd4addcd96486$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7bdcd4addcd96486$export$d0fd4b7106de2769() {
    let state = $7bdcd4addcd96486$var$useDataRouterState($7bdcd4addcd96486$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7bdcd4addcd96486$export$600dc272ed516c15() {
    let dataRouterContext = $7bdcd4addcd96486$var$useDataRouterContext($7bdcd4addcd96486$var$DataRouterHook.UseRevalidator);
    let state = $7bdcd4addcd96486$var$useDataRouterState($7bdcd4addcd96486$var$DataRouterStateHook.UseRevalidator);
    return $5cNek.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7bdcd4addcd96486$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7bdcd4addcd96486$var$useDataRouterState($7bdcd4addcd96486$var$DataRouterStateHook.UseMatches);
    return $5cNek.useMemo(()=>matches.map((m)=>(0, $4cbe0a50b1516daf$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7bdcd4addcd96486$export$1448a5050d252c4d() {
    let state = $7bdcd4addcd96486$var$useDataRouterState($7bdcd4addcd96486$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7bdcd4addcd96486$var$useCurrentRouteId($7bdcd4addcd96486$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7bdcd4addcd96486$export$fd5d37484eab868d(routeId) {
    let state = $7bdcd4addcd96486$var$useDataRouterState($7bdcd4addcd96486$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7bdcd4addcd96486$export$fdc00f3f26066d5e() {
    let state = $7bdcd4addcd96486$var$useDataRouterState($7bdcd4addcd96486$var$DataRouterStateHook.UseActionData);
    let route = $5cNek.useContext($7bdcd4addcd96486$export$9072aa6dd1f93057);
    !route && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7bdcd4addcd96486$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $5cNek.useContext($7bdcd4addcd96486$var$RouteErrorContext);
    let state = $7bdcd4addcd96486$var$useDataRouterState($7bdcd4addcd96486$var$DataRouterStateHook.UseRouteError);
    let routeId = $7bdcd4addcd96486$var$useCurrentRouteId($7bdcd4addcd96486$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7bdcd4addcd96486$export$78a72ddb39bdd145() {
    let value = $5cNek.useContext($7bdcd4addcd96486$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7bdcd4addcd96486$export$17f53340677d5831() {
    let value = $5cNek.useContext($7bdcd4addcd96486$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7bdcd4addcd96486$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7bdcd4addcd96486$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7bdcd4addcd96486$var$useDataRouterContext($7bdcd4addcd96486$var$DataRouterHook.UseBlocker);
    let state = $7bdcd4addcd96486$var$useDataRouterState($7bdcd4addcd96486$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $5cNek.useState("");
    let blockerFunction = $5cNek.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7bdcd4addcd96486$var$_extends({}, currentLocation, {
                pathname: (0, $4cbe0a50b1516daf$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7bdcd4addcd96486$var$_extends({}, nextLocation, {
                pathname: (0, $4cbe0a50b1516daf$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $5cNek.useEffect(()=>{
        let key = String(++$7bdcd4addcd96486$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $5cNek.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $4cbe0a50b1516daf$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7bdcd4addcd96486$var$useNavigateStable() {
    let { router: router } = $7bdcd4addcd96486$var$useDataRouterContext($7bdcd4addcd96486$var$DataRouterHook.UseNavigateStable);
    let id = $7bdcd4addcd96486$var$useCurrentRouteId($7bdcd4addcd96486$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $5cNek.useRef(false);
    $7bdcd4addcd96486$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $5cNek.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7bdcd4addcd96486$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7bdcd4addcd96486$var$alreadyWarned = {};
function $7bdcd4addcd96486$var$warningOnce(key, cond, message) {
    if (!cond && !$7bdcd4addcd96486$var$alreadyWarned[key]) $7bdcd4addcd96486$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7bdcd4addcd96486$var$START_TRANSITION = "startTransition";
const $7bdcd4addcd96486$var$startTransitionImpl = $5cNek[$7bdcd4addcd96486$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7bdcd4addcd96486$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $5cNek.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5cNek.useCallback((newState)=>{
        v7_startTransition && $7bdcd4addcd96486$var$startTransitionImpl ? $7bdcd4addcd96486$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5cNek.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $5cNek.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $5cNek.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $5cNek.createElement($5cNek.Fragment, null, /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7bdcd4addcd96486$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7bdcd4addcd96486$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7bdcd4addcd96486$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $5cNek.useRef();
    if (historyRef.current == null) historyRef.current = (0, $4cbe0a50b1516daf$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5cNek.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5cNek.useCallback((newState)=>{
        v7_startTransition && $7bdcd4addcd96486$var$startTransitionImpl ? $7bdcd4addcd96486$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5cNek.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7bdcd4addcd96486$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7bdcd4addcd96486$export$9c954a9d03d32f4a() && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    let { matches: matches } = $5cNek.useContext($7bdcd4addcd96486$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7bdcd4addcd96486$export$45d76561a5302f2b();
    let navigate = $7bdcd4addcd96486$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $4cbe0a50b1516daf$export$cae722b0cc860f13)(to, (0, $4cbe0a50b1516daf$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $5cNek.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7bdcd4addcd96486$export$910ae8079b2c2852(props) {
    return $7bdcd4addcd96486$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7bdcd4addcd96486$export$e7b0ac011bb776c6(_props) {
    (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7bdcd4addcd96486$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $4cbe0a50b1516daf$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7bdcd4addcd96486$export$9c954a9d03d32f4a() && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $5cNek.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $4cbe0a50b1516daf$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $5cNek.useMemo(()=>{
        let trailingPathname = (0, $4cbe0a50b1516daf$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7bdcd4addcd96486$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7bdcd4addcd96486$export$5d3fca4a98652595($7bdcd4addcd96486$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7bdcd4addcd96486$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$ResolveAwait, null, children));
}
var $7bdcd4addcd96486$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7bdcd4addcd96486$var$AwaitRenderStatus || {});
const $7bdcd4addcd96486$var$neverSettledPromise = new Promise(()=>{});
class $7bdcd4addcd96486$var$AwaitErrorBoundary extends $5cNek.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7bdcd4addcd96486$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7bdcd4addcd96486$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7bdcd4addcd96486$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7bdcd4addcd96486$var$AwaitRenderStatus.error : promise._data !== undefined ? $7bdcd4addcd96486$var$AwaitRenderStatus.success : $7bdcd4addcd96486$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7bdcd4addcd96486$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7bdcd4addcd96486$var$AwaitRenderStatus.error && promise._error instanceof (0, $4cbe0a50b1516daf$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7bdcd4addcd96486$var$neverSettledPromise;
        if (status === $7bdcd4addcd96486$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7bdcd4addcd96486$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7bdcd4addcd96486$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $5cNek.createElement($7bdcd4addcd96486$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7bdcd4addcd96486$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7bdcd4addcd96486$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $5cNek.createElement($5cNek.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7bdcd4addcd96486$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $5cNek.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $5cNek.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $5cNek.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7bdcd4addcd96486$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7bdcd4addcd96486$export$e7b0ac011bb776c6) && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7bdcd4addcd96486$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7bdcd4addcd96486$export$daf73786167a7f72(matches) {
    return $7bdcd4addcd96486$var$_renderMatches(matches);
}
function $7bdcd4addcd96486$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $5cNek.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $5cNek.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7bdcd4addcd96486$export$f30f7e456d254e83(routes, opts) {
    return (0, $4cbe0a50b1516daf$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7bdcd4addcd96486$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $4cbe0a50b1516daf$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7bdcd4addcd96486$export$52b333d321859367
    }).initialize();
}



function $8dc9873ca48d4260$var$_extends() {
    $8dc9873ca48d4260$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8dc9873ca48d4260$var$_extends.apply(this, arguments);
}
function $8dc9873ca48d4260$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8dc9873ca48d4260$var$defaultMethod = "get";
const $8dc9873ca48d4260$var$defaultEncType = "application/x-www-form-urlencoded";
function $8dc9873ca48d4260$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $8dc9873ca48d4260$var$isButtonElement(object) {
    return $8dc9873ca48d4260$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $8dc9873ca48d4260$var$isFormElement(object) {
    return $8dc9873ca48d4260$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $8dc9873ca48d4260$var$isInputElement(object) {
    return $8dc9873ca48d4260$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $8dc9873ca48d4260$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $8dc9873ca48d4260$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$8dc9873ca48d4260$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $8dc9873ca48d4260$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $8dc9873ca48d4260$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $8dc9873ca48d4260$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $8dc9873ca48d4260$var$_formDataSupportsSubmitter = null;
function $8dc9873ca48d4260$var$isFormDataSubmitterSupported() {
    if ($8dc9873ca48d4260$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $8dc9873ca48d4260$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $8dc9873ca48d4260$var$_formDataSupportsSubmitter = true;
    }
    return $8dc9873ca48d4260$var$_formDataSupportsSubmitter;
}
const $8dc9873ca48d4260$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $8dc9873ca48d4260$var$getFormEncType(encType) {
    if (encType != null && !$8dc9873ca48d4260$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $8dc9873ca48d4260$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($8dc9873ca48d4260$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $4cbe0a50b1516daf$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $8dc9873ca48d4260$var$defaultMethod;
        encType = $8dc9873ca48d4260$var$getFormEncType(target.getAttribute("enctype")) || $8dc9873ca48d4260$var$defaultEncType;
        formData = new FormData(target);
    } else if ($8dc9873ca48d4260$var$isButtonElement(target) || $8dc9873ca48d4260$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $4cbe0a50b1516daf$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $8dc9873ca48d4260$var$defaultMethod;
        encType = $8dc9873ca48d4260$var$getFormEncType(target.getAttribute("formenctype")) || $8dc9873ca48d4260$var$getFormEncType(form.getAttribute("enctype")) || $8dc9873ca48d4260$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$8dc9873ca48d4260$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($8dc9873ca48d4260$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $8dc9873ca48d4260$var$defaultMethod;
        action = null;
        encType = $8dc9873ca48d4260$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $8dc9873ca48d4260$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $8dc9873ca48d4260$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $8dc9873ca48d4260$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $8dc9873ca48d4260$export$1f3f55432a00e06d(routes, opts) {
    return (0, $4cbe0a50b1516daf$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8dc9873ca48d4260$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $4cbe0a50b1516daf$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8dc9873ca48d4260$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7bdcd4addcd96486$export$52b333d321859367)
    }).initialize();
}
function $8dc9873ca48d4260$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $4cbe0a50b1516daf$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8dc9873ca48d4260$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $4cbe0a50b1516daf$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8dc9873ca48d4260$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7bdcd4addcd96486$export$52b333d321859367)
    }).initialize();
}
function $8dc9873ca48d4260$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $8dc9873ca48d4260$var$_extends({}, state, {
        errors: $8dc9873ca48d4260$var$deserializeErrors(state.errors)
    });
    return state;
}
function $8dc9873ca48d4260$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $4cbe0a50b1516daf$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $8dc9873ca48d4260$var$START_TRANSITION = "startTransition";
const $8dc9873ca48d4260$var$startTransitionImpl = $5cNek[$8dc9873ca48d4260$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $8dc9873ca48d4260$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $5cNek.useRef();
    if (historyRef.current == null) historyRef.current = (0, $4cbe0a50b1516daf$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5cNek.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5cNek.useCallback((newState)=>{
        v7_startTransition && $8dc9873ca48d4260$var$startTransitionImpl ? $8dc9873ca48d4260$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5cNek.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $5cNek.createElement((0, $7bdcd4addcd96486$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $8dc9873ca48d4260$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $5cNek.useRef();
    if (historyRef.current == null) historyRef.current = (0, $4cbe0a50b1516daf$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $5cNek.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5cNek.useCallback((newState)=>{
        v7_startTransition && $8dc9873ca48d4260$var$startTransitionImpl ? $8dc9873ca48d4260$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5cNek.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $5cNek.createElement((0, $7bdcd4addcd96486$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $8dc9873ca48d4260$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $5cNek.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $5cNek.useCallback((newState)=>{
        v7_startTransition && $8dc9873ca48d4260$var$startTransitionImpl ? $8dc9873ca48d4260$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $5cNek.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $5cNek.createElement((0, $7bdcd4addcd96486$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $8dc9873ca48d4260$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $8dc9873ca48d4260$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $8dc9873ca48d4260$export$a6c7ac8248d6e38a = /*#__PURE__*/ $5cNek.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $8dc9873ca48d4260$var$_objectWithoutPropertiesLoose(_ref4, $8dc9873ca48d4260$var$_excluded);
    let { basename: basename } = $5cNek.useContext((0, $7bdcd4addcd96486$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $8dc9873ca48d4260$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($8dc9873ca48d4260$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $4cbe0a50b1516daf$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7bdcd4addcd96486$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $8dc9873ca48d4260$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $5cNek.createElement("a", $8dc9873ca48d4260$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $8dc9873ca48d4260$export$b0d92dbee9b5b60d = /*#__PURE__*/ $5cNek.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $8dc9873ca48d4260$var$_objectWithoutPropertiesLoose(_ref5, $8dc9873ca48d4260$var$_excluded2);
    let path = (0, $7bdcd4addcd96486$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7bdcd4addcd96486$export$45d76561a5302f2b)();
    let routerState = $5cNek.useContext((0, $7bdcd4addcd96486$export$145dfa71566a64dc));
    let { navigator: navigator } = $5cNek.useContext((0, $7bdcd4addcd96486$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $5cNek.createElement($8dc9873ca48d4260$export$a6c7ac8248d6e38a, $8dc9873ca48d4260$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $8dc9873ca48d4260$export$a7fed597f4b8afd8 = /*#__PURE__*/ $5cNek.forwardRef((props, ref)=>{
    let submit = $8dc9873ca48d4260$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $5cNek.createElement($8dc9873ca48d4260$var$FormImpl, $8dc9873ca48d4260$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $8dc9873ca48d4260$var$FormImpl = /*#__PURE__*/ $5cNek.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $8dc9873ca48d4260$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $8dc9873ca48d4260$var$_objectWithoutPropertiesLoose(_ref6, $8dc9873ca48d4260$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $8dc9873ca48d4260$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $5cNek.createElement("form", $8dc9873ca48d4260$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $8dc9873ca48d4260$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $8dc9873ca48d4260$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $8dc9873ca48d4260$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($8dc9873ca48d4260$var$DataRouterHook || ($8dc9873ca48d4260$var$DataRouterHook = {}));
var $8dc9873ca48d4260$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($8dc9873ca48d4260$var$DataRouterStateHook || ($8dc9873ca48d4260$var$DataRouterStateHook = {}));
function $8dc9873ca48d4260$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $8dc9873ca48d4260$var$useDataRouterContext(hookName) {
    let ctx = $5cNek.useContext((0, $7bdcd4addcd96486$export$3add0d5dce533e2e));
    !ctx && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    return ctx;
}
function $8dc9873ca48d4260$var$useDataRouterState(hookName) {
    let state = $5cNek.useContext((0, $7bdcd4addcd96486$export$145dfa71566a64dc));
    !state && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $8dc9873ca48d4260$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7bdcd4addcd96486$export$9770f232ac06a008)();
    let location = (0, $7bdcd4addcd96486$export$45d76561a5302f2b)();
    let path = (0, $7bdcd4addcd96486$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $5cNek.useCallback((event)=>{
        if ($8dc9873ca48d4260$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $4cbe0a50b1516daf$export$fe53371bee54353d)(location) === (0, $4cbe0a50b1516daf$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $8dc9873ca48d4260$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $5cNek.useRef($8dc9873ca48d4260$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $5cNek.useRef(false);
    let location = (0, $7bdcd4addcd96486$export$45d76561a5302f2b)();
    let searchParams = $5cNek.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $8dc9873ca48d4260$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7bdcd4addcd96486$export$9770f232ac06a008)();
    let setSearchParams = $5cNek.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $8dc9873ca48d4260$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $8dc9873ca48d4260$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $8dc9873ca48d4260$export$47c85c6e3a081d3() {
    let { router: router } = $8dc9873ca48d4260$var$useDataRouterContext($8dc9873ca48d4260$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $5cNek.useContext((0, $7bdcd4addcd96486$export$26749e8557646306));
    let currentRouteId = (0, $7bdcd4addcd96486$export$5fc8298006ad9e58)();
    return $5cNek.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $8dc9873ca48d4260$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $8dc9873ca48d4260$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $8dc9873ca48d4260$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $8dc9873ca48d4260$var$useDataRouterContext($8dc9873ca48d4260$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $5cNek.useContext((0, $7bdcd4addcd96486$export$26749e8557646306));
    return $5cNek.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $8dc9873ca48d4260$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $8dc9873ca48d4260$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $8dc9873ca48d4260$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $5cNek.useContext((0, $7bdcd4addcd96486$export$26749e8557646306));
    let routeContext = $5cNek.useContext((0, $7bdcd4addcd96486$export$9072aa6dd1f93057));
    !routeContext && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $8dc9873ca48d4260$var$_extends({}, (0, $7bdcd4addcd96486$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7bdcd4addcd96486$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $4cbe0a50b1516daf$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $4cbe0a50b1516daf$export$fe53371bee54353d)(path);
}
function $8dc9873ca48d4260$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $5cNek.forwardRef((props, ref)=>{
        let submit = $8dc9873ca48d4260$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $5cNek.createElement($8dc9873ca48d4260$var$FormImpl, $8dc9873ca48d4260$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $8dc9873ca48d4260$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $8dc9873ca48d4260$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $8dc9873ca48d4260$var$useDataRouterContext($8dc9873ca48d4260$var$DataRouterHook.UseFetcher);
    let route = $5cNek.useContext((0, $7bdcd4addcd96486$export$9072aa6dd1f93057));
    !route && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $5cNek.useState(()=>String(++$8dc9873ca48d4260$var$fetcherId));
    let [Form] = $5cNek.useState(()=>{
        !routeId && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
        return $8dc9873ca48d4260$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $5cNek.useState(()=>(href)=>{
            !router && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
            !routeId && (0, $4cbe0a50b1516daf$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $8dc9873ca48d4260$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $5cNek.useMemo(()=>$8dc9873ca48d4260$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $5cNek.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $8dc9873ca48d4260$export$fa996778a3a31087() {
    let state = $8dc9873ca48d4260$var$useDataRouterState($8dc9873ca48d4260$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $8dc9873ca48d4260$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $8dc9873ca48d4260$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $8dc9873ca48d4260$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $8dc9873ca48d4260$var$useDataRouterContext($8dc9873ca48d4260$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $8dc9873ca48d4260$var$useDataRouterState($8dc9873ca48d4260$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $5cNek.useContext((0, $7bdcd4addcd96486$export$26749e8557646306));
    let location = (0, $7bdcd4addcd96486$export$45d76561a5302f2b)();
    let matches = (0, $7bdcd4addcd96486$export$2378eb7f5ff86053)();
    let navigation = (0, $7bdcd4addcd96486$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $5cNek.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $8dc9873ca48d4260$var$usePageHide($5cNek.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $8dc9873ca48d4260$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $8dc9873ca48d4260$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($8dc9873ca48d4260$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $5cNek.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $8dc9873ca48d4260$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $8dc9873ca48d4260$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $5cNek.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($8dc9873ca48d4260$var$_extends({}, location, {
                    pathname: (0, $4cbe0a50b1516daf$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($8dc9873ca48d4260$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $5cNek.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8dc9873ca48d4260$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $5cNek.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8dc9873ca48d4260$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $5cNek.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $8dc9873ca48d4260$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $7bdcd4addcd96486$export$2af03a1de5c0910)(when);
    $5cNek.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $5cNek.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}




var $5cNek = parcelRequire("5cNek");


var $5cNek = parcelRequire("5cNek");
/** @jsx jsx */ 
var $5cNek = parcelRequire("5cNek");

var $fc165d49756d4d58$var$buttonGroupStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    display: "inline-flex",
    gap: "var(--ds-space-050, 4px)",
    "> *": {
        flex: "1 0 auto"
    }
});
function $fc165d49756d4d58$export$2e2bcd8739ae039(_ref) {
    var appearance = _ref.appearance, children = _ref.children;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        css: $fc165d49756d4d58$var$buttonGroupStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $5cNek.Fragment), {
            key: idx
        }, appearance ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}



/** @jsx jsx */ 
var $0b2708dc911de308$var$actionsStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    display: "flex",
    marginBottom: "var(--ds-space-100, 8px)",
    paddingLeft: "var(--ds-space-500, 40px)",
    alignItems: "center",
    justifyContent: "center"
});
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ var $0b2708dc911de308$var$ActionsContainer = function ActionsContainer(_ref) {
    var children = _ref.children;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        css: $0b2708dc911de308$var$actionsStyles
    }, children);
};
var $0b2708dc911de308$export$2e2bcd8739ae039 = $0b2708dc911de308$var$ActionsContainer;

/** @jsx jsx */ 

var $1b8026a5aa7fa9f2$var$gridSize = (0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)();
var $1b8026a5aa7fa9f2$var$verticalMarginSize = "var(--ds-space-600, 48px)";
var $1b8026a5aa7fa9f2$var$columnWidth = $1b8026a5aa7fa9f2$var$gridSize * 8;
var $1b8026a5aa7fa9f2$var$gutter = $1b8026a5aa7fa9f2$var$gridSize * 2;
var $1b8026a5aa7fa9f2$var$containerStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: "".concat($1b8026a5aa7fa9f2$var$verticalMarginSize, " auto"),
    textAlign: "center"
});
/* Use max-width so the component can shrink on smaller viewports. */ var $1b8026a5aa7fa9f2$var$wideContainerStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    maxWidth: "".concat($1b8026a5aa7fa9f2$var$columnWidth * 6 + $1b8026a5aa7fa9f2$var$gutter * 5, "px")
});
var $1b8026a5aa7fa9f2$var$narrowContainerStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    maxWidth: "".concat($1b8026a5aa7fa9f2$var$columnWidth * 4 + $1b8026a5aa7fa9f2$var$gutter * 3, "px")
});
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ var $1b8026a5aa7fa9f2$var$Container = function Container(_ref) {
    var children = _ref.children, width = _ref.width, testId = _ref.testId;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        "data-testid": testId,
        css: [
            $1b8026a5aa7fa9f2$var$containerStyles,
            width === "narrow" ? $1b8026a5aa7fa9f2$var$narrowContainerStyles : $1b8026a5aa7fa9f2$var$wideContainerStyles
        ]
    }, children);
};
var $1b8026a5aa7fa9f2$export$2e2bcd8739ae039 = $1b8026a5aa7fa9f2$var$Container;

/** @jsx jsx */ 

var $f2b9a1350bdd1224$var$descriptionStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    marginTop: "var(--ds-space-0, 0px)",
    marginBottom: "var(--ds-space-300, 24px)",
    color: "var(--ds-text, ".concat((0, $db8844ebfff7fa2d$export$7d61b15e0da132af), ")")
});
/**
 * __Description__
 *
 * Description of Empty State.
 *
 * @internal
 */ var $f2b9a1350bdd1224$var$Description = function Description(_ref) {
    var children = _ref.children;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("p", {
        css: $f2b9a1350bdd1224$var$descriptionStyles
    }, children);
};
var $f2b9a1350bdd1224$export$2e2bcd8739ae039 = $f2b9a1350bdd1224$var$Description;

/** @jsx jsx */ 

var $2FWxW = parcelRequire("2FWxW");


function $451d2e423d109b83$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $451d2e423d109b83$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $451d2e423d109b83$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $451d2e423d109b83$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $451d2e423d109b83$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / (0, $ea1180a9039473b6$export$85e3c3ca0c6fb93)(), "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $451d2e423d109b83$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $451d2e423d109b83$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $451d2e423d109b83$var$_objectSpread($451d2e423d109b83$var$_objectSpread({}, $451d2e423d109b83$var$baseHeading($451d2e423d109b83$export$bc02e067df412c3b.h900.size, $451d2e423d109b83$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $db8844ebfff7fa2d$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)() * 6.5, "px")
    });
};
var $451d2e423d109b83$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $451d2e423d109b83$var$_objectSpread($451d2e423d109b83$var$_objectSpread({}, $451d2e423d109b83$var$baseHeading($451d2e423d109b83$export$bc02e067df412c3b.h800.size, $451d2e423d109b83$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $db8844ebfff7fa2d$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)() * 5, "px")
    });
};
var $451d2e423d109b83$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $451d2e423d109b83$var$_objectSpread($451d2e423d109b83$var$_objectSpread({}, $451d2e423d109b83$var$baseHeading($451d2e423d109b83$export$bc02e067df412c3b.h700.size, $451d2e423d109b83$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $db8844ebfff7fa2d$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)() * 5, "px")
    });
};
var $451d2e423d109b83$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $451d2e423d109b83$var$_objectSpread($451d2e423d109b83$var$_objectSpread({}, $451d2e423d109b83$var$baseHeading($451d2e423d109b83$export$bc02e067df412c3b.h600.size, $451d2e423d109b83$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $db8844ebfff7fa2d$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)() * 3.5, "px")
    });
};
var $451d2e423d109b83$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $451d2e423d109b83$var$_objectSpread($451d2e423d109b83$var$_objectSpread({}, $451d2e423d109b83$var$baseHeading($451d2e423d109b83$export$bc02e067df412c3b.h500.size, $451d2e423d109b83$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $db8844ebfff7fa2d$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)() * 3, "px")
    });
};
var $451d2e423d109b83$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $451d2e423d109b83$var$_objectSpread($451d2e423d109b83$var$_objectSpread({}, $451d2e423d109b83$var$baseHeading($451d2e423d109b83$export$bc02e067df412c3b.h400.size, $451d2e423d109b83$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $db8844ebfff7fa2d$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)() * 2, "px")
    });
};
var $451d2e423d109b83$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $451d2e423d109b83$var$_objectSpread($451d2e423d109b83$var$_objectSpread({}, $451d2e423d109b83$var$baseHeading($451d2e423d109b83$export$bc02e067df412c3b.h300.size, $451d2e423d109b83$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $db8844ebfff7fa2d$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $451d2e423d109b83$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $451d2e423d109b83$var$_objectSpread($451d2e423d109b83$var$_objectSpread({}, $451d2e423d109b83$var$baseHeading($451d2e423d109b83$export$bc02e067df412c3b.h200.size, $451d2e423d109b83$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $db8844ebfff7fa2d$export$79f3f2b82beb0d36)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)() * 2, "px")
    });
};
var $451d2e423d109b83$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $451d2e423d109b83$var$_objectSpread($451d2e423d109b83$var$_objectSpread({}, $451d2e423d109b83$var$baseHeading($451d2e423d109b83$export$bc02e067df412c3b.h100.size, $451d2e423d109b83$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $db8844ebfff7fa2d$export$79f3f2b82beb0d36)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)() * 2, "px")
    });
};


// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $e88f80a7f5b8084b$var$headerStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)([
    (0, $451d2e423d109b83$export$1e8b2acea3fb3119)(),
    {
        marginTop: "var(--ds-space-0, 0px)",
        marginBottom: "var(--ds-space-200, 16px)"
    }
]);
/**
 * __Header__
 *
 * Header of Empty State.
 *
 * @internal
 */ var $e88f80a7f5b8084b$var$EmptyStateHeader = function EmptyStateHeader(_ref) {
    var children = _ref.children, _ref$level = _ref.level, level = _ref$level === void 0 ? 4 : _ref$level;
    var Tag = "h".concat(level > 0 && level < 7 ? level : level > 6 ? 6 : 4);
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)(Tag, {
        css: $e88f80a7f5b8084b$var$headerStyles
    }, children);
};
var $e88f80a7f5b8084b$export$2e2bcd8739ae039 = $e88f80a7f5b8084b$var$EmptyStateHeader;


var $2FWxW = parcelRequire("2FWxW");

var $d394cad71dc400eb$var$CSS_VAR_MAX_WIDTH = "--max-width";
var $d394cad71dc400eb$var$CSS_VAR_MAX_HEIGHT = "--max-height";
var $d394cad71dc400eb$var$imageStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    display: "block",
    maxWidth: "var(".concat($d394cad71dc400eb$var$CSS_VAR_MAX_WIDTH, ")"),
    maxHeight: "var(".concat($d394cad71dc400eb$var$CSS_VAR_MAX_HEIGHT, ")"),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: "0 auto ".concat("var(--ds-space-300, 24px)")
});
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ var $d394cad71dc400eb$var$Image = function Image(_ref) {
    var _ref2;
    var maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? "auto" : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? "auto" : _ref$width, src = _ref.src;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("img", {
        style: (_ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(_ref2, $d394cad71dc400eb$var$CSS_VAR_MAX_WIDTH, "".concat(maxWidth, "px")), (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(_ref2, $d394cad71dc400eb$var$CSS_VAR_MAX_HEIGHT, "".concat(maxHeight, "px")), _ref2),
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        css: $d394cad71dc400eb$var$imageStyles,
        src: src
    });
};
var $d394cad71dc400eb$export$2e2bcd8739ae039 = $d394cad71dc400eb$var$Image;

/** @jsx jsx */ 
var $bac45a1252a0e87e$var$spinnerContainerStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    width: "var(--ds-space-300, 24px)",
    marginLeft: "var(--ds-space-200, 16px)"
});
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ var $bac45a1252a0e87e$var$SpinnerContainer = function SpinnerContainer(_ref) {
    var children = _ref.children;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        css: $bac45a1252a0e87e$var$spinnerContainerStyles
    }, children);
};
var $bac45a1252a0e87e$export$2e2bcd8739ae039 = $bac45a1252a0e87e$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ var $46eadc0f17330f77$var$EmptyState = function EmptyState(_ref) {
    var description = _ref.description, header = _ref.header, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 4 : _ref$headingLevel, imageHeight = _ref.imageHeight, imageUrl = _ref.imageUrl, imageWidth = _ref.imageWidth, isLoading = _ref.isLoading, _ref$maxImageHeight = _ref.maxImageHeight, maxImageHeight = _ref$maxImageHeight === void 0 ? 160 : _ref$maxImageHeight, _ref$maxImageWidth = _ref.maxImageWidth, maxImageWidth = _ref$maxImageWidth === void 0 ? 160 : _ref$maxImageWidth, primaryAction = _ref.primaryAction, renderImage = _ref.renderImage, secondaryAction = _ref.secondaryAction, width = _ref.width, size = _ref.size, tertiaryAction = _ref.tertiaryAction, testId = _ref.testId;
    var actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $0b2708dc911de308$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $fc165d49756d4d58$export$2e2bcd8739ae039), null, secondaryAction, primaryAction), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $bac45a1252a0e87e$export$2e2bcd8739ae039), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $9240654f48141bfe$export$2e2bcd8739ae039), {
        testId: "empty-state-spinner"
    }))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $1b8026a5aa7fa9f2$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || size || "wide"
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $d394cad71dc400eb$export$2e2bcd8739ae039), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $e88f80a7f5b8084b$export$2e2bcd8739ae039), {
        level: headingLevel
    }, header), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $f2b9a1350bdd1224$export$2e2bcd8739ae039), null, description), actionsContainer, tertiaryAction);
};
var $46eadc0f17330f77$export$2e2bcd8739ae039 = $46eadc0f17330f77$var$EmptyState;


var $eda95f3e2a1fd9a2$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eda95f3e2a1fd9a2$var$ReactIs, $eda95f3e2a1fd9a2$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$eda95f3e2a1fd9a2$exports = (parcelRequire("1CFxY"))();


var $ad537e6a2268c57b$exports = {};

$ad537e6a2268c57b$exports = new URL((parcelRequire("fXxkw")).resolve("apEcX"), import.meta.url).toString();


function $69d7e7a0181e34d3$export$2e2bcd8739ae039({ primaryAction: primaryAction, maxImageHeight: maxImageHeight }) {
    return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $46eadc0f17330f77$export$2e2bcd8739ae039), {
        description: "Something went wrong",
        header: "Oops!",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ad537e6a2268c57b$exports))),
        maxImageHeight: maxImageHeight,
        primaryAction: primaryAction
    });
}
$69d7e7a0181e34d3$export$2e2bcd8739ae039.propTypes = {
    primaryAction: (0, (/*@__PURE__*/$parcel$interopDefault($eda95f3e2a1fd9a2$exports))).node,
    maxImageHeight: (0, (/*@__PURE__*/$parcel$interopDefault($eda95f3e2a1fd9a2$exports))).number
};


class $dd82041ad57c02e5$export$2e2bcd8739ae039 extends $5cNek.Component {
    state = {
        hasError: false
    };
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $69d7e7a0181e34d3$export$2e2bcd8739ae039), {});
        return this.props.children;
    }
}




var $5cNek = parcelRequire("5cNek");

var $5cNek = parcelRequire("5cNek");

var $XLpyq = parcelRequire("XLpyq");

var $5cNek = parcelRequire("5cNek");
var $99e42e712af0fd5c$exports = {};
"use strict";
Object.defineProperty($99e42e712af0fd5c$exports, "__esModule", {
    value: true
});
$99e42e712af0fd5c$exports.bindAll = $99e42e712af0fd5c$exports.bind = void 0;
var $b1638592367a3229$exports = {};
"use strict";
Object.defineProperty($b1638592367a3229$exports, "__esModule", {
    value: true
});
$b1638592367a3229$exports.bind = void 0;
function $b1638592367a3229$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$b1638592367a3229$exports.bind = $b1638592367a3229$var$bind;


Object.defineProperty($99e42e712af0fd5c$exports, "bind", {
    enumerable: true,
    get: function() {
        return $b1638592367a3229$exports.bind;
    }
});
var $a226903d86bd272c$exports = {};
"use strict";
var $a226903d86bd272c$var$__assign = $a226903d86bd272c$exports && $a226903d86bd272c$exports.__assign || function() {
    $a226903d86bd272c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a226903d86bd272c$var$__assign.apply(this, arguments);
};
Object.defineProperty($a226903d86bd272c$exports, "__esModule", {
    value: true
});
$a226903d86bd272c$exports.bindAll = void 0;

function $a226903d86bd272c$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $a226903d86bd272c$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $a226903d86bd272c$var$__assign($a226903d86bd272c$var$__assign({}, original), {
        options: $a226903d86bd272c$var$__assign($a226903d86bd272c$var$__assign({}, $a226903d86bd272c$var$toOptions(sharedOptions)), $a226903d86bd272c$var$toOptions(original.options))
    });
    return binding;
}
function $a226903d86bd272c$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $a226903d86bd272c$var$getBinding(original, sharedOptions);
        return (0, $b1638592367a3229$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$a226903d86bd272c$exports.bindAll = $a226903d86bd272c$var$bindAll;


Object.defineProperty($99e42e712af0fd5c$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $a226903d86bd272c$exports.bindAll;
    }
});


var $7016c350e338bf47$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $7016c350e338bf47$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$7016c350e338bf47$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $7016c350e338bf47$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5cNek.useState)($7016c350e338bf47$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5cNek.useEffect)(function() {
        if (!$7016c350e338bf47$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $99e42e712af0fd5c$exports.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $7016c350e338bf47$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $7016c350e338bf47$export$ff7706047246b98b = function prefersReducedMotion() {
    return $7016c350e338bf47$export$f0f789643ba5a83c;
};



var $XLpyq = parcelRequire("XLpyq");

var $5cNek = parcelRequire("5cNek");
var $7f57a10fc9481ac3$export$b902f6ef73d6633a = function useForceRender() {
    var _useState = (0, $5cNek.useState)({}), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), updateState = _useState2[1];
    var forceRender = (0, $5cNek.useCallback)(function() {
        return updateState({});
    }, []);
    return forceRender;
};


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $b4a45d26229a164b$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $b4a45d26229a164b$var$ExitingContext = /*#__PURE__*/ (0, $5cNek.createContext)($b4a45d26229a164b$var$emptyContext);
var $b4a45d26229a164b$var$isAnyPreviousKeysMissingFromCurrent = function isAnyPreviousKeysMissingFromCurrent(currentMap, previous) {
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMap[_key]) return true;
    }
    return false;
};
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $b4a45d26229a164b$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b4a45d26229a164b$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement($b4a45d26229a164b$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $b4a45d26229a164b$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $b4a45d26229a164b$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $b4a45d26229a164b$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $b4a45d26229a164b$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5cNek.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
/**
 * This handles the case when a render updates during an exit motion.
 * If any child is mounted again we removed them from the exiting children object and return true.
 */ var $b4a45d26229a164b$var$hasAnyExitingChildMountedAgain = function hasAnyExitingChildMountedAgain(exitingChildren, children) {
    var exitingChildMountedAgain = false;
    children.forEach(function(child) {
        if (exitingChildren.current[child.key]) {
            exitingChildMountedAgain = true;
            delete exitingChildren.current[child.key];
        }
    });
    return exitingChildMountedAgain;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $b4a45d26229a164b$var$ExitingPersistence = /*#__PURE__*/ (0, $5cNek.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appearFromProp = _ref$appear === void 0 ? false : _ref$appear, childs = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var children = $b4a45d26229a164b$var$childrenToArray(childs);
    var childrenObj = $b4a45d26229a164b$var$childrenToObj(children);
    var previousChildren = (0, $5cNek.useRef)([]);
    var persistedChildren = (0, $5cNek.useRef)([]);
    var forceRender = (0, $7f57a10fc9481ac3$export$b902f6ef73d6633a)();
    var exitingChildren = (0, $5cNek.useRef)({});
    var appear = (0, $5cNek.useRef)(appearFromProp);
    var defaultContextValue = (0, $5cNek.useMemo)(function() {
        return {
            appear: appear.current,
            isExiting: false
        };
    }, // React rules of hooks says this isn't needed because mutating appear won't cause a re-render.
    // While technically true - it will trigger this to make a new object on the _next_ render which is what we want.
    // Remove this or use appear instead of appear.current and you will notice a test breaks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        appear.current
    ]);
    if ((0, $7016c350e338bf47$export$b7baf7667a68d87c)()) return children;
    if (!appear.current) // We always want child motions to appear after the initial mount.
    appear.current = true;
    // This entire block can't be an effect because we need it to run synchronously during a render
    // else when elements are being removed they will be remounted instead of being updated.
    if (previousChildren.current.length && $b4a45d26229a164b$var$isAnyPreviousKeysMissingFromCurrent(childrenObj, previousChildren.current)) {
        if (persistedChildren.current.length === 0 || $b4a45d26229a164b$var$hasAnyExitingChildMountedAgain(exitingChildren, children)) persistedChildren.current = previousChildren.current;
        // We have persisted children now set from previous children.
        // Let's update previous children so we have it available next render.
        previousChildren.current = children;
        return (exitThenEnter ? persistedChildren.current : $b4a45d26229a164b$var$spliceNewElementsIntoPrevious(children, persistedChildren.current)).map(function(child) {
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            var currentChild = childrenObj[child.key];
            if (!currentChild) {
                // We've found an exiting child - mark it!
                exitingChildren.current[child.key] = true;
                return $b4a45d26229a164b$var$wrapChildWithContextProvider(child, {
                    isExiting: true,
                    appear: true,
                    onFinish: function onFinish() {
                        delete exitingChildren.current[child.key];
                        // We will only remove the exiting elements when any subsequent exiting elements have also finished.
                        // Think of removing many items from a todo list - when removing a few over a few clicks we don't
                        // want the list jumping around when they exit.
                        if (Object.keys(exitingChildren.current).length === 0) {
                            // Set previous children to nothing.
                            // This let's us skip the next render check as it's assumed children and previous will be the same.
                            previousChildren.current = [];
                            persistedChildren.current = [];
                            // Re-render after the element(s) have animated away which will end up rendering the latest children.
                            forceRender();
                        }
                    }
                });
            }
            // This element isn't exiting.
            // Wrap context and let's continue on our way.
            return $b4a45d26229a164b$var$wrapChildWithContextProvider(currentChild, defaultContextValue);
        });
    } else previousChildren.current = children;
    return children.map(function(child) {
        return $b4a45d26229a164b$var$wrapChildWithContextProvider(child, defaultContextValue);
    });
});
var $b4a45d26229a164b$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5cNek.useContext)($b4a45d26229a164b$var$ExitingContext);
};
$b4a45d26229a164b$var$ExitingPersistence.displayName = "ExitingPersistence";
var $b4a45d26229a164b$export$2e2bcd8739ae039 = $b4a45d26229a164b$var$ExitingPersistence;


/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $a77810c2cb2af93c$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $b4a45d26229a164b$export$2e2bcd8739ae039), {
        appear: true
    }, props.children);
};
var $a77810c2cb2af93c$export$2e2bcd8739ae039 = $a77810c2cb2af93c$var$ModalTransition;


var $01c6da4248d00cf1$exports = {};
function $01c6da4248d00cf1$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $01c6da4248d00cf1$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $01c6da4248d00cf1$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $01c6da4248d00cf1$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
$01c6da4248d00cf1$exports = $01c6da4248d00cf1$var$_asyncToGenerator, $01c6da4248d00cf1$exports.__esModule = true, $01c6da4248d00cf1$exports["default"] = $01c6da4248d00cf1$exports;


var $a0a1158549c39267$exports = {};
// TODO(Babel 8): Remove this file.

var $a0a1158549c39267$var$runtime = (parcelRequire("xSEPi"))();
$a0a1158549c39267$exports = $a0a1158549c39267$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $a0a1158549c39267$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a0a1158549c39267$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a0a1158549c39267$var$runtime);
}


var $1178a766cddb6e45$var$_ref, $1178a766cddb6e45$var$_globalThis$process, $1178a766cddb6e45$var$_globalThis$process$e, $1178a766cddb6e45$var$_globalThis$process2, $1178a766cddb6e45$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $1178a766cddb6e45$var$TESTS_MODE = ($1178a766cddb6e45$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($1178a766cddb6e45$var$_globalThis$process = globalThis.process) === null || $1178a766cddb6e45$var$_globalThis$process === void 0 ? void 0 : ($1178a766cddb6e45$var$_globalThis$process$e = $1178a766cddb6e45$var$_globalThis$process.env) === null || $1178a766cddb6e45$var$_globalThis$process$e === void 0 ? void 0 : $1178a766cddb6e45$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $1178a766cddb6e45$var$_ref !== void 0) ? $1178a766cddb6e45$var$_ref : false;
var $1178a766cddb6e45$var$DEBUG_MODE = !$1178a766cddb6e45$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($1178a766cddb6e45$var$_globalThis$process2 = globalThis.process) === null || $1178a766cddb6e45$var$_globalThis$process2 === void 0 ? void 0 : ($1178a766cddb6e45$var$_globalThis$process2$ = $1178a766cddb6e45$var$_globalThis$process2.env) === null || $1178a766cddb6e45$var$_globalThis$process2$ === void 0 ? void 0 : $1178a766cddb6e45$var$_globalThis$process2$.NODE_ENV) !== "production";
var $1178a766cddb6e45$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$1178a766cddb6e45$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $c78d1bca3d6a3267$var$pkgName = "@atlaskit/platform-feature-flags";
var $c78d1bca3d6a3267$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $c78d1bca3d6a3267$var$hasProcessEnv = typeof $458e44519ac5ea1c$exports !== "undefined" && typeof $458e44519ac5ea1c$exports.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $c78d1bca3d6a3267$var$ENV_ENABLE_PLATFORM_FF = $c78d1bca3d6a3267$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $c78d1bca3d6a3267$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $c78d1bca3d6a3267$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $c78d1bca3d6a3267$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $c78d1bca3d6a3267$var$ENV_ENABLE_PLATFORM_FF || $c78d1bca3d6a3267$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $c78d1bca3d6a3267$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $c78d1bca3d6a3267$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$c78d1bca3d6a3267$var$globalVar[$c78d1bca3d6a3267$export$7e41b1b2bdee3f98] = $c78d1bca3d6a3267$var$globalVar[$c78d1bca3d6a3267$export$7e41b1b2bdee3f98] || $c78d1bca3d6a3267$var$DEFAULT_PFF_GLOBAL;
function $c78d1bca3d6a3267$export$f2b591175b3e424c(resolver) {
    $c78d1bca3d6a3267$var$globalVar[$c78d1bca3d6a3267$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $c78d1bca3d6a3267$export$6333b6aff9fc6275(flagKey) {
    if ($c78d1bca3d6a3267$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1178a766cddb6e45$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $c78d1bca3d6a3267$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $c78d1bca3d6a3267$var$globalVar[$c78d1bca3d6a3267$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $37396f277ff6afb6$export$ba05d765b8392e5e(flagResolver) {
    (0, $c78d1bca3d6a3267$export$f2b591175b3e424c)(flagResolver);
}
function $37396f277ff6afb6$export$470e5c2be1411c89(name) {
    return (0, $c78d1bca3d6a3267$export$6333b6aff9fc6275)(name);
}



var $fx4dg = parcelRequire("fx4dg");

var $bc6zD = parcelRequire("bc6zD");

var $XLpyq = parcelRequire("XLpyq");


var $2FWxW = parcelRequire("2FWxW");


var $lCES2 = parcelRequire("lCES2");

var $fx4dg = parcelRequire("fx4dg");

var $eE0N6 = parcelRequire("eE0N6");

var $XLpyq = parcelRequire("XLpyq");

var $fx4dg = parcelRequire("fx4dg");
var $91472ce43e0ae803$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $91472ce43e0ae803$var$customThemeOptions = "UNSAFE_themeOptions";
var $91472ce43e0ae803$var$isThemeKind = function isThemeKind(themeKind) {
    return $91472ce43e0ae803$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $91472ce43e0ae803$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $fx4dg.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $91472ce43e0ae803$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $91472ce43e0ae803$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $91472ce43e0ae803$var$isColorMode(id)) themeObject[kind] = id;
        if ($91472ce43e0ae803$var$isThemeKind(kind) && $91472ce43e0ae803$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $91472ce43e0ae803$var$customThemeOptions) try {
            themeObject[$91472ce43e0ae803$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $91472ce43e0ae803$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $91472ce43e0ae803$var$isColorMode(id) || // custom theme state
        kind === $91472ce43e0ae803$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($eE0N6)))(id) === "object" || // other theme states
        $91472ce43e0ae803$var$isThemeKind(kind) && typeof id === "string" && $91472ce43e0ae803$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($eE0N6)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};



var $bc6zD = parcelRequire("bc6zD");

var $4iBhm = parcelRequire("4iBhm");
function $3224e528ce38b0bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3224e528ce38b0bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3224e528ce38b0bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3224e528ce38b0bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3224e528ce38b0bd$var$defaultColorMode = "light";
var $3224e528ce38b0bd$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $3224e528ce38b0bd$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _result;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $fx4dg.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $fx4dg.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $fx4dg.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $fx4dg.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $fx4dg.themeStateDefaults)["shape"] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $fx4dg.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $fx4dg.themeStateDefaults)["typography"] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $fx4dg.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $91472ce43e0ae803$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (_result = {}, (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(_result, (0, $lCES2.THEME_DATA_ATTRIBUTE), themeAttribute), (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(_result, (0, $lCES2.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $3224e528ce38b0bd$var$defaultColorMode : colorMode), _result);
    if ((0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) result = $3224e528ce38b0bd$var$_objectSpread($3224e528ce38b0bd$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))({}, (0, $lCES2.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $3224e528ce38b0bd$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $bc6zD.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $4iBhm.hash)(optionString);
        result[0, $lCES2.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $3224e528ce38b0bd$export$2e2bcd8739ae039 = $3224e528ce38b0bd$var$getThemeHtmlAttrs;



var $i2CXH = parcelRequire("i2CXH");

var $4URe7 = parcelRequire("4URe7");

var $2FWxW = parcelRequire("2FWxW");


var $lCES2 = parcelRequire("lCES2");


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a21941d8f8cea58425b92ce9b8bfcd4e>>
 * @codegenCommand yarn build tokens
 */ 












var $81e47e6c59f52326$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("12eaz"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("3pfdX"));
    },
    "dark": function dark() {
        return (parcelRequire("bXhzj"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("xkBC4"));
    },
    "legacy-light": function legacyLight() {
        return (parcelRequire("g7rvX"));
    },
    "legacy-dark": function legacyDark() {
        return (parcelRequire("94QHZ"));
    },
    "spacing": function spacing() {
        return (parcelRequire("4Eh5p"));
    },
    "typography-adg3": function typographyAdg3() {
        return (parcelRequire("goH5m"));
    },
    "shape": function shape() {
        return (parcelRequire("ak7Vt"));
    },
    "light-new-input-border": function lightNewInputBorder() {
        return (parcelRequire("7DxlS"));
    },
    "dark-new-input-border": function darkNewInputBorder() {
        return (parcelRequire("hb47Z"));
    },
    "typography": function typography() {
        return (parcelRequire("4QQ0y"));
    },
    "typography-minor3": function typographyMinor3() {
        return (parcelRequire("hexyk"));
    }
};
var $81e47e6c59f52326$export$2e2bcd8739ae039 = $81e47e6c59f52326$var$themeImportsMap;



var $lCES2 = parcelRequire("lCES2");
var $ca084eea597fc77e$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($01c6da4248d00cf1$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $lCES2.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $lCES2.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 4;
                    return $ca084eea597fc77e$export$8a48286ed7df6720(themeId);
                case 4:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $ca084eea597fc77e$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($01c6da4248d00cf1$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, $81e47e6c59f52326$export$2e2bcd8739ae039)[themeId]();
                case 2:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 5:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $ca084eea597fc77e$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $ca084eea597fc77e$export$8662df6937d86fcb = "(prefers-contrast: more)";


var $2a5b8608d2cf4f90$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $2a5b8608d2cf4f90$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $lCES2.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $2a5b8608d2cf4f90$var$darkModeMql = $2a5b8608d2cf4f90$var$isMatchMediaAvailable && window.matchMedia((0, $ca084eea597fc77e$export$bb1e815119d30f8b));
var $2a5b8608d2cf4f90$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($i2CXH)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "unbindThemeChangeListener", null);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4URe7)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$2a5b8608d2cf4f90$var$darkModeMql) return "light";
                return $2a5b8608d2cf4f90$var$darkModeMql !== null && $2a5b8608d2cf4f90$var$darkModeMql !== void 0 && $2a5b8608d2cf4f90$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($2a5b8608d2cf4f90$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $99e42e712af0fd5c$exports.bind)($2a5b8608d2cf4f90$var$darkModeMql, {
                    type: "change",
                    listener: $2a5b8608d2cf4f90$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
    return ColorModeObserver;
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $2a5b8608d2cf4f90$var$SingletonColorModeObserver = new $2a5b8608d2cf4f90$var$ColorModeObserver();
var $2a5b8608d2cf4f90$export$2e2bcd8739ae039 = $2a5b8608d2cf4f90$var$SingletonColorModeObserver;



var $i2CXH = parcelRequire("i2CXH");

var $4URe7 = parcelRequire("4URe7");

var $2FWxW = parcelRequire("2FWxW");


var $lCES2 = parcelRequire("lCES2");

var $39366a2b4ef37f5e$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $39366a2b4ef37f5e$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $lCES2.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $39366a2b4ef37f5e$var$contrastModeMql = $39366a2b4ef37f5e$var$isMatchMediaAvailable && window.matchMedia((0, $ca084eea597fc77e$export$8662df6937d86fcb));
var $39366a2b4ef37f5e$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($i2CXH)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "unbindContrastChangeListener", null);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4URe7)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$39366a2b4ef37f5e$var$contrastModeMql) return "no-preference";
                return $39366a2b4ef37f5e$var$contrastModeMql !== null && $39366a2b4ef37f5e$var$contrastModeMql !== void 0 && $39366a2b4ef37f5e$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($39366a2b4ef37f5e$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $99e42e712af0fd5c$exports.bind)($39366a2b4ef37f5e$var$contrastModeMql, {
                    type: "change",
                    listener: $39366a2b4ef37f5e$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
    return ContrastModeObserver;
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $39366a2b4ef37f5e$var$SingletonContrastModeObserver = new $39366a2b4ef37f5e$var$ContrastModeObserver();
var $39366a2b4ef37f5e$export$2e2bcd8739ae039 = $39366a2b4ef37f5e$var$SingletonContrastModeObserver;


function $232103690da5e0f9$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $2a5b8608d2cf4f90$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $2a5b8608d2cf4f90$export$2e2bcd8739ae039).bind();
    } else (0, $2a5b8608d2cf4f90$export$2e2bcd8739ae039).unbind();
    if ((0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $39366a2b4ef37f5e$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $39366a2b4ef37f5e$export$2e2bcd8739ae039).bind();
        } else (0, $39366a2b4ef37f5e$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $3224e528ce38b0bd$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $2a5b8608d2cf4f90$export$2e2bcd8739ae039).unbind();
        if ((0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) (0, $39366a2b4ef37f5e$export$2e2bcd8739ae039).unbind();
    };
}



var $gGmKi = parcelRequire("gGmKi");

var $gdzT2 = parcelRequire("gdzT2");


var $XLpyq = parcelRequire("XLpyq");

var $fx4dg = parcelRequire("fx4dg");
function $568a35d20685c70d$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $fx4dg.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $1409cd1f2dc835b3$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $568a35d20685c70d$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) {
            var increasedContrastTheme = (0, $568a35d20685c70d$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($gdzT2)))(new Set(themePreferences));
};
var $1409cd1f2dc835b3$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(themeState) {
    var colorMode = themeState.colorMode, dark = themeState.dark, light = themeState.light;
    var themeOverridePreferences = [];
    var themePreferences = colorMode === "auto" ? [
        light,
        dark
    ] : [
        themeState[colorMode]
    ];
    if ((0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.border-checkbox_nyoiu")) {
        themePreferences.includes("light") && themeOverridePreferences.push("light-new-input-border");
        themePreferences.includes("dark") && themeOverridePreferences.push("dark-new-input-border");
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($gdzT2)))(new Set(themeOverridePreferences));
};



function $9c49a4d125ba84ba$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $9c49a4d125ba84ba$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $9c49a4d125ba84ba$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9c49a4d125ba84ba$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9c49a4d125ba84ba$var$_arrayLikeToArray(o, minLen);
}
function $9c49a4d125ba84ba$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $9c49a4d125ba84ba$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($01c6da4248d00cf1$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $fx4dg.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $fx4dg.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $fx4dg.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $fx4dg.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $fx4dg.themeStateDefaults)["shape"] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $fx4dg.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $fx4dg.themeStateDefaults)["typography"] : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $fx4dg.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $1409cd1f2dc835b3$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $ca084eea597fc77e$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($01c6da4248d00cf1$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $bc6zD.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $fx4dg.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $gGmKi.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($01c6da4248d00cf1$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($a0a1158549c39267$exports))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("a0I0G"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $1409cd1f2dc835b3$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $9c49a4d125ba84ba$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $232103690da5e0f9$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $9c49a4d125ba84ba$export$2e2bcd8739ae039 = $9c49a4d125ba84ba$var$setGlobalTheme;


var $a6d4cc083d78c98b$exports = {};
"use strict";
Object.defineProperty($a6d4cc083d78c98b$exports, "__esModule", {
    value: true
});
$a6d4cc083d78c98b$exports.sanitizeUrl = $a6d4cc083d78c98b$exports.BLANK_URL = void 0;
var $a6d4cc083d78c98b$var$invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
var $a6d4cc083d78c98b$var$htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
var $a6d4cc083d78c98b$var$htmlCtrlEntityRegex = /&(newline|tab);/gi;
var $a6d4cc083d78c98b$var$ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
var $a6d4cc083d78c98b$var$urlSchemeRegex = /^.+(:|&colon;)/gim;
var $a6d4cc083d78c98b$var$relativeFirstCharacters = [
    ".",
    "/"
];
$a6d4cc083d78c98b$exports.BLANK_URL = "about:blank";
function $a6d4cc083d78c98b$var$isRelativeUrlWithoutProtocol(url) {
    return $a6d4cc083d78c98b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
// adapted from https://stackoverflow.com/a/29824550/2601552
function $a6d4cc083d78c98b$var$decodeHtmlCharacters(str) {
    var removedNullByte = str.replace($a6d4cc083d78c98b$var$ctrlCharactersRegex, "");
    return removedNullByte.replace($a6d4cc083d78c98b$var$htmlEntitiesRegex, function(match, dec) {
        return String.fromCharCode(dec);
    });
}
function $a6d4cc083d78c98b$var$sanitizeUrl(url) {
    if (!url) return $a6d4cc083d78c98b$exports.BLANK_URL;
    var sanitizedUrl = $a6d4cc083d78c98b$var$decodeHtmlCharacters(url).replace($a6d4cc083d78c98b$var$htmlCtrlEntityRegex, "").replace($a6d4cc083d78c98b$var$ctrlCharactersRegex, "").trim();
    if (!sanitizedUrl) return $a6d4cc083d78c98b$exports.BLANK_URL;
    if ($a6d4cc083d78c98b$var$isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
    var urlSchemeParseResults = sanitizedUrl.match($a6d4cc083d78c98b$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return sanitizedUrl;
    var urlScheme = urlSchemeParseResults[0];
    if ($a6d4cc083d78c98b$var$invalidProtocolRegex.test(urlScheme)) return $a6d4cc083d78c98b$exports.BLANK_URL;
    return sanitizedUrl;
}
$a6d4cc083d78c98b$exports.sanitizeUrl = $a6d4cc083d78c98b$var$sanitizeUrl;



var $5cNek = parcelRequire("5cNek");




var $5cNek = parcelRequire("5cNek");

function $879230480295e68d$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}




var $5cNek = parcelRequire("5cNek");


var $5cNek = parcelRequire("5cNek");

/**
 * defines a focus group
 */ var $7f2114630cad36e9$export$4f9a06cb7441a087 = "data-focus-lock";
var $7f2114630cad36e9$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $7f2114630cad36e9$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $7f2114630cad36e9$export$70e9b4a1820af101 = "data-autofocus-inside";
var $7f2114630cad36e9$export$134ebef29fd94853 = "data-no-autofocus";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $a55c99c4886ec89a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $5cNek = parcelRequire("5cNek");
function $ce32fe726c2e77ba$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $5cNek.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $efe8106b65a634f0$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $ce32fe726c2e77ba$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $a55c99c4886ec89a$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



var $5cNek = parcelRequire("5cNek");

var $ec7d394d236bc2c5$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $ec7d394d236bc2c5$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5cNek.createElement($5cNek.Fragment, null, /*#__PURE__*/ $5cNek.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $ec7d394d236bc2c5$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $5cNek.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $ec7d394d236bc2c5$export$b8c7b07253306600
    }));
};
$ec7d394d236bc2c5$var$InFocusGuard.propTypes = {};
$ec7d394d236bc2c5$var$InFocusGuard.defaultProps = {
    children: null
};
var $ec7d394d236bc2c5$export$2e2bcd8739ae039 = $ec7d394d236bc2c5$var$InFocusGuard;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $61d2c4b85948061e$var$extendStatics = function(d, b) {
    $61d2c4b85948061e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $61d2c4b85948061e$var$extendStatics(d, b);
};
function $61d2c4b85948061e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $61d2c4b85948061e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $61d2c4b85948061e$export$18ce0697a983be9b = function() {
    $61d2c4b85948061e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $61d2c4b85948061e$export$18ce0697a983be9b.apply(this, arguments);
};
function $61d2c4b85948061e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $61d2c4b85948061e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $61d2c4b85948061e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $61d2c4b85948061e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $61d2c4b85948061e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $61d2c4b85948061e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $61d2c4b85948061e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $61d2c4b85948061e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $61d2c4b85948061e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $61d2c4b85948061e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $61d2c4b85948061e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $61d2c4b85948061e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $61d2c4b85948061e$export$45d3717a4c69092e(o, m, p);
}
function $61d2c4b85948061e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $61d2c4b85948061e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $61d2c4b85948061e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($61d2c4b85948061e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $61d2c4b85948061e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $61d2c4b85948061e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $61d2c4b85948061e$export$10c90e4f7922046c(v) {
    return this instanceof $61d2c4b85948061e$export$10c90e4f7922046c ? (this.v = v, this) : new $61d2c4b85948061e$export$10c90e4f7922046c(v);
}
function $61d2c4b85948061e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $61d2c4b85948061e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $61d2c4b85948061e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $61d2c4b85948061e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $61d2c4b85948061e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $61d2c4b85948061e$export$19a8beecd37a4c45 === "function" ? $61d2c4b85948061e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $61d2c4b85948061e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $61d2c4b85948061e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $61d2c4b85948061e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $61d2c4b85948061e$export$45d3717a4c69092e(result, mod, k);
    }
    $61d2c4b85948061e$var$__setModuleDefault(result, mod);
    return result;
}
function $61d2c4b85948061e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $61d2c4b85948061e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $61d2c4b85948061e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $61d2c4b85948061e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $61d2c4b85948061e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $61d2c4b85948061e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $61d2c4b85948061e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $61d2c4b85948061e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $61d2c4b85948061e$export$2e2bcd8739ae039 = {
    __extends: $61d2c4b85948061e$export$a8ba968b8961cb8a,
    __assign: $61d2c4b85948061e$export$18ce0697a983be9b,
    __rest: $61d2c4b85948061e$export$3c9a16f847548506,
    __decorate: $61d2c4b85948061e$export$29e00dfd3077644b,
    __param: $61d2c4b85948061e$export$d5ad3fd78186038f,
    __metadata: $61d2c4b85948061e$export$f1db080c865becb9,
    __awaiter: $61d2c4b85948061e$export$1050f835b63b671e,
    __generator: $61d2c4b85948061e$export$67ebef60e6f28a6,
    __createBinding: $61d2c4b85948061e$export$45d3717a4c69092e,
    __exportStar: $61d2c4b85948061e$export$f33643c0debef087,
    __values: $61d2c4b85948061e$export$19a8beecd37a4c45,
    __read: $61d2c4b85948061e$export$8d051b38c9118094,
    __spread: $61d2c4b85948061e$export$afc72e2116322959,
    __spreadArrays: $61d2c4b85948061e$export$6388937ca91ccae8,
    __spreadArray: $61d2c4b85948061e$export$1216008129fb82ed,
    __await: $61d2c4b85948061e$export$10c90e4f7922046c,
    __asyncGenerator: $61d2c4b85948061e$export$e427f37a30a4de9b,
    __asyncDelegator: $61d2c4b85948061e$export$bbd80228419bb833,
    __asyncValues: $61d2c4b85948061e$export$e3b29a3d6162315f,
    __makeTemplateObject: $61d2c4b85948061e$export$4fb47efe1390b86f,
    __importStar: $61d2c4b85948061e$export$c21735bcef00d192,
    __importDefault: $61d2c4b85948061e$export$da59b14a69baef04,
    __classPrivateFieldGet: $61d2c4b85948061e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $61d2c4b85948061e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $61d2c4b85948061e$export$81fdc39f203e4e04,
    __addDisposableResource: $61d2c4b85948061e$export$88ac25d8e944e405,
    __disposeResources: $61d2c4b85948061e$export$8f076105dc360e92
};


function $fb2e3e4f492c1711$var$ItoI(a) {
    return a;
}
function $fb2e3e4f492c1711$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $fb2e3e4f492c1711$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $fb2e3e4f492c1711$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $fb2e3e4f492c1711$var$ItoI;
    return $fb2e3e4f492c1711$var$innerCreateMedium(defaults, middleware);
}
function $fb2e3e4f492c1711$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $fb2e3e4f492c1711$var$innerCreateMedium(null);
    medium.options = (0, $61d2c4b85948061e$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $7200d4c25641e6a1$export$5733e022b1d538cb = (0, $fb2e3e4f492c1711$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $7200d4c25641e6a1$export$b3e9a9312f73723c = (0, $fb2e3e4f492c1711$export$9ffbfcaf067b02c6)();
var $7200d4c25641e6a1$export$3a1d52767cbc07b8 = (0, $fb2e3e4f492c1711$export$9ffbfcaf067b02c6)();
var $7200d4c25641e6a1$export$892cbf28e5518020 = (0, $fb2e3e4f492c1711$export$e13ec7dd7a14088d)({
    async: true // focus-lock sidecar is not required on the server
});


var $c42d791a6d6c5d3c$var$emptyArray = [];
var $c42d791a6d6c5d3c$var$FocusLock = /*#__PURE__*/ $5cNek.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $5cNek.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $5cNek.useRef();
    var isActive = $5cNek.useRef(false);
    var originalFocusedElement = $5cNek.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $c42d791a6d6c5d3c$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $5cNek.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $5cNek.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $5cNek.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    (0, $5cNek.useEffect)(function() {
        if (!disabled) // cleanup return focus on trap deactivation
        // sideEffect/returnFocus should happen by this time
        originalFocusedElement.current = null;
    }, []);
    var returnFocus = $5cNek.useCallback(function(allowDefer) {
        var returnFocusTo = originalFocusedElement.current;
        if (returnFocusTo && returnFocusTo.focus) {
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) // React might return focus after update
                // it's safer to defer the action
                Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $5cNek.useCallback(function(event) {
        if (isActive.current) (0, $7200d4c25641e6a1$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $7200d4c25641e6a1$export$b3e9a9312f73723c).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $5cNek.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $452258aad9357ad1$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[$7f2114630cad36e9$export$aeda8252e54b50f7] = disabled && "disabled", _extends2[$7f2114630cad36e9$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $efe8106b65a634f0$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $5cNek.createElement($5cNek.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ // nearest focus guard
        $5cNek.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $ec7d394d236bc2c5$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $5cNek.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $ec7d394d236bc2c5$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ $5cNek.createElement(SideCar, {
        id: id,
        sideCar: (0, $7200d4c25641e6a1$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $5cNek.createElement(Container, (0, $452258aad9357ad1$export$2e2bcd8739ae039)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $5cNek.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $ec7d394d236bc2c5$export$b8c7b07253306600)
    }));
});
$c42d791a6d6c5d3c$var$FocusLock.propTypes = {};
$c42d791a6d6c5d3c$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    focusOptions: undefined,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    hasPositiveIndices: undefined,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: "div",
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $c42d791a6d6c5d3c$export$2e2bcd8739ae039 = $c42d791a6d6c5d3c$var$FocusLock;


/* eslint-disable no-mixed-operators */ 
var $5cNek = parcelRequire("5cNek");

function $5b995fd3c19ca2b2$export$2e2bcd8739ae039(t, e) {
    return $5b995fd3c19ca2b2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $5b995fd3c19ca2b2$export$2e2bcd8739ae039(t, e);
}


function $e0ad2d91e94f14ff$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $5b995fd3c19ca2b2$export$2e2bcd8739ae039)(t, o);
}


function $38eb40ee06d64f28$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $38eb40ee06d64f28$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $38eb40ee06d64f28$export$2e2bcd8739ae039(o);
}



function $e20e7378462af22c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $38eb40ee06d64f28$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $38eb40ee06d64f28$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $d300a282cf92e390$export$2e2bcd8739ae039(t) {
    var i = (0, $e20e7378462af22c$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $38eb40ee06d64f28$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $4ab674cf488516b7$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $d300a282cf92e390$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $5cNek = parcelRequire("5cNek");
function $c61e027cf26f7c9f$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $e0ad2d91e94f14ff$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $5cNek.PureComponent));
        (0, $4ab674cf488516b7$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $c61e027cf26f7c9f$export$2e2bcd8739ae039 = $c61e027cf26f7c9f$var$withSideEffect;



/*
IE11 support
 */ var $b745082946b934db$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $b745082946b934db$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $b745082946b934db$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};



var $b75bcea7023f0386$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $b75bcea7023f0386$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $b75bcea7023f0386$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $b75bcea7023f0386$var$isVisibleUncached = function(node, checkParent) {
    return !node || $b75bcea7023f0386$var$isTopNode(node) || !$b75bcea7023f0386$var$isElementHidden(node) && checkParent($b75bcea7023f0386$var$getParentNode(node));
};
var $b75bcea7023f0386$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $b75bcea7023f0386$var$isVisibleUncached(node, $b75bcea7023f0386$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $b75bcea7023f0386$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$b75bcea7023f0386$var$isTopNode(node) ? $b75bcea7023f0386$export$b8550e27de209d85(node) ? checkParent($b75bcea7023f0386$var$getParentNode(node)) : false : true;
};
var $b75bcea7023f0386$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $b75bcea7023f0386$var$isAutoFocusAllowedUncached(node, $b75bcea7023f0386$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $b75bcea7023f0386$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $b75bcea7023f0386$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $b75bcea7023f0386$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $b75bcea7023f0386$export$9d74f6fbc6f469d0 = function(node) {
    return $b75bcea7023f0386$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $b75bcea7023f0386$export$8197b0ea56b3b055 = function(node) {
    return !(($b75bcea7023f0386$export$88a6ceeed5737ba3(node) || $b75bcea7023f0386$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $b75bcea7023f0386$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $7f2114630cad36e9$export$134ebef29fd94853));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $b75bcea7023f0386$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $b75bcea7023f0386$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $b75bcea7023f0386$export$602e5a0d338d7750 = function(node) {
    return !$b75bcea7023f0386$export$d94b8b58ec2f30eb(node);
};
var $b75bcea7023f0386$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $aa831899b0588d52$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $aa831899b0588d52$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $b745082946b934db$export$45b10814cc054894)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($aa831899b0588d52$export$350ee6c095d98996);
};




/**
 * list of the object to be considered as focusable
 */ var $e3098002d0d3ba8e$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];


var $d9043a859b0f6cca$var$queryTabbables = (0, $e3098002d0d3ba8e$export$8555f4622e95784).join(",");
var $d9043a859b0f6cca$var$queryGuardTabbables = "".concat($d9043a859b0f6cca$var$queryTabbables, ", [data-focus-guard]");
var $d9043a859b0f6cca$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $b745082946b934db$export$45b10814cc054894)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $d9043a859b0f6cca$var$queryGuardTabbables : $d9043a859b0f6cca$var$queryTabbables) ? [
            child
        ] : [], $d9043a859b0f6cca$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $d9043a859b0f6cca$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $d9043a859b0f6cca$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $d9043a859b0f6cca$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $d9043a859b0f6cca$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $d9043a859b0f6cca$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $b745082946b934db$export$45b10814cc054894)(parent.parentNode.querySelectorAll($d9043a859b0f6cca$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $d9043a859b0f6cca$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $7f2114630cad36e9$export$70e9b4a1820af101), "]"));
    return (0, $b745082946b934db$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $d9043a859b0f6cca$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $b5cb83530ed2f267$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $b745082946b934db$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $b75bcea7023f0386$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $b75bcea7023f0386$export$8197b0ea56b3b055)(node);
    });
};
var $b5cb83530ed2f267$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $b745082946b934db$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $b75bcea7023f0386$export$bcaa50628f6a736e)(cache, node);
    });
};
var $b5cb83530ed2f267$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $aa831899b0588d52$export$cb40ee071f0d5226)($b5cb83530ed2f267$export$6266a5cd5915dc33((0, $d9043a859b0f6cca$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $b5cb83530ed2f267$export$23c79be8286a3b0c = function(topNodes, visibilityCache) {
    return (0, $aa831899b0588d52$export$cb40ee071f0d5226)($b5cb83530ed2f267$export$6266a5cd5915dc33((0, $d9043a859b0f6cca$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $b5cb83530ed2f267$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $b5cb83530ed2f267$export$6266a5cd5915dc33((0, $d9043a859b0f6cca$export$853fa94d922e78b9)(topNode), visibilityCache);
};
var $b5cb83530ed2f267$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $b5cb83530ed2f267$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $b745082946b934db$export$45b10814cc054894)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $b5cb83530ed2f267$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $b5cb83530ed2f267$export$2344b14b097df817(child, element);
        });
    }
};




/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $2345ed410fe05385$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $2345ed410fe05385$var$getTopParent = function(node) {
    return node.parentNode ? $2345ed410fe05385$var$getTopParent(node.parentNode) : node;
};
var $2345ed410fe05385$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $b745082946b934db$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $7f2114630cad36e9$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $2345ed410fe05385$var$filterNested((0, $b745082946b934db$export$45b10814cc054894)($2345ed410fe05385$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $7f2114630cad36e9$export$4f9a06cb7441a087), '="').concat(group, '"]:not([').concat((0, $7f2114630cad36e9$export$aeda8252e54b50f7), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};



/**
 * returns active element from document or from nested shadowdoms
 */ var $d495e925c344f235$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};


var $6130533b1e218ea8$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $6130533b1e218ea8$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $d495e925c344f235$export$78d20aae35adef88)(function() {
        return activeElement.contentWindow.document;
    }) ? $6130533b1e218ea8$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};


var $2b49d29c0ebc9800$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $2b49d29c0ebc9800$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $b745082946b934db$export$45b10814cc054894)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $2b49d29c0ebc9800$var$focusInFrame(node, activeElement);
    }));
};
var $2b49d29c0ebc9800$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $6130533b1e218ea8$export$cd4e5573fbe2b576)((0, $b745082946b934db$export$bcd7afcd904dce14)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $2345ed410fe05385$export$7e87c4720b9b279b)(topNode).some(function(node) {
        return (0, $b5cb83530ed2f267$export$2344b14b097df817)(node, activeElement) || $2b49d29c0ebc9800$var$focusInsideIframe(node, activeElement);
    });
};






var $2b7d45e8a854ac58$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $6130533b1e218ea8$export$cd4e5573fbe2b576)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $b745082946b934db$export$45b10814cc054894)(inDocument.querySelectorAll("[".concat((0, $7f2114630cad36e9$export$54ecf528c58f9ef6), "]"))).some(function(node) {
        return (0, $b5cb83530ed2f267$export$2344b14b097df817)(node, activeElement);
    });
};








var $8da047f23aeb3ad9$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $8da047f23aeb3ad9$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $8da047f23aeb3ad9$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $8da047f23aeb3ad9$var$getParents(nodeA);
    var parentsB = $8da047f23aeb3ad9$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $8da047f23aeb3ad9$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $b745082946b934db$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $b745082946b934db$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $8da047f23aeb3ad9$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $8da047f23aeb3ad9$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $b5cb83530ed2f267$export$2344b14b097df817)(common, topCommon)) topCommon = common;
                else topCommon = $8da047f23aeb3ad9$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $8da047f23aeb3ad9$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $b5cb83530ed2f267$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};


var $28da7bc20f94971d$export$30d9c643899a8835 = function(topNode) {
    var entries = (0, $2345ed410fe05385$export$7e87c4720b9b279b)(topNode).filter((0, $b75bcea7023f0386$export$602e5a0d338d7750));
    var commonParent = (0, $8da047f23aeb3ad9$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = (0, $b5cb83530ed2f267$export$3738e313571e2ad2)([
        commonParent
    ], visibilityCache, true);
    var innerElements = (0, $b5cb83530ed2f267$export$3738e313571e2ad2)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $b75bcea7023f0386$export$602e5a0d338d7750)(node);
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $b75bcea7023f0386$export$d94b8b58ec2f30eb)(node)
        };
    });
};
var $28da7bc20f94971d$export$5f246425711134ac = $28da7bc20f94971d$export$30d9c643899a8835;



var $a726b3ff23f6416f$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $b75bcea7023f0386$export$9d74f6fbc6f469d0)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $a726b3ff23f6416f$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $b75bcea7023f0386$export$9d74f6fbc6f469d0)(node) && node.name) return $a726b3ff23f6416f$var$findSelectedRadio(node, nodes);
    return node;
};
var $a726b3ff23f6416f$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($a726b3ff23f6416f$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $41ce0fde83e3b55a$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $a726b3ff23f6416f$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $41ce0fde83e3b55a$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $a726b3ff23f6416f$export$5261662167ad7ced)(nodes[index], nodes));
    return index;
};



var $50185e1ed363c93d$export$85710b12cf912438 = "NEW_FOCUS";
var $50185e1ed363c93d$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $b75bcea7023f0386$export$d94b8b58ec2f30eb)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $a726b3ff23f6416f$export$4a5a72a7124e45f9)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $41ce0fde83e3b55a$export$e06728ee87c96122)(innerNodes, 0);
    var returnLastNode = (0, $41ce0fde83e3b55a$export$e06728ee87c96122)(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) return $50185e1ed363c93d$export$85710b12cf912438;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};








var $2f98bcfb5e681b3d$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $b75bcea7023f0386$export$698b339b0c8edae3)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $2f98bcfb5e681b3d$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $b5cb83530ed2f267$export$2f70373d403a5d2b)(nodes.filter($2f98bcfb5e681b3d$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $41ce0fde83e3b55a$export$f4e86cfa0679b9cc)(autoFocusable);
    return (0, $41ce0fde83e3b55a$export$f4e86cfa0679b9cc)((0, $b5cb83530ed2f267$export$2f70373d403a5d2b)(orderedNodes));
};





var $ad4672a5459d14fa$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $b75bcea7023f0386$export$4e62c701997796c1));
};
var $ad4672a5459d14fa$export$82d3f62e3f171d1d = function(topNode, lastNode) {
    var activeElement = (0, $6130533b1e218ea8$export$cd4e5573fbe2b576)((0, $b745082946b934db$export$75093a47a9fa838d)(topNode).length > 0 ? document : (0, $b745082946b934db$export$bcd7afcd904dce14)(topNode).ownerDocument);
    var entries = (0, $2345ed410fe05385$export$7e87c4720b9b279b)(topNode).filter((0, $b75bcea7023f0386$export$602e5a0d338d7750));
    var commonParent = (0, $8da047f23aeb3ad9$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $b5cb83530ed2f267$export$23c79be8286a3b0c)(entries, visibilityCache);
    var innerElements = (0, $b5cb83530ed2f267$export$3738e313571e2ad2)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $b75bcea7023f0386$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $b5cb83530ed2f267$export$23c79be8286a3b0c)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $ad4672a5459d14fa$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $50185e1ed363c93d$export$65842178e9bb4205)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $50185e1ed363c93d$export$85710b12cf912438)) {
        var focusNode = (0, $2f98bcfb5e681b3d$export$cfb742983e257555)(anyFocusable, innerNodes, (0, $8da047f23aeb3ad9$export$8f99714c70a37db1)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $7136d4947dc03f2f$export$c12b3da842c43a8 = function(target, focusOptions) {
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};
var $7136d4947dc03f2f$var$guardCount = 0;
var $7136d4947dc03f2f$var$lockDisabled = false;
var $7136d4947dc03f2f$export$f06c444b0336b5d5 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $ad4672a5459d14fa$export$82d3f62e3f171d1d)(topNode, lastNode);
    if ($7136d4947dc03f2f$var$lockDisabled) return;
    if (focusable) {
        if ($7136d4947dc03f2f$var$guardCount > 2) {
            // tslint:disable-next-line:no-console
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $7136d4947dc03f2f$var$lockDisabled = true;
            setTimeout(function() {
                $7136d4947dc03f2f$var$lockDisabled = false;
            }, 1);
            return;
        }
        $7136d4947dc03f2f$var$guardCount++;
        $7136d4947dc03f2f$export$c12b3da842c43a8(focusable.node, options.focusOptions);
        $7136d4947dc03f2f$var$guardCount--;
    }
};






var $8c3bd8c9bf78d187$export$2e2bcd8739ae039 //
 = (0, $7136d4947dc03f2f$export$f06c444b0336b5d5);


function $5d4438b19377a2b8$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $5d4438b19377a2b8$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};



var $d03d8a300de89966$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $d03d8a300de89966$var$isFreeFocus = function isFreeFocus() {
    return $d03d8a300de89966$var$focusOnBody() || (0, $2b7d45e8a854ac58$export$be6b21806d3fd485)();
};
var $d03d8a300de89966$var$lastActiveTrap = null;
var $d03d8a300de89966$var$lastActiveFocus = null;
var $d03d8a300de89966$var$lastPortaledElement = null;
var $d03d8a300de89966$var$focusWasOutsideWindow = false;
var $d03d8a300de89966$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $d03d8a300de89966$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($d03d8a300de89966$var$lastActiveTrap.whiteList || $d03d8a300de89966$var$defaultWhitelist)(activeElement);
};
var $d03d8a300de89966$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $d03d8a300de89966$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $d03d8a300de89966$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $d03d8a300de89966$var$lastPortaledElement && $d03d8a300de89966$var$lastPortaledElement.portaledElement === element;
};
function $d03d8a300de89966$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $d03d8a300de89966$var$extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $d03d8a300de89966$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($d03d8a300de89966$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $d03d8a300de89966$var$focusWasOutsideWindow === "meanwhile";
};
var $d03d8a300de89966$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement) // dive up
    ) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $d03d8a300de89966$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $d03d8a300de89966$var$checkInHost(activeElement, area, area);
    });
};
var $d03d8a300de89966$var$activateTrap = function activateTrap() {
    var result = false;
    if ($d03d8a300de89966$var$lastActiveTrap) {
        var _lastActiveTrap = $d03d8a300de89966$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $d03d8a300de89966$var$lastPortaledElement && $d03d8a300de89966$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($d03d8a300de89966$var$extractRef).filter(Boolean));
            if (!activeElement || $d03d8a300de89966$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $d03d8a300de89966$var$focusWasOutside(crossFrame) || !$d03d8a300de89966$var$isFreeFocus() || !$d03d8a300de89966$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $2b49d29c0ebc9800$export$20115f8da7baa6fa)(workingArea) || // check for shadow-dom contained elements
                    activeElement && $d03d8a300de89966$var$withinHost(activeElement, workingArea) || $d03d8a300de89966$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$d03d8a300de89966$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $8c3bd8c9bf78d187$export$2e2bcd8739ae039)(workingArea, $d03d8a300de89966$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $d03d8a300de89966$var$lastPortaledElement = {};
                        }
                    }
                    $d03d8a300de89966$var$focusWasOutsideWindow = false;
                    $d03d8a300de89966$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $28da7bc20f94971d$export$30d9c643899a8835)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $d03d8a300de89966$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $d03d8a300de89966$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $d03d8a300de89966$var$onTrap = function onTrap(event) {
    if ($d03d8a300de89966$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $d03d8a300de89966$var$onBlur = function onBlur() {
    return (0, $5d4438b19377a2b8$export$6523025722806278)($d03d8a300de89966$var$activateTrap);
};
var $d03d8a300de89966$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $d03d8a300de89966$var$recordPortal(currentNode, source);
};
var $d03d8a300de89966$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $d03d8a300de89966$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $5cNek.createElement("div", {
        onBlur: $d03d8a300de89966$var$onBlur,
        onFocus: $d03d8a300de89966$var$onFocus
    }, children);
};
$d03d8a300de89966$var$FocusTrap.propTypes = {};
var $d03d8a300de89966$var$onWindowBlur = function onWindowBlur() {
    $d03d8a300de89966$var$focusWasOutsideWindow = "just"; // using setTimeout to set  this variable after React/sidecar reaction
    (0, $5d4438b19377a2b8$export$6523025722806278)(function() {
        $d03d8a300de89966$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $d03d8a300de89966$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $d03d8a300de89966$var$onTrap);
    document.addEventListener("focusout", $d03d8a300de89966$var$onBlur);
    window.addEventListener("blur", $d03d8a300de89966$var$onWindowBlur);
};
var $d03d8a300de89966$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $d03d8a300de89966$var$onTrap);
    document.removeEventListener("focusout", $d03d8a300de89966$var$onBlur);
    window.removeEventListener("blur", $d03d8a300de89966$var$onWindowBlur);
};
function $d03d8a300de89966$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $d03d8a300de89966$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$d03d8a300de89966$var$lastActiveTrap) $d03d8a300de89966$var$attachHandler();
    var lastTrap = $d03d8a300de89966$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $d03d8a300de89966$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $d03d8a300de89966$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $d03d8a300de89966$var$activateTrap(true);
        (0, $5d4438b19377a2b8$export$6523025722806278)($d03d8a300de89966$var$activateTrap);
    } else {
        $d03d8a300de89966$var$detachHandler();
        $d03d8a300de89966$var$lastActiveFocus = null;
    }
} // bind medium
(0, $7200d4c25641e6a1$export$5733e022b1d538cb).assignSyncMedium($d03d8a300de89966$var$onFocus);
(0, $7200d4c25641e6a1$export$b3e9a9312f73723c).assignMedium($d03d8a300de89966$var$onBlur);
(0, $7200d4c25641e6a1$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $8c3bd8c9bf78d187$export$2e2bcd8739ae039),
        focusInside: (0, $2b49d29c0ebc9800$export$20115f8da7baa6fa)
    });
});
var $d03d8a300de89966$export$2e2bcd8739ae039 = (0, $c61e027cf26f7c9f$export$2e2bcd8739ae039)($d03d8a300de89966$var$reducePropsToState, $d03d8a300de89966$var$handleStateChangeOnClient)($d03d8a300de89966$var$FocusWatcher);


/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $f92fe85f07031873$var$FocusLockCombination = /*#__PURE__*/ $5cNek.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $5cNek.createElement((0, $c42d791a6d6c5d3c$export$2e2bcd8739ae039), (0, $452258aad9357ad1$export$2e2bcd8739ae039)({
        sideCar: (0, $d03d8a300de89966$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $f92fe85f07031873$var$_ref = (0, $c42d791a6d6c5d3c$export$2e2bcd8739ae039).propTypes || {}, $f92fe85f07031873$var$sideCar = $f92fe85f07031873$var$_ref.sideCar, $f92fe85f07031873$var$propTypes = (0, $879230480295e68d$export$2e2bcd8739ae039)($f92fe85f07031873$var$_ref, [
    "sideCar"
]);
$f92fe85f07031873$var$FocusLockCombination.propTypes = {};
var $f92fe85f07031873$export$2e2bcd8739ae039 = $f92fe85f07031873$var$FocusLockCombination;



var $1ed44a3250f5123d$export$2e2bcd8739ae039 = (0, $f92fe85f07031873$export$2e2bcd8739ae039);


var $d7b2b1cbabfff2e5$exports = {};
"use strict";
Object.defineProperty($d7b2b1cbabfff2e5$exports, "__esModule", {
    value: true
});
var $edcb9a402f20b454$exports = {};
"use strict";
Object.defineProperty($edcb9a402f20b454$exports, "__esModule", {
    value: true
});
var $edcb9a402f20b454$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5cNek = parcelRequire("5cNek");
var $edcb9a402f20b454$var$_react2 = $edcb9a402f20b454$var$_interopRequireDefault($5cNek);
var $69bd6b4f3608e84f$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, $69bd6b4f3608e84f$exports) $69bd6b4f3608e84f$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $863775926fb73145$exports = {};
"use strict";
Object.defineProperty($863775926fb73145$exports, "__esModule", {
    value: true
});
$863775926fb73145$exports.TouchScrollable = undefined;
var $863775926fb73145$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $863775926fb73145$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5cNek = parcelRequire("5cNek");

var $e44bcaa44afd79b1$exports = {};
"use strict";
Object.defineProperty($e44bcaa44afd79b1$exports, "__esModule", {
    value: true
});
$e44bcaa44afd79b1$exports.pipe = $e44bcaa44afd79b1$exports.listenerOptions = undefined;
$e44bcaa44afd79b1$exports.preventTouchMove = $e44bcaa44afd79b1$var$preventTouchMove;
$e44bcaa44afd79b1$exports.allowTouchMove = $e44bcaa44afd79b1$var$allowTouchMove;
$e44bcaa44afd79b1$exports.preventInertiaScroll = $e44bcaa44afd79b1$var$preventInertiaScroll;
$e44bcaa44afd79b1$exports.isTouchDevice = $e44bcaa44afd79b1$var$isTouchDevice;
$e44bcaa44afd79b1$exports.camelToKebab = $e44bcaa44afd79b1$var$camelToKebab;
$e44bcaa44afd79b1$exports.parse = $e44bcaa44afd79b1$var$parse;
$e44bcaa44afd79b1$exports.getPadding = $e44bcaa44afd79b1$var$getPadding;
$e44bcaa44afd79b1$exports.getWindowHeight = $e44bcaa44afd79b1$var$getWindowHeight;
$e44bcaa44afd79b1$exports.getDocumentHeight = $e44bcaa44afd79b1$var$getDocumentHeight;
$e44bcaa44afd79b1$exports.makeStyleTag = $e44bcaa44afd79b1$var$makeStyleTag;
$e44bcaa44afd79b1$exports.injectStyles = $e44bcaa44afd79b1$var$injectStyles;
$e44bcaa44afd79b1$exports.insertStyleTag = $e44bcaa44afd79b1$var$insertStyleTag;

var $e44bcaa44afd79b1$var$listenerOptions = $e44bcaa44afd79b1$exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $e44bcaa44afd79b1$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $e44bcaa44afd79b1$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $e44bcaa44afd79b1$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $e44bcaa44afd79b1$var$isTouchDevice() {
    if (!$69bd6b4f3608e84f$exports.canUseDOM) return false;
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $e44bcaa44afd79b1$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $e44bcaa44afd79b1$var$parse(val) {
    return isNaN(val) ? val : val + "px";
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $e44bcaa44afd79b1$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $e44bcaa44afd79b1$var$pipe = $e44bcaa44afd79b1$exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($e44bcaa44afd79b1$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $e44bcaa44afd79b1$var$getPadding() {
    if (!$69bd6b4f3608e84f$exports.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $e44bcaa44afd79b1$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($69bd6b4f3608e84f$exports.canUseDOM) return window.innerHeight * multiplier;
}
function $e44bcaa44afd79b1$var$getDocumentHeight() {
    if ($69bd6b4f3608e84f$exports.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $e44bcaa44afd79b1$var$makeStyleTag() {
    if (!$69bd6b4f3608e84f$exports.canUseDOM) return;
    var tag = document.createElement("style");
    tag.type = "text/css";
    tag.setAttribute("data-react-scrolllock", "");
    return tag;
}
function $e44bcaa44afd79b1$var$injectStyles(tag, css) {
    if (!$69bd6b4f3608e84f$exports.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $e44bcaa44afd79b1$var$insertStyleTag(tag) {
    if (!$69bd6b4f3608e84f$exports.canUseDOM) return;
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}


function $863775926fb73145$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $863775926fb73145$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $863775926fb73145$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $863775926fb73145$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $863775926fb73145$var$TouchScrollable = $863775926fb73145$exports.TouchScrollable = function(_PureComponent) {
    $863775926fb73145$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $863775926fb73145$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $863775926fb73145$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $863775926fb73145$var$_possibleConstructorReturn(_this, _ret);
    }
    $863775926fb73145$var$_createClass(TouchScrollable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$69bd6b4f3608e84f$exports.canUseEventListeners) return;
                this.scrollableArea.addEventListener("touchstart", $e44bcaa44afd79b1$exports.preventInertiaScroll, $e44bcaa44afd79b1$exports.listenerOptions);
                this.scrollableArea.addEventListener("touchmove", $e44bcaa44afd79b1$exports.allowTouchMove, $e44bcaa44afd79b1$exports.listenerOptions);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$69bd6b4f3608e84f$exports.canUseEventListeners) return;
                this.scrollableArea.removeEventListener("touchstart", $e44bcaa44afd79b1$exports.preventInertiaScroll, $e44bcaa44afd79b1$exports.listenerOptions);
                this.scrollableArea.removeEventListener("touchmove", $e44bcaa44afd79b1$exports.allowTouchMove, $e44bcaa44afd79b1$exports.listenerOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, rest = $863775926fb73145$var$_objectWithoutProperties(_props, [
                    "children"
                ]);
                return typeof children === "function" ? children(this.getScrollableArea) : (0, $5cNek.cloneElement)(children, $863775926fb73145$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($5cNek.PureComponent);


var $26714cb1c085f903$exports = {};
"use strict";
Object.defineProperty($26714cb1c085f903$exports, "__esModule", {
    value: true
});
var $26714cb1c085f903$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$26714cb1c085f903$exports.default = $26714cb1c085f903$var$withLockSheet;

var $5cNek = parcelRequire("5cNek");
var $26714cb1c085f903$var$_react2 = $26714cb1c085f903$var$_interopRequireDefault($5cNek);

function $26714cb1c085f903$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $26714cb1c085f903$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $26714cb1c085f903$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $26714cb1c085f903$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $26714cb1c085f903$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $26714cb1c085f903$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $26714cb1c085f903$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $26714cb1c085f903$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $e44bcaa44afd79b1$exports.makeStyleTag)();
                if (!sheet) return;
                (0, $e44bcaa44afd79b1$exports.injectStyles)(sheet, styles);
                (0, $e44bcaa44afd79b1$exports.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $e44bcaa44afd79b1$exports.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $e44bcaa44afd79b1$exports.getPadding)() : null;
                var styles = "body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        " + (height ? "height: " + height + "px !important;" : "") + "\n        " + (paddingRight ? "padding-right: " + paddingRight + "px !important;" : "") + "\n      }";
                return styles;
            }, _temp), $26714cb1c085f903$var$_possibleConstructorReturn(_this, _ret);
        }
        $26714cb1c085f903$var$_createClass(SheetProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: "removeSheet",
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: "render",
                value: function render() {
                    return $26714cb1c085f903$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($5cNek.PureComponent);
}


var $edcb9a402f20b454$var$_withLockSheet2 = $edcb9a402f20b454$var$_interopRequireDefault($26714cb1c085f903$exports);
var $747e2305bec4dae2$exports = {};
"use strict";
Object.defineProperty($747e2305bec4dae2$exports, "__esModule", {
    value: true
});
var $747e2305bec4dae2$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$747e2305bec4dae2$exports.default = $747e2305bec4dae2$var$withTouchListeners;

var $5cNek = parcelRequire("5cNek");
var $747e2305bec4dae2$var$_react2 = $747e2305bec4dae2$var$_interopRequireDefault($5cNek);


function $747e2305bec4dae2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $747e2305bec4dae2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $747e2305bec4dae2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $747e2305bec4dae2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $747e2305bec4dae2$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $747e2305bec4dae2$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $747e2305bec4dae2$var$_classCallCheck(this, TouchProvider);
            return $747e2305bec4dae2$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $747e2305bec4dae2$var$_createClass(TouchProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!$69bd6b4f3608e84f$exports.canUseDOM || !(0, $e44bcaa44afd79b1$exports.isTouchDevice)()) return;
                    document.addEventListener("touchmove", $e44bcaa44afd79b1$exports.preventTouchMove, $e44bcaa44afd79b1$exports.listenerOptions);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (!$69bd6b4f3608e84f$exports.canUseDOM || !(0, $e44bcaa44afd79b1$exports.isTouchDevice)()) return;
                    document.removeEventListener("touchmove", $e44bcaa44afd79b1$exports.preventTouchMove, $e44bcaa44afd79b1$exports.listenerOptions);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $747e2305bec4dae2$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($5cNek.PureComponent);
}


var $edcb9a402f20b454$var$_withTouchListeners2 = $edcb9a402f20b454$var$_interopRequireDefault($747e2305bec4dae2$exports);

function $edcb9a402f20b454$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $edcb9a402f20b454$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $edcb9a402f20b454$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $edcb9a402f20b454$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $edcb9a402f20b454$var$ScrollLock = function(_PureComponent) {
    $edcb9a402f20b454$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $edcb9a402f20b454$var$_classCallCheck(this, ScrollLock);
        return $edcb9a402f20b454$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $edcb9a402f20b454$var$_createClass(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$69bd6b4f3608e84f$exports.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children ? $edcb9a402f20b454$var$_react2.default.createElement($863775926fb73145$exports.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($5cNek.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $edcb9a402f20b454$var$compose = (0, $e44bcaa44afd79b1$exports.pipe)($edcb9a402f20b454$var$_withTouchListeners2.default, $edcb9a402f20b454$var$_withLockSheet2.default);
var $edcb9a402f20b454$var$SheetLock = $edcb9a402f20b454$var$compose($edcb9a402f20b454$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $edcb9a402f20b454$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $edcb9a402f20b454$var$_react2.default.createElement($edcb9a402f20b454$var$SheetLock, props) : props.children;
};
$edcb9a402f20b454$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
$edcb9a402f20b454$exports.default = $edcb9a402f20b454$var$LockToggle;


Object.defineProperty($d7b2b1cbabfff2e5$exports, "default", {
    enumerable: true,
    get: function get() {
        return $d7b2b1cbabfff2e5$var$_interopRequireDefault($edcb9a402f20b454$exports).default;
    }
});

Object.defineProperty($d7b2b1cbabfff2e5$exports, "TouchScrollable", {
    enumerable: true,
    get: function get() {
        return $863775926fb73145$exports.TouchScrollable;
    }
});
function $d7b2b1cbabfff2e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}



var $2FWxW = parcelRequire("2FWxW");

var $5cNek = parcelRequire("5cNek");

var $5cNek = parcelRequire("5cNek");
function $fa7e6870d6225e8c$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $fa7e6870d6225e8c$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $5cNek.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $5cNek.useRef)(true);
    var committed = (0, $5cNek.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $fa7e6870d6225e8c$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $5cNek.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $fa7e6870d6225e8c$export$33752cf3ee811995(callback, inputs) {
    return $fa7e6870d6225e8c$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $fa7e6870d6225e8c$export$1538c33de8887b59 = $fa7e6870d6225e8c$export$b6feb8998cd9b342;
var $fa7e6870d6225e8c$export$35808ee640e87ca7 = $fa7e6870d6225e8c$export$33752cf3ee811995;



var $gdzT2 = parcelRequire("gdzT2");

var $i2CXH = parcelRequire("i2CXH");

var $4URe7 = parcelRequire("4URe7");
var $9b6b77a9e4285514$exports = {};
function $9b6b77a9e4285514$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$9b6b77a9e4285514$exports = $9b6b77a9e4285514$var$_assertThisInitialized, $9b6b77a9e4285514$exports.__esModule = true, $9b6b77a9e4285514$exports["default"] = $9b6b77a9e4285514$exports;


var $f245edb72baccf37$exports = {};
var $8c328f830b7893fe$exports = {};
var $86213fefa0ab9a08$exports = {};
function $86213fefa0ab9a08$var$_getPrototypeOf(t) {
    return $86213fefa0ab9a08$exports = $86213fefa0ab9a08$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $86213fefa0ab9a08$exports.__esModule = true, $86213fefa0ab9a08$exports["default"] = $86213fefa0ab9a08$exports, $86213fefa0ab9a08$var$_getPrototypeOf(t);
}
$86213fefa0ab9a08$exports = $86213fefa0ab9a08$var$_getPrototypeOf, $86213fefa0ab9a08$exports.__esModule = true, $86213fefa0ab9a08$exports["default"] = $86213fefa0ab9a08$exports;


function $8c328f830b7893fe$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $86213fefa0ab9a08$exports(t)););
    return t;
}
$8c328f830b7893fe$exports = $8c328f830b7893fe$var$_superPropBase, $8c328f830b7893fe$exports.__esModule = true, $8c328f830b7893fe$exports["default"] = $8c328f830b7893fe$exports;


function $f245edb72baccf37$var$_get() {
    return $f245edb72baccf37$exports = $f245edb72baccf37$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $8c328f830b7893fe$exports(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $f245edb72baccf37$exports.__esModule = true, $f245edb72baccf37$exports["default"] = $f245edb72baccf37$exports, $f245edb72baccf37$var$_get.apply(null, arguments);
}
$f245edb72baccf37$exports = $f245edb72baccf37$var$_get, $f245edb72baccf37$exports.__esModule = true, $f245edb72baccf37$exports["default"] = $f245edb72baccf37$exports;


var $bd867d017c313ee3$exports = {};
var $c6a9915816f4d61c$exports = {};
function $c6a9915816f4d61c$var$_setPrototypeOf(t, e) {
    return $c6a9915816f4d61c$exports = $c6a9915816f4d61c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $c6a9915816f4d61c$exports.__esModule = true, $c6a9915816f4d61c$exports["default"] = $c6a9915816f4d61c$exports, $c6a9915816f4d61c$var$_setPrototypeOf(t, e);
}
$c6a9915816f4d61c$exports = $c6a9915816f4d61c$var$_setPrototypeOf, $c6a9915816f4d61c$exports.__esModule = true, $c6a9915816f4d61c$exports["default"] = $c6a9915816f4d61c$exports;


function $bd867d017c313ee3$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $c6a9915816f4d61c$exports(t, e);
}
$bd867d017c313ee3$exports = $bd867d017c313ee3$var$_inherits, $bd867d017c313ee3$exports.__esModule = true, $bd867d017c313ee3$exports["default"] = $bd867d017c313ee3$exports;


var $19be517fa818097b$exports = {};

var $eE0N6 = parcelRequire("eE0N6");
var $19be517fa818097b$var$_typeof = $eE0N6.default;

function $19be517fa818097b$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $19be517fa818097b$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $9b6b77a9e4285514$exports(t);
}
$19be517fa818097b$exports = $19be517fa818097b$var$_possibleConstructorReturn, $19be517fa818097b$exports.__esModule = true, $19be517fa818097b$exports["default"] = $19be517fa818097b$exports;




var $2FWxW = parcelRequire("2FWxW");

var $eE0N6 = parcelRequire("eE0N6");

var $i2CXH = parcelRequire("i2CXH");

var $4URe7 = parcelRequire("4URe7");

var $2FWxW = parcelRequire("2FWxW");
function $27974b63e92a53fe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $27974b63e92a53fe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $27974b63e92a53fe$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $27974b63e92a53fe$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $27974b63e92a53fe$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $27974b63e92a53fe$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $27974b63e92a53fe$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($i2CXH)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $27974b63e92a53fe$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4URe7)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($eE0N6)))(updater) === "object") this.payload = $27974b63e92a53fe$var$_objectSpread($27974b63e92a53fe$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $2e0619e9d2400e6d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2e0619e9d2400e6d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($86213fefa0ab9a08$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($86213fefa0ab9a08$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($19be517fa818097b$exports)))(this, result);
    };
}
function $2e0619e9d2400e6d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $2e0619e9d2400e6d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $2e0619e9d2400e6d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $2e0619e9d2400e6d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($bd867d017c313ee3$exports)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $2e0619e9d2400e6d$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($i2CXH)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))((0, (/*@__PURE__*/$parcel$interopDefault($9b6b77a9e4285514$exports)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))((0, (/*@__PURE__*/$parcel$interopDefault($9b6b77a9e4285514$exports)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($gdzT2)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($gdzT2)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))((0, (/*@__PURE__*/$parcel$interopDefault($9b6b77a9e4285514$exports)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($9b6b77a9e4285514$exports)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4URe7)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($f245edb72baccf37$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($86213fefa0ab9a08$exports)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $27974b63e92a53fe$export$2e2bcd8739ae039));



var $5cNek = parcelRequire("5cNek");

var $5cNek = parcelRequire("5cNek");
var $0cf697ac0dc4d03a$var$AnalyticsNextContext = (0, $5cNek.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $0cf697ac0dc4d03a$export$2e2bcd8739ae039 = $0cf697ac0dc4d03a$var$AnalyticsNextContext;


var $3f81f3d463fd7682$export$2e2bcd8739ae039 = (0, $0cf697ac0dc4d03a$export$2e2bcd8739ae039);


var $4edc87bd0379a0d0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5cNek.useContext)((0, $3f81f3d463fd7682$export$2e2bcd8739ae039));
};


function $b221799c88fe4dd3$export$5bf35293e545f20c() {
    var analyticsContext = (0, $4edc87bd0379a0d0$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $fa7e6870d6225e8c$export$33752cf3ee811995)(function(payload) {
        return new (0, $2e0619e9d2400e6d$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5cNek = parcelRequire("5cNek");
var $442e1d4bf34a70aa$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5cNek.useRef)(value);
    (0, $5cNek.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};


function $4cede3b78eac3524$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4cede3b78eac3524$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4cede3b78eac3524$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4cede3b78eac3524$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4cede3b78eac3524$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $b221799c88fe4dd3$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $442e1d4bf34a70aa$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $442e1d4bf34a70aa$export$1d27a74659855e44)(fn);
    var handler = (0, $5cNek.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $4cede3b78eac3524$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $2FWxW = parcelRequire("2FWxW");

var $5cNek = parcelRequire("5cNek");


/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $ce0910c7994ac44a$export$2e2bcd8739ae039() {}





function $1b26a6a151a85669$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1b26a6a151a85669$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1b26a6a151a85669$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1b26a6a151a85669$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $1b26a6a151a85669$var$packageName = "@atlaskit/blanket";
var $1b26a6a151a85669$var$packageVersion = "12.4.4";
var $1b26a6a151a85669$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $1b26a6a151a85669$var$packageName,
    packageVersion: $1b26a6a151a85669$var$packageVersion
};
var $1b26a6a151a85669$var$baseStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    position: "fixed",
    zIndex: (0, $ea1180a9039473b6$export$7be255094ccdc533).blanket(),
    inset: 0,
    overflowY: "auto",
    pointerEvents: "initial"
});
var $1b26a6a151a85669$var$shouldAllowClickThroughStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    pointerEvents: "none"
});
var $1b26a6a151a85669$var$invisibleStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    backgroundColor: "transparent"
});
var $1b26a6a151a85669$var$lightBgStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    backgroundColor: "var(--ds-blanket, ".concat((0, $db8844ebfff7fa2d$export$486ab785e4bac3c6), ")")
});
var $1b26a6a151a85669$var$darkBgStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    backgroundColor: "var(--ds-blanket, ".concat((0, $db8844ebfff7fa2d$export$40cce05af3b2600a), ")")
});
var $1b26a6a151a85669$var$backgroundStyle = {
    light: $1b26a6a151a85669$var$lightBgStyles,
    dark: $1b26a6a151a85669$var$darkBgStyles
};
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $1b26a6a151a85669$var$Blanket = /*#__PURE__*/ (0, $5cNek.memo)(/*#__PURE__*/ (0, $5cNek.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $ce0910c7994ac44a$export$2e2bcd8739ae039) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var _useGlobalTheme = (0, $ab2a8332a3eacc83$export$7692396083754928)(), mode = _useGlobalTheme.mode;
    var mouseDownTarget = (0, $5cNek.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $4cede3b78eac3524$export$a4687b0234b40e28)($1b26a6a151a85669$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $1b26a6a151a85669$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $5cNek.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $5cNek.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return(// TODO: Remove role="presentation", since div's have no semantics anyway (DSP-11587)
    (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        role: "presentation",
        css: [
            $1b26a6a151a85669$var$baseStyles,
            shouldAllowClickThrough && $1b26a6a151a85669$var$shouldAllowClickThroughStyles,
            $1b26a6a151a85669$var$backgroundStyle[mode],
            !isTinted && $1b26a6a151a85669$var$invisibleStyles
        ],
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref
    }, children));
}));
$1b26a6a151a85669$var$Blanket.displayName = "Blanket";
var $1b26a6a151a85669$export$2e2bcd8739ae039 = $1b26a6a151a85669$var$Blanket;




var $5cNek = parcelRequire("5cNek");


var $a209631e79b9dcb1$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5cNek.createContext)(0);
var $a209631e79b9dcb1$export$48b383b280e20440 = /*#__PURE__*/ (0, $5cNek.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $ce0910c7994ac44a$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $a209631e79b9dcb1$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5cNek.useContext)($a209631e79b9dcb1$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $5cNek.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement($a209631e79b9dcb1$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $a209631e79b9dcb1$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5cNek.useRef)(0);
    var value = (0, $5cNek.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement($a209631e79b9dcb1$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $a209631e79b9dcb1$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children;
    var currentLevel = (0, $5cNek.useContext)($a209631e79b9dcb1$export$650d12d3c2ddb8fc);
    var isNested = currentLevel > 0;
    if (!(0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.layering_qmiw3")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).Fragment, null, children);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement($a209631e79b9dcb1$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement($a209631e79b9dcb1$var$LayeringProvider, null, content);
};



var $2FWxW = parcelRequire("2FWxW");

var $5cNek = parcelRequire("5cNek");
var $a55ce6e03ce6cde0$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $a55ce6e03ce6cde0$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $a55ce6e03ce6cde0$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $373b2edb19b83fdc$export$368bacef0dacbe05 = 25;
var $373b2edb19b83fdc$export$2023a81c8547415f = $373b2edb19b83fdc$export$368bacef0dacbe05 * 4;
var $373b2edb19b83fdc$export$6fa259be09e118a7 = $373b2edb19b83fdc$export$368bacef0dacbe05 * 14;
var $373b2edb19b83fdc$export$9424640c29bc466d = $373b2edb19b83fdc$export$368bacef0dacbe05 * 28;



var $2FWxW = parcelRequire("2FWxW");

var $XLpyq = parcelRequire("XLpyq");

var $5cNek = parcelRequire("5cNek");




var $5cNek = parcelRequire("5cNek");
var $8f555d5fc8423f69$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $8f555d5fc8423f69$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $5cNek.useRef)([]);
    (0, $5cNek.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8f555d5fc8423f69$var$getHookDeps(opts));
    return (0, $5cNek.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $8f555d5fc8423f69$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $5cNek.useRef)([]);
    (0, $5cNek.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8f555d5fc8423f69$var$getHookDeps(opts));
    return (0, $5cNek.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $XLpyq = parcelRequire("XLpyq");

var $5cNek = parcelRequire("5cNek");


var $5cNek = parcelRequire("5cNek");
var $3e2960d0546628f4$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $5cNek.useEffect) : (0, $5cNek.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5cNek = parcelRequire("5cNek");
function $fe64a3c6f6786294$export$c485849f2e393253() {
    var identifier = (0, $5cNek.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $32fc026d2400b8df$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5cNek.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $ce0910c7994ac44a$export$2e2bcd8739ae039)
    };
});
var $32fc026d2400b8df$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $fe64a3c6f6786294$export$c485849f2e393253)();
    var context = (0, $5cNek.useContext)($32fc026d2400b8df$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $32fc026d2400b8df$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5cNek.useRef)([]);
    var indexes = [];
    var _useState = (0, $5cNek.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $3e2960d0546628f4$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement($32fc026d2400b8df$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $32fc026d2400b8df$export$2e2bcd8739ae039 = $32fc026d2400b8df$var$StaggeredEntrance;


function $01437c0b670f4439$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $01437c0b670f4439$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $01437c0b670f4439$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $01437c0b670f4439$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $01437c0b670f4439$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $01437c0b670f4439$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $373b2edb19b83fdc$export$9424640c29bc466d) : _ref$duration;
    var staggered = (0, $32fc026d2400b8df$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $b4a45d26229a164b$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $8f555d5fc8423f69$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $5cNek.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5cNek.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $01437c0b670f4439$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $e5448515388bb91a$export$9b9c0f9d9f3552b8), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($01437c0b670f4439$var$_objectSpread($01437c0b670f4439$var$_objectSpread({}, (0, $7016c350e338bf47$export$f0f789643ba5a83c)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $01437c0b670f4439$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $e5448515388bb91a$export$d25ddfdf17c3ad3e)(isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $01437c0b670f4439$export$2e2bcd8739ae039 = $01437c0b670f4439$var$EnteringMotion;


function $b25d251a06e9a859$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b25d251a06e9a859$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b25d251a06e9a859$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b25d251a06e9a859$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b25d251a06e9a859$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $b25d251a06e9a859$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $b25d251a06e9a859$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $b25d251a06e9a859$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $b25d251a06e9a859$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $b25d251a06e9a859$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $b25d251a06e9a859$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $b25d251a06e9a859$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $b25d251a06e9a859$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $373b2edb19b83fdc$export$9424640c29bc466d) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $b25d251a06e9a859$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $01437c0b670f4439$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $b25d251a06e9a859$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $b25d251a06e9a859$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $a55ce6e03ce6cde0$export$c07234257a03d5e9;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $b25d251a06e9a859$export$2e2bcd8739ae039 = $b25d251a06e9a859$var$FadeIn;



var $5cNek = parcelRequire("5cNek");

var $5cNek = parcelRequire("5cNek");

var $2f7f561ef046b47a$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $2f7f561ef046b47a$export$72f415121273627e = "body > .atlaskit-portal-container";
var $2f7f561ef046b47a$export$13f57c02915787b3 = "atlaskit-portal";


var $2489b32386b7c13c$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $2f7f561ef046b47a$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $2489b32386b7c13c$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $2489b32386b7c13c$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $2f7f561ef046b47a$export$72f415121273627e));
    if (!parentElement) {
        var parent = document.createElement("div");
        parent.className = (0, $2f7f561ef046b47a$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        $2489b32386b7c13c$var$getBody().appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $2489b32386b7c13c$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $2489b32386b7c13c$var$getPortalParent().removeChild(container);
};
var $2489b32386b7c13c$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $2489b32386b7c13c$var$getPortalParent().appendChild(container);
};


function $3af7d5e03fbbf324$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5cNek.useMemo)(function() {
        return (0, $2489b32386b7c13c$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $2489b32386b7c13c$export$c582005add11e141)(container);
    (0, $5cNek.useEffect)(function() {
        return function() {
            (0, $2489b32386b7c13c$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $3a6b787322b342cd$exports.createPortal)(children, container);
}



var $XLpyq = parcelRequire("XLpyq");

var $5cNek = parcelRequire("5cNek");
var $ada6ad5c583c6d5e$var$useIsSubsequentRender = function useIsSubsequentRender() {
    var _useState = (0, $5cNek.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    (0, $5cNek.useEffect)(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $ada6ad5c583c6d5e$export$2e2bcd8739ae039 = $ada6ad5c583c6d5e$var$useIsSubsequentRender;



var $5cNek = parcelRequire("5cNek");
var $4e841bf9d3d49993$export$ed5835cc67e87f72 = "akPortalMount";
var $4e841bf9d3d49993$export$80816bd900e5bd00 = "akPortalUnmount";


var $c34c19cea22f801a$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $c34c19cea22f801a$var$getLayerName = function getLayerName(zIndex) {
    return $c34c19cea22f801a$var$zIndexToName.hasOwnProperty(zIndex) ? $c34c19cea22f801a$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $c34c19cea22f801a$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $c34c19cea22f801a$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $c34c19cea22f801a$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $c34c19cea22f801a$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $3057b63042915287$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5cNek.useEffect)(function() {
        (0, $c34c19cea22f801a$export$2e2bcd8739ae039)((0, $4e841bf9d3d49993$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $c34c19cea22f801a$export$2e2bcd8739ae039)((0, $4e841bf9d3d49993$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $3057b63042915287$export$2e2bcd8739ae039 = $3057b63042915287$var$useFirePortalEvent;


function $2383d2514acfdc75$export$2e2bcd8739ae039(props) {
    var _props$zIndex = props.zIndex, zIndex = _props$zIndex === void 0 ? 0 : _props$zIndex, children = props.children;
    var isSubsequentRender = (0, $ada6ad5c583c6d5e$export$2e2bcd8739ae039)();
    (0, $3057b63042915287$export$2e2bcd8739ae039)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $3af7d5e03fbbf324$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null;
}





var $XLpyq = parcelRequire("XLpyq");

var $eE0N6 = parcelRequire("eE0N6");

var $2FWxW = parcelRequire("2FWxW");

var $5cNek = parcelRequire("5cNek");


var $5cNek = parcelRequire("5cNek");

var $5cNek = parcelRequire("5cNek");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $b46077bb10b650b3$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $b46077bb10b650b3$export$e2a22331486dcca0 = $b46077bb10b650b3$export$bdbb4cbb3078e58d();


var $1d01777145ef95e3$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $b46077bb10b650b3$export$bdbb4cbb3078e58d)()
    };
};
var $1d01777145ef95e3$export$e575061ef2a070eb = $1d01777145ef95e3$export$1921362e86c73c88();
var $1d01777145ef95e3$export$b4d5da5f34fb77ad = $5cNek.createContext($1d01777145ef95e3$export$1921362e86c73c88());
var $1d01777145ef95e3$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $1d01777145ef95e3$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};


var $f48af1a2a78ceb0f$var$generateUID = function(context) {
    var quartz = context || (0, $1d01777145ef95e3$export$e575061ef2a070eb);
    var prefix = (0, $1d01777145ef95e3$export$36e24695f02d4503)(quartz);
    var id = (0, $1d01777145ef95e3$export$218c8c3169c024d2)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $f48af1a2a78ceb0f$var$useUIDState = function() {
    var context = (0, $5cNek.useContext)((0, $1d01777145ef95e3$export$b4d5da5f34fb77ad));
    var uid = (0, $5cNek.useState)(function() {
        return $f48af1a2a78ceb0f$var$generateUID(context);
    })[0];
    return uid;
};
var $f48af1a2a78ceb0f$export$87d05f07e65211f1 = function() {
    var uid = $f48af1a2a78ceb0f$var$useUIDState().uid;
    return uid;
};
var $f48af1a2a78ceb0f$export$bb5ca5fba6fb4f1f = function() {
    var gen = $f48af1a2a78ceb0f$var$useUIDState().gen;
    return gen;
};


/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $de516753a8010b90$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $5cNek = parcelRequire("5cNek");
function $e7ac342985c70600$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5cNek.useRef)(true);
    (0, $5cNek.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/** @jsx jsx */ 
var $5cNek = parcelRequire("5cNek");

var $bd2b8a986436e057$var$BORDER_WIDTH = 2;
var $bd2b8a986436e057$var$baseFocusOutsideStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    outline: "".concat($bd2b8a986436e057$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $bd2b8a986436e057$var$BORDER_WIDTH
});
var $bd2b8a986436e057$var$baseInsetStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    outlineOffset: -$bd2b8a986436e057$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $bd2b8a986436e057$var$focusRingStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    "&:focus-visible": $bd2b8a986436e057$var$baseFocusOutsideStyles,
    "@supports not selector(*:focus-visible)": {
        "&:focus": $bd2b8a986436e057$var$baseFocusOutsideStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $bd2b8a986436e057$var$insetFocusRingStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    "&:focus-visible": $bd2b8a986436e057$var$baseInsetStyles,
    "@supports not selector(*:focus-visible)": {
        "&:focus": $bd2b8a986436e057$var$baseInsetStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * There are known accessibility issues with this component.
 * Do not use without assistance from the Design System accessibility team.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $bd2b8a986436e057$var$FocusRing = /*#__PURE__*/ (0, $5cNek.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $bd2b8a986436e057$var$baseInsetStyles : $bd2b8a986436e057$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $bd2b8a986436e057$var$insetFocusRingStyles : $bd2b8a986436e057$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $e5448515388bb91a$export$9b9c0f9d9f3552b8), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5cNek.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5cNek.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$bd2b8a986436e057$var$FocusRing.displayName = "FocusRing";
var $bd2b8a986436e057$export$2e2bcd8739ae039 = $bd2b8a986436e057$var$FocusRing;



var $5cNek = parcelRequire("5cNek");


var $4ca18a2979a1967b$var$ESCAPE = "Escape";
function $4ca18a2979a1967b$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5cNek.useRef)(false);
    var _UNSAFE_useLayering = $4ca18a2979a1967b$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $5cNek.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $4ca18a2979a1967b$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5cNek.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5cNek.useEffect)(function() {
        return (0, $99e42e712af0fd5c$exports.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $4ca18a2979a1967b$export$cec37b93989366d4() {
    var currentLevel = (0, $5cNek.useContext)((0, $a209631e79b9dcb1$export$650d12d3c2ddb8fc));
    var _useContext = (0, $5cNek.useContext)((0, $a209631e79b9dcb1$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $5cNek.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}



/**
 * Our internal configuration for breakpoints configuration.
 *
 * We explicitly use `-0.01rem` for "max" values to both ensure we do not overlap our media queries, but also don't skip any fractional pixels.  There is a chance this is not safe in some browsers, eg. Safari has weird rounding.
 * @see: https://tzi.fr/css/prevent-double-breakpoint/
 *
 * @experimental Unsafe for direct consumption outside of the design system itself; please use our `media` export instead for media queries.
 */ var $eca9f6872cebcaa3$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: "0rem",
        max: "29.99rem"
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: "30rem",
        max: "47.99rem"
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: "48rem",
        max: "63.99rem"
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: "64rem",
        max: "89.99rem"
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: "90rem",
        max: "109.99rem"
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: "110rem",
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
var $eca9f6872cebcaa3$export$2d293d9871c38e91 = Object.keys($eca9f6872cebcaa3$export$e5ee4fe8b989fd09);
var $eca9f6872cebcaa3$export$b7ed752a57b4177b = $eca9f6872cebcaa3$export$2d293d9871c38e91[0];


var $140e9897c3324bb3$export$c881183ca713c214 = {
    /**
   * A media query to target viewports above the min width of a given breakpoint.
   * Note that `media.above.xs` is redundant and should not be used, but it's included for programatic purposes.
   */ above: {
        /**
     * `above.xxs` is redundant and no media query should be used, but it's included for programatic purposes…
     */ xxs: "@media all",
        /**
     * Used for mobile viewports.
     */ xs: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).xs.min, ")"),
        /**
     * Used for tablet viewports.
     */ sm: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).sm.min, ")"),
        /**
     * Used for laptop viewports.
     */ md: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).md.min, ")"),
        /**
     * Used for desktop viewports.
     */ lg: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).lg.min, ")"),
        /**
     * Used for wide screen desktop viewports.
     */ xl: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).xl.min, ")")
    },
    /**
   * A media query to target viewports below the min width of a given breakpoint.  We do this by testing the inverse, eg. below = not above…
   *
   * NOTE: `below.xxs` is intentionally not included as it could lead to incorrect usages as it's never accessible as this would be `xxs: '@media not all',`
   *
   * We use this syntax as a more compatible way to ensure media queries do not overlap, eg. `media.above.md` and `media.below.md` should not both trigger at once.
   * This is well describe in this: @see https://stackoverflow.com/a/13649011
   *
   * Ideally we would use media queries level 4 to improve this interface, but this works and browser support might not be sufficient yet: @see https://www.w3.org/TR/mediaqueries-4/
   *
   * @internal Not intended to be used outside of DST at this stage.
   * @experimental Not intended to be used outside of DST at this stage.
   */ below: {
        xs: "@media not all and (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).xs.min, ")"),
        sm: "@media not all and (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).sm.min, ")"),
        md: "@media not all and (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).md.min, ")"),
        lg: "@media not all and (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).lg.min, ")"),
        xl: "@media not all and (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).xl.min, ")")
    },
    /**
   * A media query to target viewports exactly between the min and max of a given breakpoint.
   * Ideally we would use media queries level 4 to improve this interface, but this works and browser support might not be sufficient yet: @see https://www.w3.org/TR/mediaqueries-4/
   *
   * @internal Not intended to be used outside of DST at this stage.
   * @experimental Not intended to be used outside of DST at this stage.
   */ only: {
        xxs: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).xxs.min, ") and (max-width: ").concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).xxs.max, ")"),
        xs: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).xs.min, ") and (max-width: ").concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).xs.max, ")"),
        sm: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).sm.min, ") and (max-width: ").concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).sm.max, ")"),
        md: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).md.min, ") and (max-width: ").concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).md.max, ")"),
        lg: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).lg.min, ") and (max-width: ").concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).lg.max, ")"),
        xl: "@media (min-width: ".concat((0, $eca9f6872cebcaa3$export$e5ee4fe8b989fd09).xl.min, ")")
    }
};
var $140e9897c3324bb3$export$987d49ffe1b0900f = {
    above: $140e9897c3324bb3$export$c881183ca713c214.above
};




var $lCES2 = parcelRequire("lCES2");


var $ed7126fc4c89f80a$export$7e3df82ee760448c = {
    values: [
        "small",
        "medium",
        "large",
        "x-large"
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        "x-large": 968
    },
    defaultValue: "medium"
};
var $ed7126fc4c89f80a$export$f2b922cb4a245974 = 60;
var $ed7126fc4c89f80a$var$gridSize = (0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)();
var $ed7126fc4c89f80a$export$7a57f79000377ca2 = (0, $ea1180a9039473b6$export$7a57f79000377ca2)();
var $ed7126fc4c89f80a$export$9212741279b5f103 = $ed7126fc4c89f80a$var$gridSize * 2;
var $ed7126fc4c89f80a$export$6f98e8eaf0be1996 = $ed7126fc4c89f80a$var$gridSize * 3;
var $ed7126fc4c89f80a$export$5e63d1b3b2849330 = $ed7126fc4c89f80a$var$gridSize;
var $ed7126fc4c89f80a$export$4c317248f944c2a9 = 2;
var $ed7126fc4c89f80a$export$d901150a4cc83165 = "var(--ds-border, ".concat((0, $db8844ebfff7fa2d$export$3e51e8f1440314ba), ")");
var $ed7126fc4c89f80a$export$32f78bffcd82ff28 = "var(--ds-text, ".concat((0, $db8844ebfff7fa2d$export$fbda843f0a27fe96), ")");
var $ed7126fc4c89f80a$export$3797a580396e3639 = {
    danger: "var(--ds-icon-danger, ".concat((0, $db8844ebfff7fa2d$export$2010d0fb4295b346), ")"),
    warning: "var(--ds-icon-warning, #D97008)"
};



var $5cNek = parcelRequire("5cNek");
var $1e87ba318e6deea5$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5cNek.createContext)(null);
var $1e87ba318e6deea5$export$dece24112a937f92 = /*#__PURE__*/ (0, $5cNek.createContext)(null);



var $5cNek = parcelRequire("5cNek");
function $8920d1f3ad954d45$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $5cNek.useRef)(null);
    var onMotionFinish = (0, $5cNek.useCallback)(function(state) {
        if (state === "entering" && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === "exiting" && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}



var $0564fddecf7a1deb$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return "auto";
    var isWidthName = (0, $ed7126fc4c89f80a$export$7e3df82ee760448c).values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat((0, $ed7126fc4c89f80a$export$7e3df82ee760448c).widths[widthName], "px");
    return typeof input === "number" ? "".concat(input, "px") : input;
};
var $0564fddecf7a1deb$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return "auto";
    return typeof input === "number" ? "".concat(input, "px") : input;
};



var $2FWxW = parcelRequire("2FWxW");






var $dee11ed1545f920a$var$maxWidthDimensions = "calc(100vw - ".concat((0, $ed7126fc4c89f80a$export$f2b922cb4a245974) * 2, "px)");
var $dee11ed1545f920a$var$maxHeightDimensions = "calc(100vh - ".concat((0, $ed7126fc4c89f80a$export$f2b922cb4a245974) * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $dee11ed1545f920a$var$positionerStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    display: "flex",
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    position: "fixed",
    zIndex: (0, $ea1180a9039473b6$export$7be255094ccdc533).modal(),
    top: 0,
    left: 0,
    flexDirection: "column"
});
var $dee11ed1545f920a$var$viewportScrollStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))({
    height: "auto",
    position: "relative"
}, (0, $140e9897c3324bb3$export$987d49ffe1b0900f).above.xs, {
    margin: "".concat((0, $ed7126fc4c89f80a$export$f2b922cb4a245974), "px auto"),
    pointerEvents: "none"
}));
var $dee11ed1545f920a$var$bodyScrollStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))({}, (0, $140e9897c3324bb3$export$987d49ffe1b0900f).above.xs, {
    maxWidth: $dee11ed1545f920a$var$maxWidthDimensions,
    maxHeight: $dee11ed1545f920a$var$maxHeightDimensions,
    marginRight: "auto",
    marginLeft: "auto",
    position: "absolute",
    top: "".concat((0, $ed7126fc4c89f80a$export$f2b922cb4a245974), "px"),
    right: 0,
    left: 0,
    pointerEvents: "none"
}));
var $dee11ed1545f920a$var$stackTransitionStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    transitionDuration: "".concat((0, $373b2edb19b83fdc$export$6fa259be09e118a7), "ms"),
    transitionProperty: "transform",
    transitionTimingFunction: (0, $a55ce6e03ce6cde0$export$c07234257a03d5e9),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
});
var $dee11ed1545f920a$var$stackTransformStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    transform: "translateY(var(--modal-dialog-translate-y))"
});
var $dee11ed1545f920a$var$stackIdleStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    transform: "none"
});
var $dee11ed1545f920a$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        style: {
            "--modal-dialog-translate-y": "".concat(stackIndex * ((0, $ed7126fc4c89f80a$export$9212741279b5f103) / 2), "px")
        },
        css: [
            $dee11ed1545f920a$var$positionerStyles,
            $dee11ed1545f920a$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $dee11ed1545f920a$var$stackTransformStyles : $dee11ed1545f920a$var$stackIdleStyles,
            shouldScrollInViewport ? $dee11ed1545f920a$var$viewportScrollStyles : $dee11ed1545f920a$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dee11ed1545f920a$export$2e2bcd8739ae039 = $dee11ed1545f920a$var$Positioner;


var $a9626b5b94821b47$var$_css;
var $a9626b5b94821b47$var$dialogStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)(($a9626b5b94821b47$var$_css = {
    display: "flex",
    width: "100%",
    maxWidth: "100vw",
    height: "100%",
    minHeight: 0,
    maxHeight: "100vh",
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: "0 1 auto",
    flexDirection: "column",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $db8844ebfff7fa2d$export$29a4f05edc054374), ")"),
    color: (0, $ed7126fc4c89f80a$export$32f78bffcd82ff28)
}, (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))($a9626b5b94821b47$var$_css, (0, $lCES2.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $db8844ebfff7fa2d$export$29a4f05edc054374), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))($a9626b5b94821b47$var$_css, "pointerEvents", "auto"), (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))($a9626b5b94821b47$var$_css, (0, $140e9897c3324bb3$export$987d49ffe1b0900f).above.xs, {
    width: "var(--modal-dialog-width)",
    maxWidth: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    marginRight: "inherit",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    marginLeft: "inherit",
    borderRadius: (0, $ed7126fc4c89f80a$export$7a57f79000377ca2),
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $db8844ebfff7fa2d$export$920c0d5c49070351), ", 0 2px 1px ").concat((0, $db8844ebfff7fa2d$export$920c0d5c49070351), ", 0 0 20px -6px ").concat((0, $db8844ebfff7fa2d$export$d2d3bedfb276cac0)), ")")
}), (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))($a9626b5b94821b47$var$_css, "& > form:only-child", {
    display: "inherit",
    maxHeight: "inherit",
    flexDirection: "inherit"
}), $a9626b5b94821b47$var$_css));
var $a9626b5b94821b47$var$viewportScrollStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: "100vh",
    maxHeight: "none"
}, (0, $140e9897c3324bb3$export$987d49ffe1b0900f).above.xs, {
    minHeight: "var(--modal-dialog-height)"
}));
var $a9626b5b94821b47$var$bodyScrollStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))({}, (0, $140e9897c3324bb3$export$987d49ffe1b0900f).above.xs, {
    height: "var(--modal-dialog-height)",
    maxHeight: "inherit"
}));
var $a9626b5b94821b47$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? "medium" : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $f48af1a2a78ceb0f$export$87d05f07e65211f1)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $e7ac342985c70600$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($eE0N6)))(autoFocus) === "object" ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($eE0N6)))(autoFocus) === "object");
    var _useOnMotionFinish = (0, $8920d1f3ad954d45$export$2e2bcd8739ae039)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $5cNek.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose
        };
    }, [
        testId,
        titleId,
        onClose
    ]);
    (0, $4ca18a2979a1967b$export$4a4bf067ea9e7886)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $dee11ed1545f920a$export$2e2bcd8739ae039), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $1e87ba318e6deea5$export$ab57792b9b6974a6).Provider, {
        value: modalDialogContext
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $1e87ba318e6deea5$export$dece24112a937f92).Provider, {
        value: shouldScrollInViewport
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $b25d251a06e9a859$export$2e2bcd8739ae039), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $bd2b8a986436e057$export$2e2bcd8739ae039), null, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("section", (0, (/*@__PURE__*/$parcel$interopDefault($39533520dac89738$exports)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $de516753a8010b90$export$2e2bcd8739ae039)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                "--modal-dialog-width": (0, $0564fddecf7a1deb$export$a3da89b899389ed8)(width),
                "--modal-dialog-height": (0, $0564fddecf7a1deb$export$ceba93bf0bdd16f2)(height)
            },
            css: [
                $a9626b5b94821b47$var$dialogStyles,
                shouldScrollInViewport ? $a9626b5b94821b47$var$viewportScrollStyles : $a9626b5b94821b47$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true
        }), children));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a9626b5b94821b47$export$2e2bcd8739ae039 = $a9626b5b94821b47$var$ModalDialog;



var $XLpyq = parcelRequire("XLpyq");

var $5cNek = parcelRequire("5cNek");

var $5cNek = parcelRequire("5cNek");
var $bb6effb22c45cdc6$var$uniqueReferencedValue = {};
function $bb6effb22c45cdc6$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $5cNek.useRef)($bb6effb22c45cdc6$var$uniqueReferencedValue);
    if (ref.current === $bb6effb22c45cdc6$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}


function $bec6f1ea4d6a8df5$export$2e2bcd8739ae039(callback) {
    var ref = (0, $bb6effb22c45cdc6$export$2e2bcd8739ae039)(function() {
        return callback;
    });
    return ref.current;
}



var $5cNek = parcelRequire("5cNek");
function $278278d3ed42b4db$export$2e2bcd8739ae039(value) {
    var ref = (0, $5cNek.useRef)();
    (0, $5cNek.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $XLpyq = parcelRequire("XLpyq");

var $5cNek = parcelRequire("5cNek");
function $f290d9aa13e58a2b$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $5cNek.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $5cNek.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}



/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $4e8271068da1e11a$var$modalStackRegister = [];
function $4e8271068da1e11a$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $b4a45d26229a164b$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $f290d9aa13e58a2b$export$2e2bcd8739ae039)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $278278d3ed42b4db$export$2e2bcd8739ae039)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $bec6f1ea4d6a8df5$export$2e2bcd8739ae039)(function() {
        var newStackIndex = $4e8271068da1e11a$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5cNek.useEffect)(function() {
        var currentStackIndex = $4e8271068da1e11a$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $4e8271068da1e11a$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $4e8271068da1e11a$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $4e8271068da1e11a$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5cNek.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $4e8271068da1e11a$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $4e8271068da1e11a$var$modalStackRegister.splice(currentStackIndex, 1);
                $4e8271068da1e11a$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $5cNek.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}



var $XLpyq = parcelRequire("XLpyq");

var $5cNek = parcelRequire("5cNek");

/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $b01b3315eeedf120$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $b01b3315eeedf120$export$2e2bcd8739ae039() {
    var _useState = (0, $5cNek.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $5cNek.useLayoutEffect)(function() {
        setScrollTopOffset($b01b3315eeedf120$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $5cNek.useCallback)(function() {
        if ($b01b3315eeedf120$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5cNek.useEffect)(function() {
        return (0, $99e42e712af0fd5c$exports.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}


var $6d5367bb84366e40$var$fillScreenStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: "var(--ds-space-0, 0)",
    left: "var(--ds-space-0, 0)",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
});
var $6d5367bb84366e40$var$whiteListElements = function whiteListElements(element) {
    // allows focus to reach elements outside the modal if they contain the data-atlas-extension attribute
    return !element.hasAttribute("data-atlas-extension");
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $6d5367bb84366e40$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, stackIndexOverride = props.stackIndex, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? (0, $ce0910c7994ac44a$export$2e2bcd8739ae039) : _props$onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $ce0910c7994ac44a$export$2e2bcd8739ae039) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $4e8271068da1e11a$export$2e2bcd8739ae039)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === "boolean" ? autoFocus : false;
    var onCloseHandler = (0, $4cede3b78eac3524$export$a4687b0234b40e28)({
        fn: onClose,
        action: "closed",
        componentName: "modalDialog",
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "12.7.0"
    });
    var onBlanketClicked = (0, $5cNek.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    (0, $b01b3315eeedf120$export$2e2bcd8739ae039)();
    var modalDialogWithBlanket = (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $1b26a6a151a85669$export$2e2bcd8739ae039), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $a9626b5b94821b47$export$2e2bcd8739ae039), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $a209631e79b9dcb1$export$a183686c3f6f4ea8), null, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $2383d2514acfdc75$export$2e2bcd8739ae039), {
        zIndex: (0, $ea1180a9039473b6$export$7be255094ccdc533).modal()
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $b25d251a06e9a859$export$2e2bcd8739ae039), null, function(fadeInProps) {
        return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", (0, (/*@__PURE__*/$parcel$interopDefault($39533520dac89738$exports)))({}, fadeInProps, {
            css: $6d5367bb84366e40$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $1ed44a3250f5123d$export$2e2bcd8739ae039), {
            autoFocus: autoFocusLock,
            disabled: !isForeground,
            returnFocus: true,
            whiteList: $6d5367bb84366e40$var$whiteListElements
        }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($d7b2b1cbabfff2e5$exports))), null), shouldScrollInViewport ? (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $d7b2b1cbabfff2e5$exports.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $6d5367bb84366e40$export$2e2bcd8739ae039 = $6d5367bb84366e40$var$ModalWrapper;

/** @jsx jsx */ parcelRequire("5cNek");



var $5cNek = parcelRequire("5cNek");

var $b5fcea49347fed8f$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $5cNek.useContext)((0, $1e87ba318e6deea5$export$ab57792b9b6974a6));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable – this component needs to be a child of ModalDialog.");
    return modalContext;
};



var $XLpyq = parcelRequire("XLpyq");

var $2FWxW = parcelRequire("2FWxW");

var $5cNek = parcelRequire("5cNek");


var $8e8cd390e9f2ad18$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $8e8cd390e9f2ad18$export$2e2bcd8739ae039 = $8e8cd390e9f2ad18$var$rafSchd;









var $5979f0eb99c57468$var$baseStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))({
    display: "inherit",
    margin: "var(--ds-space-0, 0px)",
    flex: "inherit",
    flexDirection: "inherit",
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto"
}, (0, $140e9897c3324bb3$export$987d49ffe1b0900f).above.xs, {
    height: "unset",
    overflowY: "auto"
}));
var $5979f0eb99c57468$var$topKeylineStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    borderTop: "".concat((0, $ed7126fc4c89f80a$export$4c317248f944c2a9), "px solid ").concat((0, $ed7126fc4c89f80a$export$d901150a4cc83165))
});
var $5979f0eb99c57468$var$bottomKeylineStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    borderBottom: "".concat((0, $ed7126fc4c89f80a$export$4c317248f944c2a9), "px solid ").concat((0, $ed7126fc4c89f80a$export$d901150a4cc83165))
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $5979f0eb99c57468$var$ScrollContainer = /*#__PURE__*/ (0, $5cNek.forwardRef)(function(props, ref) {
    var testId = props.testId, children = props.children;
    var _useStateRef = (0, $f290d9aa13e58a2b$export$2e2bcd8739ae039)({
        previous: false,
        next: false
    }), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useStateRef, 2), hasSiblings = _useStateRef2[0], setSiblings = _useStateRef2[1];
    var _useState = (0, $5cNek.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), showContentFocus = _useState2[0], setContentFocus = _useState2[1];
    var _useState3 = (0, $5cNek.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState3, 2), showTopKeyline = _useState4[0], setTopKeyline = _useState4[1];
    var _useState5 = (0, $5cNek.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState5, 2), showBottomKeyline = _useState6[0], setBottomKeyline = _useState6[1];
    var scrollableRef = (0, $5cNek.useRef)(null);
    var setLazySiblings = (0, $bec6f1ea4d6a8df5$export$2e2bcd8739ae039)(setSiblings);
    var setLazyContentFocus = (0, $bec6f1ea4d6a8df5$export$2e2bcd8739ae039)((0, $8e8cd390e9f2ad18$export$2e2bcd8739ae039)(function() {
        var target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    var setLazyKeylines = (0, $bec6f1ea4d6a8df5$export$2e2bcd8739ae039)((0, $8e8cd390e9f2ad18$export$2e2bcd8739ae039)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $ed7126fc4c89f80a$export$4c317248f944c2a9));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $ed7126fc4c89f80a$export$4c317248f944c2a9));
        }
    }));
    (0, $5cNek.useEffect)(function() {
        var target = scrollableRef.current;
        var unbindWindowEvent = (0, $99e42e712af0fd5c$exports.bind)(window, {
            type: "resize",
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $99e42e712af0fd5c$exports.bind)(target, {
            type: "scroll",
            listener: setLazyKeylines
        }) : (0, $ce0910c7994ac44a$export$2e2bcd8739ae039);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target === null || target === void 0 ? void 0 : target.previousElementSibling),
            next: Boolean(target === null || target === void 0 ? void 0 : target.nextElementSibling)
        });
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $bd2b8a986436e057$export$2e2bcd8739ae039), {
        isInset: true
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? "region" : undefined,
        "aria-label": showContentFocus ? "Scrollable content" : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $de516753a8010b90$export$2e2bcd8739ae039)([
            ref,
            scrollableRef
        ]),
        css: [
            $5979f0eb99c57468$var$baseStyles,
            showTopKeyline && $5979f0eb99c57468$var$topKeylineStyles,
            showBottomKeyline && $5979f0eb99c57468$var$bottomKeylineStyles
        ]
    }, children));
});
$5979f0eb99c57468$var$ScrollContainer.displayName = "ScrollContainer";
var $5979f0eb99c57468$export$2e2bcd8739ae039 = $5979f0eb99c57468$var$ScrollContainer;




var $5cNek = parcelRequire("5cNek");

function $9130c7b119ac65e2$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $5cNek.useContext)((0, $1e87ba318e6deea5$export$dece24112a937f92));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable – this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


var $262efd68e82332b1$var$bodyStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    /* This ensures the body fills the whole space between header and footer. */ flex: "1 1 auto"
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer.
 */ var $262efd68e82332b1$var$bodyScrollStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    padding: "".concat((0, $ed7126fc4c89f80a$export$4c317248f944c2a9), "px ").concat((0, $ed7126fc4c89f80a$export$6f98e8eaf0be1996), "px")
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $262efd68e82332b1$var$viewportScrollStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    padding: "0px ".concat((0, $ed7126fc4c89f80a$export$6f98e8eaf0be1996), "px")
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $262efd68e82332b1$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $b5fcea49347fed8f$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $9130c7b119ac65e2$export$2e2bcd8739ae039)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        css: [
            $262efd68e82332b1$var$bodyStyles,
            $262efd68e82332b1$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $d7b2b1cbabfff2e5$exports.TouchScrollable), null, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $5979f0eb99c57468$export$2e2bcd8739ae039), {
        testId: userDefinedTestId || modalTestId
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        css: [
            $262efd68e82332b1$var$bodyStyles,
            $262efd68e82332b1$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $262efd68e82332b1$export$2e2bcd8739ae039 = $262efd68e82332b1$var$ModalBody;

/** @jsx jsx */ parcelRequire("5cNek");



var $5f8549064b1f0c57$var$headerStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    display: "flex",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    padding: (0, $ed7126fc4c89f80a$export$6f98e8eaf0be1996),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    paddingBottom: "".concat((0, $ed7126fc4c89f80a$export$6f98e8eaf0be1996) - (0, $ed7126fc4c89f80a$export$4c317248f944c2a9), "px"),
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between"
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $5f8549064b1f0c57$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $b5fcea49347fed8f$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        css: $5f8549064b1f0c57$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $5f8549064b1f0c57$export$2e2bcd8739ae039 = $5f8549064b1f0c57$var$ModalHeader;

/** @jsx jsx */ 
var $c16170eedefbaacc$exports = {};
"use strict";
Object.defineProperty($c16170eedefbaacc$exports, "__esModule", {
    value: true
});
$c16170eedefbaacc$exports.default = void 0;

var $c16170eedefbaacc$var$_react = $c16170eedefbaacc$var$_interopRequireDefault((parcelRequire("5cNek")));


var $2FWxW = parcelRequire("2FWxW");

var $5cNek = parcelRequire("5cNek");


var $14de0fd9ca705d65$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $14de0fd9ca705d65$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $14de0fd9ca705d65$var$themedBackground[mode];
};


var $1c9b53be1150d86d$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $1c9b53be1150d86d$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $1c9b53be1150d86d$export$62ad7b0c781000e9 = {
    small: {
        width: $1c9b53be1150d86d$export$c647cb0ee6e282fe.small,
        height: $1c9b53be1150d86d$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $1c9b53be1150d86d$export$c647cb0ee6e282fe.medium,
        height: $1c9b53be1150d86d$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $1c9b53be1150d86d$export$c647cb0ee6e282fe.large,
        height: $1c9b53be1150d86d$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $1c9b53be1150d86d$export$c647cb0ee6e282fe.xlarge,
        height: $1c9b53be1150d86d$export$c647cb0ee6e282fe.xlarge
    }
};



var $3ce544facb216596$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $3ce544facb216596$var$smallStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, $1c9b53be1150d86d$export$62ad7b0c781000e9).small);
var $3ce544facb216596$var$mediumStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, $1c9b53be1150d86d$export$62ad7b0c781000e9).medium);
var $3ce544facb216596$var$largeStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, $1c9b53be1150d86d$export$62ad7b0c781000e9).large);
var $3ce544facb216596$var$xlargeStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, $1c9b53be1150d86d$export$62ad7b0c781000e9).xlarge);
var $3ce544facb216596$export$ef0ad74202575b64 = {
    small: $3ce544facb216596$var$smallStyles,
    medium: $3ce544facb216596$var$mediumStyles,
    large: $3ce544facb216596$var$largeStyles,
    xlarge: $3ce544facb216596$var$xlargeStyles
};
var $3ce544facb216596$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $1c9b53be1150d86d$export$62ad7b0c781000e9)[size];
    return undefined;
};


function $eb2121da32650b6d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eb2121da32650b6d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eb2121da32650b6d$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eb2121da32650b6d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $eb2121da32650b6d$var$iconStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $eb2121da32650b6d$var$_objectSpread($eb2121da32650b6d$var$_objectSpread({}, (0, $3ce544facb216596$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $eb2121da32650b6d$var$baseHcmStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $eb2121da32650b6d$var$primaryEqualsSecondaryHcmStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $eb2121da32650b6d$var$secondaryTransparentHcmStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $eb2121da32650b6d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5cNek.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $e5448515388bb91a$export$c8a8987d4410bf2d)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $3ce544facb216596$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $ab2a8332a3eacc83$export$7692396083754928)(), mode = _useGlobalTheme.mode;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", (0, (/*@__PURE__*/$parcel$interopDefault($39533520dac89738$exports)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $14de0fd9ca705d65$export$18cb9425622d4e06)(mode)
        }
    }, glyphProps, {
        css: [
            $eb2121da32650b6d$var$iconStyles,
            $eb2121da32650b6d$var$baseHcmStyles,
            primaryColor === secondaryColor && $eb2121da32650b6d$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $eb2121da32650b6d$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $e5448515388bb91a$export$dbf350e5966cf602)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $eb2121da32650b6d$export$2e2bcd8739ae039 = $eb2121da32650b6d$export$f04a61298a47a40f;


function $c16170eedefbaacc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c16170eedefbaacc$var$ErrorIcon = (props)=>/*#__PURE__*/ $c16170eedefbaacc$var$_react.default.createElement($eb2121da32650b6d$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$c16170eedefbaacc$var$ErrorIcon.displayName = "ErrorIcon";
var $c16170eedefbaacc$var$_default = $c16170eedefbaacc$var$ErrorIcon;
$c16170eedefbaacc$exports.default = $c16170eedefbaacc$var$_default;


var $90f20952c2382221$exports = {};
"use strict";
Object.defineProperty($90f20952c2382221$exports, "__esModule", {
    value: true
});
$90f20952c2382221$exports.default = void 0;

var $90f20952c2382221$var$_react = $90f20952c2382221$var$_interopRequireDefault((parcelRequire("5cNek")));

function $90f20952c2382221$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $90f20952c2382221$var$WarningIcon = (props)=>/*#__PURE__*/ $90f20952c2382221$var$_react.default.createElement($eb2121da32650b6d$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z" fill="currentColor"/><path d="M12 15a1 1 0 01-1-1V9a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$90f20952c2382221$var$WarningIcon.displayName = "WarningIcon";
var $90f20952c2382221$var$_default = $90f20952c2382221$var$WarningIcon;
$90f20952c2382221$exports.default = $90f20952c2382221$var$_default;




var $e2b7ea7cfe441535$var$fontSize = 20;
var $e2b7ea7cfe441535$var$lineHeight = 1;
var $e2b7ea7cfe441535$var$adjustedLineHeight = 1.2;
var $e2b7ea7cfe441535$var$titleStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    display: "flex",
    minWidth: 0,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    fontSize: "var(--ds-font-size-300, 20px)",
    fontStyle: "inherit",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: $e2b7ea7cfe441535$var$lineHeight
});
var $e2b7ea7cfe441535$var$textStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    minWidth: 0,
    /**
   * This ensures that the element fills the whole header space
   * and its content does not overflow (since flex items don't
   * shrink past its content size by default).
   */ flex: "1 1 auto",
    wordWrap: "break-word"
});
var $e2b7ea7cfe441535$var$iconStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    marginRight: "".concat((0, $ed7126fc4c89f80a$export$5e63d1b3b2849330), "px"),
    flex: "0 0 auto",
    alignSelf: "start"
});
/**
 * When the title is truncated (not multi-line), we adjust the
 * line height to avoid cropping the descenders. This removes
 * the extra spacing that we get from that adjustment.
 */ var $e2b7ea7cfe441535$var$lineHeightOffset = $e2b7ea7cfe441535$var$fontSize - $e2b7ea7cfe441535$var$fontSize * $e2b7ea7cfe441535$var$adjustedLineHeight;
var $e2b7ea7cfe441535$var$truncatedTextStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    // Use "clip" overflow to allow ellipses on x-axis without clipping descenders
    "@supports (overflow-x: clip)": {
        overflowX: "clip"
    },
    "@supports not (overflow-x: clip)": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview
        marginTop: "".concat($e2b7ea7cfe441535$var$lineHeightOffset / 2, "px"),
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview
        marginBottom: "".concat($e2b7ea7cfe441535$var$lineHeightOffset / 2, "px"),
        lineHeight: $e2b7ea7cfe441535$var$adjustedLineHeight,
        overflow: "hidden"
    }
});
var $e2b7ea7cfe441535$var$truncatedTextIconStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    "@supports not (overflow-x: clip)": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview
        marginBottom: "".concat($e2b7ea7cfe441535$var$lineHeightOffset / 2, "px"),
        lineHeight: 1.2
    }
});
var $e2b7ea7cfe441535$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance, isMultiline = _ref.isMultiline;
    var Icon = appearance === "danger" ? (0, (/*@__PURE__*/$parcel$interopDefault($c16170eedefbaacc$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($90f20952c2382221$exports)));
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", {
        css: [
            $e2b7ea7cfe441535$var$iconStyles,
            !isMultiline && $e2b7ea7cfe441535$var$truncatedTextIconStyles
        ]
    }, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)(Icon, {
        label: appearance,
        primaryColor: (0, $ed7126fc4c89f80a$export$3797a580396e3639)[appearance]
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $e2b7ea7cfe441535$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $b5fcea49347fed8f$export$33ffd74ebf07f060)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("h1", {
        css: $e2b7ea7cfe441535$var$titleStyles,
        "data-testid": testId
    }, appearance && (0, $e5448515388bb91a$export$c8a8987d4410bf2d)($e2b7ea7cfe441535$var$TitleIcon, {
        appearance: appearance,
        isMultiline: isMultiline
    }), (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", {
        id: titleId,
        css: [
            $e2b7ea7cfe441535$var$textStyles,
            !isMultiline && $e2b7ea7cfe441535$var$truncatedTextStyles
        ],
        "data-testid": testId && "".concat(testId, "-text")
    }, children));
};
var $e2b7ea7cfe441535$export$2e2bcd8739ae039 = $e2b7ea7cfe441535$var$ModalTitle;



var $5cNek = parcelRequire("5cNek");

var $2FWxW = parcelRequire("2FWxW");
var $8b90745a772ac2e0$exports = {};
var $a01bd44c3b3e6529$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $a01bd44c3b3e6529$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($a01bd44c3b3e6529$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $a01bd44c3b3e6529$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $a01bd44c3b3e6529$exports = function whatwgRNG() {
        $a01bd44c3b3e6529$var$getRandomValues($a01bd44c3b3e6529$var$rnds8);
        return $a01bd44c3b3e6529$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $a01bd44c3b3e6529$var$rnds = new Array(16);
    $a01bd44c3b3e6529$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $a01bd44c3b3e6529$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $a01bd44c3b3e6529$var$rnds;
    };
}


var $0561a13ed15d92e5$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $0561a13ed15d92e5$var$byteToHex = [];
for(var $0561a13ed15d92e5$var$i = 0; $0561a13ed15d92e5$var$i < 256; ++$0561a13ed15d92e5$var$i)$0561a13ed15d92e5$var$byteToHex[$0561a13ed15d92e5$var$i] = ($0561a13ed15d92e5$var$i + 0x100).toString(16).substr(1);
function $0561a13ed15d92e5$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $0561a13ed15d92e5$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
$0561a13ed15d92e5$exports = $0561a13ed15d92e5$var$bytesToUuid;


function $8b90745a772ac2e0$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $a01bd44c3b3e6529$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $0561a13ed15d92e5$exports(rnds);
}
$8b90745a772ac2e0$exports = $8b90745a772ac2e0$var$v4;


// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $09fd4c2dd73520bc$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $09fd4c2dd73520bc$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $09fd4c2dd73520bc$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $09fd4c2dd73520bc$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $09fd4c2dd73520bc$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $09fd4c2dd73520bc$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["HALP"] = "halp";
    return userType;
}({});
let $09fd4c2dd73520bc$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $09fd4c2dd73520bc$export$809831be6c4c6227 = Object.freeze([
    $09fd4c2dd73520bc$export$6b4f396210e539f3.DESKTOP,
    $09fd4c2dd73520bc$export$6b4f396210e539f3.MAC,
    $09fd4c2dd73520bc$export$6b4f396210e539f3.LINUX,
    $09fd4c2dd73520bc$export$6b4f396210e539f3.WINDOWS
]);
const $09fd4c2dd73520bc$export$19c579398ad213e7 = Object.freeze([
    $09fd4c2dd73520bc$export$6b4f396210e539f3.WEB,
    $09fd4c2dd73520bc$export$6b4f396210e539f3.MOBILE_WEB
]);
let $09fd4c2dd73520bc$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $09fd4c2dd73520bc$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $09fd4c2dd73520bc$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $09fd4c2dd73520bc$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});



var $2FWxW = parcelRequire("2FWxW");


var $2FWxW = parcelRequire("2FWxW");
class $86bbdfebbcda0876$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document.hidden !== "undefined") {
            // Opera 12.10 and Firefox 18 and later support
            this._isHidden = document.hidden;
            this._hidden = "hidden";
            this._visibilityChange = "visibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            this._isHidden = document.msHidden;
            this._hidden = "msHidden";
            this._visibilityChange = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            this._isHidden = document.webkitHidden;
            this._hidden = "webkitHidden";
            this._visibilityChange = "webkitvisibilitychange";
        }
        if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
    }
    addCallback(name, fn) {
        if (typeof name !== "string") throw new Error("Invalid name, must be string");
        if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}


class $9974581ee427c237$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}


function $71beb36867b76582$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71beb36867b76582$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71beb36867b76582$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71beb36867b76582$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $71beb36867b76582$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $71beb36867b76582$var$_objectSpread($71beb36867b76582$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $09fd4c2dd73520bc$export$99b37380a464d794).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $09fd4c2dd73520bc$export$99b37380a464d794).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $09fd4c2dd73520bc$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $09fd4c2dd73520bc$export$26b9f946b448f23e)((0, $09fd4c2dd73520bc$export$99b37380a464d794), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $09fd4c2dd73520bc$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $71beb36867b76582$var$_objectSpread($71beb36867b76582$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $86bbdfebbcda0876$export$2e2bcd8739ae039))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $9974581ee427c237$export$2e2bcd8739ae039)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($71beb36867b76582$var$_objectSpread($71beb36867b76582$var$_objectSpread($71beb36867b76582$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            this._isActiveEvents.forEach((value, key)=>this._isActiveEvents.set(key, false));
        }
    }
}


/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $430fb5e1730444aa$var$isFunction = (possibleFn)=>typeof possibleFn === "function";
var $430fb5e1730444aa$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($430fb5e1730444aa$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};



var $2FWxW = parcelRequire("2FWxW");

// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $dd2c5acb95e32cec$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $dd2c5acb95e32cec$var$isObjectObject(o) {
    return $dd2c5acb95e32cec$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $dd2c5acb95e32cec$export$53b83ca8eaab0383(o) {
    if ($dd2c5acb95e32cec$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($dd2c5acb95e32cec$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}


function $980e6b4e898a3f9e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $980e6b4e898a3f9e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $980e6b4e898a3f9e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $980e6b4e898a3f9e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $980e6b4e898a3f9e$var$libraryVersion = "4.17.0";
function $980e6b4e898a3f9e$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $980e6b4e898a3f9e$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $980e6b4e898a3f9e$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $980e6b4e898a3f9e$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $980e6b4e898a3f9e$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $980e6b4e898a3f9e$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $980e6b4e898a3f9e$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $980e6b4e898a3f9e$var$getProductField(productInfo.env, overrides.env);
    const product = $980e6b4e898a3f9e$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $980e6b4e898a3f9e$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $980e6b4e898a3f9e$var$getProductField(productInfo.version, overrides.version);
    const origin = $980e6b4e898a3f9e$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $980e6b4e898a3f9e$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $980e6b4e898a3f9e$var$isNotEmptyObject(obj) {
    return (0, $dd2c5acb95e32cec$export$53b83ca8eaab0383)(obj) && Object.keys(obj).length > 0;
}
function $980e6b4e898a3f9e$var$buildAttributesWithName(name, attrObject) {
    return $980e6b4e898a3f9e$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $980e6b4e898a3f9e$var$buildAttributes(attributes) {
    return $980e6b4e898a3f9e$var$buildAttributesWithName("attributes", attributes);
}
function $980e6b4e898a3f9e$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $980e6b4e898a3f9e$export$f045f238d77c002a(containers) {
    if ($980e6b4e898a3f9e$var$isNotEmptyObject(containers)) {
        const validContainers = $980e6b4e898a3f9e$export$3f5115a568819c1a(containers);
        return $980e6b4e898a3f9e$var$buildAttributesWithName("containers", validContainers);
    }
    return undefined;
}
function $980e6b4e898a3f9e$export$655ecf7241feac42(event, actionEventType) {
    return $980e6b4e898a3f9e$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $980e6b4e898a3f9e$export$f045f238d77c002a(event.containers));
}
function $980e6b4e898a3f9e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $980e6b4e898a3f9e$var$buildAttributesWithName("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $980e6b4e898a3f9e$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers) {
    const productFields = $980e6b4e898a3f9e$var$buildProductFields(productInfo);
    const tenantFields = $980e6b4e898a3f9e$var$buildTenantFields(tenantInfo);
    const userFields = $980e6b4e898a3f9e$var$buildUserFields(userInfo);
    const orgFields = $980e6b4e898a3f9e$var$buildOrgFields(orgInfo);
    const workspaceFields = $980e6b4e898a3f9e$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $09fd4c2dd73520bc$export$4c045e605d532c98).SCREEN
    };
    return $980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $980e6b4e898a3f9e$var$buildAttributes(attributes)), $980e6b4e898a3f9e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $980e6b4e898a3f9e$export$f045f238d77c002a(containers)), $980e6b4e898a3f9e$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields);
}
function $980e6b4e898a3f9e$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
function $980e6b4e898a3f9e$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $980e6b4e898a3f9e$var$libraryVersion
            }
        }
    };
}
function $980e6b4e898a3f9e$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $980e6b4e898a3f9e$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo) {
    const productFields = $980e6b4e898a3f9e$var$buildProductFields(productInfo, $980e6b4e898a3f9e$export$e3d99b4bfec06f6e(event));
    const tenantFields = $980e6b4e898a3f9e$var$buildTenantFields(tenantInfo);
    const orgFields = $980e6b4e898a3f9e$var$buildOrgFields(orgInfo);
    const workspaceFields = $980e6b4e898a3f9e$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $980e6b4e898a3f9e$var$buildUserFields(userInfo);
    const actionFields = $980e6b4e898a3f9e$export$655ecf7241feac42(event, actionEventType);
    return $980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread($980e6b4e898a3f9e$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $980e6b4e898a3f9e$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields);
}



var $2FWxW = parcelRequire("2FWxW");
const $adcc83eb859a9f32$export$cf090d5281b5ae06 = 10000;
const $adcc83eb859a9f32$export$8575e30be0feb909 = 30000;



var $2FWxW = parcelRequire("2FWxW");

/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $41eb7051cb2eb15f$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $41eb7051cb2eb15f$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $41eb7051cb2eb15f$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $41eb7051cb2eb15f$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $41eb7051cb2eb15f$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $41eb7051cb2eb15f$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$41eb7051cb2eb15f$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $41eb7051cb2eb15f$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);



var $2FWxW = parcelRequire("2FWxW");



var $2FWxW = parcelRequire("2FWxW");


const $f3dbcba1e548e0e2$var$actionEventTypes = Object.freeze([
    (0, $09fd4c2dd73520bc$export$4c045e605d532c98).OPERATIONAL,
    (0, $09fd4c2dd73520bc$export$4c045e605d532c98).TRACK,
    (0, $09fd4c2dd73520bc$export$4c045e605d532c98).UI
]);
function $f3dbcba1e548e0e2$export$df8ff30e3c960006(container) {
    if (!(0, $dd2c5acb95e32cec$export$53b83ca8eaab0383)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}
function $f3dbcba1e548e0e2$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach((container)=>$f3dbcba1e548e0e2$export$df8ff30e3c960006(container));
}
function $f3dbcba1e548e0e2$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $09fd4c2dd73520bc$export$4c045e605d532c98).OPERATIONAL:
        case (0, $09fd4c2dd73520bc$export$4c045e605d532c98).TRACK:
        case (0, $09fd4c2dd73520bc$export$4c045e605d532c98).UI:
            return true;
        default:
            return false;
    }
}
function $f3dbcba1e548e0e2$export$4a8d7476662aebcc(type) {
    if (!$f3dbcba1e548e0e2$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$f3dbcba1e548e0e2$var$actionEventTypes}]`);
    return true;
}
function $f3dbcba1e548e0e2$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    $f3dbcba1e548e0e2$export$e63ea5d8477971d3(event.containers);
}
function $f3dbcba1e548e0e2$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}
function $f3dbcba1e548e0e2$export$8c014fd74b0c8b99(event) {
    $f3dbcba1e548e0e2$export$e0c121325c66ed4c(event);
}
function $f3dbcba1e548e0e2$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}
function $f3dbcba1e548e0e2$export$e5bac0930c812e90(event) {
    $f3dbcba1e548e0e2$export$e0c121325c66ed4c(event);
}
function $f3dbcba1e548e0e2$export$1e561554275607ef(event) {
    $f3dbcba1e548e0e2$export$e0c121325c66ed4c(event);
}
function $f3dbcba1e548e0e2$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $09fd4c2dd73520bc$export$26b9f946b448f23e)((0, $09fd4c2dd73520bc$export$1827adfd178b4870), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $09fd4c2dd73520bc$export$ad1854f4a08c15f8)((0, $09fd4c2dd73520bc$export$1827adfd178b4870))}]`);
}
function $f3dbcba1e548e0e2$export$801b46c35394d316(productInfo) {
    if (!(0, $09fd4c2dd73520bc$export$26b9f946b448f23e)((0, $09fd4c2dd73520bc$export$6b4f396210e539f3), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $09fd4c2dd73520bc$export$ad1854f4a08c15f8)((0, $09fd4c2dd73520bc$export$6b4f396210e539f3))}]`);
    if (productInfo.origin === (0, $09fd4c2dd73520bc$export$f73e9fcd368bb695).DESKTOP && !(0, $09fd4c2dd73520bc$export$26b9f946b448f23e)((0, $09fd4c2dd73520bc$export$809831be6c4c6227), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $09fd4c2dd73520bc$export$f73e9fcd368bb695).WEB && !(0, $09fd4c2dd73520bc$export$26b9f946b448f23e)((0, $09fd4c2dd73520bc$export$19c579398ad213e7), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}



class $8cb8e45bff029653$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $f3dbcba1e548e0e2$export$d19cebda16f7579a)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $41eb7051cb2eb15f$export$b29f828819edca8d)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error("No events were returned from the compression function");
            compressedEvents.forEach((event)=>{
                (0, $f3dbcba1e548e0e2$export$4a8d7476662aebcc)(event.eventType);
                (0, $f3dbcba1e548e0e2$export$e0c121325c66ed4c)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
        if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}


function $ca5941a8c3655dba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ca5941a8c3655dba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ca5941a8c3655dba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ca5941a8c3655dba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $ca5941a8c3655dba$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $980e6b4e898a3f9e$export$655ecf7241feac42)(event, event.eventType);
                    contextFields = (0, $41eb7051cb2eb15f$export$30a06c8d3562193f)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $41eb7051cb2eb15f$export$e9bab7fafb253603)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$ca5941a8c3655dba$var$_objectSpread($ca5941a8c3655dba$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
        if (!compressionRules.every((rule)=>rule instanceof (0, $8cb8e45bff029653$export$89b3253ddfd2e6e8))) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
        this.compressionRules = compressionRules;
    }
}


// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $3471ee72dc483265$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $3471ee72dc483265$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $3471ee72dc483265$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Failed to perform compression on the delayed analytics events. " + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $3471ee72dc483265$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $3471ee72dc483265$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $41eb7051cb2eb15f$export$b29f828819edca8d)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $41eb7051cb2eb15f$export$e9bab7fafb253603)(group.userInfo, args.userInfo) && (0, $41eb7051cb2eb15f$export$e9bab7fafb253603)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $980e6b4e898a3f9e$export$9c5623a792efc9b0)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $ca5941a8c3655dba$export$2e2bcd8739ae039)(compressionRules);
    }
}


let $5d3c41c1222efe73$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});


class $b795e656b0e8c8a1$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "startLowPriorityEventDelay", (timeout = (0, $adcc83eb859a9f32$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $adcc83eb859a9f32$export$8575e30be0feb909)) : (0, $adcc83eb859a9f32$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $5d3c41c1222efe73$export$fa6e3729c21cb8f).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "stopLowPriorityEventDelay", (reason = (0, $5d3c41c1222efe73$export$fa6e3729c21cb8f).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $3471ee72dc483265$export$2e2bcd8739ae039)(fireDelayedEvent, compressors);
    }
}




var $2FWxW = parcelRequire("2FWxW");


var $2FWxW = parcelRequire("2FWxW");
let $2b3d7a34fd267bda$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $2b3d7a34fd267bda$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});



const $93fbf5ca1f44ec30$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).ACK]: `${queuePrefix}.${queueId}.${(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).ACK}`,
        [(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).QUEUE]: `${queuePrefix}.${queueId}.${(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).QUEUE}`,
        [(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).IN_PROGRESS}`,
        [(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).RECLAIM_START}`,
        [(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).RECLAIM_END}`
    });


// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $88dae63a30a0e6f0$var$validSuffixs = Object.values((0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241));
var $88dae63a30a0e6f0$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split(".")).filter((splitKeys)=>splitKeys.length === 3 && $88dae63a30a0e6f0$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $93fbf5ca1f44ec30$export$8433d54f767cbec5)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};


var $2FWxW = parcelRequire("2FWxW");



function $9bf52fbb64dde9f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9bf52fbb64dde9f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9bf52fbb64dde9f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9bf52fbb64dde9f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $9bf52fbb64dde9f4$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $9bf52fbb64dde9f4$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split(".")).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $2b3d7a34fd267bda$export$ecfa71cbc9b28241).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $2b3d7a34fd267bda$export$8bb2c1fb2b1765a9).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $9bf52fbb64dde9f4$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $9bf52fbb64dde9f4$var$promisedSetTimeout((0, $2b3d7a34fd267bda$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2b3d7a34fd267bda$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $9bf52fbb64dde9f4$var$promisedSetTimeout((0, $2b3d7a34fd267bda$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2b3d7a34fd267bda$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
    return $9bf52fbb64dde9f4$var$reclaim(options, callback);
};
const $9bf52fbb64dde9f4$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || "{}");
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $9bf52fbb64dde9f4$var$_objectSpread($9bf52fbb64dde9f4$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === "successful") $9bf52fbb64dde9f4$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === "partial") {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $9bf52fbb64dde9f4$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $9bf52fbb64dde9f4$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $9bf52fbb64dde9f4$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($8b90745a772ac2e0$exports)))();
    const queuesToReclaim = $9bf52fbb64dde9f4$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$9bf52fbb64dde9f4$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $93fbf5ca1f44ec30$export$8433d54f767cbec5)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === "rejected");
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === "fulfilled").map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};


const $ec208f630f5a9354$export$a409c8de90e11e14 = "CallbackProcessingError";
class $ec208f630f5a9354$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        const messageFromString = typeof error === "string" && error;
        const message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $ec208f630f5a9354$export$2e2bcd8739ae039.prototype);
        this.name = $ec208f630f5a9354$export$a409c8de90e11e14;
    }
}

const $25bcef8fc8be8821$export$d21fbb25eb37b5bf = "namespace-timeAdded";
const $25bcef8fc8be8821$export$8cad224051643259 = "analytics-web-client";
const $25bcef8fc8be8821$export$3d8420be07b276ab = "analytics-resilience";
const $25bcef8fc8be8821$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
const $25bcef8fc8be8821$export$89d9c1ff8ac91862 = "timeAdded";
const $25bcef8fc8be8821$export$a37d385bcd713809 = "retryAttempts";
const $25bcef8fc8be8821$export$6d8635fed0e4b14d = 15000;
let $25bcef8fc8be8821$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $25bcef8fc8be8821$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});


const $e676d3de8cfa2f69$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
class $e676d3de8cfa2f69$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super("window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $e676d3de8cfa2f69$export$2e2bcd8739ae039.prototype);
        this.name = $e676d3de8cfa2f69$export$fc14cf6dcea0f8ed;
    }
}

const $e42bedbeb36b7d5b$export$ba95206613c96b28 = "AbandonWriteError";
class $e42bedbeb36b7d5b$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $e42bedbeb36b7d5b$export$2e2bcd8739ae039.prototype);
        this.name = $e42bedbeb36b7d5b$export$ba95206613c96b28;
    }
}



const $4f7d8f5801742118$export$7e7aee9a953465ec = "InvalidPolicyError";
class $4f7d8f5801742118$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $4f7d8f5801742118$export$7e7aee9a953465ec;
    }
}


const $f40f813d687db56a$export$74101021e0969375 = (error)=>{
    if (error && typeof error === "object" && "name" in error) {
        const errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $e42bedbeb36b7d5b$export$ba95206613c96b28) || errorWithName.name === (0, $ec208f630f5a9354$export$a409c8de90e11e14) || errorWithName.name === (0, $4f7d8f5801742118$export$7e7aee9a953465ec));
    }
    return false;
};




var $2FWxW = parcelRequire("2FWxW");

const $50505b98e8b83602$export$b6df3d334cec060f = 7;
const $50505b98e8b83602$export$14ef152a03a4b6ee = 60000;
const $50505b98e8b83602$export$da9ab7b2fd5998e8 = 10;
const $50505b98e8b83602$export$1188664dfff364c8 = 5000;




var $2FWxW = parcelRequire("2FWxW");




const $68c998f404bcc5c7$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($8b90745a772ac2e0$exports)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $68c998f404bcc5c7$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $50505b98e8b83602$export$da9ab7b2fd5998e8),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $50505b98e8b83602$export$1188664dfff364c8)
    });
const $68c998f404bcc5c7$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $68c998f404bcc5c7$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $68c998f404bcc5c7$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return $68c998f404bcc5c7$export$2a5213bce1720b42(transaction);
};
const $68c998f404bcc5c7$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn("Error thrown from request:", event);
    };
};


class $0c7c0eada940b6a7$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $25bcef8fc8be8821$export$d21fbb25eb37b5bf));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $68c998f404bcc5c7$export$85ceed0783e42041)(getAllRequest);
            const result = event === null || event === void 0 ? void 0 : (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $25bcef8fc8be8821$export$7710d69e6f450f20).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $25bcef8fc8be8821$export$7710d69e6f450f20).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $68c998f404bcc5c7$export$85ceed0783e42041)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $68c998f404bcc5c7$export$feab8418f018df89)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $e42bedbeb36b7d5b$export$2e2bcd8739ae039)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $25bcef8fc8be8821$export$d21fbb25eb37b5bf));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $68c998f404bcc5c7$export$85ceed0783e42041)(request);
        return event.target.result;
    }
}



const $9a381be4bdaa3d0b$var$_excluded = [
    "item"
], $9a381be4bdaa3d0b$var$_excluded2 = [
    "items"
];
function $9a381be4bdaa3d0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a381be4bdaa3d0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a381be4bdaa3d0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a381be4bdaa3d0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $9a381be4bdaa3d0b$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                window.setTimeout(()=>{
                    this.logger.warn("IndexedDB timed out.");
                    reject(new (0, $e676d3de8cfa2f69$export$2e2bcd8739ae039)());
                }, (0, $25bcef8fc8be8821$export$6d8635fed0e4b14d));
                /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $25bcef8fc8be8821$export$8cad224051643259), 1);
                request.onupgradeneeded = (event)=>{
                    if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                    const db = request.result;
                    const store = db.createObjectStore((0, $25bcef8fc8be8821$export$3d8420be07b276ab), {
                        keyPath: "id"
                    });
                    store.createIndex((0, $25bcef8fc8be8821$export$a512a65455fce2a6), (0, $25bcef8fc8be8821$export$a512a65455fce2a6), {
                        unique: false
                    });
                    store.createIndex((0, $25bcef8fc8be8821$export$a37d385bcd713809), (0, $25bcef8fc8be8821$export$a37d385bcd713809), {
                        unique: false
                    });
                    store.createIndex((0, $25bcef8fc8be8821$export$89d9c1ff8ac91862), (0, $25bcef8fc8be8821$export$89d9c1ff8ac91862), {
                        unique: false
                    });
                    // Compound key index of product - timeAdded.
                    store.createIndex((0, $25bcef8fc8be8821$export$d21fbb25eb37b5bf), [
                        "namespace",
                        "timeAdded"
                    ], {
                        unique: false
                    });
                };
                try {
                    await (0, $68c998f404bcc5c7$export$85ceed0783e42041)(request);
                    return resolve(request.result);
                } catch (error) {
                    this.logger.warn("IndexedDB failed to initialise.", error);
                    reject(new (0, $e676d3de8cfa2f69$export$2e2bcd8739ae039)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "addItem", async (item, options = {}, policy = (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $68c998f404bcc5c7$export$aec476f33d77be11)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            if (policy === (0, $25bcef8fc8be8821$export$7710d69e6f450f20).IGNORE) throw new (0, $4f7d8f5801742118$export$2e2bcd8739ae039)(policy, "IndexedDbConnector#addItem");
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $f40f813d687db56a$export$74101021e0969375)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "bulkAddItem", async (itemOptions, policy = (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($8733b61bde91fa4a$exports)))(_ref, $9a381be4bdaa3d0b$var$_excluded);
                return (0, $68c998f404bcc5c7$export$aec476f33d77be11)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $f40f813d687db56a$export$74101021e0969375)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getItems", async (count = (0, $50505b98e8b83602$export$b6df3d334cec060f))=>{
            const fixedCount = count > 0 ? count : (0, $50505b98e8b83602$export$b6df3d334cec060f);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            const timeIndex = objectStore.index((0, $25bcef8fc8be8821$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error("Failed to open cursor:", error);
                    reject("Failed to open cursor");
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $9a381be4bdaa3d0b$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $50505b98e8b83602$export$14ef152a03a4b6ee);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $68c998f404bcc5c7$export$342d941b6f724995)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $68c998f404bcc5c7$export$342d941b6f724995)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $68c998f404bcc5c7$export$feab8418f018df89)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $68c998f404bcc5c7$export$feab8418f018df89)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readonly");
            const timeIndex = objectStore.index((0, $25bcef8fc8be8821$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $68c998f404bcc5c7$export$85ceed0783e42041)(request);
            await (0, $68c998f404bcc5c7$export$feab8418f018df89)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "processItems", async (processFn, count = (0, $50505b98e8b83602$export$b6df3d334cec060f))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($8733b61bde91fa4a$exports)))(_await$this$getItems, $9a381be4bdaa3d0b$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $ec208f630f5a9354$export$2e2bcd8739ae039)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $68c998f404bcc5c7$export$85ceed0783e42041)(objectStore.delete(id));
            } catch (error) {
                logger.error("Failed to delete item:", id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $25bcef8fc8be8821$export$3d8420be07b276ab), mode);
            const objectStore = transaction.objectStore((0, $25bcef8fc8be8821$export$3d8420be07b276ab));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $68c998f404bcc5c7$export$ddc6718318090f71)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $e676d3de8cfa2f69$export$2e2bcd8739ae039)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $0c7c0eada940b6a7$export$2e2bcd8739ae039)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $25bcef8fc8be8821$export$39337ab5872e9457).INDEXEDDB;
    }
}



var $2FWxW = parcelRequire("2FWxW");





var $2FWxW = parcelRequire("2FWxW");


class $2dc732663bd86a00$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $25bcef8fc8be8821$export$7710d69e6f450f20).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $25bcef8fc8be8821$export$7710d69e6f450f20).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $e42bedbeb36b7d5b$export$2e2bcd8739ae039)((0, $25bcef8fc8be8821$export$39337ab5872e9457).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}



const $aa9c609cf9d0344a$var$_excluded = [
    "item"
], $aa9c609cf9d0344a$var$_excluded2 = [
    "items"
];
function $aa9c609cf9d0344a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa9c609cf9d0344a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa9c609cf9d0344a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa9c609cf9d0344a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $aa9c609cf9d0344a$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $68c998f404bcc5c7$export$ddc6718318090f71)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $2dc732663bd86a00$export$2e2bcd8739ae039)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON) {
        if (policy === (0, $25bcef8fc8be8821$export$7710d69e6f450f20).IGNORE) throw new (0, $4f7d8f5801742118$export$2e2bcd8739ae039)(policy, "IndexedDbConnector#addItem");
        const storedValue = (0, $68c998f404bcc5c7$export$aec476f33d77be11)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($8733b61bde91fa4a$exports)))(_ref, $aa9c609cf9d0344a$var$_excluded);
            return (0, $68c998f404bcc5c7$export$aec476f33d77be11)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $50505b98e8b83602$export$b6df3d334cec060f)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $50505b98e8b83602$export$b6df3d334cec060f)) {
        const fixedCount = count > 0 ? count : (0, $50505b98e8b83602$export$b6df3d334cec060f);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($aa9c609cf9d0344a$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $50505b98e8b83602$export$14ef152a03a4b6ee);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($8733b61bde91fa4a$exports)))(_this$synchronousGetI, $aa9c609cf9d0344a$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $ec208f630f5a9354$export$2e2bcd8739ae039)(error);
        }
    }
    storeType() {
        return (0, $25bcef8fc8be8821$export$39337ab5872e9457).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}



class $d381f44834988aac$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $68c998f404bcc5c7$export$ddc6718318090f71)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $9a381be4bdaa3d0b$export$2e2bcd8739ae039)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $e676d3de8cfa2f69$export$2e2bcd8739ae039))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
            }
        }
        return new (0, $aa9c609cf9d0344a$export$2e2bcd8739ae039)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $25bcef8fc8be8821$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $f40f813d687db56a$export$74101021e0969375)(error)) throw error;
            else if (this.resilience.storeType() === (0, $25bcef8fc8be8821$export$39337ab5872e9457).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $aa9c609cf9d0344a$export$2e2bcd8739ae039)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $25bcef8fc8be8821$export$7710d69e6f450f20).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
        // Dont need to catch. We are just getting events if we can
        }
    }
}




var $b07c9dc78077ead8$export$2e2bcd8739ae039 = (0, $d381f44834988aac$export$2e2bcd8739ae039);



var $2FWxW = parcelRequire("2FWxW");
let $a6eb6e4e32229583$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $a6eb6e4e32229583$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});


class $949f607490dc2fd5$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "resilienceMechanism", (0, $a6eb6e4e32229583$export$c75161629e3ec34e).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $949f607490dc2fd5$var$cachedMetricsClient = null;
var $949f607490dc2fd5$export$2e2bcd8739ae039 = ()=>{
    if (!$949f607490dc2fd5$var$cachedMetricsClient) $949f607490dc2fd5$var$cachedMetricsClient = new $949f607490dc2fd5$export$4b62ee5120ab50a8();
    return $949f607490dc2fd5$var$cachedMetricsClient;
};



class $244ccf0fda045d23$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        window.addEventListener("offline", ()=>networkChangeCallback((0, $a6eb6e4e32229583$export$ee138fa712d11b84).OFFLINE));
        window.addEventListener("online", ()=>networkChangeCallback((0, $a6eb6e4e32229583$export$ee138fa712d11b84).ONLINE));
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $a6eb6e4e32229583$export$ee138fa712d11b84).ONLINE;
        return (0, $a6eb6e4e32229583$export$ee138fa712d11b84).OFFLINE;
    }
}



var $2FWxW = parcelRequire("2FWxW");

var $2FWxW = parcelRequire("2FWxW");
let $f66676318aa7aa3a$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $f66676318aa7aa3a$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $f66676318aa7aa3a$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "callbackStatus", $f66676318aa7aa3a$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $f66676318aa7aa3a$export$ef3353088fca369c.IDLE:
            case $f66676318aa7aa3a$export$ef3353088fca369c.TIMED_OUT:
            case $f66676318aa7aa3a$export$ef3353088fca369c.COMPLETED:
                if (event === $f66676318aa7aa3a$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $f66676318aa7aa3a$export$ef3353088fca369c.RUNNING;
                break;
            case $f66676318aa7aa3a$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $f66676318aa7aa3a$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $f66676318aa7aa3a$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $f66676318aa7aa3a$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $f66676318aa7aa3a$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        this.transitionCallbackStatus(this.callbackStatus, $f66676318aa7aa3a$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $f66676318aa7aa3a$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $f66676318aa7aa3a$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $f66676318aa7aa3a$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}


// Clients can optionally provide the callbackTimeoutPeriod parameter
let $8ad5b0df8bf4dc74$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});


const $b231b85fefc9b013$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $b231b85fefc9b013$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $b231b85fefc9b013$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $b231b85fefc9b013$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $b231b85fefc9b013$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $b231b85fefc9b013$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $b231b85fefc9b013$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clearTimeout", ()=>{
            if (this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $8ad5b0df8bf4dc74$export$f93c40fda808dd0c).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $8ad5b0df8bf4dc74$export$f93c40fda808dd0c).ERROR || this.callbackTimer.getCallbackStatus() === (0, $f66676318aa7aa3a$export$ef3353088fca369c).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $8ad5b0df8bf4dc74$export$f93c40fda808dd0c).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $b231b85fefc9b013$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $b231b85fefc9b013$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $b231b85fefc9b013$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $b231b85fefc9b013$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $b231b85fefc9b013$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $b231b85fefc9b013$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $b231b85fefc9b013$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $b231b85fefc9b013$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $b231b85fefc9b013$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $b231b85fefc9b013$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $f66676318aa7aa3a$export$590a718599f8f8b3)(this.options.callbackTimeoutPeriod);
    }
}



function $188163171d093f3d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $188163171d093f3d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $188163171d093f3d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $188163171d093f3d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $188163171d093f3d$var$ONE_MINUTE = 60000;
const $188163171d093f3d$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $188163171d093f3d$var$ONE_MINUTE,
    minRetryDelay: $188163171d093f3d$var$ONE_MINUTE,
    maxRetryDelay: $188163171d093f3d$var$ONE_MINUTE
};
const $188163171d093f3d$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $188163171d093f3d$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $b07c9dc78077ead8$export$2e2bcd8739ae039)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $b231b85fefc9b013$export$2e2bcd8739ae039)($188163171d093f3d$var$_objectSpread($188163171d093f3d$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $b231b85fefc9b013$export$2e2bcd8739ae039)($188163171d093f3d$var$_objectSpread($188163171d093f3d$var$_objectSpread({}, $188163171d093f3d$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $188163171d093f3d$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $949f607490dc2fd5$export$2e2bcd8739ae039)();
        this.networkStatus = new (0, $244ccf0fda045d23$export$2e2bcd8739ae039)((status)=>{
            if (status === (0, $a6eb6e4e32229583$export$ee138fa712d11b84).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $25bcef8fc8be8821$export$7710d69e6f450f20).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $a6eb6e4e32229583$export$ee138fa712d11b84).OFFLINE) {
            done((0, $8ad5b0df8bf4dc74$export$f93c40fda808dd0c).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $ec208f630f5a9354$export$a409c8de90e11e14)) {
                done((0, $8ad5b0df8bf4dc74$export$f93c40fda808dd0c).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $88dae63a30a0e6f0$export$2e2bcd8739ae039)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $9bf52fbb64dde9f4$export$2e2bcd8739ae039)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $25bcef8fc8be8821$export$7710d69e6f450f20).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: "successful"
            };
            else return {
                status: "partial",
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $8ad5b0df8bf4dc74$export$f93c40fda808dd0c).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $8ad5b0df8bf4dc74$export$f93c40fda808dd0c).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $8ad5b0df8bf4dc74$export$f93c40fda808dd0c).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $188163171d093f3d$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $188163171d093f3d$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $188163171d093f3d$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $188163171d093f3d$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $188163171d093f3d$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $188163171d093f3d$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $188163171d093f3d$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $188163171d093f3d$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $188163171d093f3d$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}



var $3af3081af45dcf8f$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $188163171d093f3d$export$2e2bcd8739ae039)(retryQueuePrefix, product, options || {}, logger);
};




var $2FWxW = parcelRequire("2FWxW");
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $949c045b162130aa$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $949c045b162130aa$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $949c045b162130aa$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});


function $9d44cb8894e82e0a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d44cb8894e82e0a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d44cb8894e82e0a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d44cb8894e82e0a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9d44cb8894e82e0a$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $949c045b162130aa$export$ddf929981dc6feb3).PAGE || item.msg.type === (0, $949c045b162130aa$export$ddf929981dc6feb3).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $9d44cb8894e82e0a$var$_objectSpread($9d44cb8894e82e0a$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $949c045b162130aa$export$ddf929981dc6feb3).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $9d44cb8894e82e0a$var$_objectSpread($9d44cb8894e82e0a$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $9d44cb8894e82e0a$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$9d44cb8894e82e0a$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}


const $5513d107ed8e0a49$export$9175ce0e1c95daf2 = 10000; // 10 seconds



var $2FWxW = parcelRequire("2FWxW");
var $174ad990f54e1f54$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $174ad990f54e1f54$var$isEqual(first, second) {
    if (first === second) return true;
    if ($174ad990f54e1f54$var$safeIsNaN(first) && $174ad990f54e1f54$var$safeIsNaN(second)) return true;
    return false;
}
function $174ad990f54e1f54$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$174ad990f54e1f54$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $174ad990f54e1f54$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $174ad990f54e1f54$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}


function $cc114c69ac5dcfd0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc114c69ac5dcfd0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc114c69ac5dcfd0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc114c69ac5dcfd0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cc114c69ac5dcfd0$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $cc114c69ac5dcfd0$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $cc114c69ac5dcfd0$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $cc114c69ac5dcfd0$var$_objectSpread({
        method: "POST",
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            "Content-Type": "text/plain"
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $cc114c69ac5dcfd0$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $cc114c69ac5dcfd0$var$getCorsForUrl = (0, $174ad990f54e1f54$export$2e2bcd8739ae039)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});




function $a47b13fb3c36753e$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $6b0837da6e886c0e$export$2e2bcd8739ae039(argument) {
    (0, $a47b13fb3c36753e$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $38eb40ee06d64f28$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $ab31105c0d76d948$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $0d5fb01217172061$export$2e2bcd8739ae039(dirtyDate) {
    (0, $a47b13fb3c36753e$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0837da6e886c0e$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $a2f7a107c510e8cf$var$MILLISECONDS_IN_DAY = 86400000;
function $a2f7a107c510e8cf$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $a47b13fb3c36753e$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $0d5fb01217172061$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $0d5fb01217172061$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $ab31105c0d76d948$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $ab31105c0d76d948$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $a2f7a107c510e8cf$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $8701fb9d4b47ee3e$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $8701fb9d4b47ee3e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $a47b13fb3c36753e$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $6b0837da6e886c0e$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $6b0837da6e886c0e$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $8701fb9d4b47ee3e$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $a2f7a107c510e8cf$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($8701fb9d4b47ee3e$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




var $2FWxW = parcelRequire("2FWxW");
var $93c88ced18b053cb$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $93c88ced18b053cb$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


const $4b89227925e5c04a$export$5d04dceb9d38c3f8 = {
    // 1 year
    expires: 365,
    secure: window.location.protocol === "https:",
    path: "/"
};



var $2FWxW = parcelRequire("2FWxW");
class $13c08becf34c7234$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var $13c08becf34c7234$export$2e2bcd8739ae039 = new $13c08becf34c7234$export$90e3e001bcac59c7();



var $2FWxW = parcelRequire("2FWxW");


const $3e609d6134138d90$export$41c06fdd37b7e9a5 = "awc";
const $3e609d6134138d90$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
function $3e609d6134138d90$export$48c17662a6902497(store) {
    const TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        const key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $3e609d6134138d90$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $3e609d6134138d90$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($3e609d6134138d90$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $13c08becf34c7234$export$2e2bcd8739ae039)) return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($3e609d6134138d90$export$48c17662a6902497(window[$3e609d6134138d90$export$770aa8bc07b3de03])) inMemoryStorage = window[$3e609d6134138d90$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $13c08becf34c7234$export$2e2bcd8739ae039);
                if (!window[$3e609d6134138d90$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$3e609d6134138d90$export$770aa8bc07b3de03] = (0, $13c08becf34c7234$export$2e2bcd8739ae039);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($3e609d6134138d90$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join("-");
        if ($3e609d6134138d90$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}


class $905bd853a1e8db7e$export$2e2bcd8739ae039 extends (0, $3e609d6134138d90$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $13c08becf34c7234$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $13c08becf34c7234$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}


class $57e64f3feb1abbd8$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $905bd853a1e8db7e$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}




const $4c25388e62f68027$export$a9330601ee8f4d95 = ()=>{
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
const $4c25388e62f68027$export$eb80e1beaa8dacf8 = "__awc_tld_test__";
const $4c25388e62f68027$export$19164982d36535d8 = "tld_test";
const $4c25388e62f68027$export$de6821eed3d5f32d = (0, $174ad990f54e1f54$export$2e2bcd8739ae039)(()=>{
    const { hostname: hostname } = location;
    const splitHostname = hostname.split(".");
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join(".")}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($93c88ced18b053cb$exports))).set($4c25388e62f68027$export$eb80e1beaa8dacf8, $4c25388e62f68027$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($93c88ced18b053cb$exports))).get($4c25388e62f68027$export$eb80e1beaa8dacf8) === $4c25388e62f68027$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($93c88ced18b053cb$exports))).remove($4c25388e62f68027$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});


function $d3574697477c7983$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3574697477c7983$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3574697477c7983$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3574697477c7983$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $d3574697477c7983$export$2e2bcd8739ae039 {
    constructor(){
        this.cookieLike = (0, $4c25388e62f68027$export$a9330601ee8f4d95)() ? (0, (/*@__PURE__*/$parcel$interopDefault($93c88ced18b053cb$exports))) : new (0, $57e64f3feb1abbd8$export$2e2bcd8739ae039)();
    }
    set(name, value, options) {
        return this.cookieLike.set(name, value, $d3574697477c7983$var$_objectSpread($d3574697477c7983$var$_objectSpread({}, (0, $4b89227925e5c04a$export$5d04dceb9d38c3f8)), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $4c25388e62f68027$export$de6821eed3d5f32d)()
        }, options));
    }
    get(name) {
        return this.cookieLike.get(name);
    }
    remove(name, options) {
        this.cookieLike.remove(name, $d3574697477c7983$var$_objectSpread({}, options));
    }
}



const $32e309d66342ebf3$export$c28ab15bb6a6e3e7 = "ajs_anonymous_id";
// Cookie is stale, if anonymousId was generated 7 days ago.
const $32e309d66342ebf3$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $32e309d66342ebf3$var$SAFE = "SAFE";
const $32e309d66342ebf3$var$UNSAFE = "UNSAFE";
const $32e309d66342ebf3$var$NOT_FOUND = "NOT_FOUND";
const $32e309d66342ebf3$var$COOKIE = "COOKIE";
const $32e309d66342ebf3$var$LOCAL_STORAGE = "LOCAL_STORAGE";
class $32e309d66342ebf3$export$2e2bcd8739ae039 {
    constructor(){
        this.store = new (0, $905bd853a1e8db7e$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $d3574697477c7983$export$2e2bcd8739ae039)();
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId() {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId();
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set($32e309d66342ebf3$export$c28ab15bb6a6e3e7, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem($32e309d66342ebf3$export$c28ab15bb6a6e3e7, stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $32e309d66342ebf3$var$LOCAL_STORAGE ? this.store.getItem($32e309d66342ebf3$export$c28ab15bb6a6e3e7) : this.cookie.get($32e309d66342ebf3$export$c28ab15bb6a6e3e7);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $32e309d66342ebf3$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === "string") return {
                    type: $32e309d66342ebf3$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $32e309d66342ebf3$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($32e309d66342ebf3$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $8701fb9d4b47ee3e$export$2e2bcd8739ae039)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $32e309d66342ebf3$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $32e309d66342ebf3$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $32e309d66342ebf3$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $32e309d66342ebf3$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($32e309d66342ebf3$var$COOKIE);
        switch(cookieValue.type){
            case $32e309d66342ebf3$var$SAFE:
            case $32e309d66342ebf3$var$UNSAFE:
                this.store.setItem($32e309d66342ebf3$export$c28ab15bb6a6e3e7, JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $32e309d66342ebf3$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId() {
        const newAnonId = (0, (/*@__PURE__*/$parcel$interopDefault($8b90745a772ac2e0$exports)))();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}



var $2FWxW = parcelRequire("2FWxW");
var $4d6b46b8ede74c8c$exports = {};
"use strict";
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $ae943510a4175c98$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $ae943510a4175c98$export$226b3eccf92c9ed9;
"use strict";
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $ae943510a4175c98$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$ae943510a4175c98$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $ae943510a4175c98$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + "00").substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === " ") offset = new Date().getTimezoneOffset();
    else if (arr[9] !== "Z" && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === "+") offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$ae943510a4175c98$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== "string") return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $ae943510a4175c98$var$matcher.test(string);
};


/**
 * Expose `traverse`.
 */ $4d6b46b8ede74c8c$exports = $4d6b46b8ede74c8c$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $4d6b46b8ede74c8c$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === "object") return $4d6b46b8ede74c8c$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $4d6b46b8ede74c8c$var$traverseArray(input, strict);
    else if ($ae943510a4175c98$export$226b3eccf92c9ed9(input, strict)) return $ae943510a4175c98$export$98e6a39c04603d36(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $4d6b46b8ede74c8c$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $4d6b46b8ede74c8c$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $4d6b46b8ede74c8c$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $4d6b46b8ede74c8c$var$traverse(value, strict);
    });
    return arr;
}


function $54e01b88558cf750$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54e01b88558cf750$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54e01b88558cf750$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54e01b88558cf750$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $54e01b88558cf750$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $54e01b88558cf750$var$_objectSpread($54e01b88558cf750$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $54e01b88558cf750$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $54e01b88558cf750$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4d6b46b8ede74c8c$exports)))(propertiesWithoutUndefined);
};
const $54e01b88558cf750$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== "object") return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $54e01b88558cf750$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$54e01b88558cf750$export$2250ccecd1e040fd(i));
            else if (typeof value === "object" && value !== null) clone[key] = $54e01b88558cf750$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $54e01b88558cf750$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};


function $b02292a31503af63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b02292a31503af63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b02292a31503af63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b02292a31503af63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $b02292a31503af63$export$2e2bcd8739ae039 {
    constructor(options){
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $b02292a31503af63$var$_objectSpread($b02292a31503af63$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $cc114c69ac5dcfd0$export$8e8f0180c1b41fad)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
            } catch (error) {
                callback(error, null);
            }
        });
        this.user = new (0, $32e309d66342ebf3$export$2e2bcd8739ae039)();
        this.options = $b02292a31503af63$var$_objectSpread($b02292a31503af63$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $5513d107ed8e0a49$export$9175ce0e1c95daf2),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console
        });
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $949f607490dc2fd5$export$2e2bcd8739ae039)();
        this.resilienceQueue = (0, $3af3081af45dcf8f$export$2e2bcd8739ae039)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $949c045b162130aa$export$ddf929981dc6feb3).TRACK, builtEvent);
        const eventWithoutMessageId = $b02292a31503af63$var$_objectSpread($b02292a31503af63$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $949c045b162130aa$export$ddf929981dc6feb3).TRACK,
            properties: (0, $54e01b88558cf750$export$44d22e5fb02cc68e)(builtEvent),
            event: eventName
        });
        const event = $b02292a31503af63$var$_objectSpread($b02292a31503af63$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $949c045b162130aa$export$ddf929981dc6feb3).PAGE, builtEvent);
        const eventWithoutMessageId = $b02292a31503af63$var$_objectSpread($b02292a31503af63$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $949c045b162130aa$export$ddf929981dc6feb3).PAGE,
            properties: (0, $54e01b88558cf750$export$44d22e5fb02cc68e)(builtEvent),
            name: eventName
        });
        const event = $b02292a31503af63$var$_objectSpread($b02292a31503af63$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $949c045b162130aa$export$ddf929981dc6feb3).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $b02292a31503af63$var$_objectSpread($b02292a31503af63$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $949c045b162130aa$export$ddf929981dc6feb3).IDENTIFY,
            traits: (0, $54e01b88558cf750$export$44d22e5fb02cc68e)(builtEvent)
        });
        const event = $b02292a31503af63$var$_objectSpread($b02292a31503af63$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $54e01b88558cf750$export$44d22e5fb02cc68e)(context);
        const segmentContext = (0, $54e01b88558cf750$export$3a7fe28f9bf4f3d9)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($8b90745a772ac2e0$exports)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                "Content-Type": "text/plain"
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $9d44cb8894e82e0a$export$c21270cab66ab290)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
}



var $2FWxW = parcelRequire("2FWxW");

var $30b164e536483518$export$f9380c9a627682d3;
var $30b164e536483518$export$98e6a39c04603d36;
var $30b164e536483518$export$fac44ee5b035f737;
var $30b164e536483518$export$7a5253c0f62e0150;
var $30b164e536483518$export$a8c1621ea79325d3;
var $30b164e536483518$export$357523c63a2253b9;
var $30b164e536483518$export$44c361b8ec72ef7f;
"use strict";
var $8dfe8e4501f39800$exports = {};
"use strict";
$8dfe8e4501f39800$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $620b49de1e180e4c$exports = {};
"use strict";
var $620b49de1e180e4c$var$token = "%[a-f0-9]{2}";
var $620b49de1e180e4c$var$singleMatcher = new RegExp("(" + $620b49de1e180e4c$var$token + ")|([^%]+?)", "gi");
var $620b49de1e180e4c$var$multiMatcher = new RegExp("(" + $620b49de1e180e4c$var$token + ")+", "gi");
function $620b49de1e180e4c$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $620b49de1e180e4c$var$decodeComponents(left), $620b49de1e180e4c$var$decodeComponents(right));
}
function $620b49de1e180e4c$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($620b49de1e180e4c$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $620b49de1e180e4c$var$decodeComponents(tokens, i).join("");
            tokens = input.match($620b49de1e180e4c$var$singleMatcher) || [];
        }
        return input;
    }
}
function $620b49de1e180e4c$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    var match = $620b49de1e180e4c$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $620b49de1e180e4c$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $620b49de1e180e4c$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$620b49de1e180e4c$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $620b49de1e180e4c$var$customDecodeURIComponent(encodedURI);
    }
};


var $dd77d77cb41ec427$exports = {};
"use strict";
$dd77d77cb41ec427$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $e06cb9fdf2947665$exports = {};
"use strict";
$e06cb9fdf2947665$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $30b164e536483518$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $30b164e536483518$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $30b164e536483518$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $30b164e536483518$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $30b164e536483518$var$encode(key, options),
                            "[",
                            $30b164e536483518$var$encode(index, options),
                            "]=",
                            $30b164e536483518$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $30b164e536483518$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $30b164e536483518$var$encode(key, options),
                            "[]=",
                            $30b164e536483518$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $30b164e536483518$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $30b164e536483518$var$encode(key, options),
                            ":list=",
                            $30b164e536483518$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $30b164e536483518$var$encode(key, options),
                                keyValueSep,
                                $30b164e536483518$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $30b164e536483518$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $30b164e536483518$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $30b164e536483518$var$encode(key, options),
                            "=",
                            $30b164e536483518$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $30b164e536483518$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $30b164e536483518$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $30b164e536483518$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$30b164e536483518$var$decode(item, options)) : value === null ? value : $30b164e536483518$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $30b164e536483518$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$30b164e536483518$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $30b164e536483518$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $30b164e536483518$var$encode(value, options) {
    if (options.encode) return options.strict ? $8dfe8e4501f39800$exports(value) : encodeURIComponent(value);
    return value;
}
function $30b164e536483518$var$decode(value, options) {
    if (options.decode) return $620b49de1e180e4c$exports(value);
    return value;
}
function $30b164e536483518$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $30b164e536483518$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $30b164e536483518$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $30b164e536483518$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $30b164e536483518$var$extract(input) {
    input = $30b164e536483518$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $30b164e536483518$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $30b164e536483518$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $30b164e536483518$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $30b164e536483518$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $dd77d77cb41ec427$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $30b164e536483518$var$decode(value, options);
        formatter($30b164e536483518$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $30b164e536483518$var$parseValue(value[k], options);
        else ret[key] = $30b164e536483518$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $30b164e536483518$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$30b164e536483518$export$f9380c9a627682d3 = $30b164e536483518$var$extract;
$30b164e536483518$export$98e6a39c04603d36 = $30b164e536483518$var$parse;
$30b164e536483518$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $30b164e536483518$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $30b164e536483518$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $30b164e536483518$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $30b164e536483518$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $30b164e536483518$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $30b164e536483518$var$encode(key, options) + "=" + $30b164e536483518$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$30b164e536483518$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $dd77d77cb41ec427$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $30b164e536483518$var$parse($30b164e536483518$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $30b164e536483518$var$decode(hash, options)
    } : {});
};
$30b164e536483518$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$30b164e536483518$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $30b164e536483518$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $30b164e536483518$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $30b164e536483518$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $30b164e536483518$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $30b164e536483518$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$30b164e536483518$var$encodeFragmentIdentifier] ? $30b164e536483518$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$30b164e536483518$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$30b164e536483518$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $30b164e536483518$export$7a5253c0f62e0150(input, options);
    return $30b164e536483518$export$a8c1621ea79325d3({
        url: url,
        query: $e06cb9fdf2947665$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$30b164e536483518$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $30b164e536483518$export$357523c63a2253b9(input, exclusionFilter, options);
};



const $675399b7c10f7dae$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, "", newUrl);
const $675399b7c10f7dae$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $675399b7c10f7dae$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    const { url: url, query: query } = (0, $30b164e536483518$export$7a5253c0f62e0150)(removedFragmentURL);
    const captureParams = (0, $41eb7051cb2eb15f$export$b460b275d6c6aa0)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $41eb7051cb2eb15f$export$d7a617dda645b4e3)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $30b164e536483518$export$fac44ee5b035f737)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $675399b7c10f7dae$export$2e2bcd8739ae039 = $675399b7c10f7dae$var$urlParamExtractor;


class $248ef6e99b563f57$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $09fd4c2dd73520bc$export$62a500c02dc63ee)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $675399b7c10f7dae$export$2e2bcd8739ae039)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}




var $2FWxW = parcelRequire("2FWxW");

const $915906d523db01a7$var$SESSION_ID_STORAGE_KEY = "session.id";
const $915906d523db01a7$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
const $915906d523db01a7$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $915906d523db01a7$export$285f6bddd927a06d = 1800000; // 30 minutes
const $915906d523db01a7$export$a92e915d70316eb2 = 5000; // 5 seconds
const $915906d523db01a7$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $915906d523db01a7$export$5702a91a6f42969f = ()=>{};
class $915906d523db01a7$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($915906d523db01a7$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($915906d523db01a7$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $915906d523db01a7$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $915906d523db01a7$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $915906d523db01a7$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $915906d523db01a7$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $905bd853a1e8db7e$export$2e2bcd8739ae039)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($915906d523db01a7$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($915906d523db01a7$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$915906d523db01a7$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}




class $cc5612cf4f95296a$export$2e2bcd8739ae039 extends (0, $3e609d6134138d90$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $13c08becf34c7234$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $13c08becf34c7234$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}



var $2FWxW = parcelRequire("2FWxW");


const $1b945870699525ee$var$STORAGE_KEY = "tab.id";
class $1b945870699525ee$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($8b90745a772ac2e0$exports)))();
            this._safeSessionStorage.setItem($1b945870699525ee$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $cc5612cf4f95296a$export$2e2bcd8739ae039)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($1b945870699525ee$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}



var $2FWxW = parcelRequire("2FWxW");






function $fa52a7e8269ee38d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa52a7e8269ee38d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa52a7e8269ee38d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa52a7e8269ee38d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $fa52a7e8269ee38d$var$STORAGE_KEY = "taskSessions";
const $fa52a7e8269ee38d$var$INIT_KEY = "taskSessionsInit";
const $fa52a7e8269ee38d$var$AWC_PARAM_PREFIX = "awc.";
const $fa52a7e8269ee38d$var$TASK_SESSION_RELOAD_TIME = 3000;
class $fa52a7e8269ee38d$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($fa52a7e8269ee38d$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($fa52a7e8269ee38d$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($fa52a7e8269ee38d$var$INIT_KEY) || "0", 10) < currentTimestamp - $fa52a7e8269ee38d$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($fa52a7e8269ee38d$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($fa52a7e8269ee38d$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($fa52a7e8269ee38d$var$STORAGE_KEY) || "");
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($fa52a7e8269ee38d$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($8b90745a772ac2e0$exports)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $30b164e536483518$export$7a5253c0f62e0150)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $41eb7051cb2eb15f$export$357523c63a2253b9)(currentState, includedTaskSessions) : (0, $41eb7051cb2eb15f$export$30a06c8d3562193f)(currentState, Object.values((0, $09fd4c2dd73520bc$export$62a500c02dc63ee)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $fa52a7e8269ee38d$var$_objectSpread($fa52a7e8269ee38d$var$_objectSpread({}, (0, $41eb7051cb2eb15f$export$781522908e4e76a1)(filteredTaskSessions, (_, taskSessionName)=>$fa52a7e8269ee38d$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $30b164e536483518$export$fac44ee5b035f737)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $41eb7051cb2eb15f$export$781522908e4e76a1)((0, $675399b7c10f7dae$export$2e2bcd8739ae039)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $cc5612cf4f95296a$export$2e2bcd8739ae039)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($fa52a7e8269ee38d$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}



var $2FWxW = parcelRequire("2FWxW");

const $52b4d850d09dfa94$var$MAX_CACHE_SIZE = 100;
const $52b4d850d09dfa94$var$COOKIE_NAME = "atlassian_analytics_debug";
const $52b4d850d09dfa94$var$DEBUG_TAG = "synthetic";
const $52b4d850d09dfa94$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($93c88ced18b053cb$exports))).get($52b4d850d09dfa94$var$COOKIE_NAME) || "false");
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($93c88ced18b053cb$exports))).remove($52b4d850d09dfa94$var$COOKIE_NAME);
    }
    return false;
};
class $52b4d850d09dfa94$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_bind", ()=>{
            if (window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem("awc.ui.viewed.last.sent");
                        localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                        localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                        localStorage.removeItem("awc-local.ui.viewed.last.sent");
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_cache", (event)=>{
            if (window.testAnalytics.eventCache.length >= $52b4d850d09dfa94$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($52b4d850d09dfa94$var$DEBUG_TAG);
                else event.tags = [
                    $52b4d850d09dfa94$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $52b4d850d09dfa94$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $52b4d850d09dfa94$export$2e2bcd8739ae039 = $52b4d850d09dfa94$var$TestingCache;




var $2FWxW = parcelRequire("2FWxW");


const $a54b2bf6a723605b$var$_excluded = [
    "embeddedProduct"
];
function $a54b2bf6a723605b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a54b2bf6a723605b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a54b2bf6a723605b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a54b2bf6a723605b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a54b2bf6a723605b$var$DEFAULT_DELAY = 2000; // 2 seconds
const $a54b2bf6a723605b$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $a54b2bf6a723605b$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
class $a54b2bf6a723605b$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_bindEventListeners", ()=>{
            window.addEventListener("focus", this._focusListener);
            window.addEventListener("blur", this._blurListener);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_unbindEventListeners", ()=>{
            window.removeEventListener("focus", this._focusListener);
            window.removeEventListener("blur", this._blurListener);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || "");
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $09fd4c2dd73520bc$export$496f06ac2a964da2).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($8733b61bde91fa4a$exports)))(_this$_getContext, $a54b2bf6a723605b$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: "ui",
                action: "viewed",
                actionSubject: "ui",
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $a54b2bf6a723605b$var$_objectSpread($a54b2bf6a723605b$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $a54b2bf6a723605b$var$_objectSpread($a54b2bf6a723605b$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!getContext) throw new Error("Missing getContext callback");
        if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $a54b2bf6a723605b$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $a54b2bf6a723605b$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $a54b2bf6a723605b$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $905bd853a1e8db7e$export$2e2bcd8739ae039)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}



function $aace6a5194dcc1f9$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return ()=>{
        callback(event);
    };
}


let $c283e514895549f9$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $c283e514895549f9$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});


const $29ba9cac1e7954df$export$545bcbd53afabfa3 = 5000;
const $29ba9cac1e7954df$export$af4087e36d63846 = ()=>[
        {
            type: (0, $c283e514895549f9$export$92ca0438bcb0d396).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $c283e514895549f9$export$92ca0438bcb0d396).UID,
            state: "TIMEOUT"
        }
    ];
const $29ba9cac1e7954df$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $c283e514895549f9$export$92ca0438bcb0d396).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $c283e514895549f9$export$92ca0438bcb0d396).UID,
            state: "UNKNOWN"
        }
    ];


const $59e7c10540deb1d4$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $29ba9cac1e7954df$export$af4087e36d63846)()), (0, $29ba9cac1e7954df$export$545bcbd53afabfa3));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $29ba9cac1e7954df$export$fa341d0c750d705b)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};


function $c2294a9653a3a26a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2294a9653a3a26a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2294a9653a3a26a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2294a9653a3a26a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c2294a9653a3a26a$var$PROD_HOST = "as.atlassian.com/api/v1";
const $c2294a9653a3a26a$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
const $c2294a9653a3a26a$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
const $c2294a9653a3a26a$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
const $c2294a9653a3a26a$var$FEDRAMP_SANDBOX_HOST = "as.atlassian-fex.com/api/v1";
const $c2294a9653a3a26a$var$STARGATE_FEDRAMP_SANDBOX_HOST = "api-private.atlassian-fex.com/gasv3/api/v1";
const $c2294a9653a3a26a$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
const $c2294a9653a3a26a$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
class $c2294a9653a3a26a$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_selectHost", ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter })=>{
            if (!useStargate) {
                if (perimeter === (0, $09fd4c2dd73520bc$export$bdd41749d2096e4b).FEDRAMP_MODERATE && env === (0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9).STAGING) return $c2294a9653a3a26a$var$FEDRAMP_SANDBOX_HOST;
                return env === (0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9).PROD ? $c2294a9653a3a26a$var$PROD_HOST : $c2294a9653a3a26a$var$STAGING_HOST;
            }
            if (useLegacyUrl) {
                if (perimeter === (0, $09fd4c2dd73520bc$export$bdd41749d2096e4b).FEDRAMP_MODERATE && env === (0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9).STAGING) return $c2294a9653a3a26a$var$STARGATE_FEDRAMP_SANDBOX_HOST;
                return env === (0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9).PROD ? $c2294a9653a3a26a$var$STARGATE_PROD_HOST : $c2294a9653a3a26a$var$STARGATE_STAGING_HOST;
            }
            /**
       * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
       * For more details, see:
       *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
       *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
       */ return window.location.host + $c2294a9653a3a26a$export$5df9262e102d0c32;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_createSubproductGetter", (subproduct)=>(0, $430fb5e1730444aa$export$2e2bcd8739ae039)(subproduct, "Cannot get subproduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $430fb5e1730444aa$export$2e2bcd8739ae039)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($c2294a9653a3a26a$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
            } catch (err) {
                this._safeSessionStorage.removeItem($c2294a9653a3a26a$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($c2294a9653a3a26a$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $09fd4c2dd73520bc$export$4c045e605d532c98).UI:
                case (0, $09fd4c2dd73520bc$export$4c045e605d532c98).OPERATIONAL:
                case (0, $09fd4c2dd73520bc$export$4c045e605d532c98).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $09fd4c2dd73520bc$export$4c045e605d532c98).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $09fd4c2dd73520bc$export$4c045e605d532c98).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    "sentWithDelay"
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
     * Calling this function in the intialisation of the client in product
     * captures specified 'origin tracing' URL params and fires a single origin landed event
     * <p>
     * This function expects a mapping between the keys for any URL parameters
     *  that should be captured and removed for origin tracing
     * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
     * Each handler function should return an object with two items
     * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
     * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
     *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
     * </p>
     * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
     * e.g. from a share or email
     *
     * An example calling this function using an external decoding library, with taskSessionId specified to persist
     * analyticsWebClient.setOriginTracingHandlers({
          atlOrigin: encodedOrigin => {
              const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
              return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
          },
      });
     *
     * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
     * @this {AnalyticsWebClient}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: "landed",
                actionSubject: "origin",
                source: "webClient",
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error("Missing tenantIdType");
            if (tenantIdType !== (0, $09fd4c2dd73520bc$export$496f06ac2a964da2).NONE && !tenantId) throw new Error("Missing tenantId");
            if (!(0, $09fd4c2dd73520bc$export$26b9f946b448f23e)((0, $09fd4c2dd73520bc$export$496f06ac2a964da2), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $09fd4c2dd73520bc$export$ad1854f4a08c15f8)((0, $09fd4c2dd73520bc$export$496f06ac2a964da2))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error("Missing orgId");
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error("Missing workspaceId");
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $f3dbcba1e548e0e2$export$c16a4e16aa4026c0)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
            if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
            this._uiViewedAttributes = $c2294a9653a3a26a$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $09fd4c2dd73520bc$export$4c045e605d532c98).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === "object") {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $f3dbcba1e548e0e2$export$dc993432a592dc27)(screenName);
            (0, $f3dbcba1e548e0e2$export$e63ea5d8477971d3)(screenContainers);
            const builtEvent = (0, $980e6b4e898a3f9e$export$c7d9a5f56acc4b19)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers);
            const builtEventWithName = $c2294a9653a3a26a$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $aace6a5194dcc1f9$export$2e2bcd8739ae039)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $f3dbcba1e548e0e2$export$8c014fd74b0c8b99)(event);
            const builtEvent = (0, $980e6b4e898a3f9e$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $09fd4c2dd73520bc$export$4c045e605d532c98).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo);
            return this._processEvent((0, $980e6b4e898a3f9e$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $aace6a5194dcc1f9$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "sendUIEvent", (event, callback)=>{
            (0, $f3dbcba1e548e0e2$export$e5bac0930c812e90)(event);
            const builtEvent = (0, $980e6b4e898a3f9e$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $09fd4c2dd73520bc$export$4c045e605d532c98).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo);
            return this._processEvent((0, $980e6b4e898a3f9e$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $aace6a5194dcc1f9$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $f3dbcba1e548e0e2$export$1e561554275607ef)(event);
            const builtEvent = (0, $980e6b4e898a3f9e$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $09fd4c2dd73520bc$export$4c045e605d532c98).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo);
            return this._processEvent((0, $980e6b4e898a3f9e$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $aace6a5194dcc1f9$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $a54b2bf6a723605b$export$2e2bcd8739ae039)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "onEvent", (analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error("Missing analyticsData");
            if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
            if (analyticsData.eventType === (0, $09fd4c2dd73520bc$export$4c045e605d532c98).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $09fd4c2dd73520bc$export$4c045e605d532c98).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $09fd4c2dd73520bc$export$4c045e605d532c98).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $09fd4c2dd73520bc$export$4c045e605d532c98).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $09fd4c2dd73520bc$export$4c045e605d532c98).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $09fd4c2dd73520bc$export$ad1854f4a08c15f8)((0, $09fd4c2dd73520bc$export$4c045e605d532c98))}]`);
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.env) throw new Error("Missing productInfo.env");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!(0, $09fd4c2dd73520bc$export$26b9f946b448f23e)((0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $09fd4c2dd73520bc$export$ad1854f4a08c15f8)((0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9))}]`);
        if (productInfo.perimeter && !(0, $09fd4c2dd73520bc$export$26b9f946b448f23e)((0, $09fd4c2dd73520bc$export$bdd41749d2096e4b), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $09fd4c2dd73520bc$export$ad1854f4a08c15f8)((0, $09fd4c2dd73520bc$export$bdd41749d2096e4b))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $09fd4c2dd73520bc$export$f73e9fcd368bb695).WEB;
        else if (!(0, $09fd4c2dd73520bc$export$26b9f946b448f23e)((0, $09fd4c2dd73520bc$export$f73e9fcd368bb695), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $09fd4c2dd73520bc$export$ad1854f4a08c15f8)((0, $09fd4c2dd73520bc$export$f73e9fcd368bb695))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $09fd4c2dd73520bc$export$f73e9fcd368bb695).WEB ? (0, $09fd4c2dd73520bc$export$6b4f396210e539f3).WEB : (0, $09fd4c2dd73520bc$export$6b4f396210e539f3).DESKTOP;
        else (0, $f3dbcba1e548e0e2$export$801b46c35394d316)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $c2294a9653a3a26a$var$_objectSpread($c2294a9653a3a26a$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $980e6b4e898a3f9e$export$3a7fe28f9bf4f3d9)(this._productInfo);
        this._safeSessionStorage = new (0, $cc5612cf4f95296a$export$2e2bcd8739ae039)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || this._selectHost({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter
        });
        const apiHostProtocol = settings.apiHostProtocol || "https";
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $59e7c10540deb1d4$export$fbe53bbbe682bcdd)(settings.xidConsent, settings.xidPromiseFn);
        this.eventProcessor = new (0, $b02292a31503af63$export$2e2bcd8739ae039)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId()
        };
        this._pageVisibility = new (0, $86bbdfebbcda0876$export$2e2bcd8739ae039)();
        this._tabTracking = new (0, $1b945870699525ee$export$2e2bcd8739ae039)();
        this._sessionTracking = new (0, $915906d523db01a7$export$2e2bcd8739ae039)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $fa52a7e8269ee38d$export$2e2bcd8739ae039)();
        this.originTracing = new (0, $248ef6e99b563f57$export$2e2bcd8739ae039)();
        // Init Apdex
        this._apdexEvent = new (0, $71beb36867b76582$export$2e2bcd8739ae039)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $675399b7c10f7dae$export$600dd5bf1b049f11);
        this.eventDelayQueue = new (0, $b795e656b0e8c8a1$export$2e2bcd8739ae039)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $52b4d850d09dfa94$export$2e2bcd8739ae039)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($8b90745a772ac2e0$exports)))();
        this._workspaceInfo = {};
    }
}



const $467fd94f96f91249$var$environment = (()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes(".dev.services.") || hostname.includes(".stg.services.")) return "staging";
    if ([
        "localhost",
        "atlastunnel"
    ].some((domain)=>hostname.includes(domain))) // Change "development" to "local" to allow Sentry to send logs locally
    return "development";
    return "production";
})();
function $467fd94f96f91249$var$getAnalyticsEnv() {
    if ($467fd94f96f91249$var$environment === "staging") return (0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9).STAGING;
    if ($467fd94f96f91249$var$environment === "production") return (0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9).PROD;
    return (0, $09fd4c2dd73520bc$export$56ac8ebc9870b1b9).DEV;
}
// default client
let $467fd94f96f91249$var$client;
function $467fd94f96f91249$export$d050db8f6426404e(aaid, product = "openInSpreadsheet", subproduct = "jiraSpreadsheets") {
    $467fd94f96f91249$var$client = new (0, $c2294a9653a3a26a$export$2e2bcd8739ae039)({
        env: $467fd94f96f91249$var$getAnalyticsEnv(),
        product: product,
        subproduct: subproduct,
        version: "1.0.0"
    }, {
        useLegacyUrl: true
    });
    $467fd94f96f91249$var$client.setUserInfo((0, $09fd4c2dd73520bc$export$1827adfd178b4870).ATLASSIAN_ACCOUNT, aaid);
    const cloudId = $467fd94f96f91249$var$getCloudId();
    if (cloudId) $467fd94f96f91249$var$client.setTenantInfo((0, $09fd4c2dd73520bc$export$496f06ac2a964da2).CLOUD_ID, cloudId);
}
function $467fd94f96f91249$export$3dd849221d1b8342(action, actionSubject, actionSubjectId, source, attributes = {}, tags = []) {
    $467fd94f96f91249$var$client.sendUIEvent({
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: source,
        attributes: attributes,
        tags: tags
    });
}
function $467fd94f96f91249$export$f3b5b1c39333b4d1(name, attributes = {}, tags = []) {
    $467fd94f96f91249$var$client.sendScreenEvent({
        name: name,
        attributes: attributes,
        tags: tags
    });
}
async function $467fd94f96f91249$export$c63f1658de23b754() {
    try {
        $467fd94f96f91249$export$3dd849221d1b8342("clicked", "button", "installAddin", "openInExcelScreen");
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Unable to send event:", e);
    }
}
function $467fd94f96f91249$var$getCloudId() {
    try {
        const jwt = new URLSearchParams(window.location.search).get("jwt");
        if (!jwt) return;
        return (0, $7d9ece1931efbf1d$export$2e2bcd8739ae039)(jwt)?.context?.cloudId;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Unable to get cloudId", error);
    }
}


function $226ec9402bb8315e$export$3d7f8d8994e49ef4({ downloadUrl: downloadUrl }) {
    $5cNek.useEffect(()=>{
        if (downloadUrl) window.open(downloadUrl, "_self");
    }, [
        downloadUrl
    ]);
    return /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)((0, $6d5367bb84366e40$export$2e2bcd8739ae039), {
        width: "small",
        children: [
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $5f8549064b1f0c57$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $e2b7ea7cfe441535$export$2e2bcd8739ae039), {
                    children: "Creating file..."
                })
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $262efd68e82332b1$export$2e2bcd8739ae039), {
                children: downloadUrl && /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)("p", {
                    style: {
                        padding: "10px 0"
                    },
                    children: [
                        "Click on ",
                        /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("a", {
                            href: downloadUrl,
                            children: "link"
                        }),
                        " if file download has not started"
                    ]
                })
            })
        ]
    });
}





var $XLpyq = parcelRequire("XLpyq");


var $5cNek = parcelRequire("5cNek");





var $5cNek = parcelRequire("5cNek");








function $99b31ce65996a2c7$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $99b31ce65996a2c7$var$tabKeyCode = 9;
function $99b31ce65996a2c7$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $99b31ce65996a2c7$var$tabKeyCode) return;
    $99b31ce65996a2c7$var$abort(event);
}
var $99b31ce65996a2c7$var$block = {
    onMouseDownCapture: $99b31ce65996a2c7$var$abort,
    onMouseUpCapture: $99b31ce65996a2c7$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $99b31ce65996a2c7$var$onKey,
    onKeyUpCapture: $99b31ce65996a2c7$var$onKey,
    onTouchStartCapture: $99b31ce65996a2c7$var$abort,
    onTouchEndCapture: $99b31ce65996a2c7$var$abort,
    onPointerDownCapture: $99b31ce65996a2c7$var$abort,
    onPointerUpCapture: $99b31ce65996a2c7$var$abort,
    onClickCapture: $99b31ce65996a2c7$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $99b31ce65996a2c7$var$abort
};
var $99b31ce65996a2c7$var$doNotBlock = {};
function $99b31ce65996a2c7$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $99b31ce65996a2c7$var$doNotBlock : $99b31ce65996a2c7$var$block;
}



var $2FWxW = parcelRequire("2FWxW");



// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $6383d535c4a3773f$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $6383d535c4a3773f$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($db8844ebfff7fa2d$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-neutral, ".concat($db8844ebfff7fa2d$export$d281fbfe3cff2df6, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($db8844ebfff7fa2d$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($db8844ebfff7fa2d$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($6383d535c4a3773f$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($db8844ebfff7fa2d$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($db8844ebfff7fa2d$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($db8844ebfff7fa2d$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$3d4f271a500072a, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($db8844ebfff7fa2d$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($db8844ebfff7fa2d$export$e62e8919cca44969, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($db8844ebfff7fa2d$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($db8844ebfff7fa2d$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($db8844ebfff7fa2d$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($db8844ebfff7fa2d$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($db8844ebfff7fa2d$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$3d4f271a500072a, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($db8844ebfff7fa2d$export$c6930421db9fa514, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($db8844ebfff7fa2d$export$c6930421db9fa514, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($db8844ebfff7fa2d$export$5aae31392d72caaa, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($db8844ebfff7fa2d$export$5aae31392d72caaa, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($db8844ebfff7fa2d$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($db8844ebfff7fa2d$export$59619663aa6500fb, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($db8844ebfff7fa2d$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($db8844ebfff7fa2d$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$59619663aa6500fb, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$59619663aa6500fb, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($db8844ebfff7fa2d$export$2010d0fb4295b346, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($db8844ebfff7fa2d$export$2010d0fb4295b346, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($db8844ebfff7fa2d$export$4a7404f376229999, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($db8844ebfff7fa2d$export$4a7404f376229999, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($db8844ebfff7fa2d$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($db8844ebfff7fa2d$export$2837b5a1a71d5c02, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($db8844ebfff7fa2d$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($db8844ebfff7fa2d$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$2837b5a1a71d5c02, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$2837b5a1a71d5c02, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($db8844ebfff7fa2d$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($db8844ebfff7fa2d$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($6383d535c4a3773f$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($db8844ebfff7fa2d$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$3d4f271a500072a, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($db8844ebfff7fa2d$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($db8844ebfff7fa2d$export$633847cf062b69e0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($db8844ebfff7fa2d$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($db8844ebfff7fa2d$export$7d61b15e0da132af, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$7d61b15e0da132af, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$7d61b15e0da132af, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($db8844ebfff7fa2d$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($db8844ebfff7fa2d$export$29a4f05edc054374, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$29a4f05edc054374, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$29a4f05edc054374, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-link, ".concat($db8844ebfff7fa2d$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($db8844ebfff7fa2d$export$e62e8919cca44969, ")"),
                dark: "var(--ds-link, ".concat($db8844ebfff7fa2d$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($db8844ebfff7fa2d$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-link-pressed, ".concat($db8844ebfff7fa2d$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$ad0bacf983b7ddaa, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($db8844ebfff7fa2d$export$f563ee71e9ee74cd, ")"),
                dark: "var(--ds-text-subtle, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($db8844ebfff7fa2d$export$7c87d337fb91a97d, ")"),
                dark: "var(--ds-text-subtle, ".concat($db8844ebfff7fa2d$export$226de0355ed012f8, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$eece5f492e429f08, ")"),
                dark: "var(--ds-text, ".concat($db8844ebfff7fa2d$export$97e81faa16a182c7, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($db8844ebfff7fa2d$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($db8844ebfff7fa2d$export$abcf8c38338b4aa5, ")")
            }
        }
    }
};
var $6383d535c4a3773f$export$2e2bcd8739ae039 = $6383d535c4a3773f$var$values;


function $c87843dd25160854$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c87843dd25160854$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c87843dd25160854$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c87843dd25160854$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c87843dd25160854$var$gridSize = (0, $ea1180a9039473b6$export$6d8204c2cb2e06b8)();
var $c87843dd25160854$var$fontSize = (0, $ea1180a9039473b6$export$85e3c3ca0c6fb93)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $c87843dd25160854$var$heights = {
    default: "".concat($c87843dd25160854$var$gridSize * 4 / $c87843dd25160854$var$fontSize, "em"),
    // 32px
    compact: "".concat($c87843dd25160854$var$gridSize * 3 / $c87843dd25160854$var$fontSize, "em"),
    none: "auto"
};
var $c87843dd25160854$var$lineHeights = {
    default: $c87843dd25160854$var$heights.default,
    compact: $c87843dd25160854$var$heights.compact,
    none: "inherit"
};
var $c87843dd25160854$var$padding = {
    // 10px gutter
    default: "0 ".concat($c87843dd25160854$var$gridSize + $c87843dd25160854$var$gridSize / 4, "px"),
    compact: "0 ".concat($c87843dd25160854$var$gridSize + $c87843dd25160854$var$gridSize / 4, "px"),
    none: "0"
};
var $c87843dd25160854$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($c87843dd25160854$var$gridSize / 4, "px"),
    default: "0 ".concat($c87843dd25160854$var$gridSize / 4, "px"),
    none: "0"
};
var $c87843dd25160854$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $c87843dd25160854$var$innerMargin = {
    content: "0 ".concat($c87843dd25160854$var$gridSize / 4, "px"),
    icon: "0 ".concat($c87843dd25160854$var$gridSize / 4, "px")
};
function $c87843dd25160854$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $c87843dd25160854$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $c87843dd25160854$var$getColor({
            group: (0, $6383d535c4a3773f$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($c87843dd25160854$var$getColor({
            group: (0, $6383d535c4a3773f$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $c87843dd25160854$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $c87843dd25160854$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $c87843dd25160854$var$_objectSpread($c87843dd25160854$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $c87843dd25160854$var$heights[spacing],
        lineHeight: $c87843dd25160854$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $c87843dd25160854$var$singleIconPadding[spacing] : $c87843dd25160854$var$padding[spacing],
        verticalAlign: $c87843dd25160854$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $c87843dd25160854$var$_objectSpread({}, baseColors),
        "&:hover": $c87843dd25160854$var$_objectSpread($c87843dd25160854$var$_objectSpread({}, $c87843dd25160854$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $c87843dd25160854$var$_objectSpread($c87843dd25160854$var$_objectSpread({}, $c87843dd25160854$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $c87843dd25160854$var$_objectSpread($c87843dd25160854$var$_objectSpread({}, $c87843dd25160854$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $c87843dd25160854$var$_objectSpread($c87843dd25160854$var$_objectSpread({}, $c87843dd25160854$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $c87843dd25160854$var$_objectSpread({}, $c87843dd25160854$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $c87843dd25160854$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $e5448515388bb91a$export$dbf350e5966cf602)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $c87843dd25160854$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $c87843dd25160854$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $e5448515388bb91a$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $c87843dd25160854$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $c87843dd25160854$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $e5448515388bb91a$export$dbf350e5966cf602)({
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $c87843dd25160854$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $5cNek = parcelRequire("5cNek");
/** @jsx jsx */ 
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $688a2ff495026f08$var$visuallyHiddenStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    width: "1px",
    height: "1px",
    padding: "0",
    position: "absolute",
    border: "0",
    clip: "rect(1px, 1px, 1px, 1px)",
    overflow: "hidden",
    whiteSpace: "nowrap"
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $688a2ff495026f08$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", {
        id: id,
        "data-testid": testId,
        css: $688a2ff495026f08$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $688a2ff495026f08$export$2e2bcd8739ae039 = $688a2ff495026f08$var$VisuallyHidden;


var $938dddb3575b4663$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5cNek.isValidElement)(children) && children.type === (0, $688a2ff495026f08$export$2e2bcd8739ae039);
};


var $802a69e7a40e5a16$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $802a69e7a40e5a16$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
var $802a69e7a40e5a16$var$iconBeforeSpacingFixStyle = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    marginLeft: "var(--ds-space-negative-025, -2px)"
});
var $802a69e7a40e5a16$var$iconAfterSpacingFixStyle = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    marginRight: "var(--ds-space-negative-025, -2px)"
});
var $802a69e7a40e5a16$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!(0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.icon-button-spacing-fix_o1zc5") || !children || (0, $938dddb3575b4663$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $802a69e7a40e5a16$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $938dddb3575b4663$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", {
        css: childrenStyles
    }, children) : null;
};
var $802a69e7a40e5a16$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $ce0910c7994ac44a$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $ce0910c7994ac44a$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($8733b61bde91fa4a$exports)))(props, $802a69e7a40e5a16$var$_excluded);
    var ourRef = (0, $5cNek.useRef)();
    var setRef = (0, $5cNek.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $e7ac342985c70600$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $5cNek.useContext)((0, $0884f9b62b1e3b6a$export$2e2bcd8739ae039));
    var handleClick = (0, $5cNek.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $4cede3b78eac3524$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "16.10.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5cNek.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5cNek.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeCss = (0, $e5448515388bb91a$export$dbf350e5966cf602)((0, $c87843dd25160854$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $db8844ebfff7fa2d$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $db8844ebfff7fa2d$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)((0, $bd2b8a986436e057$export$2e2bcd8739ae039), null, (0, $e5448515388bb91a$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($39533520dac89738$exports)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $802a69e7a40e5a16$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $99b31ce65996a2c7$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeCss,
            (0, $c87843dd25160854$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $802a69e7a40e5a16$var$getSpacingFix(children, $802a69e7a40e5a16$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, !(0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && children ? (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeCss,
            (0, $c87843dd25160854$export$7ad0316cc0dd65a)({
                spacing: spacing
            })
        ]
    }, children) : null, (0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && $802a69e7a40e5a16$var$getChildren(children, [
        fadeCss,
        (0, $c87843dd25160854$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeCss,
            (0, $c87843dd25160854$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $802a69e7a40e5a16$var$getSpacingFix(children, $802a69e7a40e5a16$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("span", {
        css: [
            (0, $c87843dd25160854$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});





function $422ebcc52ad2b4da$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $37396f277ff6afb6$export$470e5c2be1411c89)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && (0, $938dddb3575b4663$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $51e43201ca42b1ec$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $51e43201ca42b1ec$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $51e43201ca42b1ec$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $ce0910c7994ac44a$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $ce0910c7994ac44a$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($8733b61bde91fa4a$exports)))(_ref, $51e43201ca42b1ec$var$_excluded);
    var _useGlobalTheme = (0, $ab2a8332a3eacc83$export$7692396083754928)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $422ebcc52ad2b4da$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5cNek.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $5cNek.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($51e43201ca42b1ec$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5cNek.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($51e43201ca42b1ec$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5cNek.useMemo)(function() {
        return (0, $c87843dd25160854$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement((0, $802a69e7a40e5a16$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($39533520dac89738$exports)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$51e43201ca42b1ec$var$Button.displayName = "Button";
var $51e43201ca42b1ec$export$2e2bcd8739ae039 = $51e43201ca42b1ec$var$Button;



/** @jsx jsx */ 


var $6d0648147da89c56$var$footerStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    display: "flex",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    padding: (0, $ed7126fc4c89f80a$export$6f98e8eaf0be1996),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    paddingTop: "".concat((0, $ed7126fc4c89f80a$export$6f98e8eaf0be1996) - (0, $ed7126fc4c89f80a$export$4c317248f944c2a9), "px"),
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--ds-space-100, 8px)"
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $6d0648147da89c56$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $b5fcea49347fed8f$export$33ffd74ebf07f060)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)("div", {
        css: $6d0648147da89c56$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $6d0648147da89c56$export$2e2bcd8739ae039 = $6d0648147da89c56$var$ModalFooter;



var $5cNek = parcelRequire("5cNek");



var $5cNek = parcelRequire("5cNek");

const $83dff726fffbbb38$export$35fd4bcf20f5837 = /*#__PURE__*/ $5cNek.createContext({});
function $83dff726fffbbb38$export$f3357802f83e142a({ children: children }) {
    const [context, setContext] = $5cNek.useState();
    const [error, setError] = $5cNek.useState(false);
    $5cNek.useEffect(()=>{
        const locationSearchParams = new URLSearchParams(window.location.search);
        const jiraToken = locationSearchParams.get("jwt");
        const jiraSourcePage = new URL(locationSearchParams.get("link"));
        const filter = jiraSourcePage.searchParams.get("filter");
        const jql = jiraSourcePage.searchParams.get("jql");
        const timeZone = locationSearchParams.get("timeZone");
        const initialContext = {
            aaid: (0, $7d9ece1931efbf1d$export$2e2bcd8739ae039)(jiraToken).sub,
            filter: filter,
            jql: jql,
            jiraToken: jiraToken,
            jiraSourcePage: jiraSourcePage,
            timeZone: timeZone
        };
        const offlineFileInfoUrl = new window.URL(`${window.location.origin}/v2/file/info`);
        offlineFileInfoUrl.searchParams.set("jwt", jiraToken);
        offlineFileInfoUrl.searchParams.set("jiraSourcePage", jiraSourcePage);
        offlineFileInfoUrl.searchParams.set("fileType", "offline");
        offlineFileInfoUrl.searchParams.set("timeZone", timeZone);
        if (jql) offlineFileInfoUrl.searchParams.set("jql", jql);
        if (filter) offlineFileInfoUrl.searchParams.set("filter", filter);
        const onlineFileInfoUrl = new window.URL(offlineFileInfoUrl);
        onlineFileInfoUrl.searchParams.set("fileType", "online");
        Promise.all([
            fetch(offlineFileInfoUrl).then((response)=>response.json()),
            fetch(onlineFileInfoUrl).then((response)=>response.json())
        ]).then((infos)=>{
            const [offlineFileInfo, onlineFileInfo] = infos;
            initialContext.offlineFileInfo = offlineFileInfo;
            initialContext.onlineFileInfo = onlineFileInfo;
            setContext({
                ...initialContext
            });
        }).catch((e)=>{
            // eslint-disable-next-line no-console
            console.log(`Unable to fetch file info:`, e);
            setError(true);
        });
    }, []);
    return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)($83dff726fffbbb38$export$35fd4bcf20f5837.Provider, {
        value: {
            ...context
        },
        children: error ? /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $69d7e7a0181e34d3$export$2e2bcd8739ae039), {}) : children
    });
}



function $6626fa2497a5f8b0$export$e3fe5d84ef9e0c3f({ openOnlineUrl: openOnlineUrl, setDownloadUrl: setDownloadUrl, setOpeningOnline: setOpeningOnline }) {
    const { offlineFileInfo: offlineFileInfo } = $5cNek.useContext((0, $83dff726fffbbb38$export$35fd4bcf20f5837));
    const downloadButtonProps = ()=>{
        if (!offlineFileInfo) return {}; // context is not initialized
        if (offlineFileInfo.authRequired) {
            // at the end of flow redirect to the download page
            const finalRedirectUrl = `${window.location.origin}/download-in-progress${window.location.search}`;
            const effectiveAuthFlowUrl = new URL(window.location.origin + offlineFileInfo.authFlowUrl);
            // allowed auth flow clientID
            effectiveAuthFlowUrl.searchParams.set("authClientId", "openInClientApp");
            // redirect URL is whitelisted on backend for clientId=openInClientApp
            effectiveAuthFlowUrl.searchParams.set("redirectTo", finalRedirectUrl);
            return {
                onClick: ()=>{
                    (0, $467fd94f96f91249$export$3dd849221d1b8342)("clicked", "button", "startAuth", "exportToExcelScreen");
                },
                href: effectiveAuthFlowUrl
            };
        }
        return {
            onClick: ()=>{
                (0, $467fd94f96f91249$export$3dd849221d1b8342)("clicked", "button", "downloadFile", "exportToExcelScreen");
                setDownloadUrl(offlineFileInfo.contentUrl);
            }
        };
    };
    $5cNek.useEffect(()=>(0, $467fd94f96f91249$export$f3b5b1c39333b4d1)("exportToExcelScreen"), []); // run it once
    return /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)((0, $6d5367bb84366e40$export$2e2bcd8739ae039), {
        width: "small",
        children: [
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $5f8549064b1f0c57$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $e2b7ea7cfe441535$export$2e2bcd8739ae039), {
                    children: "Select your Excel product"
                })
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)((0, $262efd68e82332b1$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("p", {
                        children: "If you use Excel Online, your issues will open in a new spreadsheet in your browser. If you're a desktop user, we'll download a file for you to open in Excel."
                    }),
                    /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)("p", {
                        children: [
                            "We also suggest the",
                            " ",
                            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("a", {
                                href: "https://appsource.microsoft.com/en-us/product/office/WA200000556",
                                onClick: (0, $467fd94f96f91249$export$c63f1658de23b754),
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: "Jira Cloud for Excel"
                            }),
                            " ",
                            "app to get Jira issues directly from your spreadsheets."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)((0, $6d0648147da89c56$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $51e43201ca42b1ec$export$2e2bcd8739ae039), {
                        ...downloadButtonProps(),
                        children: "Excel on Desktop"
                    }),
                    /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $51e43201ca42b1ec$export$2e2bcd8739ae039), {
                        href: openOnlineUrl,
                        onClick: ()=>{
                            setOpeningOnline(true);
                            (0, $467fd94f96f91249$export$3dd849221d1b8342)("clicked", "button", "openOnline", "exportToExcelScreen");
                        },
                        target: "_self",
                        children: "Excel Online"
                    })
                ]
            })
        ]
    });
}




function $f9292413c8312f31$export$b611689b7ade2ea1({ downloadInProgress: downloadInProgress, uploadInProgress: uploadInProgress }) {
    const [downloadUrl, setDownloadUrl] = $5cNek.useState();
    const [openOnlineUrl, setOpenOnlineUrl] = $5cNek.useState();
    const [openingOnline, setOpeningOnline] = $5cNek.useState();
    $5cNek.useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        const colorMode = params.get("colorMode");
        if (colorMode) (0, $9c49a4d125ba84ba$export$2e2bcd8739ae039)({
            colorMode: colorMode
        });
    }, []);
    const { jiraSourcePage: jiraSourcePage, offlineFileInfo: offlineFileInfo, onlineFileInfo: onlineFileInfo } = $5cNek.useContext((0, $83dff726fffbbb38$export$35fd4bcf20f5837));
    $5cNek.useEffect(()=>{
        if (downloadInProgress && offlineFileInfo) setDownloadUrl(offlineFileInfo.contentUrl);
        if (uploadInProgress && onlineFileInfo) setDownloadUrl(onlineFileInfo.contentUrl);
        if (onlineFileInfo) {
            if (onlineFileInfo.authRequired) {
                const searchParamsExceptIssues = new URL(window.location);
                // remove useless search param in order to avoid extremely long url
                searchParamsExceptIssues.searchParams.delete("issues");
                const finalRedirectUrl = `${window.location.origin}/upload-in-progress${searchParamsExceptIssues.search}`;
                const effectiveAuthFlowUrl = new URL(window.location.origin + onlineFileInfo.authFlowUrl);
                // allowed auth flow clientID
                effectiveAuthFlowUrl.searchParams.set("authClientId", "openInClientApp");
                // redirect URL is whitelisted on backend for clientId=openInClientApp
                effectiveAuthFlowUrl.searchParams.set("redirectTo", finalRedirectUrl);
                setOpenOnlineUrl(effectiveAuthFlowUrl);
            } else setOpenOnlineUrl(onlineFileInfo.contentUrl);
        }
    }, [
        downloadInProgress,
        offlineFileInfo,
        onlineFileInfo,
        uploadInProgress
    ]);
    $5cNek.useEffect(()=>(0, $467fd94f96f91249$export$f3b5b1c39333b4d1)("exportToExcelScreen"), []); // run it once
    if (!jiraSourcePage) return null; // empty context
    return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $a77810c2cb2af93c$export$2e2bcd8739ae039), {
        children: downloadUrl || openingOnline ? /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $226ec9402bb8315e$export$3d7f8d8994e49ef4), {
            downloadUrl: downloadUrl
        }) : /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $6626fa2497a5f8b0$export$e3fe5d84ef9e0c3f), {
            openOnlineUrl: openOnlineUrl,
            setDownloadUrl: setDownloadUrl,
            setOpeningOnline: setOpeningOnline
        })
    });
}






function $da9e38504a290558$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $46eadc0f17330f77$export$2e2bcd8739ae039), {
        description: "That link has no power here",
        header: "404 Not Found",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ad537e6a2268c57b$exports)))
    });
}
Error.propTypes = {
    primaryAction: (0, (/*@__PURE__*/$parcel$interopDefault($eda95f3e2a1fd9a2$exports))).node,
    maxImageHeight: (0, (/*@__PURE__*/$parcel$interopDefault($eda95f3e2a1fd9a2$exports))).number
};




/** @jsx jsx */ 

var $5cNek = parcelRequire("5cNek");
var $bbd492ab0a18c7e8$var$HeadingContext = /*#__PURE__*/ (0, $5cNek.createContext)(undefined);
var $bbd492ab0a18c7e8$export$9e9567cdaababb98 = function useHeadingElement() {
    return Math.min((0, $5cNek.useContext)($bbd492ab0a18c7e8$var$HeadingContext) || 0, 6);
};
/**
 * __Heading context__
 *
 * The HeadingContext
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $bbd492ab0a18c7e8$var$HeadingContextProvider = function HeadingContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $bbd492ab0a18c7e8$export$9e9567cdaababb98();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5cNek))).createElement($bbd492ab0a18c7e8$var$HeadingContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $bbd492ab0a18c7e8$export$2e2bcd8739ae039 = $bbd492ab0a18c7e8$var$HeadingContextProvider;



// https://atlassian.design/foundations/typography
var $4f519056c85f1e17$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $4f519056c85f1e17$var$headingResetStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    marginTop: "var(--ds-space-0, 0px)",
    marginBottom: "var(--ds-space-0, 0px)",
    color: "var(--ds-text, #172B4D)"
});
var $4f519056c85f1e17$var$h900Styles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $4f519056c85f1e17$var$h800Styles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $4f519056c85f1e17$var$h700Styles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $4f519056c85f1e17$var$h600Styles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $4f519056c85f1e17$var$h500Styles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $4f519056c85f1e17$var$h400Styles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $4f519056c85f1e17$var$h300Styles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $4f519056c85f1e17$var$h200Styles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $4f519056c85f1e17$var$h100Styles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $4f519056c85f1e17$var$inverseStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $4f519056c85f1e17$var$subtlestStyles = (0, $e5448515388bb91a$export$dbf350e5966cf602)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $4f519056c85f1e17$var$Heading = function Heading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $458e44519ac5ea1c$exports;
    var hLevel = (0, $bbd492ab0a18c7e8$export$9e9567cdaababb98)();
    /**
   * Order here is important, we for now apply
   * 1. user choice
   * 2. inferred a11y level
   * 3. default final fallback
   */ var Markup = as || hLevel && "h".concat(hLevel) || $4f519056c85f1e17$var$levelMap[level];
    var isSubtleHeading = level === "h200" || level === "h100";
    return (0, $e5448515388bb91a$export$c8a8987d4410bf2d)(Markup, {
        id: id,
        "data-testid": testId,
        css: [
            $4f519056c85f1e17$var$headingResetStyles,
            // This can be refactored when @compiled supports style maps
            level === "h100" && $4f519056c85f1e17$var$h100Styles,
            level === "h200" && $4f519056c85f1e17$var$h200Styles,
            level === "h300" && $4f519056c85f1e17$var$h300Styles,
            level === "h400" && $4f519056c85f1e17$var$h400Styles,
            level === "h500" && $4f519056c85f1e17$var$h500Styles,
            level === "h600" && $4f519056c85f1e17$var$h600Styles,
            level === "h700" && $4f519056c85f1e17$var$h700Styles,
            level === "h800" && $4f519056c85f1e17$var$h800Styles,
            level === "h900" && $4f519056c85f1e17$var$h900Styles,
            color === "inverse" && $4f519056c85f1e17$var$inverseStyles,
            color === "default" && isSubtleHeading && $4f519056c85f1e17$var$subtlestStyles
        ]
    }, children);
};
var $4f519056c85f1e17$export$2e2bcd8739ae039 = $4f519056c85f1e17$var$Heading;



var $XLpyq = parcelRequire("XLpyq");

var $5cNek = parcelRequire("5cNek");

var $2FWxW = parcelRequire("2FWxW");

var $lCES2 = parcelRequire("lCES2");

var $fx4dg = parcelRequire("fx4dg");

function $7dcd29546dc3e1d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7dcd29546dc3e1d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7dcd29546dc3e1d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7dcd29546dc3e1d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7dcd29546dc3e1d0$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $fx4dg.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $7dcd29546dc3e1d0$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $lCES2.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $lCES2.THEME_DATA_ATTRIBUTE)) || "";
    return $7dcd29546dc3e1d0$var$_objectSpread($7dcd29546dc3e1d0$var$_objectSpread({}, (0, $91472ce43e0ae803$export$f19b488f7c0547ee)(theme)), $7dcd29546dc3e1d0$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $7dcd29546dc3e1d0$export$2e2bcd8739ae039 = $7dcd29546dc3e1d0$var$getGlobalTheme;



var $i2CXH = parcelRequire("i2CXH");

var $4URe7 = parcelRequire("4URe7");

var $2FWxW = parcelRequire("2FWxW");

var $lCES2 = parcelRequire("lCES2");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $2d727220855c7b79$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($i2CXH)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "observer", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($2FWxW)))(this, "mediaObserver", null);
        this.callback = callback;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4URe7)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                var _this = this;
                if (!this.observer) this.observer = new MutationObserver(function() {
                    _this.callback((0, $7dcd29546dc3e1d0$export$2e2bcd8739ae039)());
                });
                this.observer.observe(document.documentElement, {
                    attributeFilter: [
                        (0, $lCES2.THEME_DATA_ATTRIBUTE),
                        (0, $lCES2.COLOR_MODE_ATTRIBUTE)
                    ]
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.observer && this.observer.disconnect();
            }
        }
    ]);
    return ThemeMutationObserver;
}();


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $6da51f9682acf7ce$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5cNek.useState)((0, $7dcd29546dc3e1d0$export$2e2bcd8739ae039)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($XLpyq)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5cNek.useEffect)(function() {
        var observer = new (0, $2d727220855c7b79$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $6da51f9682acf7ce$export$2e2bcd8739ae039 = $6da51f9682acf7ce$var$useThemeObserver;



var $5cNek = parcelRequire("5cNek");




var $5cNek = parcelRequire("5cNek");
var $2b225081e0eb447a$exports = {};
"use strict";
Object.defineProperty($2b225081e0eb447a$exports, "__esModule", {
    value: true
});
var $56a762faf0bfd1a2$exports = {};
"use strict";
var $56a762faf0bfd1a2$var$__assign = $56a762faf0bfd1a2$exports && $56a762faf0bfd1a2$exports.__assign || function() {
    $56a762faf0bfd1a2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $56a762faf0bfd1a2$var$__assign.apply(this, arguments);
};
var $56a762faf0bfd1a2$var$__awaiter = $56a762faf0bfd1a2$exports && $56a762faf0bfd1a2$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $56a762faf0bfd1a2$var$__generator = $56a762faf0bfd1a2$exports && $56a762faf0bfd1a2$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $56a762faf0bfd1a2$var$__importDefault = $56a762faf0bfd1a2$exports && $56a762faf0bfd1a2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($56a762faf0bfd1a2$exports, "__esModule", {
    value: true
});
$56a762faf0bfd1a2$exports.useWebSocket = void 0;

var $5cNek = parcelRequire("5cNek");
var $61e987b36cec0b85$exports = {};
"use strict";
Object.defineProperty($61e987b36cec0b85$exports, "__esModule", {
    value: true
});
$61e987b36cec0b85$exports.isEventSourceSupported = $61e987b36cec0b85$exports.isReactNative = $61e987b36cec0b85$exports.ReadyState = $61e987b36cec0b85$exports.UNPARSABLE_JSON_OBJECT = $61e987b36cec0b85$exports.DEFAULT_RECONNECT_INTERVAL_MS = $61e987b36cec0b85$exports.DEFAULT_RECONNECT_LIMIT = $61e987b36cec0b85$exports.SOCKET_IO_PING_CODE = $61e987b36cec0b85$exports.SOCKET_IO_PATH = $61e987b36cec0b85$exports.SOCKET_IO_PING_INTERVAL = $61e987b36cec0b85$exports.DEFAULT_EVENT_SOURCE_OPTIONS = $61e987b36cec0b85$exports.EMPTY_EVENT_HANDLERS = $61e987b36cec0b85$exports.DEFAULT_OPTIONS = void 0;
var $61e987b36cec0b85$var$MILLISECONDS = 1;
var $61e987b36cec0b85$var$SECONDS = 1000 * $61e987b36cec0b85$var$MILLISECONDS;
$61e987b36cec0b85$exports.DEFAULT_OPTIONS = {};
$61e987b36cec0b85$exports.EMPTY_EVENT_HANDLERS = {};
$61e987b36cec0b85$exports.DEFAULT_EVENT_SOURCE_OPTIONS = {
    withCredentials: false,
    events: $61e987b36cec0b85$exports.EMPTY_EVENT_HANDLERS
};
$61e987b36cec0b85$exports.SOCKET_IO_PING_INTERVAL = 25 * $61e987b36cec0b85$var$SECONDS;
$61e987b36cec0b85$exports.SOCKET_IO_PATH = "/socket.io/?EIO=3&transport=websocket";
$61e987b36cec0b85$exports.SOCKET_IO_PING_CODE = "2";
$61e987b36cec0b85$exports.DEFAULT_RECONNECT_LIMIT = 20;
$61e987b36cec0b85$exports.DEFAULT_RECONNECT_INTERVAL_MS = 5000;
$61e987b36cec0b85$exports.UNPARSABLE_JSON_OBJECT = {};
var $61e987b36cec0b85$var$ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})($61e987b36cec0b85$var$ReadyState = $61e987b36cec0b85$exports.ReadyState || ($61e987b36cec0b85$exports.ReadyState = {}));
var $61e987b36cec0b85$var$eventSourceSupported = function() {
    try {
        return "EventSource" in globalThis;
    } catch (e) {
        return false;
    }
};
$61e987b36cec0b85$exports.isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
$61e987b36cec0b85$exports.isEventSourceSupported = !$61e987b36cec0b85$exports.isReactNative && $61e987b36cec0b85$var$eventSourceSupported();


var $8ab24b3eaf129274$exports = {};
"use strict";
Object.defineProperty($8ab24b3eaf129274$exports, "__esModule", {
    value: true
});
$8ab24b3eaf129274$exports.createOrJoinSocket = void 0;
var $c8e1803837586ff3$exports = {};
"use strict";
Object.defineProperty($c8e1803837586ff3$exports, "__esModule", {
    value: true
});
$c8e1803837586ff3$exports.resetWebSockets = $c8e1803837586ff3$exports.sharedWebSockets = void 0;
$c8e1803837586ff3$exports.sharedWebSockets = {};
$c8e1803837586ff3$exports.resetWebSockets = function(url) {
    if (url && $c8e1803837586ff3$exports.sharedWebSockets.hasOwnProperty(url)) delete $c8e1803837586ff3$exports.sharedWebSockets[url];
    else {
        for(var url_1 in $c8e1803837586ff3$exports.sharedWebSockets)if ($c8e1803837586ff3$exports.sharedWebSockets.hasOwnProperty(url_1)) delete $c8e1803837586ff3$exports.sharedWebSockets[url_1];
    }
};



var $5bfa54c0415b5c6c$exports = {};
"use strict";
var $5bfa54c0415b5c6c$var$__assign = $5bfa54c0415b5c6c$exports && $5bfa54c0415b5c6c$exports.__assign || function() {
    $5bfa54c0415b5c6c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5bfa54c0415b5c6c$var$__assign.apply(this, arguments);
};
Object.defineProperty($5bfa54c0415b5c6c$exports, "__esModule", {
    value: true
});
$5bfa54c0415b5c6c$exports.attachListeners = void 0;
var $0201f02896b5a636$exports = {};
"use strict";
Object.defineProperty($0201f02896b5a636$exports, "__esModule", {
    value: true
});
$0201f02896b5a636$exports.setUpSocketIOPing = $0201f02896b5a636$exports.appendQueryParams = $0201f02896b5a636$exports.parseSocketIOUrl = void 0;

$0201f02896b5a636$exports.parseSocketIOUrl = function(url) {
    if (url) {
        var isSecure = /^https|wss/.test(url);
        var strippedProtocol = url.replace(/^(https?|wss?)(:\/\/)?/, "");
        var removedFinalBackSlack = strippedProtocol.replace(/\/$/, "");
        var protocol = isSecure ? "wss" : "ws";
        return protocol + "://" + removedFinalBackSlack + $61e987b36cec0b85$exports.SOCKET_IO_PATH;
    } else if (url === "") {
        var isSecure = /^https/.test(window.location.protocol);
        var protocol = isSecure ? "wss" : "ws";
        var port = window.location.port ? ":" + window.location.port : "";
        return protocol + "://" + window.location.hostname + port + $61e987b36cec0b85$exports.SOCKET_IO_PATH;
    }
    return url;
};
$0201f02896b5a636$exports.appendQueryParams = function(url, params) {
    if (params === void 0) params = {};
    var hasParamsRegex = /\?([\w]+=[\w]+)/;
    var alreadyHasParams = hasParamsRegex.test(url);
    var stringified = "" + Object.entries(params).reduce(function(next, _a) {
        var key = _a[0], value = _a[1];
        return next + (key + "=" + value + "&");
    }, "").slice(0, -1);
    return "" + url + (alreadyHasParams ? "&" : "?") + stringified;
};
$0201f02896b5a636$exports.setUpSocketIOPing = function(sendMessage, interval) {
    if (interval === void 0) interval = $61e987b36cec0b85$exports.SOCKET_IO_PING_INTERVAL;
    var ping = function() {
        return sendMessage($61e987b36cec0b85$exports.SOCKET_IO_PING_CODE);
    };
    return setInterval(ping, interval);
};



var $239f97948f90891c$exports = {};
"use strict";
Object.defineProperty($239f97948f90891c$exports, "__esModule", {
    value: true
});
$239f97948f90891c$exports.resetGlobalState = $239f97948f90891c$exports.assertIsWebSocket = void 0;

var $fa56677dd1ea7ee8$exports = {};
"use strict";
Object.defineProperty($fa56677dd1ea7ee8$exports, "__esModule", {
    value: true
});
$fa56677dd1ea7ee8$exports.resetSubscribers = $fa56677dd1ea7ee8$exports.removeSubscriber = $fa56677dd1ea7ee8$exports.addSubscriber = $fa56677dd1ea7ee8$exports.hasSubscribers = $fa56677dd1ea7ee8$exports.getSubscribers = void 0;
var $fa56677dd1ea7ee8$var$subscribers = {};
var $fa56677dd1ea7ee8$var$EMPTY_LIST = [];
$fa56677dd1ea7ee8$exports.getSubscribers = function(url) {
    if ($fa56677dd1ea7ee8$exports.hasSubscribers(url)) return Array.from($fa56677dd1ea7ee8$var$subscribers[url]);
    return $fa56677dd1ea7ee8$var$EMPTY_LIST;
};
$fa56677dd1ea7ee8$exports.hasSubscribers = function(url) {
    var _a;
    return ((_a = $fa56677dd1ea7ee8$var$subscribers[url]) === null || _a === void 0 ? void 0 : _a.size) > 0;
};
$fa56677dd1ea7ee8$exports.addSubscriber = function(url, subscriber) {
    $fa56677dd1ea7ee8$var$subscribers[url] = $fa56677dd1ea7ee8$var$subscribers[url] || new Set();
    $fa56677dd1ea7ee8$var$subscribers[url].add(subscriber);
};
$fa56677dd1ea7ee8$exports.removeSubscriber = function(url, subscriber) {
    $fa56677dd1ea7ee8$var$subscribers[url].delete(subscriber);
};
$fa56677dd1ea7ee8$exports.resetSubscribers = function(url) {
    if (url && $fa56677dd1ea7ee8$var$subscribers.hasOwnProperty(url)) delete $fa56677dd1ea7ee8$var$subscribers[url];
    else {
        for(var url_1 in $fa56677dd1ea7ee8$var$subscribers)if ($fa56677dd1ea7ee8$var$subscribers.hasOwnProperty(url_1)) delete $fa56677dd1ea7ee8$var$subscribers[url_1];
    }
};


function $239f97948f90891c$var$assertIsWebSocket(webSocketInstance) {
    if (webSocketInstance instanceof WebSocket === false) throw new Error("");
}
$239f97948f90891c$exports.assertIsWebSocket = $239f97948f90891c$var$assertIsWebSocket;
function $239f97948f90891c$var$resetGlobalState(url) {
    $fa56677dd1ea7ee8$exports.resetSubscribers(url);
    $c8e1803837586ff3$exports.resetWebSockets(url);
}
$239f97948f90891c$exports.resetGlobalState = $239f97948f90891c$var$resetGlobalState;


var $5bfa54c0415b5c6c$var$bindMessageHandler = function(webSocketInstance, optionsRef, setLastMessage) {
    webSocketInstance.onmessage = function(message) {
        optionsRef.current.onMessage && optionsRef.current.onMessage(message);
        if (typeof optionsRef.current.filter === "function" && optionsRef.current.filter(message) !== true) return;
        setLastMessage(message);
    };
};
var $5bfa54c0415b5c6c$var$bindOpenHandler = function(webSocketInstance, optionsRef, setReadyState, reconnectCount) {
    webSocketInstance.onopen = function(event) {
        optionsRef.current.onOpen && optionsRef.current.onOpen(event);
        reconnectCount.current = 0;
        setReadyState($61e987b36cec0b85$exports.ReadyState.OPEN);
    };
};
var $5bfa54c0415b5c6c$var$bindCloseHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    if ($61e987b36cec0b85$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) return function() {};
    $239f97948f90891c$exports.assertIsWebSocket(webSocketInstance);
    var reconnectTimeout;
    webSocketInstance.onclose = function(event) {
        var _a, _b;
        optionsRef.current.onClose && optionsRef.current.onClose(event);
        setReadyState($61e987b36cec0b85$exports.ReadyState.CLOSED);
        if (optionsRef.current.shouldReconnect && optionsRef.current.shouldReconnect(event)) {
            var reconnectAttempts = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $61e987b36cec0b85$exports.DEFAULT_RECONNECT_LIMIT;
            if (reconnectCount.current < reconnectAttempts) reconnectTimeout = window.setTimeout(function() {
                reconnectCount.current++;
                reconnect();
            }, (_b = optionsRef.current.reconnectInterval) !== null && _b !== void 0 ? _b : $61e987b36cec0b85$exports.DEFAULT_RECONNECT_INTERVAL_MS);
            else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(reconnectAttempts);
                console.warn("Max reconnect attempts of " + reconnectAttempts + " exceeded");
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var $5bfa54c0415b5c6c$var$bindErrorHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    var reconnectTimeout;
    webSocketInstance.onerror = function(error) {
        var _a, _b;
        optionsRef.current.onError && optionsRef.current.onError(error);
        if ($61e987b36cec0b85$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) {
            optionsRef.current.onClose && optionsRef.current.onClose($5bfa54c0415b5c6c$var$__assign($5bfa54c0415b5c6c$var$__assign({}, error), {
                code: 1006,
                reason: "An error occurred with the EventSource: " + error,
                wasClean: false
            }));
            setReadyState($61e987b36cec0b85$exports.ReadyState.CLOSED);
            webSocketInstance.close();
        }
        if (optionsRef.current.retryOnError) {
            if (reconnectCount.current < ((_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $61e987b36cec0b85$exports.DEFAULT_RECONNECT_LIMIT)) reconnectTimeout = window.setTimeout(function() {
                reconnectCount.current++;
                reconnect();
            }, (_b = optionsRef.current.reconnectInterval) !== null && _b !== void 0 ? _b : $61e987b36cec0b85$exports.DEFAULT_RECONNECT_INTERVAL_MS);
            else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(optionsRef.current.reconnectAttempts);
                console.warn("Max reconnect attempts of " + optionsRef.current.reconnectAttempts + " exceeded");
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
$5bfa54c0415b5c6c$exports.attachListeners = function(webSocketInstance, setters, optionsRef, reconnect, reconnectCount, sendMessage) {
    var setLastMessage = setters.setLastMessage, setReadyState = setters.setReadyState;
    var interval;
    var cancelReconnectOnClose;
    var cancelReconnectOnError;
    if (optionsRef.current.fromSocketIO) interval = $0201f02896b5a636$exports.setUpSocketIOPing(sendMessage);
    $5bfa54c0415b5c6c$var$bindMessageHandler(webSocketInstance, optionsRef, setLastMessage);
    $5bfa54c0415b5c6c$var$bindOpenHandler(webSocketInstance, optionsRef, setReadyState, reconnectCount);
    cancelReconnectOnClose = $5bfa54c0415b5c6c$var$bindCloseHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    cancelReconnectOnError = $5bfa54c0415b5c6c$var$bindErrorHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    return function() {
        setReadyState($61e987b36cec0b85$exports.ReadyState.CLOSING);
        cancelReconnectOnClose();
        cancelReconnectOnError();
        webSocketInstance.close();
        if (interval) clearInterval(interval);
    };
};


var $6711d28d8d86a587$exports = {};
"use strict";
var $6711d28d8d86a587$var$__assign = $6711d28d8d86a587$exports && $6711d28d8d86a587$exports.__assign || function() {
    $6711d28d8d86a587$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6711d28d8d86a587$var$__assign.apply(this, arguments);
};
Object.defineProperty($6711d28d8d86a587$exports, "__esModule", {
    value: true
});
$6711d28d8d86a587$exports.attachSharedListeners = void 0;




var $6711d28d8d86a587$var$bindMessageHandler = function(webSocketInstance, url) {
    webSocketInstance.onmessage = function(message) {
        $fa56677dd1ea7ee8$exports.getSubscribers(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onMessage) subscriber.optionsRef.current.onMessage(message);
            if (typeof subscriber.optionsRef.current.filter === "function" && subscriber.optionsRef.current.filter(message) !== true) return;
            subscriber.setLastMessage(message);
        });
    };
};
var $6711d28d8d86a587$var$bindOpenHandler = function(webSocketInstance, url) {
    webSocketInstance.onopen = function(event) {
        $fa56677dd1ea7ee8$exports.getSubscribers(url).forEach(function(subscriber) {
            subscriber.reconnectCount.current = 0;
            if (subscriber.optionsRef.current.onOpen) subscriber.optionsRef.current.onOpen(event);
            subscriber.setReadyState($61e987b36cec0b85$exports.ReadyState.OPEN);
        });
    };
};
var $6711d28d8d86a587$var$bindCloseHandler = function(webSocketInstance, url) {
    if (webSocketInstance instanceof WebSocket) webSocketInstance.onclose = function(event) {
        $fa56677dd1ea7ee8$exports.getSubscribers(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onClose) subscriber.optionsRef.current.onClose(event);
            subscriber.setReadyState($61e987b36cec0b85$exports.ReadyState.CLOSED);
        });
        delete $c8e1803837586ff3$exports.sharedWebSockets[url];
        $fa56677dd1ea7ee8$exports.getSubscribers(url).forEach(function(subscriber) {
            var _a, _b;
            if (subscriber.optionsRef.current.shouldReconnect && subscriber.optionsRef.current.shouldReconnect(event)) {
                var reconnectAttempts = (_a = subscriber.optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $61e987b36cec0b85$exports.DEFAULT_RECONNECT_LIMIT;
                if (subscriber.reconnectCount.current < reconnectAttempts) setTimeout(function() {
                    subscriber.reconnectCount.current++;
                    subscriber.reconnect.current();
                }, (_b = subscriber.optionsRef.current.reconnectInterval) !== null && _b !== void 0 ? _b : $61e987b36cec0b85$exports.DEFAULT_RECONNECT_INTERVAL_MS);
                else {
                    subscriber.optionsRef.current.onReconnectStop && subscriber.optionsRef.current.onReconnectStop(subscriber.optionsRef.current.reconnectAttempts);
                    console.warn("Max reconnect attempts of " + reconnectAttempts + " exceeded");
                }
            }
        });
    };
};
var $6711d28d8d86a587$var$bindErrorHandler = function(webSocketInstance, url) {
    webSocketInstance.onerror = function(error) {
        $fa56677dd1ea7ee8$exports.getSubscribers(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onError) subscriber.optionsRef.current.onError(error);
            if ($61e987b36cec0b85$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) {
                subscriber.optionsRef.current.onClose && subscriber.optionsRef.current.onClose($6711d28d8d86a587$var$__assign($6711d28d8d86a587$var$__assign({}, error), {
                    code: 1006,
                    reason: "An error occurred with the EventSource: " + error,
                    wasClean: false
                }));
                subscriber.setReadyState($61e987b36cec0b85$exports.ReadyState.CLOSED);
            }
        });
        if ($61e987b36cec0b85$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) webSocketInstance.close();
    };
};
$6711d28d8d86a587$exports.attachSharedListeners = function(webSocketInstance, url, optionsRef, sendMessage) {
    var interval;
    if (optionsRef.current.fromSocketIO) interval = $0201f02896b5a636$exports.setUpSocketIOPing(sendMessage);
    $6711d28d8d86a587$var$bindMessageHandler(webSocketInstance, url);
    $6711d28d8d86a587$var$bindCloseHandler(webSocketInstance, url);
    $6711d28d8d86a587$var$bindOpenHandler(webSocketInstance, url);
    $6711d28d8d86a587$var$bindErrorHandler(webSocketInstance, url);
    return function() {
        if (interval) clearInterval(interval);
    };
};



//TODO ensure that all onClose callbacks are called
var $8ab24b3eaf129274$var$cleanSubscribers = function(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval) {
    return function() {
        $fa56677dd1ea7ee8$exports.removeSubscriber(url, subscriber);
        if (!$fa56677dd1ea7ee8$exports.hasSubscribers(url)) {
            try {
                var socketLike = $c8e1803837586ff3$exports.sharedWebSockets[url];
                if (socketLike instanceof WebSocket) socketLike.onclose = function(event) {
                    if (optionsRef.current.onClose) optionsRef.current.onClose(event);
                    setReadyState($61e987b36cec0b85$exports.ReadyState.CLOSED);
                };
                socketLike.close();
            } catch (e) {}
            if (clearSocketIoPingInterval) clearSocketIoPingInterval();
            delete $c8e1803837586ff3$exports.sharedWebSockets[url];
        }
    };
};
$8ab24b3eaf129274$exports.createOrJoinSocket = function(webSocketRef, url, setReadyState, optionsRef, setLastMessage, startRef, reconnectCount, sendMessage) {
    if (!$61e987b36cec0b85$exports.isEventSourceSupported && optionsRef.current.eventSourceOptions) {
        if ($61e987b36cec0b85$exports.isReactNative) throw new Error("EventSource is not supported in ReactNative");
        else throw new Error("EventSource is not supported");
    }
    if (optionsRef.current.share) {
        var clearSocketIoPingInterval = null;
        if ($c8e1803837586ff3$exports.sharedWebSockets[url] === undefined) {
            $c8e1803837586ff3$exports.sharedWebSockets[url] = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
            webSocketRef.current = $c8e1803837586ff3$exports.sharedWebSockets[url];
            setReadyState($61e987b36cec0b85$exports.ReadyState.CONNECTING);
            clearSocketIoPingInterval = $6711d28d8d86a587$exports.attachSharedListeners($c8e1803837586ff3$exports.sharedWebSockets[url], url, optionsRef, sendMessage);
        } else {
            webSocketRef.current = $c8e1803837586ff3$exports.sharedWebSockets[url];
            setReadyState($c8e1803837586ff3$exports.sharedWebSockets[url].readyState);
        }
        var subscriber = {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState,
            optionsRef: optionsRef,
            reconnectCount: reconnectCount,
            reconnect: startRef
        };
        $fa56677dd1ea7ee8$exports.addSubscriber(url, subscriber);
        return $8ab24b3eaf129274$var$cleanSubscribers(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval);
    } else {
        webSocketRef.current = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
        setReadyState($61e987b36cec0b85$exports.ReadyState.CONNECTING);
        if (!webSocketRef.current) throw new Error("WebSocket failed to be created");
        return $5bfa54c0415b5c6c$exports.attachListeners(webSocketRef.current, {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState
        }, optionsRef, startRef.current, reconnectCount, sendMessage);
    }
};


var $6031b7a33350238e$exports = {};
"use strict";
var $6031b7a33350238e$var$__awaiter = $6031b7a33350238e$exports && $6031b7a33350238e$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6031b7a33350238e$var$__generator = $6031b7a33350238e$exports && $6031b7a33350238e$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($6031b7a33350238e$exports, "__esModule", {
    value: true
});
$6031b7a33350238e$exports.getUrl = void 0;

$6031b7a33350238e$exports.getUrl = function(url, optionsRef) {
    return $6031b7a33350238e$var$__awaiter(void 0, void 0, void 0, function() {
        var convertedUrl, parsedUrl, parsedWithQueryParams;
        return $6031b7a33350238e$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(typeof url === "function")) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        url()
                    ];
                case 1:
                    convertedUrl = _a.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    convertedUrl = url;
                    _a.label = 3;
                case 3:
                    parsedUrl = optionsRef.current.fromSocketIO ? $0201f02896b5a636$exports.parseSocketIOUrl(convertedUrl) : convertedUrl;
                    parsedWithQueryParams = optionsRef.current.queryParams ? $0201f02896b5a636$exports.appendQueryParams(parsedUrl, optionsRef.current.queryParams) : parsedUrl;
                    return [
                        2 /*return*/ ,
                        parsedWithQueryParams
                    ];
            }
        });
    });
};



var $56a762faf0bfd1a2$var$proxy_1 = $56a762faf0bfd1a2$var$__importDefault((parcelRequire("2UUn7")));

$56a762faf0bfd1a2$exports.useWebSocket = function(url, options, connect) {
    if (options === void 0) options = $61e987b36cec0b85$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var _a = $5cNek.useState(null), lastMessage = _a[0], setLastMessage = _a[1];
    var _b = $5cNek.useState({}), readyState = _b[0], setReadyState = _b[1];
    var lastJsonMessage = $5cNek.useMemo(function() {
        if (lastMessage) try {
            return JSON.parse(lastMessage.data);
        } catch (e) {
            return $61e987b36cec0b85$exports.UNPARSABLE_JSON_OBJECT;
        }
        return null;
    }, [
        lastMessage
    ]);
    var convertedUrl = $5cNek.useRef(null);
    var webSocketRef = $5cNek.useRef(null);
    var startRef = $5cNek.useRef(function() {
        return void 0;
    });
    var reconnectCount = $5cNek.useRef(0);
    var messageQueue = $5cNek.useRef([]);
    var webSocketProxy = $5cNek.useRef(null);
    var optionsCache = $5cNek.useRef(options);
    optionsCache.current = options;
    var readyStateFromUrl = convertedUrl.current && readyState[convertedUrl.current] !== undefined ? readyState[convertedUrl.current] : url !== null && connect === true ? $61e987b36cec0b85$exports.ReadyState.CONNECTING : $61e987b36cec0b85$exports.ReadyState.UNINSTANTIATED;
    var stringifiedQueryParams = options.queryParams ? JSON.stringify(options.queryParams) : null;
    var sendMessage = $5cNek.useCallback(function(message, keep) {
        var _a;
        if (keep === void 0) keep = true;
        if ($61e987b36cec0b85$exports.isEventSourceSupported && webSocketRef.current instanceof EventSource) {
            console.warn("Unable to send a message from an eventSource");
            return;
        }
        if (((_a = webSocketRef.current) === null || _a === void 0 ? void 0 : _a.readyState) === $61e987b36cec0b85$exports.ReadyState.OPEN) {
            $239f97948f90891c$exports.assertIsWebSocket(webSocketRef.current);
            webSocketRef.current.send(message);
        } else if (keep) messageQueue.current.push(message);
    }, []);
    var sendJsonMessage = $5cNek.useCallback(function(message, keep) {
        if (keep === void 0) keep = true;
        sendMessage(JSON.stringify(message), keep);
    }, [
        sendMessage
    ]);
    var getWebSocket = $5cNek.useCallback(function() {
        if (optionsCache.current.share !== true || $61e987b36cec0b85$exports.isEventSourceSupported && webSocketRef.current instanceof EventSource) return webSocketRef.current;
        if (webSocketProxy.current === null && webSocketRef.current) {
            $239f97948f90891c$exports.assertIsWebSocket(webSocketRef.current);
            webSocketProxy.current = $56a762faf0bfd1a2$var$proxy_1.default(webSocketRef.current, startRef);
        }
        return webSocketProxy.current;
    }, []);
    $5cNek.useEffect(function() {
        if (url !== null && connect === true) {
            var removeListeners_1;
            var expectClose_1 = false;
            var start_1 = function() {
                return $56a762faf0bfd1a2$var$__awaiter(void 0, void 0, void 0, function() {
                    var _a, protectedSetLastMessage, protectedSetReadyState;
                    return $56a762faf0bfd1a2$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _a = convertedUrl;
                                return [
                                    4 /*yield*/ ,
                                    $6031b7a33350238e$exports.getUrl(url, optionsCache)
                                ];
                            case 1:
                                _a.current = _b.sent();
                                protectedSetLastMessage = function(message) {
                                    if (!expectClose_1) setLastMessage(message);
                                };
                                protectedSetReadyState = function(state) {
                                    if (!expectClose_1) setReadyState(function(prev) {
                                        var _a;
                                        return $56a762faf0bfd1a2$var$__assign($56a762faf0bfd1a2$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = state, _a));
                                    });
                                };
                                removeListeners_1 = $8ab24b3eaf129274$exports.createOrJoinSocket(webSocketRef, convertedUrl.current, protectedSetReadyState, optionsCache, protectedSetLastMessage, startRef, reconnectCount, sendMessage);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            startRef.current = function() {
                if (!expectClose_1) {
                    if (webSocketProxy.current) webSocketProxy.current = null;
                    removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                    start_1();
                }
            };
            start_1();
            return function() {
                expectClose_1 = true;
                if (webSocketProxy.current) webSocketProxy.current = null;
                removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                setLastMessage(null);
            };
        } else if (url === null || connect === false) {
            reconnectCount.current = 0; // reset reconnection attempts
            setReadyState(function(prev) {
                var _a;
                return $56a762faf0bfd1a2$var$__assign($56a762faf0bfd1a2$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = $61e987b36cec0b85$exports.ReadyState.CLOSED, _a));
            });
        }
    }, [
        url,
        connect,
        stringifiedQueryParams,
        sendMessage
    ]);
    $5cNek.useEffect(function() {
        if (readyStateFromUrl === $61e987b36cec0b85$exports.ReadyState.OPEN) messageQueue.current.splice(0).forEach(function(message) {
            sendMessage(message);
        });
    }, [
        readyStateFromUrl
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: lastMessage,
        lastJsonMessage: lastJsonMessage,
        readyState: readyStateFromUrl,
        getWebSocket: getWebSocket
    };
};


Object.defineProperty($2b225081e0eb447a$exports, "default", {
    enumerable: true,
    get: function() {
        return $56a762faf0bfd1a2$exports.useWebSocket;
    }
});
var $8252f3fb5c455d84$exports = {};
"use strict";
var $8252f3fb5c455d84$var$__assign = $8252f3fb5c455d84$exports && $8252f3fb5c455d84$exports.__assign || function() {
    $8252f3fb5c455d84$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8252f3fb5c455d84$var$__assign.apply(this, arguments);
};
Object.defineProperty($8252f3fb5c455d84$exports, "__esModule", {
    value: true
});
$8252f3fb5c455d84$exports.useSocketIO = void 0;

var $5cNek = parcelRequire("5cNek");


var $8252f3fb5c455d84$var$emptyEvent = {
    type: "empty",
    payload: null
};
var $8252f3fb5c455d84$var$getSocketData = function(event) {
    if (!event || !event.data) return $8252f3fb5c455d84$var$emptyEvent;
    var match = event.data.match(/\[.*]/);
    if (!match) return $8252f3fb5c455d84$var$emptyEvent;
    var data = JSON.parse(match);
    if (!Array.isArray(data) || !data[1]) return $8252f3fb5c455d84$var$emptyEvent;
    return {
        type: data[0],
        payload: data[1]
    };
};
$8252f3fb5c455d84$exports.useSocketIO = function(url, options, connect) {
    if (options === void 0) options = $61e987b36cec0b85$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var optionsWithSocketIO = $5cNek.useMemo(function() {
        return $8252f3fb5c455d84$var$__assign($8252f3fb5c455d84$var$__assign({}, options), {
            fromSocketIO: true
        });
    }, []);
    var _a = $56a762faf0bfd1a2$exports.useWebSocket(url, optionsWithSocketIO, connect), sendMessage = _a.sendMessage, sendJsonMessage = _a.sendJsonMessage, lastMessage = _a.lastMessage, readyState = _a.readyState, getWebSocket = _a.getWebSocket;
    var socketIOLastMessage = $5cNek.useMemo(function() {
        return $8252f3fb5c455d84$var$getSocketData(lastMessage);
    }, [
        lastMessage
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: socketIOLastMessage,
        lastJsonMessage: socketIOLastMessage,
        readyState: readyState,
        getWebSocket: getWebSocket
    };
};


Object.defineProperty($2b225081e0eb447a$exports, "useSocketIO", {
    enumerable: true,
    get: function() {
        return $8252f3fb5c455d84$exports.useSocketIO;
    }
});

Object.defineProperty($2b225081e0eb447a$exports, "ReadyState", {
    enumerable: true,
    get: function() {
        return $61e987b36cec0b85$exports.ReadyState;
    }
});
var $ec77edbdff0ebe86$exports = {};
"use strict";
var $ec77edbdff0ebe86$var$__assign = $ec77edbdff0ebe86$exports && $ec77edbdff0ebe86$exports.__assign || function() {
    $ec77edbdff0ebe86$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ec77edbdff0ebe86$var$__assign.apply(this, arguments);
};
var $ec77edbdff0ebe86$var$__rest = $ec77edbdff0ebe86$exports && $ec77edbdff0ebe86$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($ec77edbdff0ebe86$exports, "__esModule", {
    value: true
});
$ec77edbdff0ebe86$exports.useEventSource = void 0;

var $5cNek = parcelRequire("5cNek");


$ec77edbdff0ebe86$exports.useEventSource = function(url, _a, connect) {
    if (_a === void 0) _a = $61e987b36cec0b85$exports.DEFAULT_EVENT_SOURCE_OPTIONS;
    if (connect === void 0) connect = true;
    var withCredentials = _a.withCredentials, events = _a.events, options = $ec77edbdff0ebe86$var$__rest(_a, [
        "withCredentials",
        "events"
    ]);
    var optionsWithEventSource = $ec77edbdff0ebe86$var$__assign($ec77edbdff0ebe86$var$__assign({}, options), {
        eventSourceOptions: {
            withCredentials: withCredentials
        }
    });
    var eventsRef = $5cNek.useRef($61e987b36cec0b85$exports.EMPTY_EVENT_HANDLERS);
    if (events) eventsRef.current = events;
    var _b = $56a762faf0bfd1a2$exports.useWebSocket(url, optionsWithEventSource, connect), lastMessage = _b.lastMessage, readyState = _b.readyState, getWebSocket = _b.getWebSocket;
    $5cNek.useEffect(function() {
        if (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) Object.entries(eventsRef.current).forEach(function(_a) {
            var type = _a[0], handler = _a[1];
            if (type === lastMessage.type) handler(lastMessage);
        });
    }, [
        lastMessage
    ]);
    return {
        lastEvent: lastMessage,
        readyState: readyState,
        getEventSource: getWebSocket
    };
};


Object.defineProperty($2b225081e0eb447a$exports, "useEventSource", {
    enumerable: true,
    get: function() {
        return $ec77edbdff0ebe86$exports.useEventSource;
    }
});

Object.defineProperty($2b225081e0eb447a$exports, "resetGlobalState", {
    enumerable: true,
    get: function() {
        return $239f97948f90891c$exports.resetGlobalState;
    }
});




var $ga0rZ = parcelRequire("ga0rZ");

var $lCES2 = parcelRequire("lCES2");

var $e7cde00fa85e65e6$var$name = "@atlaskit/tokens";
var $e7cde00fa85e65e6$var$version = "1.28.1";
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $e7cde00fa85e65e6$var$token(path, fallback) {
    var token = (0, $ga0rZ.default)[path];
    typeof $458e44519ac5ea1c$exports;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $lCES2.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $e7cde00fa85e65e6$export$2e2bcd8739ae039 = $e7cde00fa85e65e6$var$token;



function $3ce8266cd37044aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ce8266cd37044aa$export$839f9b7dfe545fdc = {
    wrapper: {
        name: "tinu7p",
        styles: "display:flex;flex-direction:column;height:100%;justify-content:space-between"
    },
    heading: /*#__PURE__*/ (0, $e5448515388bb91a$export$dbf350e5966cf602)({
        padding: `${(0, $e7cde00fa85e65e6$export$2e2bcd8739ae039)("space.300", "24px")} ${(0, $e7cde00fa85e65e6$export$2e2bcd8739ae039)("space.300", "24px")} 22px`
    }, "", ""),
    body: /*#__PURE__*/ (0, $e5448515388bb91a$export$dbf350e5966cf602)({
        flexGrow: 1,
        padding: `${(0, $e7cde00fa85e65e6$export$2e2bcd8739ae039)("space.025", "2px")} ${(0, $e7cde00fa85e65e6$export$2e2bcd8739ae039)("space.300", "24px")}`
    }, "", ""),
    footer: /*#__PURE__*/ (0, $e5448515388bb91a$export$dbf350e5966cf602)({
        display: "flex",
        justifyContent: "flex-end",
        gap: (0, $e7cde00fa85e65e6$export$2e2bcd8739ae039)("space.100", "8px"),
        padding: `22px ${(0, $e7cde00fa85e65e6$export$2e2bcd8739ae039)("space.300", "24px")} ${(0, $e7cde00fa85e65e6$export$2e2bcd8739ae039)("space.300", "24px")}`
    }, "", "")
};


function $c482d3d206c56e7e$export$78ebdc12138f48e0({ jwt: jwt, authWindow: authWindow, updateIsSubscribedForOTP: updateIsSubscribedForOTP }) {
    const [hasWsError, setHasWsError] = $5cNek.useState(false);
    const { sendMessage: sendMessage, lastJsonMessage: lastJsonMessage, readyState: readyState } = (0, (/*@__PURE__*/$parcel$interopDefault($2b225081e0eb447a$exports)))(new URL("/ws", `wss://${window.location.host}`).toString(), {
        shouldReconnect: (e)=>true,
        reconnectInterval: 500,
        reconnectAttempts: 10,
        onReconnectStop (n) {
            // eslint-disable-next-line no-console
            console.warn(`Failed to connect to the server. Attempts: ${n}`);
            setHasWsError(true);
        }
    });
    $5cNek.useEffect(()=>{
        async function receiveMessage(event) {
            if (event?.data !== "get_panel_otp") {
                // eslint-disable-next-line no-console
                console.warn("Unknown event", event.data);
                return;
            }
            if (!lastJsonMessage?.panelOTP) await new Promise((resolve)=>setTimeout(resolve, 1000));
            authWindow && authWindow.postMessage({
                otp: lastJsonMessage?.panelOTP,
                system: lastJsonMessage?.system
            }, event.origin);
        }
        window.addEventListener("message", (event)=>receiveMessage(event));
    }, [
        authWindow,
        jwt,
        lastJsonMessage?.panelOTP,
        lastJsonMessage?.system
    ]);
    $5cNek.useEffect(()=>{
        if (readyState === (0, $2b225081e0eb447a$exports.ReadyState).OPEN && jwt) sendMessage(jwt);
    }, [
        jwt,
        readyState,
        sendMessage
    ]);
    $5cNek.useEffect(()=>{
        if (lastJsonMessage?.status === "subscribed") updateIsSubscribedForOTP(true);
        if (lastJsonMessage?.status === "done") window.AP.dialog.close();
    }, [
        lastJsonMessage
    ]);
    if (hasWsError) return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)($c482d3d206c56e7e$var$Modal, {
        heading: "Something went wrong",
        children: "Please close this dialog and try again"
    });
    if (lastJsonMessage?.panelOTP) return /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)($c482d3d206c56e7e$var$Modal, {
        heading: "Verify",
        children: [
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("p", {
                children: "If requested, please enter this code:"
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("h3", {
                children: lastJsonMessage?.panelOTP
            })
        ]
    });
    return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)($c482d3d206c56e7e$var$Modal, {
        heading: "Loading..."
    });
}
function $c482d3d206c56e7e$var$Modal({ heading: heading, children: children }) {
    return /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)("section", {
        css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).wrapper,
        children: [
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("div", {
                css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).heading,
                children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $4f519056c85f1e17$export$2e2bcd8739ae039), {
                    as: "h1",
                    level: "h600",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("div", {
                css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).body,
                children: children
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("div", {
                css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).footer,
                children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $51e43201ca42b1ec$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        window.AP.dialog.close();
                    },
                    children: "Cancel"
                })
            })
        ]
    });
}




/** Detect free variable `global` from Node.js. */ var $01ad552078bda59d$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $01ad552078bda59d$export$2e2bcd8739ae039 = $01ad552078bda59d$var$freeGlobal;


/** Detect free variable `self`. */ var $1411a3aa46f5d7a2$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1411a3aa46f5d7a2$var$root = (0, $01ad552078bda59d$export$2e2bcd8739ae039) || $1411a3aa46f5d7a2$var$freeSelf || Function("return this")();
var $1411a3aa46f5d7a2$export$2e2bcd8739ae039 = $1411a3aa46f5d7a2$var$root;


/** Built-in value references. */ var $fa0be891f22f45fa$var$Symbol = (0, $1411a3aa46f5d7a2$export$2e2bcd8739ae039).Symbol;
var $fa0be891f22f45fa$export$2e2bcd8739ae039 = $fa0be891f22f45fa$var$Symbol;



/** Used for built-in method references. */ var $ea335d2e05acbf62$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ea335d2e05acbf62$var$hasOwnProperty = $ea335d2e05acbf62$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ea335d2e05acbf62$var$nativeObjectToString = $ea335d2e05acbf62$var$objectProto.toString;
/** Built-in value references. */ var $ea335d2e05acbf62$var$symToStringTag = (0, $fa0be891f22f45fa$export$2e2bcd8739ae039) ? (0, $fa0be891f22f45fa$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $ea335d2e05acbf62$var$getRawTag(value) {
    var isOwn = $ea335d2e05acbf62$var$hasOwnProperty.call(value, $ea335d2e05acbf62$var$symToStringTag), tag = value[$ea335d2e05acbf62$var$symToStringTag];
    try {
        value[$ea335d2e05acbf62$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $ea335d2e05acbf62$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$ea335d2e05acbf62$var$symToStringTag] = tag;
        else delete value[$ea335d2e05acbf62$var$symToStringTag];
    }
    return result;
}
var $ea335d2e05acbf62$export$2e2bcd8739ae039 = $ea335d2e05acbf62$var$getRawTag;


/** Used for built-in method references. */ var $d399d76c3aae4e1c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d399d76c3aae4e1c$var$nativeObjectToString = $d399d76c3aae4e1c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d399d76c3aae4e1c$var$objectToString(value) {
    return $d399d76c3aae4e1c$var$nativeObjectToString.call(value);
}
var $d399d76c3aae4e1c$export$2e2bcd8739ae039 = $d399d76c3aae4e1c$var$objectToString;


/** `Object#toString` result references. */ var $38f60f7f14c2ccd7$var$nullTag = "[object Null]", $38f60f7f14c2ccd7$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $38f60f7f14c2ccd7$var$symToStringTag = (0, $fa0be891f22f45fa$export$2e2bcd8739ae039) ? (0, $fa0be891f22f45fa$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $38f60f7f14c2ccd7$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $38f60f7f14c2ccd7$var$undefinedTag : $38f60f7f14c2ccd7$var$nullTag;
    return $38f60f7f14c2ccd7$var$symToStringTag && $38f60f7f14c2ccd7$var$symToStringTag in Object(value) ? (0, $ea335d2e05acbf62$export$2e2bcd8739ae039)(value) : (0, $d399d76c3aae4e1c$export$2e2bcd8739ae039)(value);
}
var $38f60f7f14c2ccd7$export$2e2bcd8739ae039 = $38f60f7f14c2ccd7$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $247147f553028710$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $247147f553028710$export$2e2bcd8739ae039 = $247147f553028710$var$isObject;


/** `Object#toString` result references. */ var $597ca852020b7ccb$var$asyncTag = "[object AsyncFunction]", $597ca852020b7ccb$var$funcTag = "[object Function]", $597ca852020b7ccb$var$genTag = "[object GeneratorFunction]", $597ca852020b7ccb$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $597ca852020b7ccb$var$isFunction(value) {
    if (!(0, $247147f553028710$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $38f60f7f14c2ccd7$export$2e2bcd8739ae039)(value);
    return tag == $597ca852020b7ccb$var$funcTag || tag == $597ca852020b7ccb$var$genTag || tag == $597ca852020b7ccb$var$asyncTag || tag == $597ca852020b7ccb$var$proxyTag;
}
var $597ca852020b7ccb$export$2e2bcd8739ae039 = $597ca852020b7ccb$var$isFunction;



/** Used to detect overreaching core-js shims. */ var $80357e180d848e7c$var$coreJsData = (0, $1411a3aa46f5d7a2$export$2e2bcd8739ae039)["__core-js_shared__"];
var $80357e180d848e7c$export$2e2bcd8739ae039 = $80357e180d848e7c$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $3baf74cfb1c7a063$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $80357e180d848e7c$export$2e2bcd8739ae039) && (0, $80357e180d848e7c$export$2e2bcd8739ae039).keys && (0, $80357e180d848e7c$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $3baf74cfb1c7a063$var$isMasked(func) {
    return !!$3baf74cfb1c7a063$var$maskSrcKey && $3baf74cfb1c7a063$var$maskSrcKey in func;
}
var $3baf74cfb1c7a063$export$2e2bcd8739ae039 = $3baf74cfb1c7a063$var$isMasked;



/** Used for built-in method references. */ var $6f43f2806e63f3e0$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $6f43f2806e63f3e0$var$funcToString = $6f43f2806e63f3e0$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $6f43f2806e63f3e0$var$toSource(func) {
    if (func != null) {
        try {
            return $6f43f2806e63f3e0$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $6f43f2806e63f3e0$export$2e2bcd8739ae039 = $6f43f2806e63f3e0$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $0c9a6c796bbf7c97$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $0c9a6c796bbf7c97$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $0c9a6c796bbf7c97$var$funcProto = Function.prototype, $0c9a6c796bbf7c97$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0c9a6c796bbf7c97$var$funcToString = $0c9a6c796bbf7c97$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0c9a6c796bbf7c97$var$hasOwnProperty = $0c9a6c796bbf7c97$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $0c9a6c796bbf7c97$var$reIsNative = RegExp("^" + $0c9a6c796bbf7c97$var$funcToString.call($0c9a6c796bbf7c97$var$hasOwnProperty).replace($0c9a6c796bbf7c97$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $0c9a6c796bbf7c97$var$baseIsNative(value) {
    if (!(0, $247147f553028710$export$2e2bcd8739ae039)(value) || (0, $3baf74cfb1c7a063$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $597ca852020b7ccb$export$2e2bcd8739ae039)(value) ? $0c9a6c796bbf7c97$var$reIsNative : $0c9a6c796bbf7c97$var$reIsHostCtor;
    return pattern.test((0, $6f43f2806e63f3e0$export$2e2bcd8739ae039)(value));
}
var $0c9a6c796bbf7c97$export$2e2bcd8739ae039 = $0c9a6c796bbf7c97$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $df8133122c2cd4a6$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $df8133122c2cd4a6$export$2e2bcd8739ae039 = $df8133122c2cd4a6$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $d37761cf6a71f871$var$getNative(object, key) {
    var value = (0, $df8133122c2cd4a6$export$2e2bcd8739ae039)(object, key);
    return (0, $0c9a6c796bbf7c97$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $d37761cf6a71f871$export$2e2bcd8739ae039 = $d37761cf6a71f871$var$getNative;


/* Built-in method references that are verified to be native. */ var $f3523ec40efd7abb$var$nativeCreate = (0, $d37761cf6a71f871$export$2e2bcd8739ae039)(Object, "create");
var $f3523ec40efd7abb$export$2e2bcd8739ae039 = $f3523ec40efd7abb$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $9189d5c4fa18c120$var$hashClear() {
    this.__data__ = (0, $f3523ec40efd7abb$export$2e2bcd8739ae039) ? (0, $f3523ec40efd7abb$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $9189d5c4fa18c120$export$2e2bcd8739ae039 = $9189d5c4fa18c120$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a2514c96ba0ddb47$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $a2514c96ba0ddb47$export$2e2bcd8739ae039 = $a2514c96ba0ddb47$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $77bc7a84f287ace4$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $77bc7a84f287ace4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $77bc7a84f287ace4$var$hasOwnProperty = $77bc7a84f287ace4$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $77bc7a84f287ace4$var$hashGet(key) {
    var data = this.__data__;
    if (0, $f3523ec40efd7abb$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $77bc7a84f287ace4$var$HASH_UNDEFINED ? undefined : result;
    }
    return $77bc7a84f287ace4$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $77bc7a84f287ace4$export$2e2bcd8739ae039 = $77bc7a84f287ace4$var$hashGet;



/** Used for built-in method references. */ var $2f07c350037e3c46$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f07c350037e3c46$var$hasOwnProperty = $2f07c350037e3c46$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2f07c350037e3c46$var$hashHas(key) {
    var data = this.__data__;
    return (0, $f3523ec40efd7abb$export$2e2bcd8739ae039) ? data[key] !== undefined : $2f07c350037e3c46$var$hasOwnProperty.call(data, key);
}
var $2f07c350037e3c46$export$2e2bcd8739ae039 = $2f07c350037e3c46$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $baab0181cfa3d6af$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $baab0181cfa3d6af$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $f3523ec40efd7abb$export$2e2bcd8739ae039) && value === undefined ? $baab0181cfa3d6af$var$HASH_UNDEFINED : value;
    return this;
}
var $baab0181cfa3d6af$export$2e2bcd8739ae039 = $baab0181cfa3d6af$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cc7665fb4d3ce25b$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$cc7665fb4d3ce25b$var$Hash.prototype.clear = (0, $9189d5c4fa18c120$export$2e2bcd8739ae039);
$cc7665fb4d3ce25b$var$Hash.prototype["delete"] = (0, $a2514c96ba0ddb47$export$2e2bcd8739ae039);
$cc7665fb4d3ce25b$var$Hash.prototype.get = (0, $77bc7a84f287ace4$export$2e2bcd8739ae039);
$cc7665fb4d3ce25b$var$Hash.prototype.has = (0, $2f07c350037e3c46$export$2e2bcd8739ae039);
$cc7665fb4d3ce25b$var$Hash.prototype.set = (0, $baab0181cfa3d6af$export$2e2bcd8739ae039);
var $cc7665fb4d3ce25b$export$2e2bcd8739ae039 = $cc7665fb4d3ce25b$var$Hash;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $9c2171336301bc0d$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $9c2171336301bc0d$export$2e2bcd8739ae039 = $9c2171336301bc0d$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $21a49211f97d994d$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $21a49211f97d994d$export$2e2bcd8739ae039 = $21a49211f97d994d$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $89927f93deb8c870$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $21a49211f97d994d$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $89927f93deb8c870$export$2e2bcd8739ae039 = $89927f93deb8c870$var$assocIndexOf;


/** Used for built-in method references. */ var $ceea0f7d9e0c48c4$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ceea0f7d9e0c48c4$var$splice = $ceea0f7d9e0c48c4$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ceea0f7d9e0c48c4$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $89927f93deb8c870$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ceea0f7d9e0c48c4$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $ceea0f7d9e0c48c4$export$2e2bcd8739ae039 = $ceea0f7d9e0c48c4$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $db080b620e247cb5$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $89927f93deb8c870$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $db080b620e247cb5$export$2e2bcd8739ae039 = $db080b620e247cb5$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b9bee896aa12e404$var$listCacheHas(key) {
    return (0, $89927f93deb8c870$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $b9bee896aa12e404$export$2e2bcd8739ae039 = $b9bee896aa12e404$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $123ed9e0bb2e0a15$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $89927f93deb8c870$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $123ed9e0bb2e0a15$export$2e2bcd8739ae039 = $123ed9e0bb2e0a15$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f43b0899fda501a2$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f43b0899fda501a2$var$ListCache.prototype.clear = (0, $9c2171336301bc0d$export$2e2bcd8739ae039);
$f43b0899fda501a2$var$ListCache.prototype["delete"] = (0, $ceea0f7d9e0c48c4$export$2e2bcd8739ae039);
$f43b0899fda501a2$var$ListCache.prototype.get = (0, $db080b620e247cb5$export$2e2bcd8739ae039);
$f43b0899fda501a2$var$ListCache.prototype.has = (0, $b9bee896aa12e404$export$2e2bcd8739ae039);
$f43b0899fda501a2$var$ListCache.prototype.set = (0, $123ed9e0bb2e0a15$export$2e2bcd8739ae039);
var $f43b0899fda501a2$export$2e2bcd8739ae039 = $f43b0899fda501a2$var$ListCache;




/* Built-in method references that are verified to be native. */ var $b913078f666264eb$var$Map = (0, $d37761cf6a71f871$export$2e2bcd8739ae039)((0, $1411a3aa46f5d7a2$export$2e2bcd8739ae039), "Map");
var $b913078f666264eb$export$2e2bcd8739ae039 = $b913078f666264eb$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $a1e0ee3263af5985$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $cc7665fb4d3ce25b$export$2e2bcd8739ae039),
        "map": new ((0, $b913078f666264eb$export$2e2bcd8739ae039) || (0, $f43b0899fda501a2$export$2e2bcd8739ae039)),
        "string": new (0, $cc7665fb4d3ce25b$export$2e2bcd8739ae039)
    };
}
var $a1e0ee3263af5985$export$2e2bcd8739ae039 = $a1e0ee3263af5985$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $86933d7f966b98cc$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $86933d7f966b98cc$export$2e2bcd8739ae039 = $86933d7f966b98cc$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e298c47b030e336d$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $86933d7f966b98cc$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $e298c47b030e336d$export$2e2bcd8739ae039 = $e298c47b030e336d$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6fa67c3ec7ea6a6e$var$mapCacheDelete(key) {
    var result = (0, $e298c47b030e336d$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $6fa67c3ec7ea6a6e$export$2e2bcd8739ae039 = $6fa67c3ec7ea6a6e$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $109eefa814515c8f$var$mapCacheGet(key) {
    return (0, $e298c47b030e336d$export$2e2bcd8739ae039)(this, key).get(key);
}
var $109eefa814515c8f$export$2e2bcd8739ae039 = $109eefa814515c8f$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d1016a89153b3435$var$mapCacheHas(key) {
    return (0, $e298c47b030e336d$export$2e2bcd8739ae039)(this, key).has(key);
}
var $d1016a89153b3435$export$2e2bcd8739ae039 = $d1016a89153b3435$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $627749b58aa80ed0$var$mapCacheSet(key, value) {
    var data = (0, $e298c47b030e336d$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $627749b58aa80ed0$export$2e2bcd8739ae039 = $627749b58aa80ed0$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d64706d677479b99$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$d64706d677479b99$var$MapCache.prototype.clear = (0, $a1e0ee3263af5985$export$2e2bcd8739ae039);
$d64706d677479b99$var$MapCache.prototype["delete"] = (0, $6fa67c3ec7ea6a6e$export$2e2bcd8739ae039);
$d64706d677479b99$var$MapCache.prototype.get = (0, $109eefa814515c8f$export$2e2bcd8739ae039);
$d64706d677479b99$var$MapCache.prototype.has = (0, $d1016a89153b3435$export$2e2bcd8739ae039);
$d64706d677479b99$var$MapCache.prototype.set = (0, $627749b58aa80ed0$export$2e2bcd8739ae039);
var $d64706d677479b99$export$2e2bcd8739ae039 = $d64706d677479b99$var$MapCache;


/** Error message constants. */ var $546bd42f828d1824$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $546bd42f828d1824$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($546bd42f828d1824$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($546bd42f828d1824$var$memoize.Cache || (0, $d64706d677479b99$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$546bd42f828d1824$var$memoize.Cache = (0, $d64706d677479b99$export$2e2bcd8739ae039);
var $546bd42f828d1824$export$2e2bcd8739ae039 = $546bd42f828d1824$var$memoize;


const $c898fe8401592da6$export$801fe16824f675f7 = (0, $546bd42f828d1824$export$2e2bcd8739ae039)(()=>new Promise((resolve)=>window.AP.getCurrentUser(resolve)));
const $c898fe8401592da6$export$5b40a789c3c585b5 = ()=>new Promise((resolve)=>window.AP.context.getToken(resolve));
const $c898fe8401592da6$export$e7fd20fad3cf4b5f = ()=>new Promise((resolve)=>window.AP.getLocation(resolve));
const $c898fe8401592da6$export$61ec8404f465cd36 = async (filterID)=>{
    const data = await window.AP.request({
        url: `/rest/api/2/filter/${filterID}`,
        contentType: "application/json"
    });
    return JSON.parse(data.body);
};
const $c898fe8401592da6$export$6f4f1e976a21e3fe = async (filterID)=>{
    const filterParams = new URLSearchParams();
    if (!filterID) return filterParams;
    try {
        if (filterID < 0) {
            // it means predefined filter
            filterParams.set("filter", filterID);
            return filterParams;
        }
        const filter = await $c898fe8401592da6$export$61ec8404f465cd36(filterID);
        if (filter) {
            if (filter.favourite) {
                filterParams.set("filter", filterID);
                return filterParams;
            }
            // if filter is not starred => use jql as parameter
            // due to gside does not support import from such filters
            filterParams.set("jql", filter.jql);
            return filterParams;
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error("unable to build filter params:", e);
        return filterParams;
    }
};
const $c898fe8401592da6$export$96bb40b6f4974acf = async ()=>new Promise((resolve)=>window.AP.user.getTimeZone(resolve));



function $9e92207ae7c2aad0$var$onModalClose() {
    window.AP.dialog.close();
    (0, $467fd94f96f91249$export$3dd849221d1b8342)("clicked", "button", "cancelError", "openInExcelBlocked");
}
function $9e92207ae7c2aad0$var$reducer(prevState, newState) {
    return {
        ...prevState,
        ...newState
    };
}
function $9e92207ae7c2aad0$export$591019fa68adef38() {
    const { colorMode: colorMode } = (0, $6da51f9682acf7ce$export$2e2bcd8739ae039)();
    const [state, setState] = $5cNek.useReducer($9e92207ae7c2aad0$var$reducer, {
        targetUrl: "",
        popupsBlocked: false,
        error: false,
        jwt: undefined,
        authWindow: null,
        isSubscribedForOTP: false,
        queryParams: new URLSearchParams()
    });
    $5cNek.useEffect(()=>{
        async function prepareExcelQueryParams() {
            try {
                const [locationUrl, jwt, timeZone] = await Promise.all([
                    (0, $c898fe8401592da6$export$e7fd20fad3cf4b5f)(),
                    (0, $c898fe8401592da6$export$5b40a789c3c585b5)(),
                    (0, $c898fe8401592da6$export$96bb40b6f4974acf)()
                ]);
                const queryParams = new URLSearchParams();
                queryParams.set("link", locationUrl);
                queryParams.set("jwt", jwt);
                queryParams.set("timeZone", timeZone);
                queryParams.set("colorMode", colorMode);
                setState({
                    jwt: jwt,
                    queryParams: queryParams
                });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error("Failed to open Excel:", e);
                setState({
                    error: true
                });
            }
        }
        prepareExcelQueryParams();
    }, [
        colorMode
    ]);
    $5cNek.useEffect(()=>{
        if (!state.isSubscribedForOTP) return;
        try {
            const targetUrl = `/export-to-excel?${state.queryParams}`;
            const authWindow = window.open(targetUrl, "_blank");
            if (authWindow) setState({
                authWindow: authWindow
            });
            else setState({
                targetUrl: targetUrl,
                popupsBlocked: true
            });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Failed to open Excel:", e);
            setState({
                error: true
            });
        }
    }, [
        state.isSubscribedForOTP,
        state.queryParams
    ]);
    function openExcel() {
        try {
            const authWindow = window.open(state.targetUrl, "_blank");
            (0, $467fd94f96f91249$export$3dd849221d1b8342)("clicked", "button", "allowOpenInExcel", "openInExcelBlocked");
            setState({
                authWindow: authWindow,
                popupsBlocked: false
            });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Failed to open Excel:", e);
            setState({
                error: true
            });
        }
    }
    if (state.error) return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $69d7e7a0181e34d3$export$2e2bcd8739ae039), {
        maxImageHeight: 60,
        primaryAction: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $51e43201ca42b1ec$export$2e2bcd8739ae039), {
            appearance: "primary",
            onClick: $9e92207ae7c2aad0$var$onModalClose,
            children: "Close"
        })
    });
    if (state.popupsBlocked) return /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)("section", {
        css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).wrapper,
        children: [
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("div", {
                css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).heading,
                children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $4f519056c85f1e17$export$2e2bcd8739ae039), {
                    as: "h1",
                    level: "h600",
                    children: "Allow a new tab"
                })
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("div", {
                css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).body,
                children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("p", {
                    children: "Because of your pop-up blocker, Jira needs your permission to open a new tab"
                })
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)("div", {
                css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).footer,
                children: [
                    /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $51e43201ca42b1ec$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        onClick: $9e92207ae7c2aad0$var$onModalClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $51e43201ca42b1ec$export$2e2bcd8739ae039), {
                        appearance: "primary",
                        onClick: openExcel,
                        children: "Allow"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $c482d3d206c56e7e$export$78ebdc12138f48e0), {
        authWindow: state.authWindow,
        jwt: state.jwt,
        updateIsSubscribedForOTP: (isSubscribedForOTP)=>setState({
                isSubscribedForOTP: isSubscribedForOTP
            })
    });
}






var $5cNek = parcelRequire("5cNek");





function $f263d4d272d7c09b$var$onModalClose() {
    window.AP.dialog.close();
    (0, $467fd94f96f91249$export$3dd849221d1b8342)("clicked", "button", "cancelError", "openInGSheetsBlocked");
}
function $f263d4d272d7c09b$var$reducer(prevState, newState) {
    return {
        ...prevState,
        ...newState
    };
}
function $f263d4d272d7c09b$export$cdf77dd31110fb0d() {
    const [state, setState] = $5cNek.useReducer($f263d4d272d7c09b$var$reducer, {
        targetUrl: "",
        popupsBlocked: false,
        error: false,
        jwt: undefined,
        authWindow: null,
        isSubscribedForOTP: false,
        queryParams: new URLSearchParams()
    });
    $5cNek.useEffect(()=>{
        async function prepareGSheetsQueryParams() {
            try {
                const locationUrl = new URL(await (0, $c898fe8401592da6$export$e7fd20fad3cf4b5f)());
                const jql = locationUrl.searchParams.get("jql");
                const filterID = locationUrl.searchParams.get("filter");
                const [jwt, timeZone] = await Promise.all([
                    (0, $c898fe8401592da6$export$5b40a789c3c585b5)(),
                    (0, $c898fe8401592da6$export$96bb40b6f4974acf)()
                ]);
                let queryParams = new URLSearchParams();
                if (filterID) queryParams = await (0, $c898fe8401592da6$export$6f4f1e976a21e3fe)(filterID);
                if (jql) queryParams.set("jql", jql);
                queryParams.set("token", jwt);
                queryParams.set("timeZone", timeZone);
                setState({
                    jwt: jwt,
                    queryParams: queryParams
                });
                (0, $467fd94f96f91249$export$3dd849221d1b8342)("clicked", "button", "jira.navigator.pluggable.items.openInGSheets", "jira.navigator.pluggable.items");
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error("Failed to open in GSheets", e);
                setState({
                    error: true
                });
            }
        }
        prepareGSheetsQueryParams();
    }, []);
    $5cNek.useEffect(()=>{
        if (!state.isSubscribedForOTP) return;
        try {
            const targetUrl = `/gsheet/file/start?${state.queryParams}`;
            const authWindow = window.open(targetUrl, "_blank");
            if (authWindow) setState({
                authWindow: authWindow
            });
            else {
                setState({
                    targetUrl: targetUrl,
                    popupsBlocked: true
                });
                (0, $467fd94f96f91249$export$f3b5b1c39333b4d1)("openInGSheetsBlocked");
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Failed to open in GSheets", e);
            setState({
                error: true
            });
        }
    }, [
        state.isSubscribedForOTP,
        state.jwt,
        state.queryParams,
        state.timeZone
    ]);
    const openGSheets = ()=>{
        try {
            const authWindow = window.open(state.targetUrl, "_blank");
            (0, $467fd94f96f91249$export$3dd849221d1b8342)("clicked", "button", "allowOpenInGSheets", "openInGSheetsBlocked");
            setState({
                authWindow: authWindow,
                popupsBlocked: false
            });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Failed to open In GSheets:", e);
            setState({
                error: true
            });
        }
    };
    if (state.error) return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $69d7e7a0181e34d3$export$2e2bcd8739ae039), {
        maxImageHeight: 60,
        primaryAction: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $51e43201ca42b1ec$export$2e2bcd8739ae039), {
            appearance: "primary",
            onClick: $f263d4d272d7c09b$var$onModalClose,
            children: "Close"
        })
    });
    if (state.popupsBlocked) return /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)("section", {
        css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).wrapper,
        children: [
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("div", {
                css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).heading,
                children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $4f519056c85f1e17$export$2e2bcd8739ae039), {
                    as: "h1",
                    level: "h600",
                    children: "Allow a new tab"
                })
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("div", {
                css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).body,
                children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)("p", {
                    children: "Because of your pop-up blocker, Jira needs your permission to open Google Sheets in a new tab"
                })
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)("div", {
                css: (0, $3ce8266cd37044aa$export$839f9b7dfe545fdc).footer,
                children: [
                    /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $51e43201ca42b1ec$export$2e2bcd8739ae039), {
                        appearance: "subtle",
                        onClick: $f263d4d272d7c09b$var$onModalClose,
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $51e43201ca42b1ec$export$2e2bcd8739ae039), {
                        appearance: "primary",
                        onClick: openGSheets,
                        children: "Allow"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $c482d3d206c56e7e$export$78ebdc12138f48e0), {
        authWindow: state.authWindow,
        jwt: state.jwt,
        updateIsSubscribedForOTP: (isSubscribedForOTP)=>setState({
                isSubscribedForOTP: isSubscribedForOTP
            })
    });
}





function $50c190bffb443fa2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $50c190bffb443fa2$var$App() {
    const [isLoading, setLoading] = $5cNek.useState(true);
    $5cNek.useEffect(()=>{
        async function init() {
            if (window?.AP?.getUserInfo) {
                // started inside Jira's dialog
                const { atlassianAccountId: atlassianAccountId } = await (0, $c898fe8401592da6$export$801fe16824f675f7)();
                (0, $467fd94f96f91249$export$d050db8f6426404e)(atlassianAccountId);
            } else {
                const locationSearchParams = new URLSearchParams(window.location.search);
                const jiraToken = locationSearchParams.get("jwt");
                if (jiraToken) {
                    const aaid = (0, $7d9ece1931efbf1d$export$2e2bcd8739ae039)(jiraToken).sub;
                    (0, $467fd94f96f91249$export$d050db8f6426404e)(aaid);
                }
            }
            setLoading(false);
        }
        init();
    }, []);
    if (isLoading) return /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $9240654f48141bfe$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)((0, $7bdcd4addcd96486$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $7bdcd4addcd96486$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $9e92207ae7c2aad0$export$591019fa68adef38), {}),
                path: "/open-in-excel"
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $7bdcd4addcd96486$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $f263d4d272d7c09b$export$cdf77dd31110fb0d), {}),
                path: "/open-in-gsheets"
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $7bdcd4addcd96486$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $83dff726fffbbb38$export$f3357802f83e142a), {
                    children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $f9292413c8312f31$export$b611689b7ade2ea1), {})
                }),
                path: "/export-to-excel"
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $7bdcd4addcd96486$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $83dff726fffbbb38$export$f3357802f83e142a), {
                    children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $f9292413c8312f31$export$b611689b7ade2ea1), {
                        downloadInProgress: true
                    })
                }),
                path: "/download-in-progress"
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $7bdcd4addcd96486$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $83dff726fffbbb38$export$f3357802f83e142a), {
                    children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $f9292413c8312f31$export$b611689b7ade2ea1), {
                        uploadInProgress: true
                    })
                }),
                path: "/upload-in-progress"
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $7bdcd4addcd96486$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $da9e38504a290558$export$271f9f08425019c7), {}),
                path: "*"
            })
        ]
    });
}
(0, (/*@__PURE__*/$parcel$interopDefault($3a6b787322b342cd$exports))).render(/*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)($5cNek.StrictMode, {
    children: /*#__PURE__*/ (0, $cff4b33188421449$export$25062201e9e25d76)((0, $dd82041ad57c02e5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $e5448515388bb91a$export$98f03c5d19621d70), {
                styles: {
                    name: "1fh1s0p",
                    styles: "#root{height:100%;}"
                }
            }),
            /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)((0, $8dc9873ca48d4260$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $cff4b33188421449$export$34b9dba7ce09269b)($50c190bffb443fa2$var$App, {})
            })
        ]
    })
}), document.getElementById("root"));


//# sourceMappingURL=index.3680a6b4.js.map
